import * as i0 from '@angular/core';
import { Component, Injectable, Pipe, Inject, EventEmitter, Input, Output, ViewChild, NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import * as i1 from '@angular/common/http';
import { HttpHeaders, HttpClientModule } from '@angular/common/http';
import * as i5 from '@angular/common';
import { CommonModule, NgForOf, NgIf, NgClass, JsonPipe } from '@angular/common';
import moment from 'moment';
import * as i6 from '@ionic/angular';
import { IonicModule, IonModal } from '@ionic/angular';
import * as i1$1 from '@angular/router';
import { RouterModule, NavigationEnd } from '@angular/router';
import { of, throwError, Observable } from 'rxjs';
import { tap, share, finalize, catchError, retry, filter, startWith, map } from 'rxjs/operators';
import Swal from 'sweetalert2';
import * as L from 'leaflet';
import SmoothMarkerBouncing from 'leaflet.smooth_marker_bouncing';
import 'leaflet.markercluster';
import 'leaflet-geometryutil';
import { Capacitor } from '@capacitor/core';
import * as i16 from '@angular/forms';
import { FormsModule, ReactiveFormsModule, FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import * as i7 from '@angular/material/expansion';
import { MatExpansionModule } from '@angular/material/expansion';
import * as i4 from '@angular/material/progress-bar';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import * as i1$2 from '@angular/platform-browser';
import * as i1$3 from '@ionic-native/google-analytics/ngx';
import * as i11 from '@angular/material/tabs';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTreeModule } from '@angular/material/tree';
import { MatButtonModule } from '@angular/material/button';
import * as i8 from '@angular/material/tooltip';
import { MatTooltipModule } from '@angular/material/tooltip';
import * as i8$1 from '@angular/material/form-field';
import { MatFormFieldModule } from '@angular/material/form-field';
import * as i9 from '@angular/material/autocomplete';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import * as i7$1 from '@angular/material/input';
import { MatInputModule } from '@angular/material/input';
import * as i13 from '@angular/material/radio';
import { MatRadioModule } from '@angular/material/radio';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import * as i4$1 from '@angular/cdk/layout';
import { Breakpoints } from '@angular/cdk/layout';
import * as i10 from '@angular/material/core';
import { MAT_DATE_LOCALE, DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import * as Highcharts from 'highcharts/highstock';
import * as i9$1 from '@angular/material/datepicker';
import { MatDatepickerModule } from '@angular/material/datepicker';
import * as i6$1 from 'highcharts-angular';
import { HighchartsChartModule } from 'highcharts-angular';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import highchartsMore from 'highcharts/highcharts-more';
import HC_accessibility from 'highcharts/modules/accessibility';
import theme from 'highcharts/themes/high-contrast-light';
import Exporting from 'highcharts/modules/exporting';
import ExportData from 'highcharts/modules/export-data';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS, MAT_MOMENT_DATE_FORMATS } from '@angular/material-moment-adapter';
import * as i7$2 from '@angular/material/select';
import { MatSelectModule } from '@angular/material/select';

class App360SharedComponent {
    constructor() { }
    ngOnInit() { }
}
App360SharedComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: App360SharedComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
App360SharedComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: App360SharedComponent, selector: "lib-app360-shared", ngImport: i0, template: ` <p>app360-shared works!</p> `, isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: App360SharedComponent, decorators: [{
            type: Component,
            args: [{ selector: 'lib-app360-shared', template: ` <p>app360-shared works!</p> ` }]
        }], ctorParameters: function () { return []; } });

class TransformDatePipe {
    transform(date) {
        if (date === null) {
            return '-';
        }
        else {
            return moment.utc(date, 'YYYY/MM/DD').format('DD/MM/YY');
        }
    }
}
TransformDatePipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: TransformDatePipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
TransformDatePipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: TransformDatePipe, name: "transformDate" });
TransformDatePipe.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: TransformDatePipe, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: TransformDatePipe, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }, {
            type: Pipe,
            args: [{
                    name: 'transformDate'
                }]
        }] });

class TransformDateTimePipe {
    transform(date) {
        if (date === null) {
            return '-';
        }
        else {
            return moment.utc(date, 'YYYY/MM/DD HH:mm:ss').format('DD/MM/YY HH:mm');
        }
    }
}
TransformDateTimePipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: TransformDateTimePipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
TransformDateTimePipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: TransformDateTimePipe, name: "transformDateTime" });
TransformDateTimePipe.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: TransformDateTimePipe, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: TransformDateTimePipe, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }, {
            type: Pipe,
            args: [{
                    name: 'transformDateTime'
                }]
        }] });

class EnvironmentService {
    constructor(environment) {
        this.environment = environment;
    }
    getEnvironment() {
        return this.environment;
    }
    getProduction() {
        return this.environment.production;
    }
    getBackend() {
        return this.environment.backend;
    }
    getLanguage() {
        return this.environment.language;
    }
    setLanguage(language) {
        this.environment.language = language;
    }
    getFrontend() {
        return this.environment.frontend;
    }
    getMyUcrop() {
        return this.environment.my_ucrop;
    }
    getItemPerPage() {
        return this.environment.items_per_page;
    }
    getMapboxToken() {
        return this.environment.mapbox_token;
    }
    getStaticMapsToken() {
        return this.environment.google_maps_static_api;
    }
    getIntervalDefaultTimeout() {
        return this.environment.intervalDefaultTimeout;
    }
    isBackoffice() {
        return this.environment.isBackoffice;
    }
}
EnvironmentService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EnvironmentService, deps: [{ token: 'ENVIRONMENT' }], target: i0.ɵɵFactoryTarget.Injectable });
EnvironmentService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EnvironmentService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EnvironmentService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: ['ENVIRONMENT']
                }] }]; } });

class LoaderComponent {
    constructor(environmentService) {
        this.environmentService = environmentService;
        this.environment = this.environmentService.getEnvironment();
    }
    ngOnInit() { }
}
LoaderComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: LoaderComponent, deps: [{ token: EnvironmentService }], target: i0.ɵɵFactoryTarget.Component });
LoaderComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: LoaderComponent, selector: "lib-loader", ngImport: i0, template: "<aside id=\"main-loader\">\n  <div class=\"spinner-container\">\n    <div class=\"spinner-image\">\n      <img\n        src=\"{{ environment.backend + '/static/images/spinner.svg' }}\"\n        alt=\"Loading\"\n      />\n    </div>\n  </div>\n</aside>\n", styles: ["#main-loader{position:absolute;top:50%;left:50%;z-index:9999}#main-loader .spinner-container{position:absolute;top:50%;right:50%;transform:translate(50%,-50%)}#main-loader .spinner-container .spinner-logo{width:200px}#main-loader .spinner-container .spinner-image{background:#f2f5fc;width:100px;position:relative;border:2px solid #224261;border-radius:8px}#main-loader .spinner-container .spinner-image img{max-width:100%}\n"] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: LoaderComponent, decorators: [{
            type: Component,
            args: [{ selector: 'lib-loader', template: "<aside id=\"main-loader\">\n  <div class=\"spinner-container\">\n    <div class=\"spinner-image\">\n      <img\n        src=\"{{ environment.backend + '/static/images/spinner.svg' }}\"\n        alt=\"Loading\"\n      />\n    </div>\n  </div>\n</aside>\n", styles: ["#main-loader{position:absolute;top:50%;left:50%;z-index:9999}#main-loader .spinner-container{position:absolute;top:50%;right:50%;transform:translate(50%,-50%)}#main-loader .spinner-container .spinner-logo{width:200px}#main-loader .spinner-container .spinner-image{background:#f2f5fc;width:100px;position:relative;border:2px solid #224261;border-radius:8px}#main-loader .spinner-container .spinner-image img{max-width:100%}\n"] }]
        }], ctorParameters: function () { return [{ type: EnvironmentService }]; } });

var EquipmentGeneralTypes;
(function (EquipmentGeneralTypes) {
    EquipmentGeneralTypes["irrigation"] = "IRRIGATION";
    EquipmentGeneralTypes["climate"] = "CLIMATE";
    EquipmentGeneralTypes["datalogger"] = "DATALOGGER";
    EquipmentGeneralTypes["carts"] = "CARTS";
    EquipmentGeneralTypes["configurable"] = "CONFIGURABLE";
    EquipmentGeneralTypes["unknown"] = "UNKNOWN";
})(EquipmentGeneralTypes || (EquipmentGeneralTypes = {}));
var UserType;
(function (UserType) {
    UserType[UserType["owner"] = 1] = "owner";
    UserType[UserType["installer"] = 2] = "installer";
    UserType[UserType["regularUser"] = 3] = "regularUser";
    UserType[UserType["backofficeSuperAdmin"] = 20] = "backofficeSuperAdmin";
    UserType[UserType["backofficeSuperAdminDeveloper"] = 21] = "backofficeSuperAdminDeveloper";
    UserType[UserType["backofficeUser"] = 22] = "backofficeUser";
    UserType[UserType["backofficeFinancialAdmin"] = 23] = "backofficeFinancialAdmin";
    UserType[UserType["nonVerifiedInstaller"] = 52] = "nonVerifiedInstaller";
})(UserType || (UserType = {}));
const TERMINAL_TYPES_IRRIGATION = [20, 21, 22, 23, 24, 25, 26, 27];
const TERMINAL_TYPES_CLIMATE = [30, 31, 32, 33, 34, 35, 36, 37, 38];
const TERMINAL_TYPES_DATALOGGER = [
    100, 101, 102, 103, 104, 105, 106, 107, 108, 109
];
const TERMINAL_TYPES_CARTS = [40];
const TERMINAL_TYPES_CONFIGURABLE = [50, 51];
const TERMINAL_ENABLED_FULLY_DISABLED = 0;
const TERMINAL_ENABLED_ENABLED = 1;
const TERMINAL_ENABLED_TEMPORARY_DISABLED = 2;

class SessionLibService {
    constructor(environmentService) {
        this.environmentService = environmentService;
        this.expired = false;
    }
    // Session API Methods
    // ===================
    createSession(vid, name, email, session_vid, token, accessToken, typeUser, language, showAlert = false) {
        localStorage.setItem('vid', vid);
        localStorage.setItem('session_vid', session_vid);
        localStorage.setItem('session_token', token);
        localStorage.setItem('access_token', accessToken);
        localStorage.setItem('name', name);
        localStorage.setItem('email', email);
        localStorage.setItem('language', language);
        localStorage.setItem('type', JSON.stringify(typeUser));
        localStorage.setItem('showAlert', String(showAlert));
        console.log('Creating a new sessiong with the following parameters vid ' +
            vid +
            ' session_vid ' +
            session_vid +
            ' session_token ' +
            token +
            ' access_token ' +
            accessToken +
            ' name ' +
            name +
            ' email ' +
            email +
            ' language ' +
            language +
            ' type ' +
            JSON.stringify(typeUser) +
            ' showAlert ' +
            String(showAlert));
    }
    setShowAlert(showAlert) {
        localStorage.setItem('showAlert', String(showAlert));
    }
    getShowAlert() {
        return localStorage.getItem('showAlert') === 'true';
    }
    setLanguage(language) {
        localStorage.setItem('language', language);
    }
    getLanguage() {
        let language = localStorage.getItem('language');
        if (typeof language !== 'string' ||
            language.trim() === 'null' ||
            language.trim() === '' ||
            language.trim() === null) {
            language = this.getPreferredLanguage();
        }
        return language;
    }
    setCookiesPolicy(value) {
        localStorage.setItem('cookies_policy', value);
    }
    getCookiesPolicy() {
        return localStorage.getItem('cookies_policy');
    }
    setHome(page) {
        localStorage.setItem('home', page);
    }
    getHome() {
        return localStorage.getItem('home');
    }
    updateSessionToken(token) {
        localStorage.setItem('session_token', token);
    }
    updateSessionSessionVid(sessionVid) {
        localStorage.setItem('session_vid', sessionVid);
    }
    getImpersonated() {
        return localStorage.getItem('impersonated');
    }
    getSuplanted() {
        return localStorage.getItem('suplanted');
    }
    getName() {
        return localStorage.getItem('name');
    }
    getBillingPopupReminderDismissed() {
        return localStorage.getItem('popup_reminder_dismissed');
    }
    getBillingPopupReminderDismissedTerminal(terminalVid) {
        const reminders = JSON.parse(localStorage.getItem('popup_reminders_dismissed_terminals') || '{}');
        return terminalVid in reminders; // returns true if terminalVid exists in reminders
    }
    getUserHasNonDemoTerminals() {
        return localStorage.getItem('user_has_non_demo_terminals');
    }
    setImpersonated(impersonated) {
        if (impersonated) {
            localStorage.setItem('impersonated', 'true');
        }
        else {
            if (this.getImpersonated() !== undefined) {
                localStorage.removeItem('impersonated');
            }
        }
    }
    setBillingPopupReminderDismissed() {
        localStorage.setItem('popup_reminder_dismissed', 'true');
    }
    setBillingPopupReminderDismissedTerminal(terminalVid) {
        let reminders = JSON.parse(localStorage.getItem('popup_reminders_dismissed_terminals') || '{}');
        reminders[terminalVid] = true; // adds terminalVid to reminders
        localStorage.setItem('popup_reminders_dismissed_terminals', JSON.stringify(reminders));
    }
    setUserHasNonDemoTerminals(userHasNonDemoTerminals) {
        localStorage.setItem('user_has_non_demo_terminals', userHasNonDemoTerminals.toString());
    }
    setSuplanted() {
        localStorage.setItem('suplanted', 'true');
    }
    setNotSuplanted() {
        localStorage.setItem('suplanted', 'false');
    }
    destroySession() {
        localStorage.removeItem('vid');
        localStorage.removeItem('name');
        localStorage.removeItem('session_vid');
        localStorage.removeItem('session_token');
        localStorage.removeItem('access_token');
        localStorage.removeItem('email');
        localStorage.removeItem('avatar');
        localStorage.removeItem('type');
        localStorage.removeItem('popup_reminder_dismissed');
        localStorage.removeItem('popup_reminders_dismissed_terminals');
        localStorage.removeItem('user_has_non_demo_terminals');
        this.setImpersonated(false);
        if (this.getSuplanted() !== undefined) {
            localStorage.removeItem('suplanted');
        }
        window.location.href = '/login';
    }
    setAvatar(data) {
        localStorage.setItem('avatar', JSON.stringify(data));
    }
    getAvatar() {
        return JSON.parse(localStorage.getItem('avatar'));
    }
    getAccessToken() {
        return localStorage.getItem('access_token');
    }
    getSessionToken() {
        return localStorage.getItem('session_token');
    }
    getSessionEmail() {
        return localStorage.getItem('email');
    }
    getSessionUserVid() {
        return localStorage.getItem('vid');
    }
    getSessionSessionVid() {
        return localStorage.getItem('session_vid');
    }
    getUserType() {
        return Number(localStorage.getItem('type'));
    }
    userTypeIsInstaller() {
        const userType = this.getUserType();
        return (userType === UserType.installer ||
            userType === UserType.nonVerifiedInstaller);
    }
    userTypeIsBOSuperAdmin() {
        const userType = this.getUserType();
        return (userType === UserType.backofficeSuperAdmin ||
            userType === UserType.backofficeSuperAdminDeveloper);
    }
    sessionTokenIsExpired(expired) {
        this.expired = expired;
    }
    isSessionTokenIsExpired() {
        return this.expired;
    }
    getPreferredLanguage() {
        let userLang = navigator.language;
        if (typeof userLang === 'string') {
            const userLang_arr = userLang.split('-');
            userLang = userLang_arr[0];
        }
        else {
            userLang = this.environmentService.getLanguage();
        }
        return userLang;
    }
}
SessionLibService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: SessionLibService, deps: [{ token: EnvironmentService }], target: i0.ɵɵFactoryTarget.Injectable });
SessionLibService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: SessionLibService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: SessionLibService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: EnvironmentService }]; } });

class SanitizeLibService {
    constructor() { }
    kebab(text) {
        return text
            .replace(/([a-z])([A-Z])/g, '$1-$2')
            .replace(/[\s_]+/g, '-')
            .toLowerCase();
    }
}
SanitizeLibService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: SanitizeLibService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
SanitizeLibService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: SanitizeLibService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: SanitizeLibService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return []; } });

class HttpRepositoryService {
    constructor(http, sessionApiService, sanitizeApiService, session, environmentService) {
        this.http = http;
        this.sessionApiService = sessionApiService;
        this.sanitizeApiService = sanitizeApiService;
        this.session = session;
        this.environmentService = environmentService;
        this.cache = {};
        this.cachedObservable = {};
        this.host = this.environmentService.getBackend();
    }
    // Generic Get Request
    getRequest(url) {
        //@TO-DO: Comprobar si la sesión ha caducado
        const cacheIndex = this.sanitizeApiService.kebab(url);
        let observableResponse;
        if (typeof this.cache[cacheIndex] !== 'undefined' &&
            this.cache[cacheIndex]) {
            observableResponse = of(this.cache[cacheIndex]);
        }
        else if (typeof this.cachedObservable[cacheIndex] !== 'undefined' &&
            this.cachedObservable[cacheIndex]) {
            observableResponse = this.cachedObservable[cacheIndex];
        }
        else {
            const url_call = this.host + '/' + url;
            // @ts-ignore
            this.cachedObservable[cacheIndex] = this.http
                .get(url_call, this.getHTTPOptions())
                .pipe(
            // @ts-ignore
            tap((response) => {
                this.cache[cacheIndex] = response;
            }), share(), finalize(() => {
                this.cache[cacheIndex] = this.cachedObservable[cacheIndex] = null;
            }), catchError(this.errorOutput));
            observableResponse = this.cachedObservable[cacheIndex];
        }
        return observableResponse;
    }
    //
    // // Generic Post Request
    postRequest(url, data) {
        //@TO-DO: Comprobar si la sesión ha caducado
        const urlCall = this.host + '/' + url;
        // @ts-ignore
        return (this.http
            .post(urlCall, JSON.stringify(data), this.getHTTPOptions())
            // @ts-ignore
            .pipe(retry(1), catchError(this.errorOutput)));
    }
    //Generic Put Request
    putRequest(url, data) {
        //@TO-DO: Comprobar si la sesión ha caducado
        const urlCall = this.host + '/' + url;
        // @ts-ignore
        return (this.http
            .put(urlCall, JSON.stringify(data), this.getHTTPOptions())
            // @ts-ignore
            .pipe(retry(1), catchError(this.errorOutput)));
    }
    //Generic Delete request
    deleteRequest(url) {
        //@TO-DO: Comprobar si la sesión ha caducado
        const urlCall = this.host + '/' + url;
        // @ts-ignore
        return (this.http
            .delete(urlCall, this.getHTTPOptions())
            // @ts-ignore
            .pipe(retry(1), catchError(this.errorOutput)));
    }
    // Error output to console + screen
    errorOutput(error) {
        let errorMessage = '';
        if (error.error instanceof ErrorEvent) {
            errorMessage = error.error.message;
        }
        else {
            errorMessage =
                'Error Status: ' + error.status + '\nError Message: ' + error.message;
        }
        console.error('RestAPI Service Error!', errorMessage);
        return throwError(error.error);
    }
    /**
     * JWT Interceptor overrides this headers
     *
     * @private
     */
    getHTTPOptions() {
        const HTTPHeaders = {
            'Content-Type': 'application/json',
            'Accept-encoding': 'gzip, deflate, br',
            Accept: 'application/json',
            Language: this.session.getLanguage()
        };
        const sessionToken = this.sessionApiService.getSessionToken();
        if (sessionToken && sessionToken !== '') {
            // @ts-ignore
            HTTPHeaders['Authorization'] = sessionToken;
        }
        //HTTP Options
        return {
            headers: new HttpHeaders(HTTPHeaders)
        };
    }
}
HttpRepositoryService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: HttpRepositoryService, deps: [{ token: i1.HttpClient }, { token: SessionLibService }, { token: SanitizeLibService }, { token: SessionLibService }, { token: EnvironmentService }], target: i0.ɵɵFactoryTarget.Injectable });
HttpRepositoryService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: HttpRepositoryService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: HttpRepositoryService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: SessionLibService }, { type: SanitizeLibService }, { type: SessionLibService }, { type: EnvironmentService }]; } });

class RestApiService {
    constructor(httpRepositoryService) {
        this.httpRepositoryService = httpRepositoryService;
    }
    getTranslations() {
        return this.httpRepositoryService.getRequest('common/translations');
    }
    getMyUCROPTranslations() {
        return this.httpRepositoryService.getRequest('common/translations?site=my-ucrop');
    }
    getCountries() {
        return this.httpRepositoryService.getRequest('common/countries');
    }
    getMenu(mode = '') {
        return this.httpRepositoryService.getRequest('users/menu' + mode);
    }
    getInvitations() {
        return this.httpRepositoryService.getRequest('users/invitations');
    }
    getPendingInvitations() {
        return this.httpRepositoryService.getRequest('users/invitations/pending');
    }
    putInvitationResponse(vid, data) {
        return this.httpRepositoryService.putRequest('users/invitations/' + vid, data);
    }
    putResendEmail(vid, data) {
        return this.httpRepositoryService.putRequest('users/invitations/' + vid + '/set-as-pending', data);
    }
    getNotifications(startingDate, endingDate, userTimeZone, data) {
        return this.httpRepositoryService.postRequest(`notifications/push?starting_date=${startingDate}&ending_date=${endingDate}&tz=${userTimeZone}`, data);
    }
    getCropsList() {
        return this.httpRepositoryService.getRequest('common/crops');
    }
}
RestApiService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: RestApiService, deps: [{ token: HttpRepositoryService }], target: i0.ɵɵFactoryTarget.Injectable });
RestApiService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: RestApiService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: RestApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: HttpRepositoryService }]; } });

class AppCommonsService {
    constructor(restApiService) {
        this.restApiService = restApiService;
    }
    getTranslations() {
        return this.restApiService.getTranslations();
    }
    getMyUCROPTranslations() {
        return this.restApiService.getMyUCROPTranslations();
    }
    getMenu(mode = '') {
        return this.restApiService.getMenu(mode);
    }
    getCountries() {
        return this.restApiService.getCountries();
    }
    getCrops(forceLoad = false) {
        return new Observable((observer) => {
            if (!forceLoad &&
                typeof sessionStorage.getItem('crops_data') === 'string') {
                observer.next(JSON.parse(sessionStorage.getItem('crops_data')));
            }
            else {
                this.restApiService.getCropsList().subscribe((response) => {
                    sessionStorage.setItem('crops_data', JSON.stringify(response.items));
                    observer.next(response.items);
                }, (error) => {
                    observer.error(error);
                });
            }
        });
    }
}
AppCommonsService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: AppCommonsService, deps: [{ token: RestApiService }], target: i0.ɵɵFactoryTarget.Injectable });
AppCommonsService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: AppCommonsService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: AppCommonsService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: RestApiService }]; } });

class TranslationsLibService {
    constructor(commonService) {
        this.commonService = commonService;
        this.loadedTranslationsCount = 0;
        this.nonExistingKeys = {};
        this.translationsLoaded = new EventEmitter();
    }
    initialize(myucrop = false) {
        const getTranslationsMethod = myucrop
            ? this.commonService.getMyUCROPTranslations
            : this.commonService.getTranslations;
        getTranslationsMethod.call(this.commonService).subscribe((res) => {
            for (const [k, v] of Object.entries(res)) {
                sessionStorage.setItem('translations_' + k, String(v));
            }
            this.loadedTranslationsCount = Object.keys(res).length;
            const that = this;
            // eslint-disable-next-line prefer-arrow/prefer-arrow-functions
            setTimeout(function () {
                console.log('[TranslationsLibService]: emitTranslationsLoaded, translations count ' +
                    that.loadedTranslationsCount);
                that.emitTranslationsLoaded(true);
            }, 200);
        });
    }
    get(key) {
        let g = key;
        const g2 = sessionStorage.getItem('translations_' + key);
        if (g2) {
            g = g2;
        }
        else {
            if (key in this.nonExistingKeys) {
                return this.nonExistingKeys[key];
            }
            else if (key !== null &&
                key !== undefined &&
                key.toLowerCase() in this.nonExistingKeys) {
                return this.nonExistingKeys[key.toLowerCase()];
            }
            else {
                console.warn('[TranslationsLibService]: Key ' + key + ' does not exist');
                this.nonExistingKeys[key] = key;
                return key;
            }
        }
        return g;
    }
    emitTranslationsLoaded(loaded) {
        this.translationsLoaded.emit(loaded);
    }
    getTranslationsLoadedEmitter() {
        return this.translationsLoaded;
    }
    getMyUCROPTranslationsLoadedEmitter() {
        return this.translationsLoaded;
    }
}
TranslationsLibService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: TranslationsLibService, deps: [{ token: AppCommonsService }], target: i0.ɵɵFactoryTarget.Injectable });
TranslationsLibService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: TranslationsLibService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: TranslationsLibService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: AppCommonsService }]; } });

class TerminalsLibService {
    constructor(router, translationsLib, environment) {
        this.router = router;
        this.translationsLib = translationsLib;
        this.environment = environment;
    }
    getName(terminal) {
        return terminal.name + ' - ' + terminal.vid;
    }
    getType(type) {
        let str_type = '';
        if (TERMINAL_TYPES_IRRIGATION.includes(type)) {
            str_type = EquipmentGeneralTypes.irrigation;
        }
        else if (TERMINAL_TYPES_CLIMATE.includes(type)) {
            str_type = EquipmentGeneralTypes.climate;
        }
        else if (TERMINAL_TYPES_DATALOGGER.includes(type)) {
            str_type = EquipmentGeneralTypes.datalogger;
        }
        else if (TERMINAL_TYPES_CONFIGURABLE.includes(type)) {
            str_type = EquipmentGeneralTypes.configurable;
        }
        else {
            str_type = EquipmentGeneralTypes.unknown;
        }
        return String(str_type).toUpperCase();
    }
    getMarker(type) {
        let marker = '';
        if (TERMINAL_TYPES_IRRIGATION.includes(type)) {
            marker =
                this.environment.getBackend() +
                    '/static/terminals-vect/irrigation_marker.svg';
        }
        else if (TERMINAL_TYPES_CLIMATE.includes(type)) {
            marker =
                this.environment.getBackend() +
                    '/static/terminals-vect/climate_marker.svg';
        }
        else if (TERMINAL_TYPES_DATALOGGER.includes(type)) {
            marker =
                this.environment.getBackend() +
                    '/static/terminals-vect/datalogger_marker.svg';
        }
        else if (TERMINAL_TYPES_CONFIGURABLE.includes(type)) {
            marker =
                this.environment.getBackend() +
                    '/static/terminals-vect/configurable_marker.svg';
        }
        return marker;
    }
    getNativeMarker(type) {
        let marker = '';
        if (TERMINAL_TYPES_IRRIGATION.includes(type)) {
            marker =
                this.environment.getBackend() +
                    '/static/terminals-vect/irrigation_marker.png';
        }
        else if (TERMINAL_TYPES_CLIMATE.includes(type)) {
            marker =
                this.environment.getBackend() +
                    '/static/terminals-vect/climate_marker.png';
        }
        else if (TERMINAL_TYPES_DATALOGGER.includes(type)) {
            marker =
                this.environment.getBackend() +
                    '/static/terminals-vect/datalogger_marker.png';
        }
        else if (TERMINAL_TYPES_CONFIGURABLE.includes(type)) {
            marker =
                this.environment.getBackend() +
                    '/static/terminals-vect/configurable_marker.png';
        }
        return marker;
    }
    getIrrigationNativeMarker(status) {
        let marker = '';
        if (status === true) {
            marker =
                this.environment.getBackend() +
                    '/static/terminals-vect/irrigation_marker_on.png';
        }
        else {
            marker =
                this.environment.getBackend() +
                    '/static/terminals-vect/irrigation_marker.png';
        }
        return marker;
    }
    getIrrigationValveMarker(status) {
        let marker = '';
        if (status === true) {
            marker =
                this.environment.getBackend() + '/static/terminals-vect/valve_on.svg';
        }
        else {
            marker =
                this.environment.getBackend() + '/static/terminals-vect/valve.svg';
        }
        return marker;
    }
    getIrrigationValveNativeMarker(status) {
        let marker = '';
        if (status === true) {
            marker =
                this.environment.getBackend() + '/static/terminals-vect/valve_on.png';
        }
        else {
            marker =
                this.environment.getBackend() + '/static/terminals-vect/valve.png';
        }
        return marker;
    }
    getFieldMarker(status) {
        let marker = '';
        if (status === true) {
            marker =
                this.environment.getBackend() + '/static/fields-vect/field_on.svg';
        }
        else {
            marker = this.environment.getBackend() + '/static/fields-vect/field.svg';
        }
        return marker;
    }
    getFieldNativeMarker(status) {
        let marker = '';
        if (status === true) {
            marker =
                this.environment.getBackend() + '/static/fields-vect/field_on.png';
        }
        else {
            marker = this.environment.getBackend() + '/static/fields-vect/field.png';
        }
        return marker;
    }
    generateRoute(vid, type) {
        if (TERMINAL_TYPES_IRRIGATION.includes(type))
            return '/farming/' + vid + '/irrigation';
        if (TERMINAL_TYPES_CLIMATE.includes(type))
            return '/farming/' + vid + '/climate';
        if (TERMINAL_TYPES_DATALOGGER.includes(type))
            return '/farming/' + vid + '/datalogger';
        if (TERMINAL_TYPES_CONFIGURABLE.includes(type))
            return '/farming/' + vid + '/configurable';
        if (type === 0)
            return '/edit-terminal';
    }
    goToRoute(terminal) {
        if (terminal.type !== 0) {
            this.router.navigate([this.generateRoute(terminal.vid, terminal.type)]);
        }
        else {
            this.router.navigate([
                this.generateRoute(terminal.vid, terminal.type),
                {
                    vid: terminal.vid
                }
            ]);
        }
    }
    getClimateIcons(key) {
        switch (key) {
            case 'Met_time':
                return '<i class="bi bi-clock"></i>';
            case 'Met_temp':
                return '<i class="bi bi-thermometer-half"></i>';
            case 'Met_rain':
                return '<i class="bi bi-cloud-drizzle"></i>';
            case 'Met_windDir':
                return '<i class="bi bi-signpost-split"></i>';
            case 'Met_instRad':
                return '<i class="bi bi-brightness-high"></i>';
            case 'Met_freezeAl':
                return '<i class="bi bi-snow"></i>';
            case 'Met_pluv':
                return '<i class="bi bi-water"></i>';
            case 'Met_day':
                return '<i class="bi bi-brightness-alt-high"></i>';
            case 'Met_stormAl1':
                return '<i class="bi bi-cloud-lightning-rain"></i>';
            case 'Met_stormAl2':
                return '<i class="bi bi-cloud-lightning-rain"></i>';
            case 'Met_hum':
                return '<i class="bi bi-cloud-fill"></i>';
            case 'Met_windSpeed':
                return '<i class="bi bi-wind"></i>';
            case 'Met_cummRad':
                return '<i class="bi bi-calendar"></i>';
        }
    }
    terminalNoRights() {
        Swal.fire({
            text: this.translationsLib.get('terminal_no_rights'),
            icon: 'error',
            confirmButtonColor: '#224261'
        }).then((value) => {
            window.location.href = '/home/dashboard';
        });
    }
}
TerminalsLibService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: TerminalsLibService, deps: [{ token: i1$1.Router }, { token: TranslationsLibService }, { token: EnvironmentService }], target: i0.ɵɵFactoryTarget.Injectable });
TerminalsLibService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: TerminalsLibService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: TerminalsLibService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1$1.Router }, { type: TranslationsLibService }, { type: EnvironmentService }]; } });

class TranslationPipe {
    constructor(translationsLibService) {
        this.translationsLibService = translationsLibService;
    }
    transform(value) {
        return this.translationsLibService.get(value);
    }
}
TranslationPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: TranslationPipe, deps: [{ token: TranslationsLibService }], target: i0.ɵɵFactoryTarget.Pipe });
TranslationPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: TranslationPipe, name: "translation" });
TranslationPipe.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: TranslationPipe, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: TranslationPipe, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }, {
            type: Pipe,
            args: [{
                    name: 'translation'
                }]
        }], ctorParameters: function () { return [{ type: TranslationsLibService }]; } });

class TerminalHeaderComponent {
    constructor(router, translationsLib, terminalsLib, environmentService) {
        this.router = router;
        this.translationsLib = translationsLib;
        this.terminalsLib = terminalsLib;
        this.environmentService = environmentService;
        this.enableLink = true;
        this.link = '';
        this.showPrettyTypeName = true;
        this.showButton = true;
        this.fieldName = '';
        this.showStatusIcon = false;
        this.connected = 0; // 0: disconnected, 1: connected, 2: temporary disconnected
        this.irrigating = false;
        this.modeMatSelect = false;
        this.img = '';
        this.terminal_name = '';
        this.pretty_type_name = '';
        this.vid = '';
    }
    ngOnChanges(changes) {
        if (changes.equipment) {
            // Image
            this.img = '';
            if (typeof this.equipment?.image_path !== 'undefined') {
                this.img =
                    this.environmentService.getBackend() +
                        '/' +
                        this.equipment.image_path;
            }
            else if (typeof this.equipment?.img !== 'undefined') {
                this.img =
                    this.environmentService.getBackend() + '/' + this.equipment.img;
            }
            if (this.img.indexOf('static') < 0) {
                this.img += '/static/terminals-vect/unknown.svg';
            }
            // Terminal name
            if (typeof this.equipment?.name !== 'undefined') {
                this.terminal_name = this.equipment.name;
            }
            else if (typeof this.equipment?.terminal_name !== 'undefined') {
                this.terminal_name = this.equipment.terminal_name;
            }
            // Pretty type name
            if (typeof this.equipment?.pretty_type_name !== 'undefined') {
                this.pretty_type_name = this.equipment.pretty_type_name;
            }
            else if (typeof this.equipment?.type !== 'undefined') {
                this.pretty_type_name = this.equipment.type;
            }
            if (this.pretty_type_name === '-' || this.pretty_type_name === '0') {
                this.pretty_type_name = this.translationsLib.get('terminal_unknown');
            }
            // serial number / vid
            if (typeof this.equipment?.vid !== 'undefined') {
                this.vid = this.equipment.vid;
            }
            else if (typeof this.equipment?.serialNumber !== 'undefined') {
                this.vid = this.equipment.serialNumber;
            }
        }
    }
    clickButton(terminal) {
        if (this.link.trim() === '') {
            this.terminalsLib.goToRoute(terminal);
        }
        else {
            this.router.navigate([this.link]);
        }
    }
    getImage(image) {
        return this.environmentService.getBackend() + image;
    }
}
TerminalHeaderComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: TerminalHeaderComponent, deps: [{ token: i1$1.Router }, { token: TranslationsLibService }, { token: TerminalsLibService }, { token: EnvironmentService }], target: i0.ɵɵFactoryTarget.Component });
TerminalHeaderComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: TerminalHeaderComponent, selector: "lib-terminal-header", inputs: { equipment: "equipment", enableLink: "enableLink", link: "link", button: "button", showPrettyTypeName: "showPrettyTypeName", showButton: "showButton", fieldName: "fieldName", showStatusIcon: "showStatusIcon", connected: "connected", irrigating: "irrigating", modeMatSelect: "modeMatSelect" }, usesOnChanges: true, ngImport: i0, template: "<div class=\"terminal-header-component row\" *ngIf=\"img\">\n  <div\n    class=\"d-flex px-3 align-items-center\"\n    [ngClass]=\"{\n      'col-12': !showButton,\n      'col-9': showButton,\n      'px-lg-0': !modeMatSelect\n    }\"\n  >\n    <div class=\"d-inline-block pe-2 position-relative\">\n      <div *ngIf=\"showStatusIcon\" class=\"connection-icon d-block d-xxl-none\">\n        <ion-icon\n          *ngIf=\"connected === 0\"\n          [name]=\"'alert-circle-outline'\"\n          class=\"disconnected bg-white text-danger\"\n        >\n        </ion-icon>\n        <ion-icon\n          *ngIf=\"connected === 1 && !irrigating\"\n          [name]=\"'ellipse'\"\n          class=\"connected bg-success\"\n        >\n        </ion-icon>\n        <img\n          *ngIf=\"connected === 1 && irrigating\"\n          [src]=\"getImage('/static/terminals-vect/states/irrigating.svg')\"\n          class=\"irrigating\"\n        />\n        <ion-icon\n          *ngIf=\"connected === 2\"\n          [name]=\"'time-outline'\"\n          class=\"temporary_disconnected bg-white\"\n          style=\"color: orange\"\n        >\n        </ion-icon>\n      </div>\n      <div\n        *ngIf=\"showStatusIcon\"\n        class=\"connection-badge fs-5 d-none d-xxl-block\"\n      >\n        <div\n          *ngIf=\"connected === 0\"\n          class=\"badge disconnected bg-danger bg-secondary\"\n        >\n          {{ this.translationsLib.get(\"terminal_disconnected\") }}\n        </div>\n        <div\n          *ngIf=\"connected === 1 && !irrigating\"\n          class=\"badge connected bg-success\"\n        >\n          {{ this.translationsLib.get(\"terminal_connected\") }}\n        </div>\n        <div *ngIf=\"connected === 1 && irrigating\" class=\"badge irrigating\">\n          {{ this.translationsLib.get(\"irrigation_state_irrigating\") }}\n        </div>\n        <div\n          *ngIf=\"connected === 2\"\n          class=\"badge temporary_disconnected bg-warning\"\n          style=\"white-space: normal; transform: translateY(10px)\"\n        >\n          {{\n            this.translationsLib.get(\"terminal_status_temporary_disconnected\")\n          }}\n        </div>\n      </div>\n      <a (click)=\"clickButton(equipment)\" *ngIf=\"enableLink\">\n        <img\n          class=\"terminal-img\"\n          src=\"{{ img }}\"\n          [ngClass]=\"{\n            'is-opaque': showStatusIcon && (connected === 0 || connected === 2)\n          }\"\n          [attr.aria-label]=\"('view' | translation) + ' ' + terminal_name\"\n        />\n      </a>\n      <img\n        class=\"terminal-img\"\n        src=\"{{ img }}\"\n        *ngIf=\"!enableLink\"\n        [ngClass]=\"{\n          'is-opaque': showStatusIcon && (connected === 0 || connected === 2)\n        }\"\n        [attr.aria-label]=\"('view' | translation) + ' ' + terminal_name\"\n      />\n    </div>\n    <div\n      class=\"d-inline-block align-content-start id-container\"\n      id=\"{{ equipment.source_database }}\"\n    >\n      <a (click)=\"clickButton(equipment)\" *ngIf=\"enableLink\">\n        <div class=\"title d-inline-block\">\n          {{ terminal_name }}\n          <span\n            *ngIf=\"\n              showPrettyTypeName === true && pretty_type_name.trim() !== ''\n            \"\n            >- {{ pretty_type_name }}\n          </span>\n        </div>\n\n        <div\n          class=\"text-muted m-0 d-flex align-content-end\"\n          style=\"font-size: 14px\"\n        >\n          <span>{{ vid }}</span>\n          <span *ngIf=\"fieldName && fieldName.trim() !== ''\"\n            >- {{ fieldName }}</span\n          >\n        </div>\n      </a>\n      <ng-container *ngIf=\"!enableLink\">\n        <div class=\"title d-inline-block\">\n          {{ terminal_name }}\n          <span\n            *ngIf=\"\n              showPrettyTypeName === true && pretty_type_name.trim() !== ''\n            \"\n            >- {{ pretty_type_name }}</span\n          >\n        </div>\n\n        <p class=\"text-muted\">\n          {{ vid }}\n          <span *ngIf=\"fieldName && fieldName.trim() !== ''\"\n            >- {{ fieldName }}</span\n          >\n        </p>\n      </ng-container>\n    </div>\n  </div>\n  <div\n    class=\"d-none d-lg-block col-3 text-end align-self-center\"\n    *ngIf=\"showButton && enableLink\"\n  >\n    <button\n      (click)=\"clickButton(equipment)\"\n      class=\"btn btn-sm btn-primary\"\n      *ngIf=\"showButton && enableLink\"\n    >\n      {{ translationsLib.get(\"watch_device\") }}\n    </button>\n  </div>\n  <div class=\"d-block d-lg-none col-3 text-center align-self-center\">\n    <a\n      (click)=\"clickButton(equipment)\"\n      class=\"btn btn-primary lift text-white\"\n      *ngIf=\"showButton && enableLink\"\n    >\n      <ion-icon\n        [ios]=\"'arrow-redo-outline'\"\n        [md]=\"'arrow-redo-outline'\"\n      ></ion-icon>\n    </a>\n  </div>\n</div>\n", styles: [".terminal-header-component img.terminal-img{max-height:50px;min-width:40px}.terminal-header-component img.terminal-img.is-opaque{opacity:.4}.terminal-header-component a{cursor:pointer}.terminal-header-component .title{font-weight:700;color:#ee7869;line-height:1}.terminal-header-component .title span{color:#224261}.terminal-header-component button{border-radius:5px;background-color:#ee7869;border-color:#ee7869}.terminal-header-component .id-container{line-height:1.4}.terminal-header-component p{margin:0;font-size:14px}@media (max-width: 990px){.terminal-header-component button{line-height:1}}.terminal-header-component .connection-icon{position:absolute;right:0;bottom:0;z-index:3;width:15px;height:15px;font-size:10px}.terminal-header-component .connection-icon img,.terminal-header-component .connection-icon ion-icon{width:15px;height:15px}.terminal-header-component .connection-icon ion-icon{padding:0;background-color:transparent;border-radius:50%}.terminal-header-component .connection-icon ion-icon.connected{color:#74be27}.terminal-header-component .connection-badge{position:absolute;left:50%;bottom:-15px;z-index:2;transform:translate(calc(-50% - 2px))}.terminal-header-component .connection-badge .badge{border:1px solid white}.terminal-header-component .connection-badge .badge.irrigating{background-color:#6290b0}\n"], dependencies: [{ kind: "directive", type: i5.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i6.IonIcon, selector: "ion-icon", inputs: ["color", "flipRtl", "icon", "ios", "lazy", "md", "mode", "name", "sanitize", "size", "src"] }, { kind: "pipe", type: TranslationPipe, name: "translation" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: TerminalHeaderComponent, decorators: [{
            type: Component,
            args: [{ selector: 'lib-terminal-header', template: "<div class=\"terminal-header-component row\" *ngIf=\"img\">\n  <div\n    class=\"d-flex px-3 align-items-center\"\n    [ngClass]=\"{\n      'col-12': !showButton,\n      'col-9': showButton,\n      'px-lg-0': !modeMatSelect\n    }\"\n  >\n    <div class=\"d-inline-block pe-2 position-relative\">\n      <div *ngIf=\"showStatusIcon\" class=\"connection-icon d-block d-xxl-none\">\n        <ion-icon\n          *ngIf=\"connected === 0\"\n          [name]=\"'alert-circle-outline'\"\n          class=\"disconnected bg-white text-danger\"\n        >\n        </ion-icon>\n        <ion-icon\n          *ngIf=\"connected === 1 && !irrigating\"\n          [name]=\"'ellipse'\"\n          class=\"connected bg-success\"\n        >\n        </ion-icon>\n        <img\n          *ngIf=\"connected === 1 && irrigating\"\n          [src]=\"getImage('/static/terminals-vect/states/irrigating.svg')\"\n          class=\"irrigating\"\n        />\n        <ion-icon\n          *ngIf=\"connected === 2\"\n          [name]=\"'time-outline'\"\n          class=\"temporary_disconnected bg-white\"\n          style=\"color: orange\"\n        >\n        </ion-icon>\n      </div>\n      <div\n        *ngIf=\"showStatusIcon\"\n        class=\"connection-badge fs-5 d-none d-xxl-block\"\n      >\n        <div\n          *ngIf=\"connected === 0\"\n          class=\"badge disconnected bg-danger bg-secondary\"\n        >\n          {{ this.translationsLib.get(\"terminal_disconnected\") }}\n        </div>\n        <div\n          *ngIf=\"connected === 1 && !irrigating\"\n          class=\"badge connected bg-success\"\n        >\n          {{ this.translationsLib.get(\"terminal_connected\") }}\n        </div>\n        <div *ngIf=\"connected === 1 && irrigating\" class=\"badge irrigating\">\n          {{ this.translationsLib.get(\"irrigation_state_irrigating\") }}\n        </div>\n        <div\n          *ngIf=\"connected === 2\"\n          class=\"badge temporary_disconnected bg-warning\"\n          style=\"white-space: normal; transform: translateY(10px)\"\n        >\n          {{\n            this.translationsLib.get(\"terminal_status_temporary_disconnected\")\n          }}\n        </div>\n      </div>\n      <a (click)=\"clickButton(equipment)\" *ngIf=\"enableLink\">\n        <img\n          class=\"terminal-img\"\n          src=\"{{ img }}\"\n          [ngClass]=\"{\n            'is-opaque': showStatusIcon && (connected === 0 || connected === 2)\n          }\"\n          [attr.aria-label]=\"('view' | translation) + ' ' + terminal_name\"\n        />\n      </a>\n      <img\n        class=\"terminal-img\"\n        src=\"{{ img }}\"\n        *ngIf=\"!enableLink\"\n        [ngClass]=\"{\n          'is-opaque': showStatusIcon && (connected === 0 || connected === 2)\n        }\"\n        [attr.aria-label]=\"('view' | translation) + ' ' + terminal_name\"\n      />\n    </div>\n    <div\n      class=\"d-inline-block align-content-start id-container\"\n      id=\"{{ equipment.source_database }}\"\n    >\n      <a (click)=\"clickButton(equipment)\" *ngIf=\"enableLink\">\n        <div class=\"title d-inline-block\">\n          {{ terminal_name }}\n          <span\n            *ngIf=\"\n              showPrettyTypeName === true && pretty_type_name.trim() !== ''\n            \"\n            >- {{ pretty_type_name }}\n          </span>\n        </div>\n\n        <div\n          class=\"text-muted m-0 d-flex align-content-end\"\n          style=\"font-size: 14px\"\n        >\n          <span>{{ vid }}</span>\n          <span *ngIf=\"fieldName && fieldName.trim() !== ''\"\n            >- {{ fieldName }}</span\n          >\n        </div>\n      </a>\n      <ng-container *ngIf=\"!enableLink\">\n        <div class=\"title d-inline-block\">\n          {{ terminal_name }}\n          <span\n            *ngIf=\"\n              showPrettyTypeName === true && pretty_type_name.trim() !== ''\n            \"\n            >- {{ pretty_type_name }}</span\n          >\n        </div>\n\n        <p class=\"text-muted\">\n          {{ vid }}\n          <span *ngIf=\"fieldName && fieldName.trim() !== ''\"\n            >- {{ fieldName }}</span\n          >\n        </p>\n      </ng-container>\n    </div>\n  </div>\n  <div\n    class=\"d-none d-lg-block col-3 text-end align-self-center\"\n    *ngIf=\"showButton && enableLink\"\n  >\n    <button\n      (click)=\"clickButton(equipment)\"\n      class=\"btn btn-sm btn-primary\"\n      *ngIf=\"showButton && enableLink\"\n    >\n      {{ translationsLib.get(\"watch_device\") }}\n    </button>\n  </div>\n  <div class=\"d-block d-lg-none col-3 text-center align-self-center\">\n    <a\n      (click)=\"clickButton(equipment)\"\n      class=\"btn btn-primary lift text-white\"\n      *ngIf=\"showButton && enableLink\"\n    >\n      <ion-icon\n        [ios]=\"'arrow-redo-outline'\"\n        [md]=\"'arrow-redo-outline'\"\n      ></ion-icon>\n    </a>\n  </div>\n</div>\n", styles: [".terminal-header-component img.terminal-img{max-height:50px;min-width:40px}.terminal-header-component img.terminal-img.is-opaque{opacity:.4}.terminal-header-component a{cursor:pointer}.terminal-header-component .title{font-weight:700;color:#ee7869;line-height:1}.terminal-header-component .title span{color:#224261}.terminal-header-component button{border-radius:5px;background-color:#ee7869;border-color:#ee7869}.terminal-header-component .id-container{line-height:1.4}.terminal-header-component p{margin:0;font-size:14px}@media (max-width: 990px){.terminal-header-component button{line-height:1}}.terminal-header-component .connection-icon{position:absolute;right:0;bottom:0;z-index:3;width:15px;height:15px;font-size:10px}.terminal-header-component .connection-icon img,.terminal-header-component .connection-icon ion-icon{width:15px;height:15px}.terminal-header-component .connection-icon ion-icon{padding:0;background-color:transparent;border-radius:50%}.terminal-header-component .connection-icon ion-icon.connected{color:#74be27}.terminal-header-component .connection-badge{position:absolute;left:50%;bottom:-15px;z-index:2;transform:translate(calc(-50% - 2px))}.terminal-header-component .connection-badge .badge{border:1px solid white}.terminal-header-component .connection-badge .badge.irrigating{background-color:#6290b0}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$1.Router }, { type: TranslationsLibService }, { type: TerminalsLibService }, { type: EnvironmentService }]; }, propDecorators: { equipment: [{
                type: Input
            }], enableLink: [{
                type: Input
            }], link: [{
                type: Input
            }], button: [{
                type: Input
            }], showPrettyTypeName: [{
                type: Input
            }], showButton: [{
                type: Input
            }], fieldName: [{
                type: Input
            }], showStatusIcon: [{
                type: Input
            }], connected: [{
                type: Input
            }], irrigating: [{
                type: Input
            }], modeMatSelect: [{
                type: Input
            }] } });

class UserSummaryPipe {
    transform(user) {
        if (user) {
            const { name, surname, email } = user;
            return `${name} ${surname} <${email}>`;
        }
        return '';
    }
}
UserSummaryPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: UserSummaryPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
UserSummaryPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: UserSummaryPipe, name: "userSummary" });
UserSummaryPipe.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: UserSummaryPipe, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: UserSummaryPipe, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }, {
            type: Pipe,
            args: [{
                    name: 'userSummary'
                }]
        }] });

class PlatformLibService {
    constructor(platform) {
        this.platform = platform;
    }
    isNative() {
        return Capacitor.isNativePlatform();
    }
    choosePlatform() {
        if (this.platform.is('ios')) {
            return 'ios';
        }
        if (this.platform.is('android')) {
            return 'android';
        }
        return '';
    }
    isPad() {
        return this.platform.is('ipad');
    }
}
PlatformLibService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: PlatformLibService, deps: [{ token: i6.Platform }], target: i0.ɵɵFactoryTarget.Injectable });
PlatformLibService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: PlatformLibService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: PlatformLibService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i6.Platform }]; } });

SmoothMarkerBouncing(L);
class LeafletMapsComponent {
    constructor(terminalsLib, translationsLib, platformLib, router, renderer, environment) {
        this.terminalsLib = terminalsLib;
        this.translationsLib = translationsLib;
        this.platformLib = platformLib;
        this.router = router;
        this.renderer = renderer;
        this.environment = environment;
        this.allValves = [];
        this.fieldSize = new EventEmitter();
        this.terminalsEdit = new EventEmitter();
        this.terminalsActivation = new EventEmitter();
        this.config360 = new EventEmitter();
        this.editedFieldCoordinates = new EventEmitter();
        this.fieldsNew = new EventEmitter();
        this.changeValve = new EventEmitter();
        this.changeAllValves = new EventEmitter();
        this.backofficeEvent = new EventEmitter();
        this.clusters = L.markerClusterGroup({
            maxClusterRadius: 25,
            showCoverageOnHover: false
        });
        this.allMarkers = [];
        this.allCoordinates = [];
        this.polygonCoordinates = [];
        this.markers = [];
        this.valvesMapMarkers = [];
        this.ctrlPressed = false;
        this.showZoomInstructions = false;
        this.zoomEnabled = false;
    }
    ngOnInit() {
        this.backend = this.environment.getBackend();
    }
    ngAfterViewInit() {
        setTimeout(() => {
            this.initMap();
        }, 500);
        if (this.renderer !== null && this.map !== undefined) {
            this.renderer.listen('window', 'keydown', (event) => {
                if (event.ctrlKey || event.metaKey) {
                    this.ctrlPressed = true;
                    this.map.scrollWheelZoom.enable();
                    this.map.touchZoom.enable();
                    this.showZoomInstructions = false;
                    this.zoomEnabled = true;
                }
            });
            this.renderer.listen('window', 'keyup', (event) => {
                if (!event.ctrlKey && !event.metaKey) {
                    this.ctrlPressed = false;
                    this.map.scrollWheelZoom.disable();
                    this.map.touchZoom.disable();
                    this.zoomEnabled = false;
                }
            });
            this.renderer.listen(document.getElementById(this.coming), 'wheel', (event) => {
                if (!this.ctrlPressed) {
                    event.preventDefault();
                    this.showZoomInstructions = true;
                    setTimeout(() => {
                        this.showZoomInstructions = false;
                    }, 1000);
                }
            });
        }
    }
    initMap() {
        this.map = L.map(document.getElementById(this.coming), {
            center: [40.4637, -3.7492],
            zoom: 6,
            scrollWheelZoom: false
        });
        //ESTO ES EL HACK DE LAS LINEAS BLANCAS
        const originalInitTile = L.GridLayer.prototype._initTile;
        L.GridLayer.include({
            _initTile(tile) {
                originalInitTile.call(this, tile);
                const tileSize = this.getTileSize();
                tile.style.width = tileSize.x + 1 + 'px';
                tile.style.height = tileSize.y + 1 + 'px';
            }
        });
        //HASTA AQUI EL HACK
        //Lo comentado es para poner el mapa de google, por si quieren cambiarlo luego otra vez
        /*if (this.coming !== 'new-field' && this.coming !== 'fields-edit') {
          L.tileLayer('https://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}', {
            maxZoom: 20,
            subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
          }).addTo(this.map);
        } else {*/
        L.tileLayer('https://api.mapbox.com/styles/v1/nutricontrol/cm49qm88k01cu01sdf8qfda4t/tiles/256/{z}/{x}/{y}@2x?access_token=' +
            this.environment.getMapboxToken(), {
            maxZoom: 20,
            attribution: '&copy; <a href="https://www.mapbox.com/">Mapbox</a>'
        }).addTo(this.map);
        if (this.coming === 'new-field') {
            this.checkGeolocationPermission();
        }
        /*}*/
        setTimeout(() => {
            this.map.invalidateSize();
        }, 500);
        if (this.coming === 'fields-general') {
            if (Array.isArray(this.fields)) {
                for (const finca of this.fields) {
                    const icon = this.terminalsLib.getFieldNativeMarker(finca.field.irrgationStatus);
                    this.fieldsMethod(finca.field, icon);
                }
            }
        }
        if (this.coming === 'terminals-general') {
            if (Array.isArray(this.fields)) {
                for (const terminal of this.fields) {
                    if (terminal.latitude != null && terminal.longitude != null) {
                        let icon;
                        if (terminal.type >= 20 && terminal.type < 30) {
                            icon = this.terminalsLib.getIrrigationNativeMarker(terminal.irrgationStatus);
                        }
                        else {
                            icon = this.terminalsLib.getNativeMarker(terminal.type);
                        }
                        this.addMarker(icon, terminal, terminal, 'terminal');
                    }
                }
            }
        }
        if (this.coming === 'fields-dashboard') {
            this.fieldsMethod(this.field.field, null);
            for (const terminal of this.field.terminals) {
                if (terminal.latitude != null && terminal.longitude != null) {
                    const icon = this.terminalsLib.getNativeMarker(terminal.type);
                    this.addMarker(icon, terminal, terminal, 'terminal');
                }
            }
            for (const valve of this.field.allValves) {
                if (valve.latitude != null && valve.longitude != null) {
                    const icon = this.terminalsLib.getIrrigationValveNativeMarker(valve.active);
                    this.addMarker(icon, valve, valve, 'valve');
                }
            }
        }
        if (this.coming === 'new-field') {
            this.addResetButton();
            this.map.on('click', (e) => {
                this.onMapClick(e);
            });
        }
        if (this.coming === 'fields-edit') {
            console.log(this.fields);
            this.fieldsMethod(this.field, null);
            this.addResetButton();
        }
        if (this.coming === 'terminals-activation' ||
            this.coming === 'terminals-edit') {
            if (this.terminalData.field !== undefined &&
                this.terminalData.field !== null &&
                this.terminalData.field.coordinates &&
                this.terminalData.field.coordinates.length > 0) {
                this.fieldsMethod(this.terminalData.field, null);
            }
            if (this.markerCoordinates !== null) {
                if (this.markerCoordinates.lat === null ||
                    this.markerCoordinates.lng === null) {
                    this.checkGeolocationPermission();
                }
                const icon = this.terminalsLib.getNativeMarker(this.terminalData.type);
                if (this.coming === 'terminals-activation') {
                    this.addMarker(icon, {
                        latitude: this.markerCoordinates.lat,
                        longitude: this.markerCoordinates.lng
                    }, this.terminalData.name, this.terminalData.type, false);
                }
                else {
                    if (this.allValves.length > 0) {
                        if (this.markerCoordinates.lat !== null &&
                            this.markerCoordinates.lng !== null) {
                            this.addMarker(icon, {
                                latitude: this.markerCoordinates.lat,
                                longitude: this.markerCoordinates.lng
                            }, this.terminalData.name, this.terminalData.type, false);
                        }
                        this.allValves.forEach((valve, index) => {
                            if (valve.latitude !== null && valve.longitude !== null) {
                                const valveIcon = this.environment.getBackend() +
                                    '/static/terminals-vect/valve.svg';
                                this.addMarker(valveIcon, valve, valve, 'valve', false);
                            }
                            if (index === this.allValves.length - 1) {
                                this.repositionValvesAndConcreteMarkers();
                            }
                        });
                    }
                    else {
                        this.addMarker(icon, {
                            latitude: this.markerCoordinates.lat,
                            longitude: this.markerCoordinates.lng
                        }, this.terminalData.name, this.terminalData.type, false);
                    }
                }
            }
        }
        if (this.coming === '360-config') {
            this.map.on('click', this.create360Coordinates.bind(this));
        }
        if (this.coming.includes('valves-edit')) {
            const icon = this.environment.getBackend() + '/static/terminals-vect/valve.svg';
            if (this.valve.latitude === null) {
                this.checkGeolocationPermission();
                this.positionMarkerWhenNoPreviouslLatLng(icon, this.valve, 'valve');
            }
            else {
                this.addMarker(icon, this.valve, this.valve, 'valve', false);
            }
        }
        //BACKOFFICE
        if (this.coming === 'irrigation_consulting') {
            this.fieldsMethod(this.fields, null);
        }
        if (this.coming === 'backoffice-edit') {
            if (this.markerCoordinates.lat === null ||
                this.markerCoordinates.lng === null) {
                this.checkGeolocationPermission();
                this.positionMarkerWhenNoPreviouslLatLng(null, this.backofficeTerminal.value, 'valve');
            }
            else {
                this.addMarker(null, this.backofficeTerminal.value, this.backofficeTerminal.value, 'valve', false);
            }
        }
        //
        if (this.allCoordinates.length > 0) {
            if (this.coming === 'fields-general' ||
                this.coming === 'terminals-general' ||
                this.coming === 'fields-dashboard') {
                this.map.addLayer(this.clusters);
            }
            const bounds = L.latLngBounds(this.allCoordinates);
            setTimeout(() => {
                this.map.fitBounds(bounds, { padding: [15, 15] });
            }, 200);
        }
    }
    create360Coordinates(e) {
        this.map.off('click');
        this.config360.emit(e.latlng);
        this.addMarker(null, {
            latitude: e.latlng.lat,
            longitude: e.latlng.lng
        }, null, null, false);
        /*const { lat, lng } = e.latlng;
        this.allVal
        this.addMarker()*/
    }
    addMarker(icon, fieldBounds, markerField, markerType, popup = true) {
        let customIcon;
        let marker;
        if (icon !== null) {
            customIcon = L.icon({
                iconUrl: icon,
                iconSize: [35, 40] // tamaño del ícono
            });
            marker = L.marker([fieldBounds.latitude, fieldBounds.longitude], {
                icon: customIcon
            });
        }
        else {
            marker = L.marker([fieldBounds.latitude, fieldBounds.longitude]);
        }
        if (this.coming === 'fields-general' ||
            this.coming === 'terminals-general' ||
            this.coming === 'fields-dashboard') {
            this.clusters.addLayer(marker);
        }
        else {
            marker.addTo(this.map);
        }
        if (popup === false &&
            (this.coming === 'terminals-activation' ||
                this.coming.includes('valves-edit') ||
                this.coming === 'backoffice-edit' ||
                this.coming === '360-config' ||
                (this.coming === 'terminals-edit' && this.allValves.length === 0))) {
            this.repositionMarker(icon);
            this.markerToEdit = marker;
        }
        else {
            if (popup === false &&
                this.coming === 'terminals-edit' &&
                this.allValves.length > 0) {
                if (markerField.valve) {
                    marker.id = markerField.valve;
                    marker.valve = true;
                }
                else {
                    marker.id = markerField;
                    marker.valve = false;
                }
                this.valvesMapMarkers.push(marker);
            }
            else {
                marker.id =
                    fieldBounds.latitude +
                        '_' +
                        fieldBounds.longitude +
                        '_' +
                        markerField;
                marker.on('click', () => this.onMarkerClick(markerField, markerType));
            }
        }
        this.allMarkers.push([
            Number(fieldBounds.latitude),
            Number(fieldBounds.longitude)
        ]);
        this.allCoordinates.push([
            Number(fieldBounds.latitude),
            Number(fieldBounds.longitude)
        ]);
    }
    repositionValvesAndConcreteMarkers() {
        let markerToChange;
        let valveId;
        let isValve;
        let matchingMarker;
        setInterval(() => {
            matchingMarker = this.valvesMapMarkers.find((marker) => marker.id === this.selectedValveToEdit);
            this.valvesMapMarkers.forEach((mark) => {
                if (mark.id === this.selectedValveToEdit) {
                    if (!mark.isBouncing()) {
                        markerToChange = mark;
                        valveId = mark.id;
                        isValve = mark.valve;
                        mark.setBouncingOptions({ bounceSpeed: 100 });
                        mark.bounce();
                    }
                }
                else {
                    mark.stopBouncing();
                }
            });
        }, 100);
        this.map.on('click', (e) => {
            if (this.selectedValveToEdit !== '') {
                let icon;
                let markerField;
                if (!matchingMarker) {
                    isValve =
                        this.allValves.find((valve) => Number(valve.valve) === Number(this.selectedValveToEdit)) || false;
                }
                if (isValve === false) {
                    markerField = this.selectedValveToEdit;
                    icon = this.terminalsLib.getNativeMarker(this.terminalData.type);
                }
                else {
                    markerField = {
                        valve: this.selectedValveToEdit
                    };
                    icon =
                        this.environment.getBackend() + '/static/terminals-vect/valve.svg';
                }
                //si no hay marcador previo no puedo borrarlo
                if (matchingMarker) {
                    this.map.removeLayer(markerToChange);
                }
                else {
                    matchingMarker = true;
                }
                // Crea un nuevo marcador en la posición clicada
                this.addMarker(icon, {
                    latitude: e.latlng.lat,
                    longitude: e.latlng.lng
                }, markerField, this.terminalData.type, false);
                if (!isValve) {
                    this.terminalsEdit.emit(e.latlng.lat + ',' + e.latlng.lng);
                }
                else {
                    let contador = this.allValves.length;
                    this.allValves.forEach((valve) => {
                        if (Number(valve.valve) === Number(this.selectedValveToEdit)) {
                            valve.latitude = Number(e.latlng.lat);
                            valve.longitude = Number(e.latlng.lng);
                            valve.position = Number(valve.valve) + 1;
                            contador--;
                            if (contador === 0) {
                                this.changeAllValves.emit(this.allValves);
                            }
                        }
                        else {
                            valve.position = Number(valve.valve) + 1;
                            contador--;
                            if (contador === 0) {
                                this.changeAllValves.emit(this.allValves);
                            }
                        }
                    });
                }
            }
        });
    }
    repositionMarker(icon) {
        this.map.on('click', (e) => {
            let name;
            let type;
            if (this.markerToEdit) {
                this.map.removeLayer(this.markerToEdit);
            }
            if (this.terminalData && this.terminalData.name) {
                name = this.terminalData.name;
                type = this.terminalData.type;
            }
            else {
                if (this.valve && this.valve.valve) {
                    name = this.valve.valve;
                    type = 'valve';
                }
                else {
                    name = 'device';
                    type = 'valve';
                }
            }
            // Crea un nuevo marcador en la posición clicada
            this.addMarker(icon, {
                latitude: e.latlng.lat,
                longitude: e.latlng.lng
            }, name, type, false);
            //reposicionamos también en lo que es el formulario para que lo guarde
            if (this.coming === 'terminals-activation') {
                this.terminalsActivation.emit(e.latlng.lat + ',' + e.latlng.lng);
                /*this.terminalActivation.fillData.patchValue({
                  coordinates: e.latlng.lat + ',' + e.latlng.lng,
                });*/
            }
            if (this.coming === '360-config') {
                this.config360.emit(e.latlng);
            }
            if (this.coming === 'terminals-edit') {
                this.terminalsEdit.emit(e.latlng.lat + ',' + e.latlng.lng);
            }
            if (this.coming === 'backoffice-edit') {
                this.backofficeTerminal.patchValue({
                    latitude: e.latlng.lat,
                    longitude: e.latlng.lng
                });
                this.backofficeEvent.emit(this.backofficeTerminal);
            }
            if (this.coming.includes('valves-edit')) {
                this.valve.latitude = e.latlng.lat;
                this.valve.longitude = e.latlng.lng;
                this.valve.position = Number(this.valve.valve) + 1;
                this.changeValve.emit(this.valve);
            }
        });
    }
    positionMarkerWhenNoPreviouslLatLng(icon, data, type) {
        this.map.on('click', (e) => {
            this.map.off('click'); // Deshabilitar futuros clics que creen un marker sin nada
            const marker = this.addMarker(icon, {
                latitude: e.latlng.lat,
                longitude: e.latlng.lng
            }, data, type, false);
        });
    }
    fieldsMethod(field, icon) {
        const ws_coords = [];
        for (let x = 0; x < field.coordinates.length; x++) {
            ws_coords.push([
                field.coordinates[x].latitude,
                field.coordinates[x].longitude
            ]);
            this.allCoordinates.push([
                Number(field.coordinates[x].latitude),
                Number(field.coordinates[x].longitude)
            ]);
        }
        const polygon = L.polygon(ws_coords, {
            color: field.color,
            fillColor: field.color,
            fillOpacity: 0.35
        }).addTo(this.map);
        const center = polygon.getBounds().getCenter();
        const centerData = {
            latitude: center.lat,
            longitude: center.lng
        };
        if (this.coming === 'fields-edit') {
            this.polygon = polygon;
        }
        if (icon !== null) {
            this.addMarker(icon, centerData, field, 'field');
        }
    }
    onMarkerClick(field, type) {
        switch (type) {
            case 'field':
                this.selectedMarkerData = field;
                this.fieldsModal.present();
                break;
            case 'terminal':
                this.selectedMarkerData = field;
                this.terminalsModal.present();
                break;
            case 'valve':
                this.selectedMarkerData = field;
                this.valvesModal.present();
                break;
        }
    }
    onMapClick(e) {
        const { lat, lng } = e.latlng;
        if (this.markers.length > 0 && this.isClickOnFirstMarker(e.latlng)) {
            this.finishPolygon();
            return;
        }
        this.polygonCoordinates.push(e.latlng);
        const marker = L.circleMarker([lat, lng], {
            radius: 5,
            color: 'white',
            fillColor: this.colorField,
            fillOpacity: 0.5
        }).addTo(this.map);
        this.markers.push(marker);
        if (this.polygonCoordinates.length > 1) {
            if (this.polyline) {
                this.map.removeLayer(this.polyline);
            }
            this.polyline = L.polyline(this.polygonCoordinates, {
                color: this.colorField
            }).addTo(this.map);
        }
    }
    isClickOnFirstMarker(latlng) {
        const firstMarkerLatLng = this.polygonCoordinates[0];
        const distance = latlng.distanceTo(firstMarkerLatLng); // Calcula la distancia al primer marcador
        return distance < 15; // Un pequeño margen para detectar el clic
    }
    finishPolygon() {
        if (this.polygonCoordinates.length > 2) {
            if (this.polyline) {
                this.map.removeLayer(this.polyline);
            }
            if (this.coming === 'fields-edit') {
                this.polygon = L.polygon(this.polygonCoordinates, {
                    color: this.field['color']
                }).addTo(this.map);
                this.editedFieldCoordinates.emit(this.polygonCoordinates);
                this.fieldSize.emit(this.calculatePolygonArea(this.polygon.getLatLngs()[0]));
            }
            else {
                this.polygon = L.polygon(this.polygonCoordinates, {
                    color: this.colorField
                }).addTo(this.map);
                this.fieldsNew.emit(this.polygonCoordinates);
            }
            this.map.off('click'); // Deshabilitar futuros clics si no deseas más interacción
        }
    }
    checkGeolocationPermission() {
        if (navigator.permissions) {
            // Verificar el estado de los permisos de geolocalización
            navigator.permissions
                .query({ name: 'geolocation' })
                .then((permissionStatus) => {
                if (permissionStatus.state === 'granted') {
                    // Si el permiso está concedido, obtener directamente la ubicación
                    this.getCurrentLocation();
                }
                else if (permissionStatus.state === 'prompt') {
                    // Si el permiso necesita ser solicitado, pedir la ubicación
                    this.getCurrentLocation();
                }
                else if (permissionStatus.state === 'denied') {
                    this.map.setView([40.4637, -3.7492], 6);
                }
                // Escuchar cualquier cambio en el estado del permiso
                permissionStatus.onchange = () => {
                    if (permissionStatus.state === 'granted') {
                        this.getCurrentLocation();
                    }
                };
            });
        }
        else {
            // Si `navigator.permissions` no está disponible, solicitar la ubicación directamente
            this.getCurrentLocation();
        }
    }
    getCurrentLocation() {
        this.map.locate({ setView: true, maxZoom: 16 });
        this.map.on('locationfound', (e) => {
            this.allCoordinates.push([Number(e.latlng.lat), Number(e.latlng.lng)]);
            const bounds = L.latLngBounds(this.allCoordinates);
            setTimeout(() => {
                this.map.fitBounds(bounds, { padding: [15, 15] });
            }, 200);
        });
    }
    resetMap() {
        // Remover todos los marcadores
        this.markers.forEach((marker) => {
            this.map.removeLayer(marker);
        });
        this.markers = [];
        // Remover la línea temporal
        if (this.polyline) {
            this.map.removeLayer(this.polyline);
            this.polyline = null;
        }
        // Remover el polígono
        if (this.polygon) {
            this.map.removeLayer(this.polygon);
            this.polygon = null;
        }
        // Vaciar las coordenadas del polígono
        this.polygonCoordinates = [];
        // Volver a activar los clics en el mapa
        this.map.on('click', (e) => {
            this.onMapClick(e);
        });
    }
    addResetButton() {
        const resetButton = L.control({ position: 'topright' });
        resetButton.onAdd = () => {
            const button = L.DomUtil.create('button', '');
            button.innerHTML = this.translationsLib.get('reset');
            button.style.padding = '8px';
            button.style.backgroundColor = 'white';
            button.style.border = '2px solid black';
            // Evitar que el clic en el botón haga clic en el mapa
            L.DomEvent.on(button, 'click', (e) => {
                L.DomEvent.stopPropagation(e); // Evitar que el clic en el botón se propague al mapa
                this.resetMap();
            });
            return button;
        };
        resetButton.addTo(this.map);
    }
    calculatePolygonArea(latlngs) {
        const earthRadius = 6378137; // Radio de la Tierra en metros
        let area = 0;
        if (latlngs.length > 2) {
            for (let i = 0, len = latlngs.length; i < len; i++) {
                const p1 = latlngs[i];
                const p2 = latlngs[(i + 1) % len];
                if (p1.lat !== null &&
                    p2.lat !== null &&
                    p1.lng !== null &&
                    p2.lng !== null) {
                    area +=
                        this.toRadians(p2.lng - p1.lng) *
                            (2 +
                                Math.sin(this.toRadians(p1.lat)) +
                                Math.sin(this.toRadians(p2.lat)));
                }
            }
            area = (area * earthRadius * earthRadius) / 2.0;
        }
        return Math.abs(Number((area / 10000).toFixed(2)));
    }
    toRadians(degrees) {
        return (degrees * Math.PI) / 180;
    }
    toNumber(data) {
        return Number(data);
    }
}
LeafletMapsComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: LeafletMapsComponent, deps: [{ token: TerminalsLibService }, { token: TranslationsLibService }, { token: PlatformLibService }, { token: i1$1.Router }, { token: i0.Renderer2 }, { token: EnvironmentService }], target: i0.ɵɵFactoryTarget.Component });
LeafletMapsComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: LeafletMapsComponent, selector: "lib-leaflet-maps", inputs: { fields: "fields", field: "field", coming: "coming", markerCoordinates: "markerCoordinates", terminalData: "terminalData", backofficeTerminal: "backofficeTerminal", allValves: "allValves", valve: "valve", selectedValve: "selectedValve", colorField: "colorField", selectedValveToEdit: "selectedValveToEdit" }, outputs: { fieldSize: "fieldSize", terminalsEdit: "terminalsEdit", terminalsActivation: "terminalsActivation", config360: "config360", editedFieldCoordinates: "editedFieldCoordinates", fieldsNew: "fieldsNew", changeValve: "changeValve", changeAllValves: "changeAllValves", backofficeEvent: "backofficeEvent" }, viewQueries: [{ propertyName: "terminalsModal", first: true, predicate: ["terminalsModal"], descendants: true }, { propertyName: "fieldsModal", first: true, predicate: ["fieldsModal"], descendants: true }, { propertyName: "valvesModal", first: true, predicate: ["valvesModal"], descendants: true }], ngImport: i0, template: "<link\n  rel=\"stylesheet\"\n  href=\"https://unpkg.com/leaflet@1.6.0/dist/leaflet.css\"\n  integrity=\"sha512-xwE/Az9zrjBIphAcBb3F6JVqxf46+CDLwfLMHloNu6KEQCAWi6HcDUbeOfBIptF7tcCzusKFjFw2yuvEpDL9wQ==\"\n  crossorigin=\"\"\n/>\n<script\n  src=\"https://unpkg.com/leaflet@1.6.0/dist/leaflet.js\"\n  integrity=\"sha512-gZwIG9x3wUXg2hdXF6+rVkLF/0Vi9U8D2Ntg4Ga5I5BZpVkVxlJWbSQtXPSiUTtC0TjtGOmxa1AJPuV0CPthew==\"\n  crossorigin=\"\"\n></script>\n<link\n  rel=\"stylesheet\"\n  href=\"https://unpkg.com/leaflet-geoman-free/dist/leaflet-geoman.css\"\n/>\n<script src=\"https://unpkg.com/leaflet-geoman-free/dist/leaflet-geoman.min.js\"></script>\n<script src=\"https://unpkg.com/leaflet.markercluster@1.4.1/dist/leaflet.markercluster.js\"></script>\n<link\n  rel=\"stylesheet\"\n  href=\"https://unpkg.com/leaflet.markercluster@1.4.1/dist/MarkerCluster.Default.css\"\n/>\n<div style=\"position: relative\">\n  <div\n    [id]=\"this.coming\"\n    class=\"map\"\n    [ngClass]=\"{ 'pointer-none': showZoomInstructions }\"\n  ></div>\n  <div\n    id=\"zoom-instructions\"\n    *ngIf=\"showZoomInstructions\"\n    class=\"zoom-instructions\"\n  >\n    <span [innerHTML]=\"translationsLib.get('map_advice')\"></span>\n  </div>\n</div>\n<!--MODALES-->\n<ion-modal #terminalsModal [breakpoints]=\"[1]\">\n  <ng-template>\n    <div class=\"block align-self-center\">\n      <ion-buttons class=\"close-modal\">\n        <ion-button (click)=\"terminalsModal.dismiss()\">\n          <ion-icon name=\"close-circle-outline\"></ion-icon>\n        </ion-button>\n      </ion-buttons>\n\n      <div class=\"row mx-2 my-4 w-100\">\n        <div class=\"col-3\">\n          <img\n            src=\"{{ backend + '/' + selectedMarkerData.image_path }}\"\n            width=\"80px\"\n          />\n        </div>\n        <div class=\"col-9\">\n          <h2 class=\"mb-0\">{{ selectedMarkerData.name }}</h2>\n          <h4 class=\"text-muted\">\n            {{ selectedMarkerData.pretty_type_name }} -\n            {{ selectedMarkerData.vid }}\n          </h4>\n        </div>\n      </div>\n      <div class=\"row mx-2 my-4\">\n        <a\n          class=\"btn btn-primary\"\n          (click)=\"\n            terminalsModal.dismiss();\n            router.navigate([\n              terminalsLib.generateRoute(\n                selectedMarkerData.vid,\n                selectedMarkerData.type\n              )\n            ])\n          \"\n          >{{ this.translationsLib.get(\"view\") }}</a\n        >\n      </div>\n    </div>\n  </ng-template>\n</ion-modal>\n<ion-modal #fieldsModal [breakpoints]=\"[1]\">\n  <ng-template>\n    <div class=\"block align-self-center\">\n      <ion-buttons class=\"close-modal\">\n        <ion-button (click)=\"fieldsModal.dismiss()\">\n          <ion-icon name=\"close-circle-outline\"></ion-icon>\n        </ion-button>\n      </ion-buttons>\n\n      <div class=\"row mx-2 my-4 w-100\">\n        <div class=\"col-3\">\n          <img\n            src=\"../../../assets/img/Icons/Icono_UCROP_Finca.svg\"\n            width=\"80px\"\n          />\n        </div>\n        <div class=\"col-9\">\n          <h1>{{ selectedMarkerData.name }}</h1>\n        </div>\n      </div>\n      <div class=\"row mx-2 my-4\">\n        <a\n          class=\"btn btn-primary\"\n          (click)=\"\n            fieldsModal.dismiss();\n            router.navigate(['./field', { vid: selectedMarkerData.vid }])\n          \"\n          >{{ this.translationsLib.get(\"view\") }}</a\n        >\n      </div>\n    </div>\n  </ng-template>\n</ion-modal>\n<ion-modal #valvesModal [breakpoints]=\"[1]\">\n  <ng-template>\n    <ng-container *ngIf=\"selectedMarkerData.active\">\n      <div class=\"block-active align-self-center\">\n        <ion-buttons class=\"close-modal\">\n          <ion-button (click)=\"valvesModal.dismiss()\">\n            <ion-icon name=\"close-circle-outline\"></ion-icon>\n          </ion-button>\n        </ion-buttons>\n\n        <div class=\"row mx-2 my-4 w-100\">\n          <div class=\"col-3\">\n            <img\n              src=\"../../../assets/img/Icons/Icono_UCROP_Valvula.svg\"\n              width=\"80px\"\n            />\n          </div>\n          <div class=\"col-9\">\n            <h2>{{ selectedMarkerData.name }}</h2>\n            <div class=\"m-0 mb-1\">\n              <b>{{ this.translationsLib.get(\"irrigation_valve\") }}:</b>\n              {{ toNumber(selectedMarkerData.valve) + 1 }}\n            </div>\n            <div class=\"m-0 mb-1\">\n              <b>{{ this.translationsLib.get(\"irrigation_status\") }}:</b>\n              {{ this.translationsLib.get(\"irrigation_active\") }}\n              <ng-container\n                *ngIf=\"selectedMarkerData.irrigationParams.nameProgram !== '-'\"\n              >\n                ({{ selectedMarkerData.irrigationParams.nameProgram }}\n                {{\n                  this.translationsLib.get(\n                    \"reports_\" + selectedMarkerData.irrigationParams.phase\n                  )\n                }})\n              </ng-container>\n            </div>\n            <div\n              class=\"m-0 mb-1\"\n              *ngIf=\"\n                selectedMarkerData.irrigationParams.irrigated.quantity !== '-'\n              \"\n            >\n              <b>{{ this.translationsLib.get(\"irrigation_irrigated\") }}:</b>\n              {{ selectedMarkerData.irrigationParams.irrigated.quantity }}\n            </div>\n            <div\n              class=\"m-0 mb-1\"\n              *ngIf=\"selectedMarkerData.irrigationParams.irrigated.time !== '-'\"\n            >\n              <b\n                >{{ this.translationsLib.get(\"irrigation_irrigated_time\") }}:</b\n              >\n              {{ selectedMarkerData.irrigationParams.irrigated.time }}\n            </div>\n            <div\n              class=\"m-0 mb-1\"\n              *ngIf=\"selectedMarkerData.irrigationParams.remaining !== '-'\"\n            >\n              <b\n                >{{ this.translationsLib.get(\"irrigation_remaining_time\") }}:</b\n              >\n              {{ selectedMarkerData.irrigationParams.remaining }}\n            </div>\n            <div\n              class=\"m-0 mb-1\"\n              *ngIf=\"selectedMarkerData.irrigationParams.activations !== '-'\"\n            >\n              <b>{{ this.translationsLib.get(\"irrigation_activations\") }}:</b>\n              {{ selectedMarkerData.irrigationParams.activations }}\n              ({{\n                translationsLib.get(\n                  \"reports_activation_\" +\n                    selectedMarkerData.irrigationParams.startedBy\n                )\n              }})\n            </div>\n            <div\n              class=\"m-0 mb-1\"\n              *ngIf=\"selectedMarkerData.irrigationParams.activeGroup !== '-'\"\n            >\n              <b>{{ this.translationsLib.get(\"irrigation_active_group\") }}:</b>\n              <ng-container *ngFor=\"let group of selectedMarkerData.groups\">\n                <ng-container *ngIf=\"group.name && group.name.trim()\">\n                  {{ group.name }}\n                </ng-container>\n                <ng-container *ngIf=\"!group.name || !group.name.trim()\">\n                  {{ group.group + 1 }}\n                </ng-container>\n              </ng-container>\n            </div>\n          </div>\n        </div>\n        <!--<div class=\"row mx-2 my-4\" >\n          <a class=\"btn btn-primary\" href=\"'/field;vid=' + {{selectedMarkerData.vid}}\">{{this.translationsLib.get('view')}}</a>\n        </div>-->\n      </div>\n    </ng-container>\n    <ng-container *ngIf=\"!selectedMarkerData.active\">\n      <div class=\"block align-self-center\">\n        <ion-buttons class=\"close-modal\">\n          <ion-button (click)=\"valvesModal.dismiss()\">\n            <ion-icon name=\"close-circle-outline\"></ion-icon>\n          </ion-button>\n        </ion-buttons>\n        <div class=\"row mx-2 my-4 w-100\">\n          <div class=\"col-3\">\n            <img\n              src=\"../../../assets/img/Icons/Icono_UCROP_Valvula.svg\"\n              width=\"80px\"\n            />\n          </div>\n          <div class=\"col-9\">\n            <h2>{{ selectedMarkerData.name }}</h2>\n            <div class=\"m-0 mb-1\">\n              <b>{{ this.translationsLib.get(\"irrigation_valve\") }}:</b>\n              {{ toNumber(selectedMarkerData.valve) + 1 }}\n            </div>\n            <div class=\"m-0 mb-1\">\n              <b>{{ this.translationsLib.get(\"irrigation_status\") }}:</b>\n              {{ this.translationsLib.get(\"irrigation_inactive\") }}\n            </div>\n          </div>\n        </div>\n      </div>\n    </ng-container>\n  </ng-template>\n</ion-modal>\n", styles: ["@media (max-width: 800px){.map{height:300px;width:100%;border-radius:.5rem;position:relative}}@media (min-width: 800px){.map{height:500px;width:100%;border-radius:.5rem;position:relative}}.pointer-none{pointer-events:none}::ng-deep .leaflet-control-attribution{display:none}ion-modal{--height: auto;--width: auto;--border-radius: 15px}ion-modal ::ng-deep .ion-page{padding:10px}.zoom-instructions{position:absolute;top:200px;left:20%;right:20%;background:white;padding:10px;z-index:1000;border:1px solid #ccc;width:fit-content;margin:auto;border-radius:12px;pointer-events:none!important}.zoom-instructions ::ng-deep p{margin-bottom:0}#resetMapNative{background-color:#fff;color:#000;position:absolute;right:10px;top:380px;max-width:40px}.close-modal{position:absolute;top:5px;right:0}.close-modal ion-button{font-size:20px}\n"], dependencies: [{ kind: "directive", type: i5.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i5.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i6.IonButton, selector: "ion-button", inputs: ["buttonType", "color", "disabled", "download", "expand", "fill", "form", "href", "mode", "rel", "routerAnimation", "routerDirection", "shape", "size", "strong", "target", "type"] }, { kind: "component", type: i6.IonButtons, selector: "ion-buttons", inputs: ["collapse"] }, { kind: "component", type: i6.IonIcon, selector: "ion-icon", inputs: ["color", "flipRtl", "icon", "ios", "lazy", "md", "mode", "name", "sanitize", "size", "src"] }, { kind: "component", type: i6.IonModal, selector: "ion-modal", inputs: ["animated", "keepContentsMounted", "backdropBreakpoint", "backdropDismiss", "breakpoints", "canDismiss", "cssClass", "enterAnimation", "event", "handle", "handleBehavior", "initialBreakpoint", "isOpen", "keyboardClose", "leaveAnimation", "mode", "presentingElement", "showBackdrop", "swipeToClose", "translucent", "trigger"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: LeafletMapsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'lib-leaflet-maps', template: "<link\n  rel=\"stylesheet\"\n  href=\"https://unpkg.com/leaflet@1.6.0/dist/leaflet.css\"\n  integrity=\"sha512-xwE/Az9zrjBIphAcBb3F6JVqxf46+CDLwfLMHloNu6KEQCAWi6HcDUbeOfBIptF7tcCzusKFjFw2yuvEpDL9wQ==\"\n  crossorigin=\"\"\n/>\n<script\n  src=\"https://unpkg.com/leaflet@1.6.0/dist/leaflet.js\"\n  integrity=\"sha512-gZwIG9x3wUXg2hdXF6+rVkLF/0Vi9U8D2Ntg4Ga5I5BZpVkVxlJWbSQtXPSiUTtC0TjtGOmxa1AJPuV0CPthew==\"\n  crossorigin=\"\"\n></script>\n<link\n  rel=\"stylesheet\"\n  href=\"https://unpkg.com/leaflet-geoman-free/dist/leaflet-geoman.css\"\n/>\n<script src=\"https://unpkg.com/leaflet-geoman-free/dist/leaflet-geoman.min.js\"></script>\n<script src=\"https://unpkg.com/leaflet.markercluster@1.4.1/dist/leaflet.markercluster.js\"></script>\n<link\n  rel=\"stylesheet\"\n  href=\"https://unpkg.com/leaflet.markercluster@1.4.1/dist/MarkerCluster.Default.css\"\n/>\n<div style=\"position: relative\">\n  <div\n    [id]=\"this.coming\"\n    class=\"map\"\n    [ngClass]=\"{ 'pointer-none': showZoomInstructions }\"\n  ></div>\n  <div\n    id=\"zoom-instructions\"\n    *ngIf=\"showZoomInstructions\"\n    class=\"zoom-instructions\"\n  >\n    <span [innerHTML]=\"translationsLib.get('map_advice')\"></span>\n  </div>\n</div>\n<!--MODALES-->\n<ion-modal #terminalsModal [breakpoints]=\"[1]\">\n  <ng-template>\n    <div class=\"block align-self-center\">\n      <ion-buttons class=\"close-modal\">\n        <ion-button (click)=\"terminalsModal.dismiss()\">\n          <ion-icon name=\"close-circle-outline\"></ion-icon>\n        </ion-button>\n      </ion-buttons>\n\n      <div class=\"row mx-2 my-4 w-100\">\n        <div class=\"col-3\">\n          <img\n            src=\"{{ backend + '/' + selectedMarkerData.image_path }}\"\n            width=\"80px\"\n          />\n        </div>\n        <div class=\"col-9\">\n          <h2 class=\"mb-0\">{{ selectedMarkerData.name }}</h2>\n          <h4 class=\"text-muted\">\n            {{ selectedMarkerData.pretty_type_name }} -\n            {{ selectedMarkerData.vid }}\n          </h4>\n        </div>\n      </div>\n      <div class=\"row mx-2 my-4\">\n        <a\n          class=\"btn btn-primary\"\n          (click)=\"\n            terminalsModal.dismiss();\n            router.navigate([\n              terminalsLib.generateRoute(\n                selectedMarkerData.vid,\n                selectedMarkerData.type\n              )\n            ])\n          \"\n          >{{ this.translationsLib.get(\"view\") }}</a\n        >\n      </div>\n    </div>\n  </ng-template>\n</ion-modal>\n<ion-modal #fieldsModal [breakpoints]=\"[1]\">\n  <ng-template>\n    <div class=\"block align-self-center\">\n      <ion-buttons class=\"close-modal\">\n        <ion-button (click)=\"fieldsModal.dismiss()\">\n          <ion-icon name=\"close-circle-outline\"></ion-icon>\n        </ion-button>\n      </ion-buttons>\n\n      <div class=\"row mx-2 my-4 w-100\">\n        <div class=\"col-3\">\n          <img\n            src=\"../../../assets/img/Icons/Icono_UCROP_Finca.svg\"\n            width=\"80px\"\n          />\n        </div>\n        <div class=\"col-9\">\n          <h1>{{ selectedMarkerData.name }}</h1>\n        </div>\n      </div>\n      <div class=\"row mx-2 my-4\">\n        <a\n          class=\"btn btn-primary\"\n          (click)=\"\n            fieldsModal.dismiss();\n            router.navigate(['./field', { vid: selectedMarkerData.vid }])\n          \"\n          >{{ this.translationsLib.get(\"view\") }}</a\n        >\n      </div>\n    </div>\n  </ng-template>\n</ion-modal>\n<ion-modal #valvesModal [breakpoints]=\"[1]\">\n  <ng-template>\n    <ng-container *ngIf=\"selectedMarkerData.active\">\n      <div class=\"block-active align-self-center\">\n        <ion-buttons class=\"close-modal\">\n          <ion-button (click)=\"valvesModal.dismiss()\">\n            <ion-icon name=\"close-circle-outline\"></ion-icon>\n          </ion-button>\n        </ion-buttons>\n\n        <div class=\"row mx-2 my-4 w-100\">\n          <div class=\"col-3\">\n            <img\n              src=\"../../../assets/img/Icons/Icono_UCROP_Valvula.svg\"\n              width=\"80px\"\n            />\n          </div>\n          <div class=\"col-9\">\n            <h2>{{ selectedMarkerData.name }}</h2>\n            <div class=\"m-0 mb-1\">\n              <b>{{ this.translationsLib.get(\"irrigation_valve\") }}:</b>\n              {{ toNumber(selectedMarkerData.valve) + 1 }}\n            </div>\n            <div class=\"m-0 mb-1\">\n              <b>{{ this.translationsLib.get(\"irrigation_status\") }}:</b>\n              {{ this.translationsLib.get(\"irrigation_active\") }}\n              <ng-container\n                *ngIf=\"selectedMarkerData.irrigationParams.nameProgram !== '-'\"\n              >\n                ({{ selectedMarkerData.irrigationParams.nameProgram }}\n                {{\n                  this.translationsLib.get(\n                    \"reports_\" + selectedMarkerData.irrigationParams.phase\n                  )\n                }})\n              </ng-container>\n            </div>\n            <div\n              class=\"m-0 mb-1\"\n              *ngIf=\"\n                selectedMarkerData.irrigationParams.irrigated.quantity !== '-'\n              \"\n            >\n              <b>{{ this.translationsLib.get(\"irrigation_irrigated\") }}:</b>\n              {{ selectedMarkerData.irrigationParams.irrigated.quantity }}\n            </div>\n            <div\n              class=\"m-0 mb-1\"\n              *ngIf=\"selectedMarkerData.irrigationParams.irrigated.time !== '-'\"\n            >\n              <b\n                >{{ this.translationsLib.get(\"irrigation_irrigated_time\") }}:</b\n              >\n              {{ selectedMarkerData.irrigationParams.irrigated.time }}\n            </div>\n            <div\n              class=\"m-0 mb-1\"\n              *ngIf=\"selectedMarkerData.irrigationParams.remaining !== '-'\"\n            >\n              <b\n                >{{ this.translationsLib.get(\"irrigation_remaining_time\") }}:</b\n              >\n              {{ selectedMarkerData.irrigationParams.remaining }}\n            </div>\n            <div\n              class=\"m-0 mb-1\"\n              *ngIf=\"selectedMarkerData.irrigationParams.activations !== '-'\"\n            >\n              <b>{{ this.translationsLib.get(\"irrigation_activations\") }}:</b>\n              {{ selectedMarkerData.irrigationParams.activations }}\n              ({{\n                translationsLib.get(\n                  \"reports_activation_\" +\n                    selectedMarkerData.irrigationParams.startedBy\n                )\n              }})\n            </div>\n            <div\n              class=\"m-0 mb-1\"\n              *ngIf=\"selectedMarkerData.irrigationParams.activeGroup !== '-'\"\n            >\n              <b>{{ this.translationsLib.get(\"irrigation_active_group\") }}:</b>\n              <ng-container *ngFor=\"let group of selectedMarkerData.groups\">\n                <ng-container *ngIf=\"group.name && group.name.trim()\">\n                  {{ group.name }}\n                </ng-container>\n                <ng-container *ngIf=\"!group.name || !group.name.trim()\">\n                  {{ group.group + 1 }}\n                </ng-container>\n              </ng-container>\n            </div>\n          </div>\n        </div>\n        <!--<div class=\"row mx-2 my-4\" >\n          <a class=\"btn btn-primary\" href=\"'/field;vid=' + {{selectedMarkerData.vid}}\">{{this.translationsLib.get('view')}}</a>\n        </div>-->\n      </div>\n    </ng-container>\n    <ng-container *ngIf=\"!selectedMarkerData.active\">\n      <div class=\"block align-self-center\">\n        <ion-buttons class=\"close-modal\">\n          <ion-button (click)=\"valvesModal.dismiss()\">\n            <ion-icon name=\"close-circle-outline\"></ion-icon>\n          </ion-button>\n        </ion-buttons>\n        <div class=\"row mx-2 my-4 w-100\">\n          <div class=\"col-3\">\n            <img\n              src=\"../../../assets/img/Icons/Icono_UCROP_Valvula.svg\"\n              width=\"80px\"\n            />\n          </div>\n          <div class=\"col-9\">\n            <h2>{{ selectedMarkerData.name }}</h2>\n            <div class=\"m-0 mb-1\">\n              <b>{{ this.translationsLib.get(\"irrigation_valve\") }}:</b>\n              {{ toNumber(selectedMarkerData.valve) + 1 }}\n            </div>\n            <div class=\"m-0 mb-1\">\n              <b>{{ this.translationsLib.get(\"irrigation_status\") }}:</b>\n              {{ this.translationsLib.get(\"irrigation_inactive\") }}\n            </div>\n          </div>\n        </div>\n      </div>\n    </ng-container>\n  </ng-template>\n</ion-modal>\n", styles: ["@media (max-width: 800px){.map{height:300px;width:100%;border-radius:.5rem;position:relative}}@media (min-width: 800px){.map{height:500px;width:100%;border-radius:.5rem;position:relative}}.pointer-none{pointer-events:none}::ng-deep .leaflet-control-attribution{display:none}ion-modal{--height: auto;--width: auto;--border-radius: 15px}ion-modal ::ng-deep .ion-page{padding:10px}.zoom-instructions{position:absolute;top:200px;left:20%;right:20%;background:white;padding:10px;z-index:1000;border:1px solid #ccc;width:fit-content;margin:auto;border-radius:12px;pointer-events:none!important}.zoom-instructions ::ng-deep p{margin-bottom:0}#resetMapNative{background-color:#fff;color:#000;position:absolute;right:10px;top:380px;max-width:40px}.close-modal{position:absolute;top:5px;right:0}.close-modal ion-button{font-size:20px}\n"] }]
        }], ctorParameters: function () { return [{ type: TerminalsLibService }, { type: TranslationsLibService }, { type: PlatformLibService }, { type: i1$1.Router }, { type: i0.Renderer2 }, { type: EnvironmentService }]; }, propDecorators: { fields: [{
                type: Input
            }], field: [{
                type: Input
            }], coming: [{
                type: Input
            }], markerCoordinates: [{
                type: Input
            }], terminalData: [{
                type: Input
            }], backofficeTerminal: [{
                type: Input
            }], allValves: [{
                type: Input
            }], valve: [{
                type: Input
            }], selectedValve: [{
                type: Input
            }], colorField: [{
                type: Input
            }], selectedValveToEdit: [{
                type: Input
            }], fieldSize: [{
                type: Output
            }], terminalsEdit: [{
                type: Output
            }], terminalsActivation: [{
                type: Output
            }], config360: [{
                type: Output
            }], editedFieldCoordinates: [{
                type: Output
            }], fieldsNew: [{
                type: Output
            }], changeValve: [{
                type: Output
            }], changeAllValves: [{
                type: Output
            }], backofficeEvent: [{
                type: Output
            }], terminalsModal: [{
                type: ViewChild,
                args: ['terminalsModal']
            }], fieldsModal: [{
                type: ViewChild,
                args: ['fieldsModal']
            }], valvesModal: [{
                type: ViewChild,
                args: ['valvesModal']
            }] } });

class MapsModule {
}
MapsModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: MapsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
MapsModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: MapsModule, declarations: [LeafletMapsComponent], imports: [CommonModule,
        FormsModule,
        ReactiveFormsModule,
        IonicModule,
        RouterModule], exports: [LeafletMapsComponent] });
MapsModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: MapsModule, providers: [LeafletMapsComponent], imports: [CommonModule,
        FormsModule,
        ReactiveFormsModule,
        IonicModule,
        RouterModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: MapsModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [LeafletMapsComponent],
                    imports: [
                        CommonModule,
                        FormsModule,
                        ReactiveFormsModule,
                        IonicModule,
                        RouterModule
                    ],
                    exports: [LeafletMapsComponent],
                    providers: [LeafletMapsComponent],
                    schemas: [CUSTOM_ELEMENTS_SCHEMA]
                }]
        }] });

class BottomTabsComponent {
    constructor(commonsService, platformLib, translationsLib, router) {
        this.commonsService = commonsService;
        this.platformLib = platformLib;
        this.translationsLib = translationsLib;
        this.router = router;
        this.isMenuOpen = false;
        this.ready = false;
        this.fix20pxMarginTop = false;
        this.currentRoute = '';
    }
    ngOnInit() {
        this.fix20pxMarginTop = this.platformLib.isPad();
        this.commonsService
            .getMenu(this.platform === 'my-ucrop' ? '?mode=my-ucrop' : '')
            .subscribe((res) => {
            this.menu = res.layout_configuration.bottom_tabs;
            this.ready = true;
        });
        this.currentRoute = this.router.url;
        this.router.events
            .pipe(filter((event) => event instanceof NavigationEnd))
            .subscribe((event) => {
            this.currentRoute = event.urlAfterRedirects;
        });
    }
    // Use `router.navigate` instead of `routerLink` to avoid needing route configuration in the library,
    // keeping route management centralized in the main app.
    navigateTo(path) {
        this.router.navigate([path]);
    }
}
BottomTabsComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BottomTabsComponent, deps: [{ token: AppCommonsService }, { token: PlatformLibService }, { token: TranslationsLibService }, { token: i1$1.Router }], target: i0.ɵɵFactoryTarget.Component });
BottomTabsComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: BottomTabsComponent, selector: "lib-bottom-tabs", inputs: { isMenuOpen: "isMenuOpen", platform: "platform" }, ngImport: i0, template: "<ng-container *ngIf=\"ready === true\">\n  <aside\n    id=\"bottom-tabs-main-container\"\n    [ngClass]=\"{\n      fix20pxMarginTop: fix20pxMarginTop === true,\n      'ucrop-theme': platform === 'ucrop',\n      'backoffice-theme': platform === 'backoffice',\n      'my-ucrop-theme': platform === 'my-ucrop'\n    }\"\n  >\n    <div class=\"row\">\n      <div\n        *ngFor=\"let tab of menu\"\n        [class.selected]=\"currentRoute === '/' + tab.page && !isMenuOpen\"\n        class=\"col\"\n      >\n        <a (click)=\"navigateTo(tab.page)\">\n          <div class=\"row\">\n            <div class=\"col-12 text-center\">\n              <ion-icon name=\"{{ tab.icon }}\"></ion-icon>\n            </div>\n            <div class=\"col-12 text-center bottom-tab-name p-0\">\n              {{ tab.title }}\n            </div>\n          </div>\n        </a>\n      </div>\n      <div class=\"col\" [class.selected]=\"isMenuOpen\">\n        <div class=\"row\">\n          <div class=\"col-12 text-center\">\n            <ion-menu-button></ion-menu-button>\n          </div>\n          <div class=\"col-12 text-center bottom-tab-name p-0\" id=\"menu-text\">\n            <ion-menu-toggle>\n              {{ translationsLib.get(\"sidebar_menu\") }}\n            </ion-menu-toggle>\n          </div>\n        </div>\n      </div>\n    </div>\n  </aside>\n</ng-container>\n", styles: ["#bottom-tabs-main-container{position:absolute;inset:0}#bottom-tabs-main-container .col{position:relative;height:60px}#bottom-tabs-main-container .col ion-icon{font-size:1.5rem;position:relative;top:.5rem}#bottom-tabs-main-container .col #menu-text{position:relative;top:2px}#bottom-tabs-main-container .col ion-menu-button{font-size:1.8rem;top:.4rem;position:relative}#bottom-tabs-main-container .bottom-tab-name{overflow:hidden;height:18px}@media only screen and (max-width: 991px) and (orientation: landscape){#bottom-tabs-main-container .bottom-tab-name{display:none}}#bottom-tabs-main-container.fix20pxMarginTop{top:-20px!important}#bottom-tabs-main-container.ucrop-theme{background-color:var(--menu-ucrop-bg)}#bottom-tabs-main-container.ucrop-theme .col a,#bottom-tabs-main-container.ucrop-theme .col #menu-text{color:var(--menu-ucrop-text)}#bottom-tabs-main-container.ucrop-theme .col ion-icon,#bottom-tabs-main-container.ucrop-theme .col ion-menu-button{color:var(--menu-ucrop-icon)}#bottom-tabs-main-container.ucrop-theme .col ion-menu-button:hover{color:var(--menu-ucrop-hover)}#bottom-tabs-main-container.ucrop-theme .col.selected{background-color:var(--menu-ucrop-hover)!important}#bottom-tabs-main-container.ucrop-theme .col.selected a,#bottom-tabs-main-container.ucrop-theme .col.selected ion-icon,#bottom-tabs-main-container.ucrop-theme .col.selected #menu-text,#bottom-tabs-main-container.ucrop-theme .col.selected ion-menu-button{color:#fff}#bottom-tabs-main-container.my-ucrop-theme{background-color:var(--menu-my-ucrop-bg)}#bottom-tabs-main-container.my-ucrop-theme .col a,#bottom-tabs-main-container.my-ucrop-theme .col #menu-text{color:var(--menu-my-ucrop-text)}#bottom-tabs-main-container.my-ucrop-theme .col ion-icon,#bottom-tabs-main-container.my-ucrop-theme .col ion-menu-button{color:var(--menu-my-ucrop-icon)}#bottom-tabs-main-container.my-ucrop-theme .col ion-menu-button:hover{color:var(--menu-my-ucrop-hover)}#bottom-tabs-main-container.my-ucrop-theme .col.selected{background-color:var(--menu-my-ucrop-hover)!important}#bottom-tabs-main-container.my-ucrop-theme .col.selected a,#bottom-tabs-main-container.my-ucrop-theme .col.selected ion-icon,#bottom-tabs-main-container.my-ucrop-theme .col.selected #menu-text,#bottom-tabs-main-container.my-ucrop-theme .col.selected ion-menu-button{color:#fff}#bottom-tabs-main-container.backoffice-theme{background-color:var(--menu-backoffice-bg)}#bottom-tabs-main-container.backoffice-theme .col a,#bottom-tabs-main-container.backoffice-theme .col #menu-text{color:var(--menu-backoffice-text)}#bottom-tabs-main-container.backoffice-theme .col ion-icon,#bottom-tabs-main-container.backoffice-theme .col ion-menu-button{color:var(--menu-backoffice-icon)}#bottom-tabs-main-container.backoffice-theme .col ion-menu-button:hover{color:var(--menu-backoffice-hover)}#bottom-tabs-main-container.backoffice-theme .col.selected{background-color:var(--menu-backoffice-hover)!important}#bottom-tabs-main-container.backoffice-theme .col.selected a,#bottom-tabs-main-container.backoffice-theme .col.selected ion-icon,#bottom-tabs-main-container.backoffice-theme .col.selected #menu-text,#bottom-tabs-main-container.backoffice-theme .col.selected ion-menu-button{color:#fff}\n"], dependencies: [{ kind: "directive", type: i5.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i5.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i6.IonIcon, selector: "ion-icon", inputs: ["color", "flipRtl", "icon", "ios", "lazy", "md", "mode", "name", "sanitize", "size", "src"] }, { kind: "component", type: i6.IonMenuButton, selector: "ion-menu-button", inputs: ["autoHide", "color", "disabled", "menu", "mode", "type"] }, { kind: "component", type: i6.IonMenuToggle, selector: "ion-menu-toggle", inputs: ["autoHide", "menu"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: BottomTabsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'lib-bottom-tabs', template: "<ng-container *ngIf=\"ready === true\">\n  <aside\n    id=\"bottom-tabs-main-container\"\n    [ngClass]=\"{\n      fix20pxMarginTop: fix20pxMarginTop === true,\n      'ucrop-theme': platform === 'ucrop',\n      'backoffice-theme': platform === 'backoffice',\n      'my-ucrop-theme': platform === 'my-ucrop'\n    }\"\n  >\n    <div class=\"row\">\n      <div\n        *ngFor=\"let tab of menu\"\n        [class.selected]=\"currentRoute === '/' + tab.page && !isMenuOpen\"\n        class=\"col\"\n      >\n        <a (click)=\"navigateTo(tab.page)\">\n          <div class=\"row\">\n            <div class=\"col-12 text-center\">\n              <ion-icon name=\"{{ tab.icon }}\"></ion-icon>\n            </div>\n            <div class=\"col-12 text-center bottom-tab-name p-0\">\n              {{ tab.title }}\n            </div>\n          </div>\n        </a>\n      </div>\n      <div class=\"col\" [class.selected]=\"isMenuOpen\">\n        <div class=\"row\">\n          <div class=\"col-12 text-center\">\n            <ion-menu-button></ion-menu-button>\n          </div>\n          <div class=\"col-12 text-center bottom-tab-name p-0\" id=\"menu-text\">\n            <ion-menu-toggle>\n              {{ translationsLib.get(\"sidebar_menu\") }}\n            </ion-menu-toggle>\n          </div>\n        </div>\n      </div>\n    </div>\n  </aside>\n</ng-container>\n", styles: ["#bottom-tabs-main-container{position:absolute;inset:0}#bottom-tabs-main-container .col{position:relative;height:60px}#bottom-tabs-main-container .col ion-icon{font-size:1.5rem;position:relative;top:.5rem}#bottom-tabs-main-container .col #menu-text{position:relative;top:2px}#bottom-tabs-main-container .col ion-menu-button{font-size:1.8rem;top:.4rem;position:relative}#bottom-tabs-main-container .bottom-tab-name{overflow:hidden;height:18px}@media only screen and (max-width: 991px) and (orientation: landscape){#bottom-tabs-main-container .bottom-tab-name{display:none}}#bottom-tabs-main-container.fix20pxMarginTop{top:-20px!important}#bottom-tabs-main-container.ucrop-theme{background-color:var(--menu-ucrop-bg)}#bottom-tabs-main-container.ucrop-theme .col a,#bottom-tabs-main-container.ucrop-theme .col #menu-text{color:var(--menu-ucrop-text)}#bottom-tabs-main-container.ucrop-theme .col ion-icon,#bottom-tabs-main-container.ucrop-theme .col ion-menu-button{color:var(--menu-ucrop-icon)}#bottom-tabs-main-container.ucrop-theme .col ion-menu-button:hover{color:var(--menu-ucrop-hover)}#bottom-tabs-main-container.ucrop-theme .col.selected{background-color:var(--menu-ucrop-hover)!important}#bottom-tabs-main-container.ucrop-theme .col.selected a,#bottom-tabs-main-container.ucrop-theme .col.selected ion-icon,#bottom-tabs-main-container.ucrop-theme .col.selected #menu-text,#bottom-tabs-main-container.ucrop-theme .col.selected ion-menu-button{color:#fff}#bottom-tabs-main-container.my-ucrop-theme{background-color:var(--menu-my-ucrop-bg)}#bottom-tabs-main-container.my-ucrop-theme .col a,#bottom-tabs-main-container.my-ucrop-theme .col #menu-text{color:var(--menu-my-ucrop-text)}#bottom-tabs-main-container.my-ucrop-theme .col ion-icon,#bottom-tabs-main-container.my-ucrop-theme .col ion-menu-button{color:var(--menu-my-ucrop-icon)}#bottom-tabs-main-container.my-ucrop-theme .col ion-menu-button:hover{color:var(--menu-my-ucrop-hover)}#bottom-tabs-main-container.my-ucrop-theme .col.selected{background-color:var(--menu-my-ucrop-hover)!important}#bottom-tabs-main-container.my-ucrop-theme .col.selected a,#bottom-tabs-main-container.my-ucrop-theme .col.selected ion-icon,#bottom-tabs-main-container.my-ucrop-theme .col.selected #menu-text,#bottom-tabs-main-container.my-ucrop-theme .col.selected ion-menu-button{color:#fff}#bottom-tabs-main-container.backoffice-theme{background-color:var(--menu-backoffice-bg)}#bottom-tabs-main-container.backoffice-theme .col a,#bottom-tabs-main-container.backoffice-theme .col #menu-text{color:var(--menu-backoffice-text)}#bottom-tabs-main-container.backoffice-theme .col ion-icon,#bottom-tabs-main-container.backoffice-theme .col ion-menu-button{color:var(--menu-backoffice-icon)}#bottom-tabs-main-container.backoffice-theme .col ion-menu-button:hover{color:var(--menu-backoffice-hover)}#bottom-tabs-main-container.backoffice-theme .col.selected{background-color:var(--menu-backoffice-hover)!important}#bottom-tabs-main-container.backoffice-theme .col.selected a,#bottom-tabs-main-container.backoffice-theme .col.selected ion-icon,#bottom-tabs-main-container.backoffice-theme .col.selected #menu-text,#bottom-tabs-main-container.backoffice-theme .col.selected ion-menu-button{color:#fff}\n"] }]
        }], ctorParameters: function () { return [{ type: AppCommonsService }, { type: PlatformLibService }, { type: TranslationsLibService }, { type: i1$1.Router }]; }, propDecorators: { isMenuOpen: [{
                type: Input
            }], platform: [{
                type: Input
            }] } });

class SidebarComponent {
    constructor(router, commonsService, session, route, platformLib, environment) {
        this.router = router;
        this.commonsService = commonsService;
        this.session = session;
        this.route = route;
        this.platformLib = platformLib;
        this.environment = environment;
        this.mode = '';
        this.installerMenu = [];
        this.isNative = false;
    }
    ngOnInit() {
        switch (this.platform) {
            case 'my-ucrop':
                this.logo =
                    this.environment.getBackend() + '/static/logos/my_ucrop.svg';
                this.mode = '?mode=my-ucrop';
                break;
            case 'backoffice':
                this.logo =
                    this.environment.getBackend() +
                        '/static/logos/backoffice_negative.svg';
                break;
            default:
                this.logo =
                    this.environment.getBackend() + '/static/logos/ucrop_negative.svg';
                break;
        }
        this.isNative = this.platformLib.isNative();
        this.commonsService.getMenu(this.mode).subscribe((response) => {
            this.appPages = response.layout_configuration.upper_menu;
            this.appPages = Object.values(this.appPages);
            this.installerMenu = response.layout_configuration.bottom_menu;
            this.session.setHome(response.layout_configuration.home[0].page);
        });
        if (this.session.getImpersonated()) {
            Swal.fire({
                toast: true,
                icon: 'warning',
                title: 'Está conectado como: ' + this.session.getSessionEmail(),
                position: 'bottom-left',
                showConfirmButton: false,
                background: '#FFFF00',
                iconColor: '#000000',
                color: '#000000',
                timer: 300,
                width: 'auto',
                didOpen: () => {
                    Swal.toggleTimer();
                }
            });
        }
        setTimeout(() => {
            try {
                if (this.route.snapshot.firstChild.params.vid) {
                    this.selectItem({ vid: this.route.snapshot.firstChild.params.vid });
                }
            }
            catch (e) {
                console.log("[Sidebar]: Couldn't selectItem by vid");
            }
        }, 500);
    }
    goField(item) {
        this.router.navigate(['./field', { vid: item.vid }]);
    }
    goTerminal(item) {
        this.router.navigate(['./terminal', { vid: item.vid }]);
    }
    goHome() {
        const home = String(this.session.getHome());
        location.replace(home);
    }
    selectItem(item) {
        if (this.isSelected != null) {
            const oldSelected = document.getElementById(this.isSelected.vid);
            oldSelected.style.backgroundColor = '#224261';
            oldSelected.classList.remove('menu-item-active');
        }
        if (item !== '' && item !== 'fields') {
            const selected = document.getElementById(item.vid);
            if (selected) {
                selected.style.backgroundColor = '#ee7869';
                this.isSelected = item;
                selected.classList.add('menu-item-active');
            }
        }
        if (item === 'fields') {
            const selected = document.getElementById('mat-expansion-panel-header-0');
            if (selected !== null) {
                selected.style.backgroundColor = '#ee7869';
                selected.classList.add('menu-item-active');
                this.isSelected = { vid: 'mat-expansion-panel-header-0' };
            }
        }
    }
}
SidebarComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: SidebarComponent, deps: [{ token: i1$1.Router }, { token: AppCommonsService }, { token: SessionLibService }, { token: i1$1.ActivatedRoute }, { token: PlatformLibService }, { token: EnvironmentService }], target: i0.ɵɵFactoryTarget.Component });
SidebarComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: SidebarComponent, isStandalone: true, selector: "lib-sidebar", inputs: { platform: "platform" }, ngImport: i0, template: "<section\n  [ngClass]=\"{\n    'ucrop-theme': platform === 'ucrop',\n    'backoffice-theme': platform === 'backoffice',\n    'my-ucrop-theme': platform === 'my-ucrop'\n  }\"\n>\n  <aside id=\"main-logo\" (click)=\"goHome()\">\n    <picture>\n      <img src=\"{{ logo }}\" alt=\"Home\" />\n    </picture>\n  </aside>\n  <ion-list id=\"main-list\">\n    <ion-menu-toggle\n      auto-hide=\"false\"\n      *ngFor=\"let p of appPages; let i = index\"\n    >\n      <ion-item\n        routerDirection=\"root\"\n        [routerLink]=\"[p.page]\"\n        lines=\"none\"\n        detail=\"false\"\n        routerLinkActive=\"selected\"\n        (click)=\"selectItem('')\"\n        *ngIf=\"p.items.length === 0 || p.page === 'terminals-general'\"\n      >\n        <ion-icon\n          slot=\"start\"\n          [ios]=\"p.icon + '-outline'\"\n          [md]=\"p.icon + '-sharp'\"\n        ></ion-icon>\n        <ion-label>{{ p.title }}</ion-label>\n      </ion-item>\n\n      <mat-expansion-panel\n        *ngIf=\"p.items.length !== 0 && p.page !== 'terminals-general'\"\n        class=\"menu-expansion-panel\"\n        [disabled]=\"true\"\n        [expanded]=\"true\"\n      >\n        <mat-expansion-panel-header\n          (click)=\"router.navigate(['/fields-general'])\"\n          routerLinkActive=\"selected\"\n        >\n          <ion-item\n            routerDirection=\"root\"\n            lines=\"none\"\n            detail=\"false\"\n            routerLinkActive=\"selected\"\n            *ngIf=\"p.items.length !== 0\"\n            (click)=\"selectItem('fields')\"\n          >\n            <ion-icon\n              slot=\"start\"\n              [ios]=\"p.icon + '-outline'\"\n              [md]=\"p.icon + '-sharp'\"\n            ></ion-icon>\n            <ion-label>{{ p.title }}</ion-label>\n          </ion-item>\n        </mat-expansion-panel-header>\n        <ng-template matExpansionPanelContent>\n          <div *ngIf=\"p.page === 'fields-general'\">\n            <ion-item\n              id=\"{{ item.vid }}\"\n              routerDirection=\"root\"\n              (click)=\"selectItem(item)\"\n              [routerLink]=\"['./field', { vid: item.vid }]\"\n              *ngFor=\"let item of p.items\"\n              class=\"ionic-sidebar-items\"\n              menuClose\n              lines=\"none\"\n              detail=\"false\"\n            >\n              <ion-label class=\"sub-item-menu\">\n                <ion-icon\n                  slot=\"start\"\n                  [ios]=\"'flower-outline'\"\n                  [md]=\"'flower-sharp'\"\n                ></ion-icon>\n                <span>{{ item.name }}</span>\n              </ion-label>\n            </ion-item>\n          </div>\n        </ng-template>\n      </mat-expansion-panel>\n    </ion-menu-toggle>\n  </ion-list>\n\n  <div class=\"menu-separator-container\" *ngIf=\"installerMenu.length > 0\">\n    <div class=\"menu-separator\"></div>\n  </div>\n\n  <ion-list id=\"installer-list\" *ngIf=\"installerMenu.length > 0\">\n    <ion-menu-toggle auto-hide=\"false\" *ngFor=\"let p of installerMenu\">\n      <ion-item\n        routerDirection=\"root\"\n        [routerLink]=\"[p.page]\"\n        lines=\"none\"\n        detail=\"false\"\n        routerLinkActive=\"selected\"\n        (click)=\"selectItem('')\"\n        *ngIf=\"p.items.length === 0 || p.page === 'terminals-general'\"\n      >\n        <ion-icon\n          slot=\"start\"\n          [ios]=\"p.icon + '-outline'\"\n          [md]=\"p.icon + '-sharp'\"\n        ></ion-icon>\n        <ion-label>{{ p.title }}</ion-label>\n      </ion-item>\n\n      <mat-expansion-panel\n        *ngIf=\"p.items.length !== 0 && p.page !== 'terminals-general'\"\n        class=\"menu-expansion-panel\"\n        [disabled]=\"true\"\n        [expanded]=\"true\"\n      >\n        <mat-expansion-panel-header id=\"menu-expansion-panel-header\">\n          <ion-item\n            routerDirection=\"root\"\n            lines=\"none\"\n            detail=\"false\"\n            routerLinkActive=\"selected\"\n            *ngIf=\"p.items.length !== 0\"\n          >\n            <ion-icon\n              slot=\"start\"\n              [ios]=\"p.icon + '-outline'\"\n              [md]=\"p.icon + '-sharp'\"\n            ></ion-icon>\n            <ion-label>{{ p.title }}</ion-label>\n          </ion-item>\n        </mat-expansion-panel-header>\n        <ng-template matExpansionPanelContent>\n          <div *ngIf=\"p.page === 'fields'\">\n            <ion-item\n              id=\"{{ item.vid }}\"\n              [routerLink]=\"['./field', { vid: item.vid }]\"\n              routerLinkActive=\"'./field;vid='{{ +item.vid }} \"\n              (click)=\"selectItem(item)\"\n              *ngFor=\"let item of p.items\"\n              class=\"ionic-sidebar-items\"\n              menuClose\n              lines=\"none\"\n            >\n              <ion-label class=\"sub-item-menu-inferior\">{{\n                item.name\n              }}</ion-label>\n            </ion-item>\n          </div>\n        </ng-template>\n      </mat-expansion-panel>\n    </ion-menu-toggle>\n  </ion-list>\n</section>\n", styles: ["section{height:100%;position:relative;z-index:999}section #main-logo{padding:0 20px}section #main-logo picture{height:90px;position:relative;cursor:pointer;display:block;text-align:center}section ion-list{padding:20px 0}section ion-list ion-item{--background: transparent}section ion-list ion-item.md{--padding-start: 10px;--padding-end: 10px}section ion-list ion-item.md ion-label{font-weight:500;font-size:16px}section ion-list ion-item.ios{--padding-start: 16px;--padding-end: 16px}section ion-list ion-item.ios ion-icon{font-size:1rem}section ion-list ion-icon{margin-right:11px}section ion-list .menu-expansion-panel{box-shadow:none;background:transparent;border-radius:0!important}section ion-list .mat-expansion-panel-header{padding-left:0}section ion-list ::ng-deep .mat-expansion-panel-body{padding:0!important}section ion-list .sub-item-menu{margin-top:-6px!important;font-size:14px!important;padding-left:35px!important}section ion-list .sub-item-menu ion-icon{margin-top:0;margin-right:5px;position:relative;top:2px}section ion-list .sub-item-menu-inferior{margin-top:0!important;font-size:14px!important;padding-left:23px!important}section ion-list .ionic-sidebar-items{cursor:pointer;margin-top:0;margin-bottom:0}section.ucrop-theme{background:var(--menu-ucrop-bg)}section.ucrop-theme img{max-width:200px}section.ucrop-theme ion-list{background:var(--menu-ucrop-bg)}section.ucrop-theme ion-list ion-item{height:34px}section.ucrop-theme ion-list ion-item.selected{--background: var(--menu-ucrop-hover)}section.ucrop-theme ion-list ion-item ion-icon{margin-top:-5px;color:var(--menu-ucrop-icon)}section.ucrop-theme ion-list ion-item ion-label{margin-top:0;color:var(--menu-ucrop-text)}section.ucrop-theme ion-list ion-item .ionic-sidebar-items{height:34px}section.ucrop-theme ion-list .mat-expansion-panel-header{height:34px}section.my-ucrop-theme{background:var(--menu-my-ucrop-bg)}section.my-ucrop-theme img{margin-top:.75rem;max-width:215px}section.my-ucrop-theme ion-list{background:var(--menu-my-ucrop-bg)}section.my-ucrop-theme ion-list ion-item.selected{--background: var(--menu-my-ucrop-hover)}section.my-ucrop-theme ion-list ion-item.selected ion-icon,section.my-ucrop-theme ion-list ion-item.selected ion-label{color:#fff}section.my-ucrop-theme ion-list ion-item ion-icon{color:var(--menu-my-ucrop-icon)}section.my-ucrop-theme ion-list ion-item ion-label{color:var(--menu-my-ucrop-text)}section.backoffice-theme{background:var(--menu-backoffice-bg)}section.backoffice-theme img{margin-top:.75rem;max-width:170px}section.backoffice-theme ion-list{background:var(--menu-backoffice-bg)}section.backoffice-theme ion-list ion-item.selected{--background: var(--menu-backoffice-hover)}section.backoffice-theme ion-list ion-item.selected ion-icon,section.backoffice-theme ion-list ion-item.selected ion-label{color:#fff}section.backoffice-theme ion-list ion-item ion-icon{color:var(--menu-backoffice-icon)}section.backoffice-theme ion-list ion-item ion-label{color:var(--menu-backoffice-text)}section .menu-separator-container{background:var(--menu-ucrop-bg)}section .menu-separator-container .menu-separator{border-bottom:1px solid #4c667f;margin:0 .8rem}\n"], dependencies: [{ kind: "ngmodule", type: RouterModule }, { kind: "directive", type: i1$1.RouterLink, selector: ":not(a):not(area)[routerLink]", inputs: ["queryParams", "fragment", "queryParamsHandling", "state", "relativeTo", "preserveFragment", "skipLocationChange", "replaceUrl", "routerLink"] }, { kind: "directive", type: i1$1.RouterLinkActive, selector: "[routerLinkActive]", inputs: ["routerLinkActiveOptions", "ariaCurrentWhenActive", "routerLinkActive"], outputs: ["isActiveChange"], exportAs: ["routerLinkActive"] }, { kind: "ngmodule", type: IonicModule }, { kind: "component", type: i6.IonIcon, selector: "ion-icon", inputs: ["color", "flipRtl", "icon", "ios", "lazy", "md", "mode", "name", "sanitize", "size", "src"] }, { kind: "component", type: i6.IonItem, selector: "ion-item", inputs: ["button", "color", "counter", "counterFormatter", "detail", "detailIcon", "disabled", "download", "fill", "href", "lines", "mode", "rel", "routerAnimation", "routerDirection", "shape", "target", "type"] }, { kind: "component", type: i6.IonLabel, selector: "ion-label", inputs: ["color", "mode", "position"] }, { kind: "component", type: i6.IonList, selector: "ion-list", inputs: ["inset", "lines", "mode"] }, { kind: "component", type: i6.IonMenuToggle, selector: "ion-menu-toggle", inputs: ["autoHide", "menu"] }, { kind: "directive", type: i6.RouterLinkDelegate, selector: ":not(a):not(area)[routerLink]", inputs: ["routerDirection", "routerAnimation"] }, { kind: "ngmodule", type: MatExpansionModule }, { kind: "component", type: i7.MatExpansionPanel, selector: "mat-expansion-panel", inputs: ["disabled", "expanded", "hideToggle", "togglePosition"], outputs: ["opened", "closed", "expandedChange", "afterExpand", "afterCollapse"], exportAs: ["matExpansionPanel"] }, { kind: "component", type: i7.MatExpansionPanelHeader, selector: "mat-expansion-panel-header", inputs: ["tabIndex", "expandedHeight", "collapsedHeight"] }, { kind: "directive", type: i7.MatExpansionPanelContent, selector: "ng-template[matExpansionPanelContent]" }, { kind: "directive", type: NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: SidebarComponent, decorators: [{
            type: Component,
            args: [{ standalone: true, selector: 'lib-sidebar', imports: [
                        RouterModule,
                        IonicModule,
                        MatExpansionModule,
                        NgForOf,
                        NgIf,
                        NgClass
                    ], template: "<section\n  [ngClass]=\"{\n    'ucrop-theme': platform === 'ucrop',\n    'backoffice-theme': platform === 'backoffice',\n    'my-ucrop-theme': platform === 'my-ucrop'\n  }\"\n>\n  <aside id=\"main-logo\" (click)=\"goHome()\">\n    <picture>\n      <img src=\"{{ logo }}\" alt=\"Home\" />\n    </picture>\n  </aside>\n  <ion-list id=\"main-list\">\n    <ion-menu-toggle\n      auto-hide=\"false\"\n      *ngFor=\"let p of appPages; let i = index\"\n    >\n      <ion-item\n        routerDirection=\"root\"\n        [routerLink]=\"[p.page]\"\n        lines=\"none\"\n        detail=\"false\"\n        routerLinkActive=\"selected\"\n        (click)=\"selectItem('')\"\n        *ngIf=\"p.items.length === 0 || p.page === 'terminals-general'\"\n      >\n        <ion-icon\n          slot=\"start\"\n          [ios]=\"p.icon + '-outline'\"\n          [md]=\"p.icon + '-sharp'\"\n        ></ion-icon>\n        <ion-label>{{ p.title }}</ion-label>\n      </ion-item>\n\n      <mat-expansion-panel\n        *ngIf=\"p.items.length !== 0 && p.page !== 'terminals-general'\"\n        class=\"menu-expansion-panel\"\n        [disabled]=\"true\"\n        [expanded]=\"true\"\n      >\n        <mat-expansion-panel-header\n          (click)=\"router.navigate(['/fields-general'])\"\n          routerLinkActive=\"selected\"\n        >\n          <ion-item\n            routerDirection=\"root\"\n            lines=\"none\"\n            detail=\"false\"\n            routerLinkActive=\"selected\"\n            *ngIf=\"p.items.length !== 0\"\n            (click)=\"selectItem('fields')\"\n          >\n            <ion-icon\n              slot=\"start\"\n              [ios]=\"p.icon + '-outline'\"\n              [md]=\"p.icon + '-sharp'\"\n            ></ion-icon>\n            <ion-label>{{ p.title }}</ion-label>\n          </ion-item>\n        </mat-expansion-panel-header>\n        <ng-template matExpansionPanelContent>\n          <div *ngIf=\"p.page === 'fields-general'\">\n            <ion-item\n              id=\"{{ item.vid }}\"\n              routerDirection=\"root\"\n              (click)=\"selectItem(item)\"\n              [routerLink]=\"['./field', { vid: item.vid }]\"\n              *ngFor=\"let item of p.items\"\n              class=\"ionic-sidebar-items\"\n              menuClose\n              lines=\"none\"\n              detail=\"false\"\n            >\n              <ion-label class=\"sub-item-menu\">\n                <ion-icon\n                  slot=\"start\"\n                  [ios]=\"'flower-outline'\"\n                  [md]=\"'flower-sharp'\"\n                ></ion-icon>\n                <span>{{ item.name }}</span>\n              </ion-label>\n            </ion-item>\n          </div>\n        </ng-template>\n      </mat-expansion-panel>\n    </ion-menu-toggle>\n  </ion-list>\n\n  <div class=\"menu-separator-container\" *ngIf=\"installerMenu.length > 0\">\n    <div class=\"menu-separator\"></div>\n  </div>\n\n  <ion-list id=\"installer-list\" *ngIf=\"installerMenu.length > 0\">\n    <ion-menu-toggle auto-hide=\"false\" *ngFor=\"let p of installerMenu\">\n      <ion-item\n        routerDirection=\"root\"\n        [routerLink]=\"[p.page]\"\n        lines=\"none\"\n        detail=\"false\"\n        routerLinkActive=\"selected\"\n        (click)=\"selectItem('')\"\n        *ngIf=\"p.items.length === 0 || p.page === 'terminals-general'\"\n      >\n        <ion-icon\n          slot=\"start\"\n          [ios]=\"p.icon + '-outline'\"\n          [md]=\"p.icon + '-sharp'\"\n        ></ion-icon>\n        <ion-label>{{ p.title }}</ion-label>\n      </ion-item>\n\n      <mat-expansion-panel\n        *ngIf=\"p.items.length !== 0 && p.page !== 'terminals-general'\"\n        class=\"menu-expansion-panel\"\n        [disabled]=\"true\"\n        [expanded]=\"true\"\n      >\n        <mat-expansion-panel-header id=\"menu-expansion-panel-header\">\n          <ion-item\n            routerDirection=\"root\"\n            lines=\"none\"\n            detail=\"false\"\n            routerLinkActive=\"selected\"\n            *ngIf=\"p.items.length !== 0\"\n          >\n            <ion-icon\n              slot=\"start\"\n              [ios]=\"p.icon + '-outline'\"\n              [md]=\"p.icon + '-sharp'\"\n            ></ion-icon>\n            <ion-label>{{ p.title }}</ion-label>\n          </ion-item>\n        </mat-expansion-panel-header>\n        <ng-template matExpansionPanelContent>\n          <div *ngIf=\"p.page === 'fields'\">\n            <ion-item\n              id=\"{{ item.vid }}\"\n              [routerLink]=\"['./field', { vid: item.vid }]\"\n              routerLinkActive=\"'./field;vid='{{ +item.vid }} \"\n              (click)=\"selectItem(item)\"\n              *ngFor=\"let item of p.items\"\n              class=\"ionic-sidebar-items\"\n              menuClose\n              lines=\"none\"\n            >\n              <ion-label class=\"sub-item-menu-inferior\">{{\n                item.name\n              }}</ion-label>\n            </ion-item>\n          </div>\n        </ng-template>\n      </mat-expansion-panel>\n    </ion-menu-toggle>\n  </ion-list>\n</section>\n", styles: ["section{height:100%;position:relative;z-index:999}section #main-logo{padding:0 20px}section #main-logo picture{height:90px;position:relative;cursor:pointer;display:block;text-align:center}section ion-list{padding:20px 0}section ion-list ion-item{--background: transparent}section ion-list ion-item.md{--padding-start: 10px;--padding-end: 10px}section ion-list ion-item.md ion-label{font-weight:500;font-size:16px}section ion-list ion-item.ios{--padding-start: 16px;--padding-end: 16px}section ion-list ion-item.ios ion-icon{font-size:1rem}section ion-list ion-icon{margin-right:11px}section ion-list .menu-expansion-panel{box-shadow:none;background:transparent;border-radius:0!important}section ion-list .mat-expansion-panel-header{padding-left:0}section ion-list ::ng-deep .mat-expansion-panel-body{padding:0!important}section ion-list .sub-item-menu{margin-top:-6px!important;font-size:14px!important;padding-left:35px!important}section ion-list .sub-item-menu ion-icon{margin-top:0;margin-right:5px;position:relative;top:2px}section ion-list .sub-item-menu-inferior{margin-top:0!important;font-size:14px!important;padding-left:23px!important}section ion-list .ionic-sidebar-items{cursor:pointer;margin-top:0;margin-bottom:0}section.ucrop-theme{background:var(--menu-ucrop-bg)}section.ucrop-theme img{max-width:200px}section.ucrop-theme ion-list{background:var(--menu-ucrop-bg)}section.ucrop-theme ion-list ion-item{height:34px}section.ucrop-theme ion-list ion-item.selected{--background: var(--menu-ucrop-hover)}section.ucrop-theme ion-list ion-item ion-icon{margin-top:-5px;color:var(--menu-ucrop-icon)}section.ucrop-theme ion-list ion-item ion-label{margin-top:0;color:var(--menu-ucrop-text)}section.ucrop-theme ion-list ion-item .ionic-sidebar-items{height:34px}section.ucrop-theme ion-list .mat-expansion-panel-header{height:34px}section.my-ucrop-theme{background:var(--menu-my-ucrop-bg)}section.my-ucrop-theme img{margin-top:.75rem;max-width:215px}section.my-ucrop-theme ion-list{background:var(--menu-my-ucrop-bg)}section.my-ucrop-theme ion-list ion-item.selected{--background: var(--menu-my-ucrop-hover)}section.my-ucrop-theme ion-list ion-item.selected ion-icon,section.my-ucrop-theme ion-list ion-item.selected ion-label{color:#fff}section.my-ucrop-theme ion-list ion-item ion-icon{color:var(--menu-my-ucrop-icon)}section.my-ucrop-theme ion-list ion-item ion-label{color:var(--menu-my-ucrop-text)}section.backoffice-theme{background:var(--menu-backoffice-bg)}section.backoffice-theme img{margin-top:.75rem;max-width:170px}section.backoffice-theme ion-list{background:var(--menu-backoffice-bg)}section.backoffice-theme ion-list ion-item.selected{--background: var(--menu-backoffice-hover)}section.backoffice-theme ion-list ion-item.selected ion-icon,section.backoffice-theme ion-list ion-item.selected ion-label{color:#fff}section.backoffice-theme ion-list ion-item ion-icon{color:var(--menu-backoffice-icon)}section.backoffice-theme ion-list ion-item ion-label{color:var(--menu-backoffice-text)}section .menu-separator-container{background:var(--menu-ucrop-bg)}section .menu-separator-container .menu-separator{border-bottom:1px solid #4c667f;margin:0 .8rem}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$1.Router }, { type: AppCommonsService }, { type: SessionLibService }, { type: i1$1.ActivatedRoute }, { type: PlatformLibService }, { type: EnvironmentService }]; }, propDecorators: { platform: [{
                type: Input
            }] } });

class ProgressBarComponent {
    constructor(translationsLib) {
        this.translationsLib = translationsLib;
        this.progress = 0;
        this.newItemEvent = new EventEmitter();
        this.finished = false;
    }
    ngOnInit() { }
    ngOnChanges(changes) {
        if ((typeof changes.progress.previousValue === 'string' ||
            changes.progress.previousValue instanceof String) &&
            changes.progress.currentValue === '0') {
            this.finished = true;
        }
        else {
            this.finished = false;
        }
    }
    childFunction() {
        this.newItemEvent.emit();
    }
}
ProgressBarComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: ProgressBarComponent, deps: [{ token: TranslationsLibService }], target: i0.ɵɵFactoryTarget.Component });
ProgressBarComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: ProgressBarComponent, selector: "lib-progress-bar", inputs: { progress: "progress" }, outputs: { newItemEvent: "newItemEvent" }, usesOnChanges: true, ngImport: i0, template: "<div class=\"card\" id=\"progressBar\">\n  <div class=\"row\" *ngIf=\"finished === true\">\n    <div class=\"col-12 my-4 text-center\">\n      <b>{{ translationsLib.get(\"finished\") }}</b>\n    </div>\n  </div>\n  <div class=\"row\" *ngIf=\"finished === false\">\n    <div class=\"col-12\">\n      <mat-progress-bar\n        mode=\"determinate\"\n        value=\"{{ progress }}\"\n      ></mat-progress-bar>\n    </div>\n    <div class=\"col-12 text-center pt-2\">\n      <b>{{ progress }}%</b>\n    </div>\n  </div>\n  <div class=\"row\" *ngIf=\"finished === false\">\n    <div class=\"col-6 text-end\">\n      <button class=\"btn btn-light\">\n        <ion-icon\n          name=\"arrow-redo-outline\"\n          style=\"color: #db9113; font-size: 25px; position: relative; top: 5px\"\n        ></ion-icon>\n        <span>{{ translationsLib.get(\"retry\") }}</span>\n      </button>\n    </div>\n    <div class=\"col-6 text-start\">\n      <button class=\"btn btn-light\">\n        <ion-icon\n          name=\"close-outline\"\n          style=\"color: #bc1a1a; font-size: 25px; position: relative; top: 5px\"\n          (click)=\"childFunction()\"\n        ></ion-icon>\n        <span>{{ translationsLib.get(\"cancel\") }}</span>\n      </button>\n    </div>\n  </div>\n</div>\n", styles: ["#progressBar{background-color:#56acb240;padding:12px}.mat-progress-bar{height:12px;border-radius:29px}::ng-deep .mat-progress-bar .mat-progress-bar-buffer{background:white}::ng-deep .mat-progress-bar-fill:after{background-color:#56acb2}.btn-light{background-color:transparent!important;border-color:transparent}\n"], dependencies: [{ kind: "directive", type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i6.IonIcon, selector: "ion-icon", inputs: ["color", "flipRtl", "icon", "ios", "lazy", "md", "mode", "name", "sanitize", "size", "src"] }, { kind: "component", type: i4.MatProgressBar, selector: "mat-progress-bar", inputs: ["color", "value", "bufferValue", "mode"], outputs: ["animationEnd"], exportAs: ["matProgressBar"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: ProgressBarComponent, decorators: [{
            type: Component,
            args: [{ selector: 'lib-progress-bar', template: "<div class=\"card\" id=\"progressBar\">\n  <div class=\"row\" *ngIf=\"finished === true\">\n    <div class=\"col-12 my-4 text-center\">\n      <b>{{ translationsLib.get(\"finished\") }}</b>\n    </div>\n  </div>\n  <div class=\"row\" *ngIf=\"finished === false\">\n    <div class=\"col-12\">\n      <mat-progress-bar\n        mode=\"determinate\"\n        value=\"{{ progress }}\"\n      ></mat-progress-bar>\n    </div>\n    <div class=\"col-12 text-center pt-2\">\n      <b>{{ progress }}%</b>\n    </div>\n  </div>\n  <div class=\"row\" *ngIf=\"finished === false\">\n    <div class=\"col-6 text-end\">\n      <button class=\"btn btn-light\">\n        <ion-icon\n          name=\"arrow-redo-outline\"\n          style=\"color: #db9113; font-size: 25px; position: relative; top: 5px\"\n        ></ion-icon>\n        <span>{{ translationsLib.get(\"retry\") }}</span>\n      </button>\n    </div>\n    <div class=\"col-6 text-start\">\n      <button class=\"btn btn-light\">\n        <ion-icon\n          name=\"close-outline\"\n          style=\"color: #bc1a1a; font-size: 25px; position: relative; top: 5px\"\n          (click)=\"childFunction()\"\n        ></ion-icon>\n        <span>{{ translationsLib.get(\"cancel\") }}</span>\n      </button>\n    </div>\n  </div>\n</div>\n", styles: ["#progressBar{background-color:#56acb240;padding:12px}.mat-progress-bar{height:12px;border-radius:29px}::ng-deep .mat-progress-bar .mat-progress-bar-buffer{background:white}::ng-deep .mat-progress-bar-fill:after{background-color:#56acb2}.btn-light{background-color:transparent!important;border-color:transparent}\n"] }]
        }], ctorParameters: function () { return [{ type: TranslationsLibService }]; }, propDecorators: { progress: [{
                type: Input
            }], newItemEvent: [{
                type: Output
            }] } });

class TextAvatarComponent {
    constructor() {
        this.firstLetter = '';
        this.styles = {
            border: '2px solid',
            'border-color': '#fff',
            'background-color': '#fff',
            color: '#000',
        };
        this.COLORS = [
            '#e57373',
            '#f06292',
            '#ba68c8',
            '#9575cd',
            '#7986cb',
            '#64b5f6',
            '#4fc3f7',
            '#4dd0e1',
            '#4db6ac',
            '#81c784',
            '#aed581',
            '#ff8a65',
            '#d4e157',
            '#673ab7',
            '#ffb74d',
            '#a1887f',
            '#90a4ae',
        ];
    }
    ngOnChanges(changes) {
        let text = changes['text'] ? changes['text'].currentValue : null;
        const color = changes['color'] ? changes['color'].currentValue : null;
        const textColor = changes['textColor'] ? changes['textColor'].currentValue : this.styles.color;
        if (text === null || typeof text !== 'string' || text.length === 0) {
            text = '?';
        }
        text = text.replace('undefined', '');
        if (text === '?') {
            this.firstLetter = '?';
            this.styles = {
                ...this.styles,
                'border-color': this.backgroundColorHexString(color, text),
                color: textColor,
            };
        }
        else {
            text = this.extractFirstCharacter(text);
            this.firstLetter = text.substring(0, 2);
            const backgroundColor = this.backgroundColorHexString(color, text);
            this.styles = {
                ...this.styles,
                'border-color': backgroundColor,
                'background-color': backgroundColor,
                color: textColor,
            };
        }
    }
    extractFirstCharacter(text) {
        let initials = '';
        text
            .toUpperCase()
            .split(' ')
            .forEach((i) => {
            initials += i[0];
        });
        return initials;
    }
    backgroundColorHexString(color, text) {
        return color || this.getColor(text);
    }
    getColor(str) {
        return this.COLORS[Math.abs(this.toNumber(str)) % this.COLORS.length];
    }
    toNumber(str) {
        let h = 0;
        for (let i = 0; i < str.length; i++) {
            h = 31 * h + str.charCodeAt(i);
            h |= 0; // Convert to 32bit integer
        }
        return h;
    }
    ;
}
TextAvatarComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: TextAvatarComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
TextAvatarComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: TextAvatarComponent, selector: "text-avatar", inputs: { text: "text", color: "color", textColor: "textColor" }, usesOnChanges: true, ngImport: i0, template: "<div class=\"u-text-avatar\" [ngStyle]=\"styles\">\r\n  {{ firstLetter }}\r\n</div>\r\n", styles: [".u-text-avatar{display:flex;justify-content:center;align-items:center;width:100%;height:100%;border-radius:500px}\n"], dependencies: [{ kind: "directive", type: i5.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: TextAvatarComponent, decorators: [{
            type: Component,
            args: [{ selector: 'text-avatar', template: "<div class=\"u-text-avatar\" [ngStyle]=\"styles\">\r\n  {{ firstLetter }}\r\n</div>\r\n", styles: [".u-text-avatar{display:flex;justify-content:center;align-items:center;width:100%;height:100%;border-radius:500px}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { text: [{
                type: Input
            }], color: [{
                type: Input
            }], textColor: [{
                type: Input
            }] } });

class FieldCropsNamesPipe {
    transform(field) {
        if (typeof sessionStorage.getItem('crops_data') === 'string') {
            const cropsList = JSON.parse(sessionStorage.getItem('crops_data'));
            if (!field || !cropsList || cropsList.length === 0)
                return '...';
            if (typeof field.multicrops === undefined ||
                field.multicrops === null ||
                (field.multicrops.length === 0 &&
                    field.crop_id !== undefined &&
                    field.crop_id !== null)) {
                return cropsList.find((crop) => crop.id === field.crop_id)?.name;
            }
            // Hago un objeto {calabazas: 2, higos: 1}
            const countNames = field.multicrops.reduce((prev, curr) => {
                const cropName = cropsList.find((crop) => crop.id === curr.crop_id);
                if (cropName) {
                    if (prev[cropName.name])
                        prev[cropName.name]++;
                    else
                        prev[cropName.name] = 1;
                }
                return { ...prev };
            }, {});
            // A partir del objeto monto "calabazas (x2), higos 1"
            return Object.keys(countNames)
                .map((name) => countNames[name] > 1 ? name + ' (x' + countNames[name] + ')' : name)
                .join(', ');
        }
        else {
            return '...';
        }
    }
}
FieldCropsNamesPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: FieldCropsNamesPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
FieldCropsNamesPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: FieldCropsNamesPipe, name: "fieldCropsName" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: FieldCropsNamesPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'fieldCropsName',
                }]
        }] });

class SensorIconPipe {
    constructor(sanitizer) {
        this.sanitizer = sanitizer;
        this.ionicIcons = {
            TEMPERATURE_OUTLINE: 'thermometer-outline',
            HUMIDITY_OUTLINE: 'cloudy-outline',
            SIGNAL: 'cellular-outline',
            BATTERY: 'battery-outline',
            ET0: 'flame-outline',
            RADIATION_OUTLINE: 'sunny-outline',
            RAIN: 'rainy-outline',
            NAVIGATE: 'navigate-outline',
            WIND_DIRECTION_OUTLINE: 'compass-outline',
            VIRTUAL: 'help-circle-outline',
            'SHOW-MORE': 'alert-circle-outline',
            PLAY: 'play-circle-outline',
            STOP: 'stop-circle-outline',
            COG: 'cog-outline',
            CLEAR: 'close-outline',
            DOTS: 'ellipsis-vertical-outline',
            EXPORT: 'reader-outline',
            ARROW: 'arrow-redo-outline',
            'FORWARD-ARROW': 'chevron-forward-outline',
            'DOWN-ARROW': 'chevron-down-outline',
            'CREATE-INSTALLER': 'create',
            SUNNY: 'sunny-outline',
            'ARROW-UP': 'arrow-up-outline',
            'ARROW-DOWN': 'arrow-down-outline',
            'HORIZONTAL-DOTS': 'ellipsis-horizontal-outline',
            'PLAY-SKIP-BACK': 'play-skip-back',
            'CARET-BACK': 'caret-back',
            'CARET-FORWARD': 'caret-forward',
            'PLAY-SKIP-FORWARD': 'play-skip-forward',
            'RELOAD-OUTLINE': 'reload-outline',
            'CLOSE-CIRCLE-OUTLINE': 'close-circle-outline',
        };
        this.bootstrapIcons = {
            WIND: 'bi bi-wind',
            SUNRISE: 'bi bi-sunrise',
            SUNSET: 'bi bi-sunset',
            ACCUMULATED_RADIATION: 'bi bi-calendar',
            PLUVIOMETER: 'bi bi-water',
            WIND_DIRECTION: 'bi bi-repeat',
            WIND_VELOCITY_OUTLINE: 'bi bi-wind',
            WIND_LEVEL_0: 'bi bi-wind',
            WIND_LEVEL_1: 'bi bi-wind',
            SEARCH: 'bi bi-search',
            'LEFT-ARROW': 'bi bi-caret-left',
            'RIGHT-ARROW': 'bi bi-caret-right',
            CLOCK: 'bi bi-clock',
            THERMOMETER: 'bi bi-thermometer-half',
            'THERMOMETER-SUN': 'bi bi-thermometer-sun',
            SUN: 'bi bi-sun',
            DRIZZLE: 'bi bi-cloud-drizzle',
            SIGNPOST: 'bi bi-signpost-split',
            BRIGHTNESS: 'bi bi-brightness-high',
            SNOW: 'bi bi-snow',
            WATER: 'bi bi-water',
            'BRIGHTNESS-ALT': 'bi bi-brightness-alt-high',
            'CLOUD-LIGHTNING': 'bi bi-cloud-lightning-rain',
            'CLOUD-FILL': 'bi bi-cloud-fill',
            'MET-WIND': 'bi bi-wind',
            'MET-CALENDAR': 'bi bi-calendar',
            REMOVE: 'bi bi-x',
        };
        //../../../assets/img/magnitudes_icons/
        this.colorIcons = {
            SUNRISE: '../../../assets/img/magnitudes_icons/Iconos_Magnitudes_UCROP-SUNRISE-Amanecer.svg',
            SUNSET: '../../../assets/img/magnitudes_icons/Iconos_Magnitudes_UCROP-SUNSET-Anochecer.svg',
            SNOW: '../../../assets/img/magnitudes_icons/Iconos_Magnitudes_UCROP-SNOW-Snow.svg',
            SIGNPOST: '../../../assets/img/magnitudes_icons/Iconos_Magnitudes_UCROP-SIGNPOST-SPLIT-Signpost-split_01.svg',
            DRIZZLE: '../../../assets/img/magnitudes_icons/Iconos_Magnitudes_UCROP-CLOUD-DRIZZLE-Dia-Cloud-drizzle.svg',
            CLOCK: '../../../assets/img/magnitudes_icons/Iconos_Magnitudes_UCROP-CLOCK-Clock.svg',
            BRIGHTNESS_ALT: '../../../assets/img/magnitudes_icons/Iconos_Magnitudes_UCROP-DAYNIGHT-Dia-Noche_02.svg',
            ACCUMULATED_RADIATION: '../../../assets/img/magnitudes_icons/Iconos_Magnitudes_UCROP-RADIATION-Radiacion_Acumulada.svg',
            PLUVIOMETER: '../../../assets/img/magnitudes_icons/Iconos_Magnitudes_UCROP-PLUVIOMETER-Pluviometro.svg',
            WIND_DIRECTION: '../../../assets/img/magnitudes_icons/Iconos_Magnitudes_UCROP-WIND_DIR-Direccion_del_viento.svg',
            WIND_VELOCITY: '../../../assets/img/magnitudes_icons/Iconos_Magnitudes_UCROP-WIND_SPEED-Velocidad_del_viento.svg',
            TEMPERATURE: '../../../assets/img/magnitudes_icons/Iconos_Magnitudes_UCROP-TEMP-Temperatura_Ambiente.svg',
            HUMIDITY: '../../../assets/img/magnitudes_icons/Iconos_Magnitudes_UCROP-RH-Humedad_relativa_ambiente.svg',
            SIGNAL: '../../../assets/img/magnitudes_icons/Iconos_Magnitudes_UCROP-SIGNAL-Intensidad_señal_portadora_telefonía.svg',
            BATTERY: '../../../assets/img/magnitudes_icons/',
            ET0: '../../../assets/img/magnitudes_icons/Iconos_Magnitudes_UCROP-ET0-Evapotranspiracion_de_referencia.svg',
            RADIATION: '../../../assets/img/magnitudes_icons/Iconos_Magnitudes_UCROP-RADIATION-Radiacion.svg',
            CHILL_HOURS: '../../../assets/img/magnitudes_icons/Iconos_Magnitudes_UCROP-CHILL_HOURS-Horas_Frio (2).svg',
            DECAGON: '../../../assets/img/magnitudes_icons/Iconos_Magnitudes_UCROP-DECAGON-Sonda_Decagon.svg',
            DWP: '../../../assets/img/magnitudes_icons/Iconos_Magnitudes_UCROP-DWP-Punto_de_Rocio (2).svg',
            EC: '../../../assets/img/magnitudes_icons/Iconos_Magnitudes_UCROP-EC-Conductividad_Electrica.svg',
            ETc: '../../../assets/img/magnitudes_icons/Iconos_Magnitudes_UCROP-ETc-Evapotranspiracion_del_cultivo.svg',
            GENERIC: '../../../assets/img/magnitudes_icons/Iconos_Magnitudes_UCROP-GENERIC.svg',
            HD: '../../../assets/img/magnitudes_icons/Iconos_Magnitudes_UCROP-HD-Deficit_Hidrico (2).svg',
            MATRIX_POTENTIAL: '../../../assets/img/magnitudes_icons/Iconos_Magnitudes_UCROP-MATRIX_POTENTIAL-Potencial_matricial_del_suelo.svg',
            OTHER: '../../../assets/img/magnitudes_icons/Iconos_Magnitudes_UCROP-OTHER.svg',
            MV_V: '../../../assets/img/magnitudes_icons/Iconos_Magnitudes_UCROP-MV_V-Milivoltios_por_voltio (2).svg',
            pH: '../../../assets/img/magnitudes_icons/Iconos_Magnitudes_UCROP-pH.svg',
            PORE_WATER_EC: '../../../assets/img/magnitudes_icons/Iconos_Magnitudes_UCROP-PORE_WATER_EC-CE_del_poro_de_agua.svg',
            PULSE_COUNTERMETER: '../../../assets/img/magnitudes_icons/Iconos_Magnitudes_UCROP-PULSE_COUNTERMETER-Contador_de_agua-abono.svg',
            SOIL_EC: '../../../assets/img/magnitudes_icons/Iconos_Magnitudes_UCROP-SOIL_EC-CE del suelo.svg',
            SOIL_TEMP: '../../../assets/img/magnitudes_icons/Iconos_Magnitudes_UCROP-SOIL_TEMP-Temperatura_Suelo.svg',
            SOIL_TENSION: '../../../assets/img/magnitudes_icons/Iconos_Magnitudes_UCROP-MATRIX_POTENTIAL-Potencial_matricial_del_suelo.svg',
            SOIL_TEXTURE: '../../../assets/img/magnitudes_icons/Iconos_Magnitudes_UCROP-SOIL_TEXTURE-Textura_del_suelo.svg',
            TENSION: '../../../assets/img/magnitudes_icons/Iconos_Magnitudes_UCROP-TENSION-Tension-Voltaje_leido.svg',
            VPD: '../../../assets/img/magnitudes_icons/Iconos_Magnitudes_UCROP-VPD-Deficit_Presion_Vapor.svg',
            VWC: '../../../assets/img/magnitudes_icons/Iconos_Magnitudes_UCROP-VWC-Volumetric_Water_Content-Referencia_humedad_suelo.svg',
            WATER_TEMP: '../../../assets/img/magnitudes_icons/Iconos_Magnitudes_UCROP-WATER_TEMP-Temperatura_Agua.svg',
        };
    }
    transform(key, style = '', className, isIonIconTag) {
        key = key.toUpperCase();
        let output = '';
        if (this.colorIcons.hasOwnProperty(key)) {
            output = `<img src="${this.colorIcons[key]}" alt="Icon ${key}" style="${style} min-height: 22px; max-width:22px;">`;
        }
        else {
            if (this.ionicIcons.hasOwnProperty(key) && isIonIconTag) {
                return this.ionicIcons[key];
            }
            else if (this.ionicIcons.hasOwnProperty(key)) {
                output = `<ion-icon name="${this.ionicIcons[key]}" class="${className}" style="${style}"></ion-icon>`;
            }
            else if (this.bootstrapIcons.hasOwnProperty(key)) {
                output = `<i class="${this.bootstrapIcons[key]}" style="${style}"></i>`;
            }
            else {
                console.warn('[SENSOR-ICON-PIPE]: Icono no encontrado ' + key);
            }
        }
        return this.sanitizer.bypassSecurityTrustHtml(output);
    }
}
SensorIconPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: SensorIconPipe, deps: [{ token: i1$2.DomSanitizer }], target: i0.ɵɵFactoryTarget.Pipe });
SensorIconPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: SensorIconPipe, name: "sensorIcon" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: SensorIconPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'sensorIcon',
                }]
        }], ctorParameters: function () { return [{ type: i1$2.DomSanitizer }]; } });

class AppCommonsModule {
}
AppCommonsModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: AppCommonsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
AppCommonsModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: AppCommonsModule, declarations: [TransformDatePipe,
        TransformDateTimePipe,
        LoaderComponent,
        TerminalHeaderComponent,
        UserSummaryPipe,
        BottomTabsComponent,
        ProgressBarComponent,
        TranslationPipe,
        TextAvatarComponent,
        FieldCropsNamesPipe,
        SensorIconPipe], imports: [CommonModule,
        IonicModule, i6.IonicModule, MapsModule,
        SidebarComponent,
        MatProgressBarModule], exports: [TransformDatePipe,
        TransformDateTimePipe,
        LoaderComponent,
        TerminalHeaderComponent,
        UserSummaryPipe,
        MapsModule,
        BottomTabsComponent,
        SidebarComponent,
        ProgressBarComponent,
        TranslationPipe,
        TextAvatarComponent,
        FieldCropsNamesPipe,
        SensorIconPipe] });
AppCommonsModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: AppCommonsModule, imports: [CommonModule,
        IonicModule,
        IonicModule.forRoot(),
        MapsModule,
        SidebarComponent,
        MatProgressBarModule, MapsModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: AppCommonsModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        TransformDatePipe,
                        TransformDateTimePipe,
                        LoaderComponent,
                        TerminalHeaderComponent,
                        UserSummaryPipe,
                        BottomTabsComponent,
                        ProgressBarComponent,
                        TranslationPipe,
                        TextAvatarComponent,
                        FieldCropsNamesPipe,
                        SensorIconPipe,
                    ],
                    imports: [
                        CommonModule,
                        IonicModule,
                        IonicModule.forRoot(),
                        MapsModule,
                        SidebarComponent,
                        MatProgressBarModule
                    ],
                    exports: [
                        TransformDatePipe,
                        TransformDateTimePipe,
                        LoaderComponent,
                        TerminalHeaderComponent,
                        UserSummaryPipe,
                        MapsModule,
                        BottomTabsComponent,
                        SidebarComponent,
                        ProgressBarComponent,
                        TranslationPipe,
                        TextAvatarComponent,
                        FieldCropsNamesPipe,
                        SensorIconPipe,
                    ]
                }]
        }] });

class App360SharedModule {
}
App360SharedModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: App360SharedModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
App360SharedModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: App360SharedModule, declarations: [App360SharedComponent], imports: [HttpClientModule, AppCommonsModule], exports: [AppCommonsModule] });
App360SharedModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: App360SharedModule, imports: [HttpClientModule, AppCommonsModule, AppCommonsModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: App360SharedModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [App360SharedComponent],
                    imports: [HttpClientModule, AppCommonsModule],
                    providers: [],
                    exports: [AppCommonsModule]
                }]
        }] });

class MapsLibService {
    constructor(translationsLib, environment) {
        this.translationsLib = translationsLib;
        this._environment = environment;
    }
    staticPolygonMapString(coordenadasString, centro, color, size, zoomDefault) {
        let zoom = 0; //aqui va un switch con los casos
        if (size < 20) {
            zoom = 16;
        }
        if (size > 20 && size < 50) {
            zoom = 15;
        }
        if (size > 50 && size < 300) {
            zoom = 14;
        }
        if (size > 300 && size < 600) {
            zoom = 13;
        }
        if (size > 600 && size < 1000) {
            zoom = 12;
        }
        if (size > 1000) {
            zoom = zoomDefault;
        }
        const map = 'https://maps.googleapis.com/maps/api/staticmap?center=' +
            centro.lat +
            ', ' +
            centro.lng +
            '&zoom=' +
            zoom +
            '&path=color:0x' +
            color +
            '%7Cweight:1%7Cfillcolor:0x' +
            color +
            '%7C' +
            coordenadasString +
            '&size=700x400&maptype=hybrid' +
            '&key=' +
            this._environment.getStaticMapsToken();
        return map;
    }
    staticMarkersMapString(marker1) {
        const map = 'https://maps.googleapis.com/maps/api/staticmap?center=' +
            marker1.lat +
            ',' +
            marker1.lon +
            '&zoom=19&size=700x400&maptype=hybrid' +
            '&markers=icon:' +
            marker1.icon +
            '%7C' +
            marker1.lat +
            ',' +
            marker1.lon +
            '&key=' +
            this._environment.getStaticMapsToken();
        return map;
    }
}
MapsLibService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: MapsLibService, deps: [{ token: TranslationsLibService }, { token: EnvironmentService }], target: i0.ɵɵFactoryTarget.Injectable });
MapsLibService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: MapsLibService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: MapsLibService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: TranslationsLibService }, { type: EnvironmentService }]; } });

class SidebarLibService {
    constructor() { }
    showSidebar() {
        return (window.location.pathname !== '/' &&
            window.location.pathname !== '/login' &&
            window.location.pathname !== '/bo-login' &&
            window.location.pathname !== '/register' &&
            window.location.pathname !== '/2fa-confirmation' &&
            window.location.pathname !== '/bo-2fa-confirmation' &&
            window.location.pathname.indexOf('/register-confirmation') < 0 &&
            window.location.pathname.indexOf('/reset-password') < 0 &&
            window.location.pathname.indexOf('/reset-user-invitation') < 0);
    }
}
SidebarLibService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: SidebarLibService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
SidebarLibService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: SidebarLibService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: SidebarLibService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return []; } });

class UsersLibService {
    constructor(translationsLib) {
        this.translationsLib = translationsLib;
    }
    isBackoffice(type) {
        return type >= 20 && type <= 29;
    }
    isBackofficeSuperAdmin(type) {
        return type === 20 || type === 21;
    }
    isInstaller(type) {
        return type === 2 || type === 52;
    }
    isNonConfirmedInstaller(type) {
        return type === 52;
    }
    getRolText(type) {
        return this.translationsLib.get('user_type_' + type);
    }
    getStatus(status) {
        switch (status) {
            case 0: {
                return 'UNKNOWN';
            }
            case 1: {
                return 'OK';
            }
            case 50: {
                return 'Pendiente de invitar';
            }
            case 51: {
                return 'Invitación enviada no aceptada';
            }
        }
    }
    statusIsInvitable(status) {
        return status === 50 || status === 51;
    }
}
UsersLibService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: UsersLibService, deps: [{ token: TranslationsLibService }], target: i0.ɵɵFactoryTarget.Injectable });
UsersLibService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: UsersLibService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: UsersLibService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: TranslationsLibService }]; } });

class HelpersLibService {
    constructor(titleService, session) {
        this.titleService = titleService;
        this.session = session;
    }
    setTitle(page, name, mode) {
        const prefix = 'UCROP | ';
        const baseTitle = name.includes(page) ? name : `${page}: ${name}`;
        const title = mode
            ? `${prefix}${mode} | ${baseTitle}`
            : `${prefix}${baseTitle}`;
        this.titleService.setTitle(title);
    }
    focusTab(tab) {
        if (typeof tab !== 'undefined') {
            for (let x = 50; x <= 2500; x = x + 500) {
                setTimeout(() => {
                    tab.focusTab(0);
                    tab.realignInkBar();
                }, x);
            }
        }
    }
    getUsersLocale(defaultValue) {
        if (this.session.getLanguage() !== null) {
            return this.session.getLanguage();
        }
        else {
            if (typeof window === 'undefined' ||
                typeof window.navigator === 'undefined') {
                return defaultValue;
            }
            const wn = window.navigator;
            let lang = wn.languages ? wn.languages[0] : defaultValue;
            lang = lang || wn.language || wn.browserLanguage || wn.userLanguage;
            const minLang = lang.split('-');
            return minLang[0];
        }
    }
    validateEmail(email) {
        const re = /\S+@\S+\.\S+/;
        return re.test(email);
    }
}
HelpersLibService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: HelpersLibService, deps: [{ token: i1$2.Title }, { token: SessionLibService }], target: i0.ɵɵFactoryTarget.Injectable });
HelpersLibService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: HelpersLibService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: HelpersLibService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1$2.Title }, { type: SessionLibService }]; } });

class HighchartsLibService {
    constructor(translationsLib) {
        this.translationsLib = translationsLib;
    }
    getGlobalBluePaletteColors() {
        return [
            '#1D2F6F',
            '#8390FA',
            '#339DB1',
            '#FAC748',
            '#FF7350',
            '#FF1175',
            '#0032b4',
            '#0083FC',
            '#8c288c',
            '#6700ff',
        ];
    }
    getGlobalPurplePaletteColors() {
        return [
            '#9b20d9',
            '#9215ac',
            '#861ec9',
            '#7a17e6',
            '#7010f9',
            '#691af3',
            '#6225ed',
            '#5b30e7',
            '#533be1',
            '#4c46db',
            '#4551d5',
            '#3e5ccf',
            '#3667c9',
            '#2f72c3',
            '#277dbd',
            '#1f88b7',
            '#1693b1',
            '#0a9eaa',
            '#03c69b',
            '#00f194',
        ];
    }
    getDarkGlobalPaletteColors(random) {
        const palette = [
            '#1D2F6F',
            '#601c67',
            '#b04f1b',
            '#b0344e',
            '#7A7485',
            '#332C49',
            '#44BEA4',
            '#6700ff',
            '#268828',
            '#b0344e',
            '#88861b',
        ];
        if (random === false) {
            return palette;
        }
        else {
            return palette
                .map((value) => ({ value, sort: Math.random() }))
                .sort((a, b) => a.sort - b.sort)
                .map(({ value }) => value);
        }
    }
    getGlobalGreenPaletteColors() {
        return [
            '#1a5657',
            '#1aa657',
            '#537233',
            '#b7efa1',
            '#515359',
            '#b4835c',
            '#178069',
            '#a69f06',
        ];
    }
    getGlobalPaletteColors1() {
        return ['#1827C2', '#BF00A1', '#FF1175', '#FF7350', '#FFBA45', '#F9F871'];
    }
    getCSSVariableValue(variableName) {
        const root = document.documentElement;
        return getComputedStyle(root).getPropertyValue(variableName).trim();
    }
    getCorporatePaletteColorByKey(key) {
        switch (key.toLowerCase()) {
            case 'terminal_ntc':
                return '#152842';
            case 'terminal_xilema':
                return '#005DB9';
            case 'terminal_irrigation':
                return this.getCSSVariableValue('--irrigation-border');
            case 'terminal_climate':
                return this.getCSSVariableValue('--climate-border');
            case 'terminal_datalogger':
                return this.getCSSVariableValue('--datalogger-border');
            case 'terminal_configurable':
                return this.getCSSVariableValue('--configurable-border');
            case 'terminal_carts':
                return this.getCSSVariableValue('--terminals-border');
            case 'terminal_unknown':
                return this.getCSSVariableValue('--cancel-color');
            default:
                return null;
        }
    }
    getCorporatePaletteColors() {
        return [
            this.getCSSVariableValue('--irrigation-border'),
            this.getCSSVariableValue('--climate-border'),
            this.getCSSVariableValue('--datalogger-border'),
            this.getCSSVariableValue('--configurable-border'),
            this.getCSSVariableValue('--brown-color'),
            this.getCSSVariableValue('--orange-color'),
            this.getCSSVariableValue('--violet-color'),
            this.getCSSVariableValue('--purple-color'),
            this.getCSSVariableValue('--lightblue-color'),
            this.getCSSVariableValue('--green-color'),
        ];
    }
    getLangOptions() {
        return {
            contextButtonTitle: 'Chart context menu',
            decimalPoint: '.',
            downloadCSV: this.translationsLib.get('highcharts_download_csv'),
            downloadJPEG: this.translationsLib.get('highcharts_download_jpeg'),
            downloadMIDI: 'Download MIDI',
            downloadPDF: this.translationsLib.get('highcharts_download_pdf'),
            downloadPNG: this.translationsLib.get('highcharts_download_png'),
            downloadSVG: this.translationsLib.get('highcharts_download_svg'),
            downloadXLS: this.translationsLib.get('highcharts_download_xls'),
            exitFullscreen: this.translationsLib.get('highcharts_exit_fullscreen'),
            hideData: this.translationsLib.get('highcharts_hide_data_table'),
            invalidDate: undefined,
            loading: this.translationsLib.get('highcharts_loading'),
            mainBreadcrumb: 'Main',
            months: [
                'January',
                'February',
                'March',
                'April',
                'May',
                'June',
                'July',
                'August',
                'September',
                'October',
                'November',
                'December',
            ],
            //exportData:{},
            //navigation:{...},
            noData: 'No data to display',
            numericSymbolMagnitude: 1000,
            numericSymbols: ['k', 'M', 'G', 'T', 'P', 'E'],
            playAsSound: 'Play as sound',
            printChart: this.translationsLib.get('highcharts_print_chart'),
            resetZoom: this.translationsLib.get('highcharts_reset_zoom'),
            resetZoomTitle: this.translationsLib.get('highcharts_reset_zoom'),
            shortMonths: [
                'Jan',
                'Feb',
                'Mar',
                'Apr',
                'May',
                'Jun',
                'Jul',
                'Aug',
                'Sep',
                'Oct',
                'Nov',
                'Dec',
            ],
            shortWeekdays: undefined,
            thousandsSep: ',',
            viewData: this.translationsLib.get('highcharts_view_data_table'),
            viewFullscreen: this.translationsLib.get('highcharts_enter_full_screen'),
            weekdays: [
                'Sunday',
                'Monday',
                'Tuesday',
                'Wednesday',
                'Thursday',
                'Friday',
                'Saturday',
            ],
        };
    }
}
HighchartsLibService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: HighchartsLibService, deps: [{ token: TranslationsLibService }], target: i0.ɵɵFactoryTarget.Injectable });
HighchartsLibService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: HighchartsLibService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: HighchartsLibService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: TranslationsLibService }]; } });

class AnalyticsLibService {
    constructor(ga, session, environmentService) {
        this.ga = ga;
        this.session = session;
        this.environmentService = environmentService;
        this.isProduction = false;
        this.isProduction = this.environmentService.getProduction();
    }
    initializeApp() {
        if (!this.isProduction) {
            return;
        }
        this.ga
            .startTrackerWithId('G-BN3LL4Y442')
            .then(() => {
            console.log('Google analytics is ready now');
            // Tracker is ready
            // You can now track pages or set additional information such as AppVersion or UserId
        })
            .catch((e) => console.log('Error starting GoogleAnalytics', e));
    }
    sendEventFieldView(fieldName, vid) {
        if (!this.isProduction) {
            return;
        }
        gtag('event', 'page_view', {
            View_Field: fieldName + ' - field;vid=' + vid,
        });
        gtag('event', 'page_view_by_type', {
            View_Field: 'Field',
        });
        gtag('event', 'page_view_by_user', {
            View_Field: ' View_field - ' + this.session.getSessionEmail(),
        });
    }
    sendEventFieldEdit(fieldName, vid) {
        if (!this.isProduction) {
            return;
        }
        gtag('event', 'page_view', {
            Edit_Field: fieldName + ' - field;vid=' + vid,
        });
        gtag('event', 'page_view_by_type', {
            Edit_Field: 'Field',
        });
        gtag('event', 'page_view_by_user', {
            Edit_Field: ' View_field - ' + this.session.getSessionEmail(),
        });
    }
    sendEventFieldCreate() {
        if (!this.isProduction) {
            return;
        }
        gtag('event', 'page_view', {
            Create_Field: 'Create',
        });
        gtag('event', 'page_view_by_type', {
            Create_Field: 'Field',
        });
        gtag('event', 'page_view_by_user', {
            Create_Field: ' View_field - ' + this.session.getSessionEmail(),
        });
    }
    sendEventTerminalView(terminalName, vid) {
        if (!this.isProduction) {
            return;
        }
        gtag('event', 'page_view', {
            View_Terminal: terminalName + ' - field;vid=' + vid,
        });
        gtag('event', 'page_view_by_type', {
            View_Terminal: 'Terminal',
        });
        gtag('event', 'page_view_by_user', {
            View_Terminal: ' View_Terminal - ' + this.session.getSessionEmail(),
        });
    }
    sendEventTerminalEdit(terminalName, vid) {
        if (!this.isProduction) {
            return;
        }
        gtag('event', 'page_view', {
            Edit_Terminal: terminalName + ' - field;vid=' + vid,
        });
        gtag('event', 'page_view_by_type', {
            Edit_Terminal: 'Terminal',
        });
        gtag('event', 'page_view_by_user', {
            Edit_Terminal: ' Edit_Terminal - ' + this.session.getSessionEmail(),
        });
    }
    sendEventTerminalPair() {
        if (!this.isProduction) {
            return;
        }
        gtag('event', 'page_view', {
            Pair_Terminal: 'Pair_terminal',
        });
        gtag('event', 'page_view_by_type', {
            Pair_Terminal: 'Terminal',
        });
        gtag('event', 'page_view_by_user', {
            Pair_Terminal: ' Pair_Terminal - ' + this.session.getSessionEmail(),
        });
    }
    sendEventPageView(page) {
        if (!this.isProduction) {
            return;
        }
        gtag('event', 'page_view', {
            page_title: page + '',
        });
        gtag('event', 'page_view_by_user', {
            [page]: page + ' - ' + this.session.getSessionEmail(),
        });
    }
    sendEventTerminalCalendarView(terminalName, terminalVid) {
        if (!this.isProduction) {
            return;
        }
        gtag('event', 'page_view', {
            Calendar_Terminal: terminalName + ' - terminal-calendar;vid=' + terminalVid,
        });
        gtag('event', 'page_view_by_type', {
            Calendar_Terminal: 'Calendar_terminal',
        });
        gtag('event', 'page_view_by_user', {
            Calendar_Terminal: ' Calendar_terminal - ' + this.session.getSessionEmail(),
        });
    }
}
AnalyticsLibService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: AnalyticsLibService, deps: [{ token: i1$3.GoogleAnalytics }, { token: SessionLibService }, { token: EnvironmentService }], target: i0.ɵɵFactoryTarget.Injectable });
AnalyticsLibService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: AnalyticsLibService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: AnalyticsLibService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1$3.GoogleAnalytics }, { type: SessionLibService }, { type: EnvironmentService }]; } });

const INVITATIONS_TYPES = {
    PENDING: 0,
    ACCEPTED: 1,
    REJECTED: 2,
    CANCELLED: 3
};

class NotificationsService {
    constructor(restApiService) {
        this.restApiService = restApiService;
    }
    getInvitations() {
        return this.restApiService.getInvitations();
    }
    getPendingInvitations() {
        return this.restApiService.getPendingInvitations();
    }
    putInvitationResponse(vid, data) {
        return this.restApiService.putInvitationResponse(vid, data);
    }
    putResendEmail(vid, data) {
        return this.restApiService.putResendEmail(vid, data);
    }
    getNotifications(startingDate, endingDate, userTimeZone, data) {
        return this.restApiService.getNotifications(startingDate, endingDate, userTimeZone, data);
    }
}
NotificationsService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: NotificationsService, deps: [{ token: RestApiService }], target: i0.ɵɵFactoryTarget.Injectable });
NotificationsService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: NotificationsService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: NotificationsService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: RestApiService }]; } });

class InvitationsComponent {
    constructor(session, translationsLib, helpersLib, analyticsLib, notificationsService, usersLib, environmentService) {
        this.session = session;
        this.translationsLib = translationsLib;
        this.helpersLib = helpersLib;
        this.analyticsLib = analyticsLib;
        this.notificationsService = notificationsService;
        this.usersLib = usersLib;
        this.environmentService = environmentService;
        this.showSideHelp = true;
        this.invitations = [];
        this.user = null;
        this.userEmail = '';
        this.ready = false;
    }
    ngOnInit() {
        this.helpersLib.setTitle(this.translationsLib.get('notification_notifications'), this.translationsLib.get('notification_notifications'), null);
        if (this.environmentService.getProduction()) {
            this.analyticsLib.sendEventPageView('notificaciones');
        }
        //this.getPending();
        // If invitations has not been passed as input parameter (used in the BO), just ask for current user invitations
        if (this.invitations.length === 0) {
            this.getInvitations();
        }
        // If user has not been passed as input parameter (used in the BO), just check for current user invitations
        if (this.user === null) {
            this.userEmail = this.userEmail = this.session.getSessionEmail();
        }
        else {
            this.userEmail = this.user.email;
        }
    }
    getInvitations() {
        this.ready = false;
        this.notificationsService.getInvitations().subscribe((res) => {
            this.invitations = res.items;
            setTimeout(() => {
                this.ready = true;
            }, 100);
        });
    }
    putInvitationResponse(vid, mode, type) {
        const data = {
            status: type,
            mode,
        };
        this.notificationsService.putInvitationResponse(vid, data).subscribe(() => {
            let swal_text = '';
            switch (type) {
                case INVITATIONS_TYPES.ACCEPTED:
                    swal_text = this.translationsLib.get('email_invitation_title_accepted');
                    break;
                case INVITATIONS_TYPES.REJECTED:
                    swal_text = this.translationsLib.get('email_invitation_title_rejected');
                    break;
                case INVITATIONS_TYPES.CANCELLED:
                    swal_text = this.translationsLib.get('email_invitation_title_cancelled');
                    break;
            }
            if (swal_text !== '') {
                Swal.fire({
                    text: swal_text,
                    icon: 'success',
                    confirmButtonColor: '#224261',
                });
            }
            this.getInvitations();
        });
    }
    putResendEmail(vid, mode) {
        const data = {
            mode,
        };
        this.notificationsService.putResendEmail(vid, data).subscribe(() => {
            this.getInvitations();
            this.getPending();
        });
    }
    getPending() {
        // eslint-disable-next-line @typescript-eslint/dot-notation
        if (typeof window['mainHeaderNotificationsInterval'] !== undefined) {
            // eslint-disable-next-line @typescript-eslint/dot-notation
            clearInterval(window['mainHeaderNotificationsInterval']);
        }
        // eslint-disable-next-line @typescript-eslint/dot-notation
        window['mainHeaderNotificationsInterval'] = setInterval(() => {
            this.getPending();
        }, this.environmentService.getIntervalDefaultTimeout());
    }
    getRolText(type) {
        return this.usersLib.getRolText(type);
    }
    reload() {
        location.reload();
    }
}
InvitationsComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: InvitationsComponent, deps: [{ token: SessionLibService }, { token: TranslationsLibService }, { token: HelpersLibService }, { token: AnalyticsLibService }, { token: NotificationsService }, { token: UsersLibService }, { token: EnvironmentService }], target: i0.ɵɵFactoryTarget.Component });
InvitationsComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: InvitationsComponent, selector: "lib-invitations", inputs: { showSideHelp: "showSideHelp", invitations: "invitations", user: "user" }, ngImport: i0, template: "<div class=\"card\">\r\n  <div class=\"card-header\">\r\n    <h2 class=\"text-header-primary m-0\">{{ 'notification_invitations' | translation }}</h2>\r\n    <a (click)=\"reload()\" class=\"btn btn-primary p-2 lh-1\">\r\n      <ion-icon name=\"refresh-outline\" class=\"d-flex fs-2\"></ion-icon>\r\n    </a>\r\n  </div>\r\n  <div class=\"card-body px-2 px-sm-4\">\r\n    <div class=\"row\">\r\n      <div class=\"col-12 col-xl-4 col-xxl-3\" *ngIf=\"this.showSideHelp === true\">\r\n        <div class=\"card d-none d-xl-block mb-0\" style=\"position: sticky; top: 1.5rem\">\r\n          <img src=\"assets/img/notifications/invitations.svg\" class=\"card-img-top\" alt=\"...\">\r\n          <div class=\"card-body\">\r\n            <h2 class=\"text-center mt-0 mb-4\" style=\"color: var(--warning-color)\">{{ 'notification_invitations_question' | translation }}</h2>\r\n            <p class=\"card-text\" style=\"text-align: justify\">{{ 'notification_invitations_explain' | translation }}</p>\r\n          </div>\r\n        </div>\r\n        <div class=\"card d-xl-none\">\r\n          <div class=\"row align-items-center\">\r\n            <div class=\"d-none d-sm-block col-4\">\r\n              <img src=\"assets/img/notifications/invitations.svg\" class=\"img-fluid\" alt=\"...\">\r\n            </div>\r\n            <div class=\"col-12 col-sm-8\">\r\n              <div class=\"card-body\">\r\n                <h2 class=\"text-center mt-0 mb-4\" style=\"color: var(--warning-color)\">{{ 'notification_invitations_question' | translation }}</h2>\r\n                <p class=\"card-text\" style=\"text-align: justify\">{{ 'notification_invitations_explain' | translation }}</p>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <div class=\"col-12 col-xl-8 col-xxl-9\" [ngClass]=\"{'col-md-12 col-xxl-12': this.showSideHelp === false}\">\r\n        <lib-loader *ngIf=\"ready === false\"></lib-loader>\r\n        <div class=\"card mb-0\" *ngIf=\"ready === true\">\r\n          <div class=\"card-body py-2\">\r\n            <div *ngIf=\"invitations.length === 0\">\r\n              <h4 class=\"my-4 text-center text-muted\">{{ 'notification_no_invitations' | translation }}</h4>\r\n            </div>\r\n            <div class=\"row\" [ngClass]=\"{'border-bottom': !isLast}\" style=\"min-height: 47px\" *ngFor=\"let invitation of invitations; let isLast = last\">\r\n\r\n              <!-- REVERSE INVITATION: Invitation received -->\r\n              <div class=\"align-self-center col-8 col-sm-9 col-xxl-10 my-2\"\r\n                   *ngIf=\"(invitation.target_user_email === userEmail && invitation.reverse_invitation === true)\">\r\n                <div class=\"row\">\r\n                  <div class=\"col-auto align-self-center d-none d-sm-block\">\r\n                    <img src=\"assets/img/notifications/received.svg\" style=\"width: 25px;\" alt=\"...\">\r\n                  </div>\r\n                  <div class=\"col\">\r\n                    <strong>{{ invitation.source_user_name }} <{{ invitation.source_user_email }}></strong>&nbsp;\r\n                    <span>{{ 'notification_you_have_requested_to_be' | translation }}</span>&nbsp;\r\n                    <strong>{{ getRolText(invitation.element_permission_type) }}</strong>&nbsp;\r\n                    <span>{{ 'notification_of_the_terminal' | translation }}</span>&nbsp;\r\n                    <strong>{{ invitation.element_name }}\r\n                    </strong>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n\r\n              <!-- REVERSE INVITATION: Invitation received -->\r\n              <div class=\"align-self-center col-8 col-sm-9 col-xxl-10 my-2\"\r\n                   *ngIf=\"invitation.target_user_email !== userEmail && invitation.reverse_invitation === true\">\r\n                <div class=\"row\">\r\n                  <div class=\"col-auto align-self-center d-none d-sm-block\">\r\n                    <img src=\"assets/img/notifications/received.svg\" style=\"width: 25px;\" alt=\"...\">\r\n                  </div>\r\n                  <div class=\"col\">\r\n                    <strong>{{ invitation.target_user_name }} <{{ invitation.target_user_email }}></strong>&nbsp;\r\n                    <span>{{ 'notification_you_have_received_a_request' | translation }}</span>&nbsp;\r\n                    <strong>{{ getRolText(invitation.element_permission_type) }}</strong>&nbsp;\r\n                    <span>{{ 'notification_of_the_terminal' | translation }}</span>&nbsp;\r\n                    <strong>{{ invitation.element_name }}</strong>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n\r\n              <!-- REGULAR INVITATION: Invitation sent -->\r\n              <div class=\"align-self-center col-8 col-sm-9 col-xxl-10 my-2\"\r\n                   *ngIf=\"invitation.target_user_email !== userEmail && invitation.reverse_invitation === false\">\r\n                <div class=\"row\">\r\n                  <div class=\"col-auto align-self-center d-none d-sm-block\">\r\n                    <img src=\"assets/img/notifications/sent.svg\" style=\"width: 25px;\" alt=\"...\">\r\n                  </div>\r\n                  <div class=\"col\">\r\n                    <span>{{ 'notification_you_have_invited1' | translation }}</span>&nbsp;\r\n                    <strong>{{ invitation.target_user_name }} <{{ invitation.target_user_email }}></strong>&nbsp;\r\n                    <span>{{ 'notification_you_have_invited2' | translation }}</span>&nbsp;\r\n                    <strong>{{ getRolText(invitation.element_permission_type) }}</strong>&nbsp;\r\n                    <span>{{ 'notification_you_have_invited3' | translation }}</span>&nbsp;\r\n                    <strong>{{ invitation.element_name }}</strong>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n\r\n              <!-- REGULAR INVITATION: Invitation received -->\r\n              <div class=\"align-self-center col-8 col-sm-9 col-xxl-10 my-2\"\r\n                   *ngIf=\"invitation.target_user_email === userEmail && invitation.reverse_invitation === false\">\r\n                <div class=\"row\">\r\n                  <div class=\"col-auto align-self-center d-none d-sm-block\">\r\n                    <img src=\"assets/img/notifications/received.svg\" style=\"width: 25px;\" alt=\"...\">\r\n                  </div>\r\n                  <div class=\"col\">\r\n                    <strong>{{ invitation.source_user_name }} <{{ invitation.source_user_email }}></strong>&nbsp;\r\n                    <span>{{ 'notification_you_have_been_invited1' | translation }}</span>&nbsp;\r\n                    <strong>{{ getRolText(invitation.element_permission_type) }}</strong>&nbsp;\r\n                    <span>{{ 'notification_you_have_been_invited2' | translation }}</span>&nbsp;\r\n                    <strong>{{ invitation.element_name }}</strong>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n\r\n              <div class=\"col-4 col-sm-3 col-xxl-2 my-2 align-self-center text-end p-1\">\r\n                <b *ngIf=\"invitation.invitation_status === 1\">{{ 'notification_accepted' | translation }}</b>\r\n                <b *ngIf=\"invitation.invitation_status === 2\">{{ 'notification_rejected' | translation }}</b>\r\n                <b *ngIf=\"invitation.invitation_status === 3\">{{ 'notification_cancelled' | translation }}</b>\r\n\r\n                <button title=\"{{ 'notification_accept' | translation }}\" type=\"button\" class=\"btn btn-success ms-2 p-2 lh-1\"\r\n                        *ngIf=\"invitation.can_be_accepted\" (click)=\"putInvitationResponse(invitation.vid, invitation.invitation_type, 1)\">\r\n                  <ion-icon name=\"checkmark-circle-outline\" class=\"d-flex fs-2\"></ion-icon>\r\n                </button>\r\n                <button title=\"{{ 'notification_reject' | translation }}\" type=\"button\" class=\"btn btn-danger ms-2 p-2 lh-1\"\r\n                        *ngIf=\"invitation.can_be_rejected\" (click)=\"putInvitationResponse(invitation.vid, invitation.invitation_type, 2)\">\r\n                  <ion-icon name=\"close-outline\" class=\"d-flex fs-2\"></ion-icon>\r\n                </button>\r\n                <button title=\"{{ 'notification_resend_email' | translation }}\" type=\"button\" class=\"btn btn-warning ms-2 p-2 lh-1\"\r\n                        *ngIf=\"invitation.can_be_resent\" (click)=\"putResendEmail(invitation.vid, invitation.invitation_type)\">\r\n                  <ion-icon name=\"arrow-redo-outline\" class=\"d-flex fs-2\"></ion-icon>\r\n                </button>\r\n                <button title=\"{{ 'notification_cancel' | translation }}\" type=\"button\" class=\"btn btn-secondary ms-2 p-2 lh-1\"\r\n                        *ngIf=\"invitation.can_be_cancelled\" (click)=\"putInvitationResponse(invitation.vid, invitation.invitation_type, 3)\">\r\n                  <ion-icon name=\"trash-outline\" class=\"d-flex fs-2\"></ion-icon>\r\n                </button>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [""], dependencies: [{ kind: "directive", type: i5.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i5.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: LoaderComponent, selector: "lib-loader" }, { kind: "component", type: i6.IonIcon, selector: "ion-icon", inputs: ["color", "flipRtl", "icon", "ios", "lazy", "md", "mode", "name", "sanitize", "size", "src"] }, { kind: "pipe", type: TranslationPipe, name: "translation" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: InvitationsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'lib-invitations', template: "<div class=\"card\">\r\n  <div class=\"card-header\">\r\n    <h2 class=\"text-header-primary m-0\">{{ 'notification_invitations' | translation }}</h2>\r\n    <a (click)=\"reload()\" class=\"btn btn-primary p-2 lh-1\">\r\n      <ion-icon name=\"refresh-outline\" class=\"d-flex fs-2\"></ion-icon>\r\n    </a>\r\n  </div>\r\n  <div class=\"card-body px-2 px-sm-4\">\r\n    <div class=\"row\">\r\n      <div class=\"col-12 col-xl-4 col-xxl-3\" *ngIf=\"this.showSideHelp === true\">\r\n        <div class=\"card d-none d-xl-block mb-0\" style=\"position: sticky; top: 1.5rem\">\r\n          <img src=\"assets/img/notifications/invitations.svg\" class=\"card-img-top\" alt=\"...\">\r\n          <div class=\"card-body\">\r\n            <h2 class=\"text-center mt-0 mb-4\" style=\"color: var(--warning-color)\">{{ 'notification_invitations_question' | translation }}</h2>\r\n            <p class=\"card-text\" style=\"text-align: justify\">{{ 'notification_invitations_explain' | translation }}</p>\r\n          </div>\r\n        </div>\r\n        <div class=\"card d-xl-none\">\r\n          <div class=\"row align-items-center\">\r\n            <div class=\"d-none d-sm-block col-4\">\r\n              <img src=\"assets/img/notifications/invitations.svg\" class=\"img-fluid\" alt=\"...\">\r\n            </div>\r\n            <div class=\"col-12 col-sm-8\">\r\n              <div class=\"card-body\">\r\n                <h2 class=\"text-center mt-0 mb-4\" style=\"color: var(--warning-color)\">{{ 'notification_invitations_question' | translation }}</h2>\r\n                <p class=\"card-text\" style=\"text-align: justify\">{{ 'notification_invitations_explain' | translation }}</p>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <div class=\"col-12 col-xl-8 col-xxl-9\" [ngClass]=\"{'col-md-12 col-xxl-12': this.showSideHelp === false}\">\r\n        <lib-loader *ngIf=\"ready === false\"></lib-loader>\r\n        <div class=\"card mb-0\" *ngIf=\"ready === true\">\r\n          <div class=\"card-body py-2\">\r\n            <div *ngIf=\"invitations.length === 0\">\r\n              <h4 class=\"my-4 text-center text-muted\">{{ 'notification_no_invitations' | translation }}</h4>\r\n            </div>\r\n            <div class=\"row\" [ngClass]=\"{'border-bottom': !isLast}\" style=\"min-height: 47px\" *ngFor=\"let invitation of invitations; let isLast = last\">\r\n\r\n              <!-- REVERSE INVITATION: Invitation received -->\r\n              <div class=\"align-self-center col-8 col-sm-9 col-xxl-10 my-2\"\r\n                   *ngIf=\"(invitation.target_user_email === userEmail && invitation.reverse_invitation === true)\">\r\n                <div class=\"row\">\r\n                  <div class=\"col-auto align-self-center d-none d-sm-block\">\r\n                    <img src=\"assets/img/notifications/received.svg\" style=\"width: 25px;\" alt=\"...\">\r\n                  </div>\r\n                  <div class=\"col\">\r\n                    <strong>{{ invitation.source_user_name }} <{{ invitation.source_user_email }}></strong>&nbsp;\r\n                    <span>{{ 'notification_you_have_requested_to_be' | translation }}</span>&nbsp;\r\n                    <strong>{{ getRolText(invitation.element_permission_type) }}</strong>&nbsp;\r\n                    <span>{{ 'notification_of_the_terminal' | translation }}</span>&nbsp;\r\n                    <strong>{{ invitation.element_name }}\r\n                    </strong>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n\r\n              <!-- REVERSE INVITATION: Invitation received -->\r\n              <div class=\"align-self-center col-8 col-sm-9 col-xxl-10 my-2\"\r\n                   *ngIf=\"invitation.target_user_email !== userEmail && invitation.reverse_invitation === true\">\r\n                <div class=\"row\">\r\n                  <div class=\"col-auto align-self-center d-none d-sm-block\">\r\n                    <img src=\"assets/img/notifications/received.svg\" style=\"width: 25px;\" alt=\"...\">\r\n                  </div>\r\n                  <div class=\"col\">\r\n                    <strong>{{ invitation.target_user_name }} <{{ invitation.target_user_email }}></strong>&nbsp;\r\n                    <span>{{ 'notification_you_have_received_a_request' | translation }}</span>&nbsp;\r\n                    <strong>{{ getRolText(invitation.element_permission_type) }}</strong>&nbsp;\r\n                    <span>{{ 'notification_of_the_terminal' | translation }}</span>&nbsp;\r\n                    <strong>{{ invitation.element_name }}</strong>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n\r\n              <!-- REGULAR INVITATION: Invitation sent -->\r\n              <div class=\"align-self-center col-8 col-sm-9 col-xxl-10 my-2\"\r\n                   *ngIf=\"invitation.target_user_email !== userEmail && invitation.reverse_invitation === false\">\r\n                <div class=\"row\">\r\n                  <div class=\"col-auto align-self-center d-none d-sm-block\">\r\n                    <img src=\"assets/img/notifications/sent.svg\" style=\"width: 25px;\" alt=\"...\">\r\n                  </div>\r\n                  <div class=\"col\">\r\n                    <span>{{ 'notification_you_have_invited1' | translation }}</span>&nbsp;\r\n                    <strong>{{ invitation.target_user_name }} <{{ invitation.target_user_email }}></strong>&nbsp;\r\n                    <span>{{ 'notification_you_have_invited2' | translation }}</span>&nbsp;\r\n                    <strong>{{ getRolText(invitation.element_permission_type) }}</strong>&nbsp;\r\n                    <span>{{ 'notification_you_have_invited3' | translation }}</span>&nbsp;\r\n                    <strong>{{ invitation.element_name }}</strong>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n\r\n              <!-- REGULAR INVITATION: Invitation received -->\r\n              <div class=\"align-self-center col-8 col-sm-9 col-xxl-10 my-2\"\r\n                   *ngIf=\"invitation.target_user_email === userEmail && invitation.reverse_invitation === false\">\r\n                <div class=\"row\">\r\n                  <div class=\"col-auto align-self-center d-none d-sm-block\">\r\n                    <img src=\"assets/img/notifications/received.svg\" style=\"width: 25px;\" alt=\"...\">\r\n                  </div>\r\n                  <div class=\"col\">\r\n                    <strong>{{ invitation.source_user_name }} <{{ invitation.source_user_email }}></strong>&nbsp;\r\n                    <span>{{ 'notification_you_have_been_invited1' | translation }}</span>&nbsp;\r\n                    <strong>{{ getRolText(invitation.element_permission_type) }}</strong>&nbsp;\r\n                    <span>{{ 'notification_you_have_been_invited2' | translation }}</span>&nbsp;\r\n                    <strong>{{ invitation.element_name }}</strong>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n\r\n              <div class=\"col-4 col-sm-3 col-xxl-2 my-2 align-self-center text-end p-1\">\r\n                <b *ngIf=\"invitation.invitation_status === 1\">{{ 'notification_accepted' | translation }}</b>\r\n                <b *ngIf=\"invitation.invitation_status === 2\">{{ 'notification_rejected' | translation }}</b>\r\n                <b *ngIf=\"invitation.invitation_status === 3\">{{ 'notification_cancelled' | translation }}</b>\r\n\r\n                <button title=\"{{ 'notification_accept' | translation }}\" type=\"button\" class=\"btn btn-success ms-2 p-2 lh-1\"\r\n                        *ngIf=\"invitation.can_be_accepted\" (click)=\"putInvitationResponse(invitation.vid, invitation.invitation_type, 1)\">\r\n                  <ion-icon name=\"checkmark-circle-outline\" class=\"d-flex fs-2\"></ion-icon>\r\n                </button>\r\n                <button title=\"{{ 'notification_reject' | translation }}\" type=\"button\" class=\"btn btn-danger ms-2 p-2 lh-1\"\r\n                        *ngIf=\"invitation.can_be_rejected\" (click)=\"putInvitationResponse(invitation.vid, invitation.invitation_type, 2)\">\r\n                  <ion-icon name=\"close-outline\" class=\"d-flex fs-2\"></ion-icon>\r\n                </button>\r\n                <button title=\"{{ 'notification_resend_email' | translation }}\" type=\"button\" class=\"btn btn-warning ms-2 p-2 lh-1\"\r\n                        *ngIf=\"invitation.can_be_resent\" (click)=\"putResendEmail(invitation.vid, invitation.invitation_type)\">\r\n                  <ion-icon name=\"arrow-redo-outline\" class=\"d-flex fs-2\"></ion-icon>\r\n                </button>\r\n                <button title=\"{{ 'notification_cancel' | translation }}\" type=\"button\" class=\"btn btn-secondary ms-2 p-2 lh-1\"\r\n                        *ngIf=\"invitation.can_be_cancelled\" (click)=\"putInvitationResponse(invitation.vid, invitation.invitation_type, 3)\">\r\n                  <ion-icon name=\"trash-outline\" class=\"d-flex fs-2\"></ion-icon>\r\n                </button>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n" }]
        }], ctorParameters: function () { return [{ type: SessionLibService }, { type: TranslationsLibService }, { type: HelpersLibService }, { type: AnalyticsLibService }, { type: NotificationsService }, { type: UsersLibService }, { type: EnvironmentService }]; }, propDecorators: { showSideHelp: [{
                type: Input
            }], invitations: [{
                type: Input
            }], user: [{
                type: Input
            }] } });

class NotificationsModule {
}
NotificationsModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: NotificationsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
NotificationsModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: NotificationsModule, declarations: [InvitationsComponent], imports: [CommonModule,
        AppCommonsModule,
        IonicModule,
        MatExpansionModule,
        MatTabsModule,
        MatTreeModule,
        MatButtonModule,
        MatTooltipModule,
        MatAutocompleteModule,
        MatInputModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatRadioModule,
        MatIconModule,
        MatMenuModule,
        App360SharedModule,
        NgIf], exports: [InvitationsComponent] });
NotificationsModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: NotificationsModule, imports: [CommonModule,
        AppCommonsModule,
        IonicModule,
        MatExpansionModule,
        MatTabsModule,
        MatTreeModule,
        MatButtonModule,
        MatTooltipModule,
        MatAutocompleteModule,
        MatInputModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatRadioModule,
        MatIconModule,
        MatMenuModule,
        App360SharedModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: NotificationsModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        InvitationsComponent,
                    ],
                    exports: [
                        InvitationsComponent,
                    ],
                    imports: [
                        CommonModule,
                        AppCommonsModule,
                        IonicModule,
                        MatExpansionModule,
                        MatTabsModule,
                        MatTreeModule,
                        MatButtonModule,
                        MatTooltipModule,
                        MatAutocompleteModule,
                        MatInputModule,
                        ReactiveFormsModule,
                        MatFormFieldModule,
                        MatRadioModule,
                        MatIconModule,
                        MatMenuModule,
                        App360SharedModule,
                        NgIf
                    ]
                }]
        }] });

class TerminalsRestApiService {
    constructor(httpRepositoryService) {
        this.httpRepositoryService = httpRepositoryService;
    }
    getPrePairing(data) {
        return this.httpRepositoryService.getRequest('pairing/terminal/' + data);
    }
    postPairing(data, tVid) {
        return this.httpRepositoryService.postRequest('pairing/terminal/' + tVid, data);
    }
    getIrrigationValves(vid) {
        return this.httpRepositoryService.getRequest('farming/' + vid + '/valves/management');
    }
    putIrrigationValves(vid, data) {
        return this.httpRepositoryService.putRequest('farming/' + vid + '/valves/management', data);
    }
    getNonAttached() {
        return this.httpRepositoryService.getRequest('terminals/non-attached');
    }
    getNonAttachedOfFieldOwner(fieldVid) {
        return this.httpRepositoryService.getRequest('backoffice-users/terminals/non-attached-by-field/' + fieldVid);
    }
    getNonDemo() {
        return this.httpRepositoryService.getRequest('terminals/non-demo');
    }
    postAttaching(tVid, fVid) {
        return this.httpRepositoryService.postRequest('pairing/attach-terminal/' + tVid + '/to-field/' + fVid, []);
    }
    backofficePostAttaching(tVid, fVid) {
        return this.httpRepositoryService.postRequest('backoffice-users/pairing/attach-terminal/' + tVid + '/to-field/' + fVid, []);
    }
    getTerminals() {
        return this.httpRepositoryService.getRequest('terminals');
    }
    getTerminal(vid) {
        return this.httpRepositoryService.getRequest('terminals/' + vid);
    }
    getUserContacts(vid) {
        return this.httpRepositoryService.getRequest('users/' + vid + '/contacts');
    }
    postDetaching(tVid, fVid) {
        return this.httpRepositoryService.deleteRequest('pairing/detach-terminal/' + tVid + '/from-field/' + fVid);
    }
    backofficePostDetaching(tVid, fVid) {
        return this.httpRepositoryService.deleteRequest('backoffice-users/pairing/detach-terminal/' + tVid + '/from-field/' + fVid);
    }
    getTerminalsApiInfo(data) {
        return this.httpRepositoryService.postRequest('farming/multi-terminal/nuve/equipment?q=valves', data);
    }
    getTerminalsApiInfoWithWaterSystems(data) {
        return this.httpRepositoryService.postRequest('farming/multi-terminal/nuve/equipment?q=watersystems-status', data);
    }
    getPickUpConfig(vid) {
        return this.httpRepositoryService.getRequest('farming/' + vid + '/equipment/pick_up_config');
    }
    getConfigStatus(vid) {
        return this.httpRepositoryService.getRequest('farming/' + vid + '/equipment/config_status');
    }
    putUpdateTerminal(data, vid) {
        return this.httpRepositoryService.putRequest('terminals/' + vid, data);
    }
    putEquipment(vid, data) {
        //Es un post aunque sea el de editar
        return this.httpRepositoryService.postRequest('farming/' + vid + '/equipment', data);
    }
    setUpConfig(vid) {
        return this.httpRepositoryService.postRequest('farming/' + vid + '/equipment/pick_up_config', []);
    }
    postActivateTerminal(vid) {
        return this.httpRepositoryService.postRequest('terminals/' + vid + '/activate', []);
    }
    getDevices(terminalVid) {
        return this.httpRepositoryService.getRequest(`farming/${terminalVid}/devices`);
    }
    getTerminalAdministrativeManagement(vid) {
        return this.httpRepositoryService.getRequest('terminals/' + vid + '/administrative-management');
    }
    claimTerminalAdministrativeManagement(vid) {
        return this.httpRepositoryService.postRequest('terminals/' + vid + '/claim-administrative-management', {});
    }
    transferTerminalAdministrativeManagement(vid) {
        return this.httpRepositoryService.postRequest('terminals/' + vid + '/transfer-administrative-management', {});
    }
    getTerminalSpecificTemplates(terminalVid) {
        return this.httpRepositoryService.getRequest(`terminals/${terminalVid}/specific-templates-configuration`);
    }
    getTerminalAvailableTemplates(terminalVid) {
        return this.httpRepositoryService.getRequest(`terminals/${terminalVid}/available-master-templates-configuration`);
    }
    postAttachMasterTemplate(terminalVid, templateId, screenName) {
        return this.httpRepositoryService.postRequest(`terminals/${terminalVid}/attach-master-templates-configuration/${templateId}/to-screen/${screenName}`, []);
    }
    deleteSpecificTemplate(terminalVid, specificTemplateVid) {
        return this.httpRepositoryService.deleteRequest(`terminals/${terminalVid}/specific-templates-configuration/${specificTemplateVid}`);
    }
    releaseTerminalAdministrativeManagement(vid) {
        return this.httpRepositoryService.putRequest('terminals/' + vid + '/release-administrative-management', {});
    }
    enableTerminal(vid) {
        return this.httpRepositoryService.postRequest('terminals/' + vid + '/enable', {});
    }
    temporaryDisableTerminal(vid) {
        return this.httpRepositoryService.postRequest('terminals/' + vid + '/temporary-disable', {});
    }
}
TerminalsRestApiService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: TerminalsRestApiService, deps: [{ token: HttpRepositoryService }], target: i0.ɵɵFactoryTarget.Injectable });
TerminalsRestApiService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: TerminalsRestApiService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: TerminalsRestApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: HttpRepositoryService }]; } });

class TerminalsService {
    constructor(terminalsRestApiService) {
        this.terminalsRestApiService = terminalsRestApiService;
        //
    }
    getPrePairing(data) {
        return this.terminalsRestApiService.getPrePairing(data);
    }
    postPairing(data, tVid) {
        return this.terminalsRestApiService.postPairing(data, tVid);
    }
    getTerminalValves(vid) {
        return this.terminalsRestApiService.getIrrigationValves(vid);
    }
    putTerminalValves(vid, data) {
        return this.terminalsRestApiService.putIrrigationValves(vid, data);
    }
    getNonAttached() {
        return this.terminalsRestApiService.getNonAttached();
    }
    getNonAttachedOfFieldOwner(fieldVid) {
        return this.terminalsRestApiService.getNonAttachedOfFieldOwner(fieldVid);
    }
    getNonDemo() {
        return this.terminalsRestApiService.getNonDemo();
    }
    postAttaching(tVid, fVid) {
        return this.terminalsRestApiService.postAttaching(tVid, fVid);
    }
    backofficePostAttaching(tVid, fVid) {
        return this.terminalsRestApiService.backofficePostAttaching(tVid, fVid);
    }
    getTerminals() {
        return this.terminalsRestApiService.getTerminals();
    }
    getTerminal(vid) {
        return this.terminalsRestApiService.getTerminal(vid);
    }
    getUserContacts(vid) {
        return this.terminalsRestApiService.getUserContacts(vid);
    }
    detachTerminalfromField(tVid, fVid) {
        return this.terminalsRestApiService.postDetaching(tVid, fVid);
    }
    backofficeDetachTerminalfromField(tVid, fVid) {
        return this.terminalsRestApiService.backofficePostDetaching(tVid, fVid);
    }
    getTerminalsApiInfo(data) {
        return this.terminalsRestApiService.getTerminalsApiInfo(data);
    }
    getTerminalsApiInfoWithWaterSystems(data) {
        return this.terminalsRestApiService.getTerminalsApiInfoWithWaterSystems(data);
    }
    getPickUpConfig(vid) {
        return this.terminalsRestApiService.getPickUpConfig(vid);
    }
    getConfigStatus(vid) {
        return this.terminalsRestApiService.getConfigStatus(vid);
    }
    putUpdateTerminal(data, vid) {
        return this.terminalsRestApiService.putUpdateTerminal(data, vid);
    }
    putEquipment(vid, data) {
        return this.terminalsRestApiService.putEquipment(vid, data);
    }
    setUpConfig(vid) {
        return this.terminalsRestApiService.setUpConfig(vid);
    }
    postActivation(vid) {
        return this.terminalsRestApiService.postActivateTerminal(vid);
    }
    getDevices(vid) {
        return this.terminalsRestApiService.getDevices(vid);
    }
    getTerminalAdministrativeManagement(vid) {
        return this.terminalsRestApiService.getTerminalAdministrativeManagement(vid);
    }
    claimTerminalAdministrativeManagement(vid) {
        return this.terminalsRestApiService.claimTerminalAdministrativeManagement(vid);
    }
    transferTerminalAdministrativeManagement(vid) {
        return this.terminalsRestApiService.transferTerminalAdministrativeManagement(vid);
    }
    getTerminalSpecificTemplates(vid) {
        return this.terminalsRestApiService.getTerminalSpecificTemplates(vid);
    }
    getTerminalAvailableTemplates(vid) {
        return this.terminalsRestApiService.getTerminalAvailableTemplates(vid);
    }
    postAttachMasterTemplates(terminalVid, templateId, screenName) {
        return this.terminalsRestApiService.postAttachMasterTemplate(terminalVid, templateId, screenName);
    }
    deleteAttachedSpecificTemplates(terminalVid, specificTemplateVid) {
        return this.terminalsRestApiService.deleteSpecificTemplate(terminalVid, specificTemplateVid);
    }
    releaseTerminalAdministrativeManagement(vid) {
        return new Observable((observer) => {
            this.terminalsRestApiService
                .releaseTerminalAdministrativeManagement(vid)
                .subscribe((response) => {
                observer.next(response);
            }, (error) => {
                observer.error(error);
            });
        });
    }
    enableTerminal(vid) {
        return new Observable((observer) => {
            this.terminalsRestApiService.enableTerminal(vid).subscribe((response) => {
                observer.next(response);
            }, (error) => {
                observer.error(error);
            });
        });
    }
    temporaryDisableTerminal(vid) {
        return new Observable((observer) => {
            this.terminalsRestApiService.temporaryDisableTerminal(vid).subscribe((response) => {
                observer.next(response);
            }, (error) => {
                observer.error(error);
            });
        });
    }
}
TerminalsService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: TerminalsService, deps: [{ token: TerminalsRestApiService }], target: i0.ɵɵFactoryTarget.Injectable });
TerminalsService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: TerminalsService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: TerminalsService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: TerminalsRestApiService }]; } });

class OrganizationsService {
    constructor(environmentService) {
        this.environmentService = environmentService;
        this.host = this.environmentService.getBackend();
    }
    getOrganizationAvatarLogo(organizationVid) {
        return this.host + '/organizations/' + organizationVid + '/avatar-logo';
    }
    parsedOrganizations(organizations) {
        organizations.forEach((organization, index) => {
            organizations[index] = this.parseOrganization(organization);
        });
        return organizations;
    }
    parseOrganization(organization) {
        if (organization.avatar_logo && organization.avatar_logo.trim() !== '') {
            organization.avatar_logo = this.getOrganizationAvatarLogo(organization.vid);
        }
        return organization;
    }
}
OrganizationsService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: OrganizationsService, deps: [{ token: EnvironmentService }], target: i0.ɵɵFactoryTarget.Injectable });
OrganizationsService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: OrganizationsService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: OrganizationsService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: EnvironmentService }]; } });

class OrganizationsItemProfileComponent {
    constructor(translationsLib, organizationService) {
        this.translationsLib = translationsLib;
        this.organizationService = organizationService;
        this.organizations = [];
        this.showTitle = true;
        this.parsedOrganizations = [];
    }
    ngOnInit() {
        this.parsedOrganizations = this.organizationService.parsedOrganizations(this.organizations);
    }
}
OrganizationsItemProfileComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: OrganizationsItemProfileComponent, deps: [{ token: TranslationsLibService }, { token: OrganizationsService }], target: i0.ɵɵFactoryTarget.Component });
OrganizationsItemProfileComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: OrganizationsItemProfileComponent, selector: "lib-organizations-item-profile", inputs: { organizations: "organizations", showTitle: "showTitle" }, ngImport: i0, template: "<div class=\"row justify-content-between\">\n  <div class=\"col-12\">\n    <div class=\"row\" *ngIf=\"showTitle === true\">\n      <div class=\"col-12\">\n        <h2>\n          {{ 'organizations_organizations' | translation }}\n        </h2>\n      </div>\n    </div>\n    <div class=\"row\">\n      <div class=\"col-12\" *ngIf=\"parsedOrganizations.length > 0\">\n        <div class=\"row mb-2\">\n          <div class=\"col-12 col-lg-6\" *ngFor=\"let parsedOrganization of parsedOrganizations\">\n            <h5 class=\"mt-2\">\n              <ng-container *ngIf=\"parsedOrganization.root_organization !== null && parsedOrganization.vid !== parsedOrganization.root_organization.vid\">\n                {{ parsedOrganization.root_organization.name }}:\n              </ng-container>\n              <ng-container *ngIf=\"parsedOrganization.name === 'CATCH_ALL_OU'\">\n                {{ 'organizations_CATCH_ALL_OU' | translation }}\n              </ng-container>\n              <ng-container *ngIf=\"parsedOrganization.name !== 'CATCH_ALL_OU'\">\n                {{ parsedOrganization.name }}\n              </ng-container>\n            </h5>\n            <img class=\"item-avatar-logo\" src=\"{{ parsedOrganization.avatar_logo }}\" *ngIf=\"parsedOrganization.avatar_logo\"/>\n          </div>\n        </div>\n        <div class=\"row\">\n          <div class=\"col-12\">\n            <div class=\"small text-muted mb-md-0\" [innerHTML]=\"'organizations_help_text' | translation\"></div>\n          </div>\n        </div>\n      </div>\n      <div class=\"col-12\" *ngIf=\"parsedOrganizations.length === 0\">\n        <p class=\"small text-muted mb-md-0\">\n          {{ 'organizations_no_organization' | translation }}\n        </p>\n      </div>\n    </div>\n  </div>\n</div>\n", styles: [".item-avatar-logo{max-width:125px;max-height:125px}\n"], dependencies: [{ kind: "directive", type: i5.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "pipe", type: TranslationPipe, name: "translation" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: OrganizationsItemProfileComponent, decorators: [{
            type: Component,
            args: [{ selector: 'lib-organizations-item-profile', template: "<div class=\"row justify-content-between\">\n  <div class=\"col-12\">\n    <div class=\"row\" *ngIf=\"showTitle === true\">\n      <div class=\"col-12\">\n        <h2>\n          {{ 'organizations_organizations' | translation }}\n        </h2>\n      </div>\n    </div>\n    <div class=\"row\">\n      <div class=\"col-12\" *ngIf=\"parsedOrganizations.length > 0\">\n        <div class=\"row mb-2\">\n          <div class=\"col-12 col-lg-6\" *ngFor=\"let parsedOrganization of parsedOrganizations\">\n            <h5 class=\"mt-2\">\n              <ng-container *ngIf=\"parsedOrganization.root_organization !== null && parsedOrganization.vid !== parsedOrganization.root_organization.vid\">\n                {{ parsedOrganization.root_organization.name }}:\n              </ng-container>\n              <ng-container *ngIf=\"parsedOrganization.name === 'CATCH_ALL_OU'\">\n                {{ 'organizations_CATCH_ALL_OU' | translation }}\n              </ng-container>\n              <ng-container *ngIf=\"parsedOrganization.name !== 'CATCH_ALL_OU'\">\n                {{ parsedOrganization.name }}\n              </ng-container>\n            </h5>\n            <img class=\"item-avatar-logo\" src=\"{{ parsedOrganization.avatar_logo }}\" *ngIf=\"parsedOrganization.avatar_logo\"/>\n          </div>\n        </div>\n        <div class=\"row\">\n          <div class=\"col-12\">\n            <div class=\"small text-muted mb-md-0\" [innerHTML]=\"'organizations_help_text' | translation\"></div>\n          </div>\n        </div>\n      </div>\n      <div class=\"col-12\" *ngIf=\"parsedOrganizations.length === 0\">\n        <p class=\"small text-muted mb-md-0\">\n          {{ 'organizations_no_organization' | translation }}\n        </p>\n      </div>\n    </div>\n  </div>\n</div>\n", styles: [".item-avatar-logo{max-width:125px;max-height:125px}\n"] }]
        }], ctorParameters: function () { return [{ type: TranslationsLibService }, { type: OrganizationsService }]; }, propDecorators: { organizations: [{
                type: Input
            }], showTitle: [{
                type: Input
            }] } });

class OrganizationsModule {
}
OrganizationsModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: OrganizationsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
OrganizationsModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: OrganizationsModule, declarations: [OrganizationsItemProfileComponent], imports: [NgForOf, NgIf, JsonPipe, NgClass, App360SharedModule], exports: [OrganizationsItemProfileComponent] });
OrganizationsModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: OrganizationsModule, imports: [App360SharedModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: OrganizationsModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [OrganizationsItemProfileComponent],
                    exports: [OrganizationsItemProfileComponent],
                    imports: [NgForOf, NgIf, JsonPipe, NgClass, App360SharedModule],
                }]
        }] });

class ModulesRestApiService {
    constructor(httpRepositoryService) {
        this.httpRepositoryService = httpRepositoryService;
    }
    getModules() {
        return this.httpRepositoryService.getRequest('modules');
    }
    getModulesByVid(vid) {
        return this.httpRepositoryService.getRequest('modules/' + vid);
    }
    getModulesByTerminalVid(terminalVid) {
        return this.httpRepositoryService.getRequest('modules/find-by-terminal/' + terminalVid);
    }
    getModuleDataByVid(vid, data) {
        return this.httpRepositoryService.getRequest('modules/' +
            vid +
            '/data?starting_at=' +
            data.start +
            '&ending_at=' +
            data.end);
    }
    putModules(vid, data) {
        return this.httpRepositoryService.putRequest('modules/' + vid, data);
    }
    postModules(vid, data) {
        return this.httpRepositoryService.postRequest('modules/' + vid, data);
    }
    getBackofficeModules(page) {
        return this.httpRepositoryService.getRequest('backoffice-modules/modules?page=' + page);
    }
    getBackofficeModulesFilter(data) {
        return this.httpRepositoryService.getRequest('backoffice-modules/modules?' + data);
    }
    getBackofficeModulesData(vid) {
        return this.httpRepositoryService.getRequest('backoffice-modules/modules/' + vid + '/data');
    }
    postBackofficeModulesData(vid, type, data) {
        return this.httpRepositoryService.postRequest('backoffice-modules/modules/' + vid + '/data-by-type/' + type, data);
    }
    putBackofficeModulesData(vid, data) {
        return this.httpRepositoryService.putRequest('backoffice-modules/modules/' + vid + '/data', data);
    }
    getBackofficeModulesDataWithDates(vid, data) {
        return this.httpRepositoryService.getRequest('backoffice-modules/modules/' +
            vid +
            '/data?starting_at=' +
            +data.start +
            '&ending_at=' +
            data.end);
    }
    getIRISPrediction(vid) {
        return this.httpRepositoryService.getRequest('iris/irrigation-consulting/prediction/' + vid);
    }
}
ModulesRestApiService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: ModulesRestApiService, deps: [{ token: HttpRepositoryService }], target: i0.ɵɵFactoryTarget.Injectable });
ModulesRestApiService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: ModulesRestApiService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: ModulesRestApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: HttpRepositoryService }]; } });

class ModulesService {
    constructor(modulesRestApiService) {
        this.modulesRestApiService = modulesRestApiService;
    }
    getModules() {
        return this.modulesRestApiService.getModules();
    }
    getModulesByVid(vid) {
        return this.modulesRestApiService.getModulesByVid(vid);
    }
    getModulesByTerminalVid(vid) {
        return this.modulesRestApiService.getModulesByTerminalVid(vid);
    }
    getModuleDataByVid(vid, data) {
        return this.modulesRestApiService.getModuleDataByVid(vid, data);
    }
    putModule(vid, data) {
        return this.modulesRestApiService.putModules(vid, data);
    }
    getBackofficeModules(page) {
        return this.modulesRestApiService.getBackofficeModules(page);
    }
    getBackofficeModulesFilter(page) {
        return this.modulesRestApiService.getBackofficeModulesFilter(page);
    }
    getBackofficeModulesData(vid) {
        return this.modulesRestApiService.getBackofficeModulesData(vid);
    }
    getBackofficeModulesDataWithDates(vid, date) {
        return this.modulesRestApiService.getBackofficeModulesDataWithDates(vid, date);
    }
    putBackofficeModulesData(vid, data) {
        return this.modulesRestApiService.putBackofficeModulesData(vid, data);
    }
    postBackofficeModulesData(vid, type, data) {
        return this.modulesRestApiService.postBackofficeModulesData(vid, type, data);
    }
    getIRISPrediction(vid) {
        return this.modulesRestApiService.getIRISPrediction(vid);
    }
}
ModulesService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: ModulesService, deps: [{ token: ModulesRestApiService }], target: i0.ɵɵFactoryTarget.Injectable });
ModulesService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: ModulesService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: ModulesService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: ModulesRestApiService }]; } });

class PermissionsRestApiService {
    constructor(httpRepositoryService) {
        this.httpRepositoryService = httpRepositoryService;
    }
    getPermissionList() {
        return this.httpRepositoryService.getRequest('pairing/permissions-list');
    }
    postAttachUsertoField(email, vid, data) {
        return this.httpRepositoryService.postRequest('pairing/attach-user/' + email + '/to-field/' + vid, data);
    }
    changeUserFieldPermissions(email, vid, data) {
        return this.httpRepositoryService.postRequest('pairing/attach-user/' + email + '/to-field/' + vid, data);
    }
    backofficeChangeUserFieldPermissions(email, vid, data) {
        return this.httpRepositoryService.postRequest('backoffice-users/pairing/attach-user/' + email + '/to-field/' + vid, data);
    }
    changeUserTerminalPermissions(email, vid, data) {
        return this.httpRepositoryService.postRequest('pairing/attach-user/' + email + '/to-terminal/' + vid, data);
    }
    postAttachUsertoTerminal(email, vid, data) {
        return this.httpRepositoryService.postRequest('pairing/attach-user/' + email + '/to-terminal/' + vid, data);
    }
    getUserContacts(vid) {
        return this.httpRepositoryService.getRequest('users/' + vid + '/contacts');
    }
    detachUserFromTerminal(email, vid) {
        return this.httpRepositoryService.deleteRequest('pairing/detach-user/' + email + '/from-terminal/' + vid);
    }
    detachInstallerFromTerminal(email, vid) {
        return this.httpRepositoryService.deleteRequest('/pairing/detach-installer/' + email + '/from-terminal/' + vid);
    }
    detachUserFromField(email, vid) {
        return this.httpRepositoryService.deleteRequest('/pairing/detach-user/' + email + '/from-field/' + vid);
    }
    backofficeDetachUserFromField(email, vid) {
        return this.httpRepositoryService.deleteRequest('backoffice-users/pairing/detach-user/' + email + '/from-field/' + vid);
    }
    getFields() {
        return this.httpRepositoryService.getRequest('fields');
    }
    postPairingAttachToDemo() {
        return this.httpRepositoryService.postRequest('pairing/attach-to-demo', {});
    }
    deletePairingDetachFromDemo() {
        return this.httpRepositoryService.deleteRequest('pairing/detach-from-demo');
    }
}
PermissionsRestApiService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: PermissionsRestApiService, deps: [{ token: HttpRepositoryService }], target: i0.ɵɵFactoryTarget.Injectable });
PermissionsRestApiService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: PermissionsRestApiService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: PermissionsRestApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: HttpRepositoryService }]; } });

class PermissionsService {
    constructor(permissionsRestApiService) {
        this.permissionsRestApiService = permissionsRestApiService;
    }
    getPermissionsList() {
        return this.permissionsRestApiService.getPermissionList();
    }
    pairUsertoField(email, vid, data) {
        return this.permissionsRestApiService.postAttachUsertoField(email, vid, data);
    }
    changeUserFieldPermissions(email, vid, data) {
        return this.permissionsRestApiService.changeUserFieldPermissions(email, vid, data);
    }
    backofficeChangeUserFieldPermissions(email, vid, data) {
        return this.permissionsRestApiService.backofficeChangeUserFieldPermissions(email, vid, data);
    }
    changeUserTerminalPermissions(email, vid, data) {
        return this.permissionsRestApiService.changeUserTerminalPermissions(email, vid, data);
    }
    pairUsertoTerminal(email, vid, data) {
        return this.permissionsRestApiService.postAttachUsertoTerminal(email, vid, data);
    }
    getUserContacts(vid) {
        return this.permissionsRestApiService.getUserContacts(vid);
    }
    detachUserFromTerminal(email, vid) {
        return this.permissionsRestApiService.detachUserFromTerminal(email, vid);
    }
    detachInstallerFromTerminal(email, vid) {
        return this.permissionsRestApiService.detachInstallerFromTerminal(email, vid);
    }
    detachUserFromField(email, vid) {
        return this.permissionsRestApiService.detachUserFromField(email, vid);
    }
    backofficeDetachUserFromField(email, vid) {
        return this.permissionsRestApiService.backofficeDetachUserFromField(email, vid);
    }
    getFields() {
        return this.permissionsRestApiService.getFields();
    }
    postPairingAttachToDemo() {
        return this.permissionsRestApiService.postPairingAttachToDemo();
    }
    deletePairingDetachFromDemo() {
        return this.permissionsRestApiService.deletePairingDetachFromDemo();
    }
}
PermissionsService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: PermissionsService, deps: [{ token: PermissionsRestApiService }], target: i0.ɵɵFactoryTarget.Injectable });
PermissionsService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: PermissionsService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: PermissionsService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: PermissionsRestApiService }]; } });

class PermissionTableMainComponent {
    constructor(translationsLib, terminalService, permissionService, breakpointObserver) {
        this.translationsLib = translationsLib;
        this.terminalService = terminalService;
        this.permissionService = permissionService;
        this.breakpointObserver = breakpointObserver;
        this.terminalVid = '';
        this.mode = '';
        this.owner = null;
        this.installer = null;
        this.authedUserCanAdminOwner = false;
        this.authedUserCanAdminInstaller = false;
        this.showAttachInstaller = false;
        this.showAttachOwner = false;
        this.attachInstallerForm = new FormControl('');
        this.attachOwnerForm = new FormControl('');
        this.isMobile = false;
    }
    ngOnInit() {
        this.owner = this.owner || null;
        this.installer = this.installer || null;
    }
    ngAfterViewInit() {
        this.breakpointObserver
            .observe([Breakpoints.XSmall])
            .subscribe((result) => {
            this.isMobile = result.matches;
        });
    }
    attachInstallerToTerminal() {
        this.terminalService
            .postPairing({
            pair_installer: this.attachInstallerForm.value,
        }, this.terminalVid)
            .subscribe((paired) => {
            if (paired.paired_installer === this.attachInstallerForm.value &&
                paired.paired_installer_status === 'pending_invitation') {
                Swal.fire({
                    text: this.translationsLib.get('permission_invitation_sent'),
                    icon: 'success',
                    confirmButtonColor: '#224261',
                }).then((res) => {
                    if (res.isConfirmed || res.isDismissed) {
                        this.showAttachInstaller = false;
                    }
                });
            }
            else {
                Swal.fire({
                    text: this.translationsLib.get('permission_invitation_sent_to_installer_error'),
                    icon: 'error',
                    confirmButtonColor: '#224261',
                }).then();
            }
        });
    }
    detachInstallerFromTerminal() {
        Swal.fire({
            text: this.translationsLib.get('permission_confirm_detach_installer_from_terminal'),
            icon: 'warning',
            confirmButtonColor: '#224261',
            showDenyButton: true,
            confirmButtonText: this.translationsLib.get('accept'),
            denyButtonText: this.translationsLib.get('cancel'),
        }).then((res) => {
            if (res.isConfirmed) {
                this.permissionService
                    .detachInstallerFromTerminal(this.installer.email, this.terminalVid)
                    .subscribe(() => {
                    Swal.fire({
                        text: this.translationsLib.get('save_changes_success'),
                        showConfirmButton: true,
                        confirmButtonText: this.translationsLib.get('accept'),
                        icon: 'success',
                    }).then(() => {
                        this.installer = null;
                        this.ngOnInit();
                    });
                });
            }
        });
    }
    attachOwnerToTerminal() {
        this.terminalService
            .postPairing({
            pair_owner: this.attachOwnerForm.value,
        }, this.terminalVid)
            .subscribe((paired) => {
            if (paired.paired_owner === this.attachOwnerForm.value &&
                paired.paired_owner_status === 'pending_invitation') {
                Swal.fire({
                    text: this.translationsLib.get('permission_invitation_sent'),
                    icon: 'success',
                    confirmButtonColor: '#224261',
                }).then((res) => {
                    if (res.isConfirmed || res.isDismissed) {
                        this.showAttachOwner = false;
                    }
                });
            }
            else {
                Swal.fire({
                    text: this.translationsLib.get('permission_invitation_sent_to_owner_error'),
                    icon: 'error',
                    confirmButtonColor: '#224261',
                }).then();
            }
        });
    }
}
PermissionTableMainComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: PermissionTableMainComponent, deps: [{ token: TranslationsLibService }, { token: TerminalsService }, { token: PermissionsService }, { token: i4$1.BreakpointObserver }], target: i0.ɵɵFactoryTarget.Component });
PermissionTableMainComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: PermissionTableMainComponent, selector: "lib-permission-table-main", inputs: { terminalVid: "terminalVid", mode: "mode", owner: "owner", installer: "installer", authedUserCanAdminOwner: "authedUserCanAdminOwner", authedUserCanAdminInstaller: "authedUserCanAdminInstaller" }, ngImport: i0, template: "<div class=\"card p-3 shadow-none\">\n  <div class=\"card-header p-0\">\n    <div class=\"card-header-title\">\n      <div class=\"row\">\n        <div class=\"col-6\">\n          <h1 class=\"text-start\">{{ 'permission_main_permissions' | translation }}</h1>\n        </div>\n        <div class=\"col-6 align-self-center\">\n\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class=\"card-body p-0\">\n    <div class=\"row\" *ngIf=\"isMobile\">\n      <!-- MOBILE MAIN PERMISSIONS: INSTALLER -->\n      <div class=\"col-12 mt-2\" *ngIf=\"mode === 'terminal'\">\n        <div>\n          {{ 'permission_installer' | translation }}\n        </div>\n        <div class=\"fw-bold mt-2\">\n          <ng-container *ngIf=\"installer\">\n            <div class=\"fw-bold\">\n              {{ installer.name }} {{ installer.surname }}\n            </div>\n            <div class=\"text-muted\">\n              {{ installer.email }}\n            </div>\n          </ng-container>\n          <ng-container *ngIf=\"!installer\">\n            <div class=\"fw-bold\">\n              {{ 'permission_no_installer' | translation }}\n            </div>\n          </ng-container>\n        </div>\n        <div class=\"fw-normal text-muted mt-1\" *ngIf=\"!installer\">\n          {{ 'permission_invitation_pending' | translation }}\n        </div>\n        <div class=\"mt-3\" *ngIf=\"authedUserCanAdminInstaller\">\n          <ng-container *ngTemplateOutlet=\"installerAction\"></ng-container>\n        </div>\n      </div>\n      <hr *ngIf=\"mode === 'terminal'\" class=\"mt-3 mb-2\">\n      <!-- MOBILE MAIN PERMISSIONS: OWNER -->\n      <div class=\"col-12\">\n        <div>\n          {{ 'permission_owner' | translation }}\n        </div>\n        <div class=\"fw-bold mt-2\">\n          <ng-container *ngIf=\"owner\">\n            <div class=\"fw-bold\">\n              {{ owner.name }} {{ owner.surname }}\n            </div>\n            <div class=\"text-muted\">\n              {{ owner.email }}\n            </div>\n          </ng-container>\n          <ng-container *ngIf=\"!owner\">\n            <div class=\"fw-bold\">\n              {{ 'permission_no_owner' | translation }}\n            </div>\n          </ng-container>\n        </div>\n        <div class=\"d-block d-sm-none text-muted mt-1\" *ngIf=\"!owner\">\n          {{ 'permission_invitation_pending' | translation }}\n        </div>\n        <div class=\"mt-3\" *ngIf=\"authedUserCanAdminOwner\">\n          <ng-container *ngTemplateOutlet=\"ownerAction\"></ng-container>\n        </div>\n      </div>\n    </div>\n\n    <!-- DESKTOP MAIN PERMISSIONS TABLE -->\n    <table *ngIf=\"!isMobile\"\n           class=\"table table-responsive-sm card-table\">\n      <thead>\n      <tr>\n        <th class=\"col-4 px-1 px-sm-2\">\n          {{ 'permission_user_s' | translation }}\n        </th>\n        <th class=\"col-2 px-1 px-sm-2\">\n          {{ 'permission_type' | translation }}\n        </th>\n        <th class=\"col-2 col-sm-4 px-1 px-sm-2 text-center\">\n          {{ 'status' | translation }}\n        </th>\n        <th class=\"col-4 col-sm-2 px-1 px-sm-2 text-center\"\n            *ngIf=\"authedUserCanAdminInstaller === true || authedUserCanAdminOwner === true\">\n          {{ 'permission_action' | translation }}\n        </th>\n      </tr>\n      </thead>\n      <tbody>\n      <!-- DESKTOP MAIN PERMISSIONS: INSTALLER -->\n      <tr *ngIf=\"mode === 'terminal'\">\n        <td class=\"px-1 px-sm-2\">\n          <ng-container *ngIf=\"installer\">\n            <div class=\"fw-bold\">\n              {{ installer.name }} {{ installer.surname }}\n            </div>\n            <div class=\"text-muted fw-normal\">\n              {{ installer.email }}\n            </div>\n          </ng-container>\n          <ng-container *ngIf=\"!installer\">\n            <div class=\"fw-bold\">\n              {{ 'permission_no_installer' | translation }}\n            </div>\n            <div class=\"fw-normal text-muted\">\n              {{ 'permission_invitation_pending' | translation }}\n            </div>\n          </ng-container>\n        </td>\n        <td class=\"px-1 px-sm-2\">\n          {{ 'permission_installer' | translation }}\n        </td>\n        <td class=\"px-1 px-sm-2 text-center\">\n          <div class=\"checkbox-ok\" *ngIf=\"installer\">\n            <ion-icon name=\"checkmark-outline\"></ion-icon>\n          </div>\n          <div class=\"checkbox-ko\" *ngIf=\"!installer\">\n            <ion-icon name=\"close-outline\"></ion-icon>\n          </div>\n        </td>\n        <td class=\"px-1 px-sm-2 text-center\" *ngIf=\"authedUserCanAdminInstaller === true\">\n          <ng-container *ngTemplateOutlet=\"installerAction\"></ng-container>\n        </td>\n      </tr>\n      <!-- DESKTOP MAIN PERMISSIONS: OWNER -->\n      <tr>\n        <td class=\"px-1 px-sm-2\">\n          <ng-container *ngIf=\"owner\">\n            <div class=\"fw-bold\">\n              {{ owner.name }} {{ owner.surname }}\n            </div>\n            <div class=\"text-muted\">\n              {{ owner.email }}\n            </div>\n          </ng-container>\n          <ng-container *ngIf=\"!owner\">\n            <div class=\"fw-bold\">\n              {{ 'permission_no_owner' | translation }}\n            </div>\n            <div class=\"d-block d-sm-none text-muted\">\n              {{ 'permission_invitation_pending' | translation }}\n            </div>\n          </ng-container>\n        </td>\n        <td class=\"px-1 px-sm-2\">\n          {{ 'permission_owner' | translation }}\n        </td>\n        <td class=\"px-1 px-sm-2 text-center\">\n          <div class=\"checkbox-ok\" *ngIf=\"owner\">\n            <ion-icon name=\"checkmark-outline\"></ion-icon>\n          </div>\n          <div class=\"checkbox-ko\" *ngIf=\"!owner\">\n            <ion-icon name=\"close-outline\"></ion-icon>\n          </div>\n        </td>\n        <td class=\"px-1 px-sm-2 text-center\" *ngIf=\"authedUserCanAdminOwner === true\">\n          <ng-container *ngTemplateOutlet=\"ownerAction\"></ng-container>\n        </td>\n      </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n\n<ng-template #installerAction>\n  <button class=\"btn btn-sm btn-primary\"\n          (click)=\"showAttachInstaller = true\"\n          *ngIf=\"showAttachInstaller !== true\">\n    {{ 'permission_add_installer' | translation }}\n  </button>\n  <div *ngIf=\"showAttachInstaller === true\"\n       class=\"align-self-center\">\n    <div>\n      {{ 'permission_invite_installer' | translation }}\n    </div>\n    <input type=\"email\"\n           matInput\n           class=\"form-control my-2 py-2\"\n           aria-label=\"Text\"\n           placeholder=\"Email\"\n           [formControl]=\"attachInstallerForm\"\n    >\n    <button class=\"btn btn-sm btn-primary\"\n            (click)=\"attachInstallerToTerminal()\">\n      {{ 'add' | translation }}\n    </button>\n  </div>\n</ng-template>\n<ng-template #ownerAction>\n  <button class=\"btn btn-sm btn-primary\"\n          (click)=\"showAttachOwner = true\"\n          *ngIf=\"showAttachOwner !== true\">\n    {{ 'permission_add_owner' | translation }}\n  </button>\n  <div *ngIf=\"showAttachOwner === true\"\n       class=\"align-self-center\">\n    <div>\n      {{ 'permission_invite_owner' | translation }}\n    </div>\n    <input type=\"email\"\n           matInput\n           class=\"form-control my-2 py-2\"\n           aria-label=\"Text\"\n           placeholder=\"Email\"\n           [formControl]=\"attachOwnerForm\"\n    >\n    <button class=\"btn btn-sm btn-primary\"\n            (click)=\"attachOwnerToTerminal()\">\n      {{ 'add' | translation }}\n    </button>\n  </div>\n</ng-template>\n", styles: ["h1{color:#e96055;font-size:1.25rem;margin-top:0}table thead th{font-size:9.5px;word-break:break-all}input{background:#F2F5FC!important}@media (max-width: 991px){.card-table thead th:first-child,.card-table tbody td:first-child{padding-left:0!important}.card-table thead th:last-child{padding-right:0!important}.card-table tbody td:last-child{padding-right:0!important}}\n"], dependencies: [{ kind: "directive", type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i5.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "component", type: i6.IonIcon, selector: "ion-icon", inputs: ["color", "flipRtl", "icon", "ios", "lazy", "md", "mode", "name", "sanitize", "size", "src"] }, { kind: "directive", type: i7$1.MatInput, selector: "input[matInput], textarea[matInput], select[matNativeControl],      input[matNativeControl], textarea[matNativeControl]", inputs: ["disabled", "id", "placeholder", "name", "required", "type", "errorStateMatcher", "aria-describedby", "value", "readonly"], exportAs: ["matInput"] }, { kind: "directive", type: i16.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i16.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i16.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "pipe", type: TranslationPipe, name: "translation" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: PermissionTableMainComponent, decorators: [{
            type: Component,
            args: [{ selector: 'lib-permission-table-main', template: "<div class=\"card p-3 shadow-none\">\n  <div class=\"card-header p-0\">\n    <div class=\"card-header-title\">\n      <div class=\"row\">\n        <div class=\"col-6\">\n          <h1 class=\"text-start\">{{ 'permission_main_permissions' | translation }}</h1>\n        </div>\n        <div class=\"col-6 align-self-center\">\n\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class=\"card-body p-0\">\n    <div class=\"row\" *ngIf=\"isMobile\">\n      <!-- MOBILE MAIN PERMISSIONS: INSTALLER -->\n      <div class=\"col-12 mt-2\" *ngIf=\"mode === 'terminal'\">\n        <div>\n          {{ 'permission_installer' | translation }}\n        </div>\n        <div class=\"fw-bold mt-2\">\n          <ng-container *ngIf=\"installer\">\n            <div class=\"fw-bold\">\n              {{ installer.name }} {{ installer.surname }}\n            </div>\n            <div class=\"text-muted\">\n              {{ installer.email }}\n            </div>\n          </ng-container>\n          <ng-container *ngIf=\"!installer\">\n            <div class=\"fw-bold\">\n              {{ 'permission_no_installer' | translation }}\n            </div>\n          </ng-container>\n        </div>\n        <div class=\"fw-normal text-muted mt-1\" *ngIf=\"!installer\">\n          {{ 'permission_invitation_pending' | translation }}\n        </div>\n        <div class=\"mt-3\" *ngIf=\"authedUserCanAdminInstaller\">\n          <ng-container *ngTemplateOutlet=\"installerAction\"></ng-container>\n        </div>\n      </div>\n      <hr *ngIf=\"mode === 'terminal'\" class=\"mt-3 mb-2\">\n      <!-- MOBILE MAIN PERMISSIONS: OWNER -->\n      <div class=\"col-12\">\n        <div>\n          {{ 'permission_owner' | translation }}\n        </div>\n        <div class=\"fw-bold mt-2\">\n          <ng-container *ngIf=\"owner\">\n            <div class=\"fw-bold\">\n              {{ owner.name }} {{ owner.surname }}\n            </div>\n            <div class=\"text-muted\">\n              {{ owner.email }}\n            </div>\n          </ng-container>\n          <ng-container *ngIf=\"!owner\">\n            <div class=\"fw-bold\">\n              {{ 'permission_no_owner' | translation }}\n            </div>\n          </ng-container>\n        </div>\n        <div class=\"d-block d-sm-none text-muted mt-1\" *ngIf=\"!owner\">\n          {{ 'permission_invitation_pending' | translation }}\n        </div>\n        <div class=\"mt-3\" *ngIf=\"authedUserCanAdminOwner\">\n          <ng-container *ngTemplateOutlet=\"ownerAction\"></ng-container>\n        </div>\n      </div>\n    </div>\n\n    <!-- DESKTOP MAIN PERMISSIONS TABLE -->\n    <table *ngIf=\"!isMobile\"\n           class=\"table table-responsive-sm card-table\">\n      <thead>\n      <tr>\n        <th class=\"col-4 px-1 px-sm-2\">\n          {{ 'permission_user_s' | translation }}\n        </th>\n        <th class=\"col-2 px-1 px-sm-2\">\n          {{ 'permission_type' | translation }}\n        </th>\n        <th class=\"col-2 col-sm-4 px-1 px-sm-2 text-center\">\n          {{ 'status' | translation }}\n        </th>\n        <th class=\"col-4 col-sm-2 px-1 px-sm-2 text-center\"\n            *ngIf=\"authedUserCanAdminInstaller === true || authedUserCanAdminOwner === true\">\n          {{ 'permission_action' | translation }}\n        </th>\n      </tr>\n      </thead>\n      <tbody>\n      <!-- DESKTOP MAIN PERMISSIONS: INSTALLER -->\n      <tr *ngIf=\"mode === 'terminal'\">\n        <td class=\"px-1 px-sm-2\">\n          <ng-container *ngIf=\"installer\">\n            <div class=\"fw-bold\">\n              {{ installer.name }} {{ installer.surname }}\n            </div>\n            <div class=\"text-muted fw-normal\">\n              {{ installer.email }}\n            </div>\n          </ng-container>\n          <ng-container *ngIf=\"!installer\">\n            <div class=\"fw-bold\">\n              {{ 'permission_no_installer' | translation }}\n            </div>\n            <div class=\"fw-normal text-muted\">\n              {{ 'permission_invitation_pending' | translation }}\n            </div>\n          </ng-container>\n        </td>\n        <td class=\"px-1 px-sm-2\">\n          {{ 'permission_installer' | translation }}\n        </td>\n        <td class=\"px-1 px-sm-2 text-center\">\n          <div class=\"checkbox-ok\" *ngIf=\"installer\">\n            <ion-icon name=\"checkmark-outline\"></ion-icon>\n          </div>\n          <div class=\"checkbox-ko\" *ngIf=\"!installer\">\n            <ion-icon name=\"close-outline\"></ion-icon>\n          </div>\n        </td>\n        <td class=\"px-1 px-sm-2 text-center\" *ngIf=\"authedUserCanAdminInstaller === true\">\n          <ng-container *ngTemplateOutlet=\"installerAction\"></ng-container>\n        </td>\n      </tr>\n      <!-- DESKTOP MAIN PERMISSIONS: OWNER -->\n      <tr>\n        <td class=\"px-1 px-sm-2\">\n          <ng-container *ngIf=\"owner\">\n            <div class=\"fw-bold\">\n              {{ owner.name }} {{ owner.surname }}\n            </div>\n            <div class=\"text-muted\">\n              {{ owner.email }}\n            </div>\n          </ng-container>\n          <ng-container *ngIf=\"!owner\">\n            <div class=\"fw-bold\">\n              {{ 'permission_no_owner' | translation }}\n            </div>\n            <div class=\"d-block d-sm-none text-muted\">\n              {{ 'permission_invitation_pending' | translation }}\n            </div>\n          </ng-container>\n        </td>\n        <td class=\"px-1 px-sm-2\">\n          {{ 'permission_owner' | translation }}\n        </td>\n        <td class=\"px-1 px-sm-2 text-center\">\n          <div class=\"checkbox-ok\" *ngIf=\"owner\">\n            <ion-icon name=\"checkmark-outline\"></ion-icon>\n          </div>\n          <div class=\"checkbox-ko\" *ngIf=\"!owner\">\n            <ion-icon name=\"close-outline\"></ion-icon>\n          </div>\n        </td>\n        <td class=\"px-1 px-sm-2 text-center\" *ngIf=\"authedUserCanAdminOwner === true\">\n          <ng-container *ngTemplateOutlet=\"ownerAction\"></ng-container>\n        </td>\n      </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n\n<ng-template #installerAction>\n  <button class=\"btn btn-sm btn-primary\"\n          (click)=\"showAttachInstaller = true\"\n          *ngIf=\"showAttachInstaller !== true\">\n    {{ 'permission_add_installer' | translation }}\n  </button>\n  <div *ngIf=\"showAttachInstaller === true\"\n       class=\"align-self-center\">\n    <div>\n      {{ 'permission_invite_installer' | translation }}\n    </div>\n    <input type=\"email\"\n           matInput\n           class=\"form-control my-2 py-2\"\n           aria-label=\"Text\"\n           placeholder=\"Email\"\n           [formControl]=\"attachInstallerForm\"\n    >\n    <button class=\"btn btn-sm btn-primary\"\n            (click)=\"attachInstallerToTerminal()\">\n      {{ 'add' | translation }}\n    </button>\n  </div>\n</ng-template>\n<ng-template #ownerAction>\n  <button class=\"btn btn-sm btn-primary\"\n          (click)=\"showAttachOwner = true\"\n          *ngIf=\"showAttachOwner !== true\">\n    {{ 'permission_add_owner' | translation }}\n  </button>\n  <div *ngIf=\"showAttachOwner === true\"\n       class=\"align-self-center\">\n    <div>\n      {{ 'permission_invite_owner' | translation }}\n    </div>\n    <input type=\"email\"\n           matInput\n           class=\"form-control my-2 py-2\"\n           aria-label=\"Text\"\n           placeholder=\"Email\"\n           [formControl]=\"attachOwnerForm\"\n    >\n    <button class=\"btn btn-sm btn-primary\"\n            (click)=\"attachOwnerToTerminal()\">\n      {{ 'add' | translation }}\n    </button>\n  </div>\n</ng-template>\n", styles: ["h1{color:#e96055;font-size:1.25rem;margin-top:0}table thead th{font-size:9.5px;word-break:break-all}input{background:#F2F5FC!important}@media (max-width: 991px){.card-table thead th:first-child,.card-table tbody td:first-child{padding-left:0!important}.card-table thead th:last-child{padding-right:0!important}.card-table tbody td:last-child{padding-right:0!important}}\n"] }]
        }], ctorParameters: function () { return [{ type: TranslationsLibService }, { type: TerminalsService }, { type: PermissionsService }, { type: i4$1.BreakpointObserver }]; }, propDecorators: { terminalVid: [{
                type: Input
            }], mode: [{
                type: Input
            }], owner: [{
                type: Input
            }], installer: [{
                type: Input
            }], authedUserCanAdminOwner: [{
                type: Input
            }], authedUserCanAdminInstaller: [{
                type: Input
            }] } });

class PermissionsLibService {
    constructor(translationsLib) {
        this.translationsLib = translationsLib;
    }
    getPermissionText(type) {
        return this.translationsLib.get('permission_type_' + type);
    }
    setPermissions(terminal_vid, permissions) {
        localStorage.setItem(terminal_vid, JSON.stringify(permissions));
    }
    getPermissions(terminal_vid) {
        const terminalPermissions = localStorage.getItem(terminal_vid);
        if (terminalPermissions === null) {
            return { message: `Error parsing JSON for key ${terminal_vid}` };
        }
        if (terminalPermissions) {
            try {
                return JSON.parse(terminalPermissions);
            }
            catch (e) {
                console.error(`Error parsing JSON for key ${terminal_vid}: ${e.message}`);
            }
        }
    }
}
PermissionsLibService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: PermissionsLibService, deps: [{ token: TranslationsLibService }], target: i0.ɵɵFactoryTarget.Injectable });
PermissionsLibService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: PermissionsLibService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: PermissionsLibService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: TranslationsLibService }]; } });

class PermissionsTableInjectedUsersComponent {
    constructor(translationsLib, permissionsTerminal) {
        this.translationsLib = translationsLib;
        this.permissionsTerminal = permissionsTerminal;
        this.regularUsers = [];
        this.injectedRegularUsers = [];
    }
    ngOnInit() {
        this.getInjectedUsers();
    }
    getInjectedUsers() {
        this.regularUsers.forEach((regularUser) => {
            const injectionReason = regularUser.permission_regular_user.injection_reason || null;
            if (injectionReason !== null) {
                this.injectedRegularUsers.push(regularUser);
            }
        });
    }
}
PermissionsTableInjectedUsersComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: PermissionsTableInjectedUsersComponent, deps: [{ token: TranslationsLibService }, { token: PermissionsLibService }], target: i0.ɵɵFactoryTarget.Component });
PermissionsTableInjectedUsersComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: PermissionsTableInjectedUsersComponent, selector: "lib-permissions-table-injected-users", inputs: { regularUsers: "regularUsers" }, ngImport: i0, template: "<ng-container *ngIf=\"injectedRegularUsers.length > 0\">\n  <div class=\"card\">\n    <div class=\"card-header p-0\">\n      <div class=\"card-header-title\">\n        <div class=\"row\">\n          <div class=\"col-12\">\n            <h1 class=\"text-start\">{{ 'permission_injected_users' | translation }}</h1>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div class=\"card-body p-0\">\n\n      <!-- INJECTED USERS TABLE -->\n      <table class=\"table table-responsive-sm card-table\"  *ngIf=\"injectedRegularUsers.length > 0\">\n        <thead>\n        <tr>\n          <th class=\"col-7 px-0 py-3\">\n            {{ 'permission_user_s' | translation }}\n          </th>\n          <th class=\"col-3 text-center px-0 py-3\">\n            {{ 'permission_permissions' | translation }}\n          </th>\n          <th class=\"col-2 text-end px-0 py-3\">\n            {{ 'permission_injection_reason' | translation }}\n          </th>\n        </tr>\n        </thead>\n        <tbody>\n        <tr *ngFor=\"let user of injectedRegularUsers\">\n          <td style=\"padding-left: 0px !important; color: #444444; font-size: 15px\" class=\"text-start\">\n            <b>\n              {{ user.name }} {{ user.surname }}<br>\n              <span class=\"text-muted text-break\">{{ user.email }}</span>\n            </b>\n          </td>\n          <td class=\"text-center\">\n            {{ this.permissionsTerminal.getPermissionText(user.permission_regular_user.permission || 0) }}\n          </td>\n          <td  class=\"p-0 text-center\">\n            {{ this.permissionsTerminal.getPermissionText(user.permission_regular_user.injection_reason || '') }}\n          </td>\n        </tr>\n        </tbody>\n      </table>\n\n    </div>\n  </div>\n</ng-container>\n", styles: [".icono{position:relative;top:3px;font-size:18px}.body{padding:1.5rem}.table thead th{font-size:9.5px;word-break:break-all;text-align:center!important}.table td{font-size:15px;font-weight:500}.card{padding:12px;box-shadow:none}h1{color:#e96055;font-size:1.25rem;margin-top:0}h2{font-size:1rem}h3{color:#444;font-weight:700;font-size:13px}h4{color:#444;font-size:11px}\n"], dependencies: [{ kind: "directive", type: i5.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "pipe", type: TranslationPipe, name: "translation" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: PermissionsTableInjectedUsersComponent, decorators: [{
            type: Component,
            args: [{ selector: 'lib-permissions-table-injected-users', template: "<ng-container *ngIf=\"injectedRegularUsers.length > 0\">\n  <div class=\"card\">\n    <div class=\"card-header p-0\">\n      <div class=\"card-header-title\">\n        <div class=\"row\">\n          <div class=\"col-12\">\n            <h1 class=\"text-start\">{{ 'permission_injected_users' | translation }}</h1>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div class=\"card-body p-0\">\n\n      <!-- INJECTED USERS TABLE -->\n      <table class=\"table table-responsive-sm card-table\"  *ngIf=\"injectedRegularUsers.length > 0\">\n        <thead>\n        <tr>\n          <th class=\"col-7 px-0 py-3\">\n            {{ 'permission_user_s' | translation }}\n          </th>\n          <th class=\"col-3 text-center px-0 py-3\">\n            {{ 'permission_permissions' | translation }}\n          </th>\n          <th class=\"col-2 text-end px-0 py-3\">\n            {{ 'permission_injection_reason' | translation }}\n          </th>\n        </tr>\n        </thead>\n        <tbody>\n        <tr *ngFor=\"let user of injectedRegularUsers\">\n          <td style=\"padding-left: 0px !important; color: #444444; font-size: 15px\" class=\"text-start\">\n            <b>\n              {{ user.name }} {{ user.surname }}<br>\n              <span class=\"text-muted text-break\">{{ user.email }}</span>\n            </b>\n          </td>\n          <td class=\"text-center\">\n            {{ this.permissionsTerminal.getPermissionText(user.permission_regular_user.permission || 0) }}\n          </td>\n          <td  class=\"p-0 text-center\">\n            {{ this.permissionsTerminal.getPermissionText(user.permission_regular_user.injection_reason || '') }}\n          </td>\n        </tr>\n        </tbody>\n      </table>\n\n    </div>\n  </div>\n</ng-container>\n", styles: [".icono{position:relative;top:3px;font-size:18px}.body{padding:1.5rem}.table thead th{font-size:9.5px;word-break:break-all;text-align:center!important}.table td{font-size:15px;font-weight:500}.card{padding:12px;box-shadow:none}h1{color:#e96055;font-size:1.25rem;margin-top:0}h2{font-size:1rem}h3{color:#444;font-weight:700;font-size:13px}h4{color:#444;font-size:11px}\n"] }]
        }], ctorParameters: function () { return [{ type: TranslationsLibService }, { type: PermissionsLibService }]; }, propDecorators: { regularUsers: [{
                type: Input
            }] } });

class PermissionsAdministrativeManagementComponent {
    constructor(sessionLib, translationsLib, terminalsService) {
        this.sessionLib = sessionLib;
        this.translationsLib = translationsLib;
        this.terminalsService = terminalsService;
        this.terminalVid = '';
        this.ownerVid = '';
        this.installerVid = '';
        this.loaded = false;
        this.canClaim = false;
        this.canTransferToOwner = false;
        this.canReleaseAndTemporarilyDeactivate = false;
        this.TERMINAL_ENABLED_TEMPORARY_DISABLED = TERMINAL_ENABLED_TEMPORARY_DISABLED;
        this.TERMINAL_ENABLED_ENABLED = TERMINAL_ENABLED_ENABLED;
    }
    ngOnInit() {
        this.getAM();
    }
    getAM() {
        const authedUserVid = this.sessionLib.getSessionUserVid();
        this.loaded = false;
        this.canClaim = false;
        this.canTransferToOwner = false;
        this.canReleaseAndTemporarilyDeactivate = false;
        this.terminalsService
            .getTerminalAdministrativeManagement(this.terminalVid)
            .subscribe((terminalAdministrativeManagement) => {
            this.loaded = true;
            this.terminalAdministrativeManagement =
                terminalAdministrativeManagement;
            // If nobody has the administrative management, owner or installer can claim it
            if ((this.ownerVid === authedUserVid ||
                this.installerVid === authedUserVid) &&
                terminalAdministrativeManagement.administrative_management_type ===
                    'none') {
                this.canClaim = true;
            }
            // Installer can transfer administrative management to owner
            else if (terminalAdministrativeManagement.user_identity?.vid ===
                this.installerVid &&
                this.ownerVid !== null &&
                this.ownerVid !== this.installerVid &&
                this.installerVid === this.sessionLib.getSessionUserVid()) {
                this.canTransferToOwner = true;
            }
            // Administrative management can release and temporarily deactivate a terminal
            if (terminalAdministrativeManagement.administrative_management_type ===
                'owner' &&
                terminalAdministrativeManagement.user_identity?.vid ===
                    authedUserVid) {
                this.canReleaseAndTemporarilyDeactivate = true;
            }
        }, (error) => {
            this.loaded = true;
        });
    }
    claim() {
        this.loaded = false;
        this.terminalsService
            .claimTerminalAdministrativeManagement(this.terminalVid)
            .subscribe((terminalAdministrativeManagement) => {
            this.getAM();
        }, (error) => {
            this.loaded = true;
            Swal.fire({
                text: this.translationsLib.get('something_was_wrong'),
                showConfirmButton: true,
                confirmButtonText: this.translationsLib.get('accept'),
                icon: 'error',
            });
        });
    }
    transferToOwner() {
        this.loaded = false;
        this.terminalsService
            .transferTerminalAdministrativeManagement(this.terminalVid)
            .subscribe((terminalAdministrativeManagement) => {
            this.getAM();
        }, (error) => {
            this.loaded = true;
            Swal.fire({
                text: this.translationsLib.get('something_was_wrong'),
                showConfirmButton: true,
                confirmButtonText: this.translationsLib.get('accept'),
                icon: 'error',
            });
        });
    }
    release() {
        Swal.fire({
            title: this.translationsLib.get('permissions_release_administrative_management_title'),
            text: this.translationsLib.get('permissions_release_administrative_management_text'),
            showConfirmButton: true,
            showDenyButton: true,
            denyButtonText: this.translationsLib.get('cancel'),
            confirmButtonText: this.translationsLib.get('accept'),
            icon: 'warning',
        }).then((result) => {
            if (result.isConfirmed) {
                this.loaded = false;
                this.terminalsService
                    .releaseTerminalAdministrativeManagement(this.terminalVid)
                    .subscribe(() => {
                    this.getAM();
                }, (error) => {
                    this.loaded = true;
                    Swal.fire({
                        text: this.translationsLib.get('something_was_wrong'),
                        showConfirmButton: true,
                        confirmButtonText: this.translationsLib.get('accept'),
                        icon: 'error',
                    });
                });
            }
        });
    }
    temporarilyDeactivate() {
        Swal.fire({
            title: this.translationsLib.get('terminal_temporarily_deactivate_title'),
            text: this.translationsLib.get('terminal_temporarily_deactivate_text'),
            showConfirmButton: true,
            showDenyButton: true,
            denyButtonText: this.translationsLib.get('cancel'),
            confirmButtonText: this.translationsLib.get('accept'),
            icon: 'warning',
        }).then((result) => {
            if (result.isConfirmed) {
                this.loaded = false;
                this.terminalsService
                    .temporaryDisableTerminal(this.terminalVid)
                    .subscribe(() => {
                    this.getAM();
                }, (error) => {
                    this.loaded = true;
                    Swal.fire({
                        text: this.translationsLib.get('something_was_wrong'),
                        showConfirmButton: true,
                        confirmButtonText: this.translationsLib.get('accept'),
                        icon: 'error',
                    });
                });
            }
        });
    }
    enable() {
        this.loaded = false;
        this.terminalsService.enableTerminal(this.terminalVid).subscribe(() => {
            this.getAM();
        }, (error) => {
            this.loaded = true;
            Swal.fire({
                text: this.translationsLib.get('something_was_wrong'),
                showConfirmButton: true,
                confirmButtonText: this.translationsLib.get('accept'),
                icon: 'error',
            });
        });
    }
}
PermissionsAdministrativeManagementComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: PermissionsAdministrativeManagementComponent, deps: [{ token: SessionLibService }, { token: TranslationsLibService }, { token: TerminalsService }], target: i0.ɵɵFactoryTarget.Component });
PermissionsAdministrativeManagementComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: PermissionsAdministrativeManagementComponent, selector: "lib-permissions-administrative-management", inputs: { terminalVid: "terminalVid", ownerVid: "ownerVid", installerVid: "installerVid" }, ngImport: i0, template: "<div class=\"container-fluid\">\n  <div class=\"row\">\n    <div class=\"col-12 p-0\">\n      <lib-loader *ngIf=\"loaded === false\"></lib-loader>\n\n      <div class=\"card\" *ngIf=\"loaded === true\">\n        <div class=\"card-header p-0\">\n          <div class=\"card-header-title\">\n            <h1 class=\"text-start\">\n              {{ 'permission_administrative_management' | translation }}\n            </h1>\n          </div>\n        </div>\n        <div class=\"card-body px-0 px-lg-4\">\n          <div class=\"row\">\n            <div class=\"col-12 text-start\" *ngIf=\"terminalAdministrativeManagement\">\n              <div class=\"row\">\n                <!-- CLAIM -->\n                <ng-container *ngIf=\"terminalAdministrativeManagement.administrative_management_type === 'none'\">\n                  <div class=\"col-12 col-lg-6\">\n                    <p class=\"m-0\">\n                      <b>\n                        {{ 'permission_administrative_nobody' | translation }}\n                      </b>\n                    </p>\n                  </div>\n                  <div class=\"col-12 col-lg-6\" *ngIf=\"canClaim === true\">\n                    <p class=\"m-0\">\n                      <b>\n                        {{ 'permission_you_can_claim_administrative_management' | translation }}\n                      </b>\n                    </p>\n                    <p class=\"m-0\">\n                      <button class=\"btn btn-sm btn-info\" (click)=\"claim()\">\n                        {{ 'claim' | translation }}\n                      </button>\n                    </p>\n                  </div>\n                </ng-container>\n\n                <!-- SHOW AM -->\n                <ng-container *ngIf=\"terminalAdministrativeManagement.administrative_management_type !== 'none'\">\n                  <ng-container *ngIf=\"terminalAdministrativeManagement.administrative_management_type === 'organization'\">\n                    <div class=\"col-12 col-lg-6\">\n                      <b>\n                        <ng-container *ngIf=\"terminalAdministrativeManagement.organization_identity !== null\">\n                          {{ terminalAdministrativeManagement.organization_identity.name }}\n                        </ng-container>\n                        <ng-container *ngIf=\"terminalAdministrativeManagement.organization_identity === null\">\n                          {{ 'permissions_administrative_management_anonymous_organization' | translation }}\n                        </ng-container>\n                      </b>\n                    </div>\n                  </ng-container>\n\n                  <ng-container *ngIf=\"terminalAdministrativeManagement.administrative_management_type === 'owner'\">\n                    <div class=\"col-12 col-lg-6\">\n                      <b>\n                        <ng-container *ngIf=\"terminalAdministrativeManagement.user_identity !== null\">\n                          {{ terminalAdministrativeManagement.user_identity.name }} {{ terminalAdministrativeManagement.user_identity.surname }} <br/>\n                          <a class=\"text-muted\" style=\"cursor: pointer;\" href=\"mailto:{{ terminalAdministrativeManagement.user_identity.email }}\">{{ terminalAdministrativeManagement.user_identity.email }}</a>\n                        </ng-container>\n                        <ng-container *ngIf=\"terminalAdministrativeManagement.user_identity === null\">\n                          {{ 'permissions_administrative_management_anonymous_user' | translation }}\n                        </ng-container>\n                      </b>\n                    </div>\n                  </ng-container>\n                </ng-container>\n\n                <!-- TRANSFER TO OWNER -->\n                <ng-container *ngIf=\"canTransferToOwner === true\">\n                  <div class=\"col-12 mt-3 mt-lg-0\" [ngClass]=\"canReleaseAndTemporarilyDeactivate ? 'col-lg-3' : 'col-lg-6'\">\n                    <p class=\"m-0\">\n                      <b>\n                        {{ 'permission_you_can_transfer_to_owner_administrative_management' | translation }}\n                      </b>\n                    </p>\n                    <p class=\"m-0\">\n                      <button class=\"btn btn-sm btn-info\" (click)=\"transferToOwner()\">\n                        {{ 'transfer' | translation }}\n                      </button>\n                    </p>\n                  </div>\n                </ng-container>\n\n                <!-- RELEASE ADMINISTRATIVE MANAGEMENT AND ACTIVATE/TEMPORARY DISABLE -->\n                <ng-container *ngIf=\"canReleaseAndTemporarilyDeactivate === true\">\n                  <div class=\"col-12 mt-3 mt-lg-0\" [ngClass]=\"canTransferToOwner ? 'col-lg-3' : 'col-lg-6'\">\n                    <p class=\"m-0\">\n                      <b>\n                        {{ 'advanced_actions' | translation }}\n                      </b>\n                    </p>\n                    <div class=\"d-flex flex-wrap gap-2\">\n                      <button class=\"btn btn-sm btn-danger\" (click)=\"release()\">\n                        {{ 'permissions_release_administrative_management' | translation }}\n                      </button>\n                      <button class=\"btn btn-sm btn-warning\" *ngIf=\"terminalAdministrativeManagement.terminal_identity.enabled !== TERMINAL_ENABLED_TEMPORARY_DISABLED\" (click)=\"temporarilyDeactivate()\">\n                        {{ 'terminal_temporarily_deactivate' | translation }}\n                      </button>\n                      <button class=\"btn btn-sm btn-success\" *ngIf=\"terminalAdministrativeManagement.terminal_identity.enabled !== TERMINAL_ENABLED_ENABLED\" (click)=\"enable()\">\n                        {{ 'terminal_activate_terminal' | translation }}\n                      </button>\n                    </div>\n                  </div>\n                </ng-container>\n              </div>\n            </div>\n            <!-- CLAIM ADMINISTRATIVE MANAGEMENT -->\n            <div class=\"col-12 text-start\" *ngIf=\"!terminalAdministrativeManagement\">\n              <i>{{ 'no_results' | translation }}</i>\n            </div>\n          </div>\n          <div class=\"row mt-4\">\n            <div class=\"col-12 text-start text-muted\">\n              <i [innerHTML]=\"'permission_administrative_management_help' | translation\"></i>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n", styles: [".icono{position:relative;top:3px;font-size:18px}.body{padding:1.5rem}.table thead th{font-size:9.5px;word-break:break-all;text-align:center!important;padding:.5rem!important}.table td{font-size:15px;font-weight:500}.card{padding:12px;box-shadow:none}h1{color:#e96055;font-size:1.25rem;margin-top:0}h2{font-size:1rem}h3{color:#444;font-weight:700;font-size:13px}h4{color:#444;font-size:11px}\n"], dependencies: [{ kind: "directive", type: i5.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: LoaderComponent, selector: "lib-loader" }, { kind: "pipe", type: TranslationPipe, name: "translation" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: PermissionsAdministrativeManagementComponent, decorators: [{
            type: Component,
            args: [{ selector: 'lib-permissions-administrative-management', template: "<div class=\"container-fluid\">\n  <div class=\"row\">\n    <div class=\"col-12 p-0\">\n      <lib-loader *ngIf=\"loaded === false\"></lib-loader>\n\n      <div class=\"card\" *ngIf=\"loaded === true\">\n        <div class=\"card-header p-0\">\n          <div class=\"card-header-title\">\n            <h1 class=\"text-start\">\n              {{ 'permission_administrative_management' | translation }}\n            </h1>\n          </div>\n        </div>\n        <div class=\"card-body px-0 px-lg-4\">\n          <div class=\"row\">\n            <div class=\"col-12 text-start\" *ngIf=\"terminalAdministrativeManagement\">\n              <div class=\"row\">\n                <!-- CLAIM -->\n                <ng-container *ngIf=\"terminalAdministrativeManagement.administrative_management_type === 'none'\">\n                  <div class=\"col-12 col-lg-6\">\n                    <p class=\"m-0\">\n                      <b>\n                        {{ 'permission_administrative_nobody' | translation }}\n                      </b>\n                    </p>\n                  </div>\n                  <div class=\"col-12 col-lg-6\" *ngIf=\"canClaim === true\">\n                    <p class=\"m-0\">\n                      <b>\n                        {{ 'permission_you_can_claim_administrative_management' | translation }}\n                      </b>\n                    </p>\n                    <p class=\"m-0\">\n                      <button class=\"btn btn-sm btn-info\" (click)=\"claim()\">\n                        {{ 'claim' | translation }}\n                      </button>\n                    </p>\n                  </div>\n                </ng-container>\n\n                <!-- SHOW AM -->\n                <ng-container *ngIf=\"terminalAdministrativeManagement.administrative_management_type !== 'none'\">\n                  <ng-container *ngIf=\"terminalAdministrativeManagement.administrative_management_type === 'organization'\">\n                    <div class=\"col-12 col-lg-6\">\n                      <b>\n                        <ng-container *ngIf=\"terminalAdministrativeManagement.organization_identity !== null\">\n                          {{ terminalAdministrativeManagement.organization_identity.name }}\n                        </ng-container>\n                        <ng-container *ngIf=\"terminalAdministrativeManagement.organization_identity === null\">\n                          {{ 'permissions_administrative_management_anonymous_organization' | translation }}\n                        </ng-container>\n                      </b>\n                    </div>\n                  </ng-container>\n\n                  <ng-container *ngIf=\"terminalAdministrativeManagement.administrative_management_type === 'owner'\">\n                    <div class=\"col-12 col-lg-6\">\n                      <b>\n                        <ng-container *ngIf=\"terminalAdministrativeManagement.user_identity !== null\">\n                          {{ terminalAdministrativeManagement.user_identity.name }} {{ terminalAdministrativeManagement.user_identity.surname }} <br/>\n                          <a class=\"text-muted\" style=\"cursor: pointer;\" href=\"mailto:{{ terminalAdministrativeManagement.user_identity.email }}\">{{ terminalAdministrativeManagement.user_identity.email }}</a>\n                        </ng-container>\n                        <ng-container *ngIf=\"terminalAdministrativeManagement.user_identity === null\">\n                          {{ 'permissions_administrative_management_anonymous_user' | translation }}\n                        </ng-container>\n                      </b>\n                    </div>\n                  </ng-container>\n                </ng-container>\n\n                <!-- TRANSFER TO OWNER -->\n                <ng-container *ngIf=\"canTransferToOwner === true\">\n                  <div class=\"col-12 mt-3 mt-lg-0\" [ngClass]=\"canReleaseAndTemporarilyDeactivate ? 'col-lg-3' : 'col-lg-6'\">\n                    <p class=\"m-0\">\n                      <b>\n                        {{ 'permission_you_can_transfer_to_owner_administrative_management' | translation }}\n                      </b>\n                    </p>\n                    <p class=\"m-0\">\n                      <button class=\"btn btn-sm btn-info\" (click)=\"transferToOwner()\">\n                        {{ 'transfer' | translation }}\n                      </button>\n                    </p>\n                  </div>\n                </ng-container>\n\n                <!-- RELEASE ADMINISTRATIVE MANAGEMENT AND ACTIVATE/TEMPORARY DISABLE -->\n                <ng-container *ngIf=\"canReleaseAndTemporarilyDeactivate === true\">\n                  <div class=\"col-12 mt-3 mt-lg-0\" [ngClass]=\"canTransferToOwner ? 'col-lg-3' : 'col-lg-6'\">\n                    <p class=\"m-0\">\n                      <b>\n                        {{ 'advanced_actions' | translation }}\n                      </b>\n                    </p>\n                    <div class=\"d-flex flex-wrap gap-2\">\n                      <button class=\"btn btn-sm btn-danger\" (click)=\"release()\">\n                        {{ 'permissions_release_administrative_management' | translation }}\n                      </button>\n                      <button class=\"btn btn-sm btn-warning\" *ngIf=\"terminalAdministrativeManagement.terminal_identity.enabled !== TERMINAL_ENABLED_TEMPORARY_DISABLED\" (click)=\"temporarilyDeactivate()\">\n                        {{ 'terminal_temporarily_deactivate' | translation }}\n                      </button>\n                      <button class=\"btn btn-sm btn-success\" *ngIf=\"terminalAdministrativeManagement.terminal_identity.enabled !== TERMINAL_ENABLED_ENABLED\" (click)=\"enable()\">\n                        {{ 'terminal_activate_terminal' | translation }}\n                      </button>\n                    </div>\n                  </div>\n                </ng-container>\n              </div>\n            </div>\n            <!-- CLAIM ADMINISTRATIVE MANAGEMENT -->\n            <div class=\"col-12 text-start\" *ngIf=\"!terminalAdministrativeManagement\">\n              <i>{{ 'no_results' | translation }}</i>\n            </div>\n          </div>\n          <div class=\"row mt-4\">\n            <div class=\"col-12 text-start text-muted\">\n              <i [innerHTML]=\"'permission_administrative_management_help' | translation\"></i>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n", styles: [".icono{position:relative;top:3px;font-size:18px}.body{padding:1.5rem}.table thead th{font-size:9.5px;word-break:break-all;text-align:center!important;padding:.5rem!important}.table td{font-size:15px;font-weight:500}.card{padding:12px;box-shadow:none}h1{color:#e96055;font-size:1.25rem;margin-top:0}h2{font-size:1rem}h3{color:#444;font-weight:700;font-size:13px}h4{color:#444;font-size:11px}\n"] }]
        }], ctorParameters: function () { return [{ type: SessionLibService }, { type: TranslationsLibService }, { type: TerminalsService }]; }, propDecorators: { terminalVid: [{
                type: Input
            }], ownerVid: [{
                type: Input
            }], installerVid: [{
                type: Input
            }] } });

class PermissionsTableRegularUsersComponent {
    constructor(translationsLib, permissionService, sessionLib, breakpointObserver, toastController) {
        this.translationsLib = translationsLib;
        this.permissionService = permissionService;
        this.sessionLib = sessionLib;
        this.breakpointObserver = breakpointObserver;
        this.toastController = toastController;
        this.READ_PERMISSION = 4;
        this.WRITE_PERMISSION = 5;
        this.ADMIN_PERMISSION = 3;
        this.terminalVid = '';
        this.canAdmin = false;
        this.addUser = false;
        this.mode = '';
        this.regularUsers = [];
        this.contacts = [];
        this.getPermissionsList = new EventEmitter();
        this.nonInjectedRegularUsers = [];
        this.nonInjectedRegularUsersLoading = false;
        this.sessionUserEmail = '';
        this.emailForm = new FormControl('');
        this.contactOptions = [];
        this.isMobile = false;
    }
    ngOnInit() {
        this.addUser = this.addUser || false;
        this.regularUsers = this.regularUsers || [];
        this.sessionUserEmail = this.sessionLib.getSessionEmail();
        this.contacts.forEach((contact) => {
            this.contactOptions.push(contact.email);
        });
        this.filteredOptions = this.emailForm.valueChanges.pipe(startWith(''), map((value) => this.filter(value || '')));
    }
    ngOnChanges(changes) {
        if ('regularUsers' in changes) {
            this.nonInjectedRegularUsersLoading = false;
            this.nonInjectedRegularUsers = [];
            this.getNonInjectedUsers();
        }
    }
    ngAfterViewInit() {
        this.breakpointObserver
            .observe([Breakpoints.XSmall])
            .subscribe((result) => {
            this.isMobile = result.matches;
        });
    }
    filter(value) {
        const filterValue = value.toLowerCase();
        return this.contactOptions.filter((option) => option.toLowerCase().includes(filterValue));
    }
    changeUserPermission(user, permission) {
        this.nonInjectedRegularUsersLoading = true;
        if (this.mode === 'field') {
            this.changeUserFieldPermission(user.email, permission);
        }
        else if (this.mode === 'terminal') {
            this.changeUserTerminalPermission(user.email, permission);
        }
    }
    getNonInjectedUsers() {
        this.regularUsers.forEach((regularUser) => {
            const injectionReason = regularUser.permission_regular_user.injection_reason || null;
            if (injectionReason === null) {
                this.nonInjectedRegularUsers.push(regularUser);
            }
        });
    }
    detachUserFrom(email) {
        if (this.mode === 'field') {
            this.detachUserFromField(email);
        }
        else if (this.mode === 'terminal') {
            this.detachUserFromTerminal(email);
        }
    }
    attachUserTo() {
        if (this.mode === 'field') {
            this.attachUserToField();
        }
        else if (this.mode === 'terminal') {
            this.attachUserToTerminal();
        }
    }
    changeUserFieldPermission(email, value) {
        const changeUserFieldPermissionRequest$ = this.platform === 'backoffice'
            ? this.permissionService.backofficeChangeUserFieldPermissions(email, this.terminalVid, { permission: value })
            : this.permissionService.changeUserFieldPermissions(email, this.terminalVid, { permission: value });
        changeUserFieldPermissionRequest$.subscribe(() => {
            this.getPermissionsList.emit();
        });
    }
    changeUserTerminalPermission(email, value) {
        this.permissionService
            .changeUserTerminalPermissions(email, this.terminalVid, {
            permission: value
        })
            .subscribe(() => {
            this.getPermissionsList.emit();
            let permissionTypeString = '';
            switch (value) {
                case this.READ_PERMISSION:
                    permissionTypeString = 'permission_read_help';
                    break;
                case this.WRITE_PERMISSION:
                    permissionTypeString = 'permission_write_help';
                    break;
                case this.ADMIN_PERMISSION:
                    permissionTypeString = 'permission_admin_help';
                    break;
            }
            this.presentToast(this.translationsLib.get(permissionTypeString) + '<br>' + email).then();
        });
    }
    attachUserToField() {
        this.addUser = false;
        const attachUserToFieldRequest$ = this.platform === 'backoffice'
            ? this.permissionService.backofficeChangeUserFieldPermissions(this.emailForm.value, this.terminalVid, {
                permission: 4
            })
            : this.permissionService.pairUsertoField(this.emailForm.value, this.terminalVid, {
                permission: 4
            });
        attachUserToFieldRequest$.subscribe(() => {
            this.emailForm.reset();
            this.getPermissionsList.emit();
        }, () => {
            Swal.fire({
                text: this.translationsLib.get('permission_cant_add_that_user'),
                icon: 'error',
                confirmButtonColor: '#224261'
            }).then();
        });
    }
    detachUserFromField(email) {
        const detachUserFromFieldRequest$ = this.platform === 'backoffice'
            ? this.permissionService.backofficeDetachUserFromField(email, this.terminalVid)
            : this.permissionService.detachUserFromField(email, this.terminalVid);
        detachUserFromFieldRequest$.subscribe(() => {
            if (email === this.sessionUserEmail) {
                window.location.href = '/';
            }
            else {
                this.getPermissionsList.emit();
            }
        });
    }
    detachUserFromTerminal(email) {
        this.permissionService
            .detachUserFromTerminal(email, this.terminalVid)
            .subscribe(() => {
            if (email === this.sessionUserEmail) {
                window.location.href = '/';
            }
            else {
                this.getPermissionsList.emit();
            }
        });
    }
    attachUserToTerminal() {
        this.addUser = false;
        this.permissionService
            .pairUsertoTerminal(this.emailForm.value, this.terminalVid, {
            permission: 4
        })
            .subscribe(() => {
            this.emailForm.reset();
            this.getPermissionsList.emit();
        }, () => {
            Swal.fire({
                text: this.translationsLib.get('permission_cant_add_that_user'),
                icon: 'error',
                confirmButtonColor: '#224261'
            }).then();
        });
    }
    canShowUsers() {
        return (this.nonInjectedRegularUsersLoading === false &&
            this.nonInjectedRegularUsers.length > 0 &&
            this.addUser === false);
    }
    hasPermission(user, permission) {
        return user.permission_regular_user.permission === permission;
    }
    async presentToast(message, duration = 3000) {
        const toast = await this.toastController.create({
            message,
            duration
        });
        await toast.present();
    }
}
PermissionsTableRegularUsersComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: PermissionsTableRegularUsersComponent, deps: [{ token: TranslationsLibService }, { token: PermissionsService }, { token: SessionLibService }, { token: i4$1.BreakpointObserver }, { token: i6.ToastController }], target: i0.ɵɵFactoryTarget.Component });
PermissionsTableRegularUsersComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: PermissionsTableRegularUsersComponent, selector: "lib-permissions-table-regular-users", inputs: { terminalVid: "terminalVid", canAdmin: "canAdmin", addUser: "addUser", mode: "mode", regularUsers: "regularUsers", contacts: "contacts", platform: "platform" }, outputs: { getPermissionsList: "getPermissionsList" }, usesOnChanges: true, ngImport: i0, template: "<div class=\"card\">\n  <div class=\"card-header p-0\">\n    <div class=\"card-header-title\">\n      <div class=\"row\">\n        <div class=\"col-6\">\n          <h1 class=\"text-start\">{{ 'permission_user' | translation }}</h1>\n        </div>\n        <div class=\"col-6 align-self-center\">\n          <a class=\"btn btn-sm btn-primary lift float-end\"\n             *ngIf=\"canAdmin === true\"\n             (click)=\"addUser = true\">\n            {{ 'permission_addUser' | translation }}\n          </a>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class=\"card-body p-0\">\n    <!-- USERS TABLE -->\n    <table class=\"table table-responsive-sm card-table\" *ngIf=\"canShowUsers()\">\n      <thead>\n      <tr>\n        <th [class]=\"!isMobile ? 'col-4 px-0 py-3' : ''\">\n          {{ 'permission_user_s' | translation }}\n        </th>\n        <ng-container *ngIf=\"!isMobile\">\n          <ng-container *ngTemplateOutlet=\"userActionsHeader\"></ng-container>\n        </ng-container>\n      </tr>\n      </thead>\n      <tbody>\n      <tr *ngFor=\"let user of nonInjectedRegularUsers\" [class]=\"isMobile ? 'border-bottom-5 border-secondary' : ''\">\n        <td [style]=\"!isMobile ? 'color: #444444; font-size: 15px' : ''\"\n            [class]=\"!isMobile ? 'p-0 text-start' : 'pb-0'\">\n          <div class=\"fw-bold\">{{ user.name }} {{ user.surname }}</div>\n          <div class=\"fw-normal text-muted text-break mb-3\">{{ user.email }}</div>\n          <table class=\"table table-responsive-sm card-table\" *ngIf=\"isMobile\">\n            <thead>\n            <tr>\n              <ng-container *ngTemplateOutlet=\"userActionsHeader\"></ng-container>\n            </tr>\n            </thead>\n            <tbody>\n            <tr>\n              <ng-container *ngTemplateOutlet=\"userActions; context: { user: user }\"></ng-container>\n            </tr>\n            </tbody>\n          </table>\n        </td>\n        <ng-container *ngIf=\"!isMobile\">\n          <ng-container *ngTemplateOutlet=\"userActions; context: { user: user }\"></ng-container>\n        </ng-container>\n      </tr>\n      </tbody>\n    </table>\n\n    <!-- ADD USER -->\n    <div class=\"mb-2\" *ngIf=\"addUser === true\">\n      <form class=\"ion-justify-content-center\">\n        <label class=\"col-sm-5 col-form-label\">\n          {{ 'permission_invite_user' | translation }}\n        </label>\n        <div>\n          <input type=\"text\"\n                 matInput\n                 class=\"form-control\"\n                 aria-label=\"Text\"\n                 [formControl]=\"emailForm\"\n                 [matAutocomplete]=\"auto\"\n                 required>\n          <mat-autocomplete autoActiveFirstOption #auto=\"matAutocomplete\">\n            <mat-option *ngFor=\"let option of filteredOptions | async\"\n                        [value]=\"option\"\n                        [formControl]=\"emailForm\"\n                        ngDefaultControl>\n              {{ option }}\n            </mat-option>\n          </mat-autocomplete>\n        </div>\n        <br>\n        <button class=\"btn btn-primary float-end ms-3\" (click)=\"attachUserTo()\">\n          {{ 'add' | translation }}\n        </button>\n        <button class=\"btn btn-danger float-end\" (click)=\"addUser = false\">\n          {{ 'cancel' | translation }}\n        </button>\n      </form>\n    </div>\n\n    <!-- RELOADING USERS -->\n    <lib-loader *ngIf=\"nonInjectedRegularUsersLoading === true\"></lib-loader>\n\n    <!-- NO USERS -->\n    <p class=\"pt-5\" style=\"text-align: center; font-style: oblique\"\n       *ngIf=\"nonInjectedRegularUsersLoading === false && nonInjectedRegularUsers.length === 0 && addUser === false\">\n        <span *ngIf=\"mode === 'field'\">\n          {{ 'permission_field_no_users' | translation }}\n        </span>\n      <span *ngIf=\"mode === 'terminal'\">\n          {{ 'permission_terminal_no_users' | translation }}\n        </span>\n    </p>\n  </div>\n</div>\n\n<ng-template #userActionsHeader>\n  <th class=\"col-2 text-start text-md-center px-0 py-3\">\n    <span>\n      {{ 'permission_read' | translation }}\n      <mat-raised-button\n        #tooltip=\"matTooltip\" (click)=\"tooltip.toggle()\"\n        matTooltip=\"{{ 'permission_read_help' | translation }}\">\n        <ion-icon name=\"help-circle-outline\"></ion-icon>\n      </mat-raised-button>\n    </span>\n  </th>\n  <th class=\"col-2 text-start text-md-center px-0 py-3\">\n    {{ 'permission_write' | translation }}\n    <mat-raised-button\n      #tooltip=\"matTooltip\" (click)=\"tooltip.toggle()\"\n      matTooltip=\"{{ 'permission_write_help' | translation }}\">\n      <ion-icon name=\"help-circle-outline\"></ion-icon>\n    </mat-raised-button>\n  </th>\n  <th class=\"col-2 text-start text-md-center px-0 py-3\">\n    {{ 'permission_admin' | translation }}\n    <mat-raised-button\n      #tooltip=\"matTooltip\" (click)=\"tooltip.toggle()\"\n      matTooltip=\"{{ 'permission_admin_help' | translation }}\">\n      <ion-icon name=\"help-circle-outline\"></ion-icon>\n    </mat-raised-button>\n  </th>\n  <th class=\"col-2 text-center px-0 py-3\">\n    {{ 'permission_action' | translation }}\n  </th>\n</ng-template>\n\n<ng-template let-user=\"user\" #userActions>\n  <td class=\"text-center position-relative\">\n    <mat-radio-group\n      *ngIf=\"hasPermission(user, READ_PERMISSION) || sessionUserEmail !== user.email\">\n      <mat-radio-button [checked]=\"hasPermission(user, READ_PERMISSION)\"\n                        [value]=\"READ_PERMISSION\"\n                        (click)=\"changeUserPermission(user, READ_PERMISSION)\"\n                        value=\"4\">\n      </mat-radio-button>\n    </mat-radio-group>\n\n    <span class=\"radio-button-off\"\n          *ngIf=\"!hasPermission(user, READ_PERMISSION) && sessionUserEmail === user.email\">\n      -\n    </span>\n  </td>\n  <td class=\"text-center position-relative\">\n    <mat-radio-group\n      *ngIf=\"hasPermission(user, WRITE_PERMISSION) || sessionUserEmail !== user.email\">\n      <mat-radio-button [checked]=\"hasPermission(user, WRITE_PERMISSION)\"\n                        [value]=\"WRITE_PERMISSION\"\n                        (click)=\"changeUserPermission(user, WRITE_PERMISSION)\">\n      </mat-radio-button>\n    </mat-radio-group>\n\n    <span class=\"radio-button-off\"\n          *ngIf=\"!hasPermission(user, WRITE_PERMISSION) && sessionUserEmail === user.email\">-</span>\n  </td>\n  <td class=\"text-center position-relative\">\n    <mat-radio-group\n      *ngIf=\"hasPermission(user, ADMIN_PERMISSION) || sessionUserEmail !== user.email\">\n      <mat-radio-button [checked]=\"hasPermission(user, ADMIN_PERMISSION)\"\n                        [value]=\"ADMIN_PERMISSION\"\n                        (click)=\"changeUserPermission(user, ADMIN_PERMISSION)\">\n      </mat-radio-button>\n    </mat-radio-group>\n\n    <span class=\"radio-button-off\"\n          *ngIf=\"!hasPermission(user, ADMIN_PERMISSION) && sessionUserEmail === user.email\">-</span>\n  </td>\n  <td *ngIf=\"canAdmin===true\" class=\"p-0 text-center\">\n    <a class=\"btn btn-sm btn-danger lift\" (click)=\"detachUserFrom(user.email)\">\n      <ion-icon class=\"trash-icon\" [ios]=\"'trash-outline'\" [md]=\"'trash-outline'\"></ion-icon>\n    </a>\n  </td>\n</ng-template>\n", styles: [".radio-button-off{font-size:24px;color:#ddd;margin-right:8px}.trash-icon{position:relative;top:3px;font-size:18px}h1{color:#e96055;font-size:1.25rem;margin-top:0}.card{padding:12px;box-shadow:none}.card .card-table thead th{font-size:9.5px;word-break:break-all}.card .card-table td{font-size:15px;font-weight:500}@media (max-width: 991px){.card .card-table thead th:first-child,.card .card-table tbody td:first-child{padding-left:0!important}.card .card-table thead th:last-child,.card .card-table tbody td:last-child{padding-right:0!important}}ion-radio{--color-checked: #224261;--color: #66B8BE}ion-radio::part(container){border-color:#66b8be}ion-radio.radio-checked::part(container){border-color:#224261}input{background:#F2F5FC!important}@media (min-width: 1280px){button{line-height:1.5!important}}\n"], dependencies: [{ kind: "directive", type: i5.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i5.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "component", type: i6.IonIcon, selector: "ion-icon", inputs: ["color", "flipRtl", "icon", "ios", "lazy", "md", "mode", "name", "sanitize", "size", "src"] }, { kind: "component", type: LoaderComponent, selector: "lib-loader" }, { kind: "directive", type: i8.MatTooltip, selector: "[matTooltip]", exportAs: ["matTooltip"] }, { kind: "component", type: i9.MatAutocomplete, selector: "mat-autocomplete", inputs: ["disableRipple"], exportAs: ["matAutocomplete"] }, { kind: "directive", type: i9.MatAutocompleteTrigger, selector: "input[matAutocomplete], textarea[matAutocomplete]", exportAs: ["matAutocompleteTrigger"] }, { kind: "component", type: i10.MatOption, selector: "mat-option", exportAs: ["matOption"] }, { kind: "directive", type: i7$1.MatInput, selector: "input[matInput], textarea[matInput], select[matNativeControl],      input[matNativeControl], textarea[matNativeControl]", inputs: ["disabled", "id", "placeholder", "name", "required", "type", "errorStateMatcher", "aria-describedby", "value", "readonly"], exportAs: ["matInput"] }, { kind: "directive", type: i16.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i16.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i16.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i16.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i16.RequiredValidator, selector: ":not([type=checkbox])[required][formControlName],:not([type=checkbox])[required][formControl],:not([type=checkbox])[required][ngModel]", inputs: ["required"] }, { kind: "directive", type: i16.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "directive", type: i13.MatRadioGroup, selector: "mat-radio-group", exportAs: ["matRadioGroup"] }, { kind: "component", type: i13.MatRadioButton, selector: "mat-radio-button", inputs: ["disableRipple", "tabIndex"], exportAs: ["matRadioButton"] }, { kind: "pipe", type: i5.AsyncPipe, name: "async" }, { kind: "pipe", type: TranslationPipe, name: "translation" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: PermissionsTableRegularUsersComponent, decorators: [{
            type: Component,
            args: [{ selector: 'lib-permissions-table-regular-users', template: "<div class=\"card\">\n  <div class=\"card-header p-0\">\n    <div class=\"card-header-title\">\n      <div class=\"row\">\n        <div class=\"col-6\">\n          <h1 class=\"text-start\">{{ 'permission_user' | translation }}</h1>\n        </div>\n        <div class=\"col-6 align-self-center\">\n          <a class=\"btn btn-sm btn-primary lift float-end\"\n             *ngIf=\"canAdmin === true\"\n             (click)=\"addUser = true\">\n            {{ 'permission_addUser' | translation }}\n          </a>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class=\"card-body p-0\">\n    <!-- USERS TABLE -->\n    <table class=\"table table-responsive-sm card-table\" *ngIf=\"canShowUsers()\">\n      <thead>\n      <tr>\n        <th [class]=\"!isMobile ? 'col-4 px-0 py-3' : ''\">\n          {{ 'permission_user_s' | translation }}\n        </th>\n        <ng-container *ngIf=\"!isMobile\">\n          <ng-container *ngTemplateOutlet=\"userActionsHeader\"></ng-container>\n        </ng-container>\n      </tr>\n      </thead>\n      <tbody>\n      <tr *ngFor=\"let user of nonInjectedRegularUsers\" [class]=\"isMobile ? 'border-bottom-5 border-secondary' : ''\">\n        <td [style]=\"!isMobile ? 'color: #444444; font-size: 15px' : ''\"\n            [class]=\"!isMobile ? 'p-0 text-start' : 'pb-0'\">\n          <div class=\"fw-bold\">{{ user.name }} {{ user.surname }}</div>\n          <div class=\"fw-normal text-muted text-break mb-3\">{{ user.email }}</div>\n          <table class=\"table table-responsive-sm card-table\" *ngIf=\"isMobile\">\n            <thead>\n            <tr>\n              <ng-container *ngTemplateOutlet=\"userActionsHeader\"></ng-container>\n            </tr>\n            </thead>\n            <tbody>\n            <tr>\n              <ng-container *ngTemplateOutlet=\"userActions; context: { user: user }\"></ng-container>\n            </tr>\n            </tbody>\n          </table>\n        </td>\n        <ng-container *ngIf=\"!isMobile\">\n          <ng-container *ngTemplateOutlet=\"userActions; context: { user: user }\"></ng-container>\n        </ng-container>\n      </tr>\n      </tbody>\n    </table>\n\n    <!-- ADD USER -->\n    <div class=\"mb-2\" *ngIf=\"addUser === true\">\n      <form class=\"ion-justify-content-center\">\n        <label class=\"col-sm-5 col-form-label\">\n          {{ 'permission_invite_user' | translation }}\n        </label>\n        <div>\n          <input type=\"text\"\n                 matInput\n                 class=\"form-control\"\n                 aria-label=\"Text\"\n                 [formControl]=\"emailForm\"\n                 [matAutocomplete]=\"auto\"\n                 required>\n          <mat-autocomplete autoActiveFirstOption #auto=\"matAutocomplete\">\n            <mat-option *ngFor=\"let option of filteredOptions | async\"\n                        [value]=\"option\"\n                        [formControl]=\"emailForm\"\n                        ngDefaultControl>\n              {{ option }}\n            </mat-option>\n          </mat-autocomplete>\n        </div>\n        <br>\n        <button class=\"btn btn-primary float-end ms-3\" (click)=\"attachUserTo()\">\n          {{ 'add' | translation }}\n        </button>\n        <button class=\"btn btn-danger float-end\" (click)=\"addUser = false\">\n          {{ 'cancel' | translation }}\n        </button>\n      </form>\n    </div>\n\n    <!-- RELOADING USERS -->\n    <lib-loader *ngIf=\"nonInjectedRegularUsersLoading === true\"></lib-loader>\n\n    <!-- NO USERS -->\n    <p class=\"pt-5\" style=\"text-align: center; font-style: oblique\"\n       *ngIf=\"nonInjectedRegularUsersLoading === false && nonInjectedRegularUsers.length === 0 && addUser === false\">\n        <span *ngIf=\"mode === 'field'\">\n          {{ 'permission_field_no_users' | translation }}\n        </span>\n      <span *ngIf=\"mode === 'terminal'\">\n          {{ 'permission_terminal_no_users' | translation }}\n        </span>\n    </p>\n  </div>\n</div>\n\n<ng-template #userActionsHeader>\n  <th class=\"col-2 text-start text-md-center px-0 py-3\">\n    <span>\n      {{ 'permission_read' | translation }}\n      <mat-raised-button\n        #tooltip=\"matTooltip\" (click)=\"tooltip.toggle()\"\n        matTooltip=\"{{ 'permission_read_help' | translation }}\">\n        <ion-icon name=\"help-circle-outline\"></ion-icon>\n      </mat-raised-button>\n    </span>\n  </th>\n  <th class=\"col-2 text-start text-md-center px-0 py-3\">\n    {{ 'permission_write' | translation }}\n    <mat-raised-button\n      #tooltip=\"matTooltip\" (click)=\"tooltip.toggle()\"\n      matTooltip=\"{{ 'permission_write_help' | translation }}\">\n      <ion-icon name=\"help-circle-outline\"></ion-icon>\n    </mat-raised-button>\n  </th>\n  <th class=\"col-2 text-start text-md-center px-0 py-3\">\n    {{ 'permission_admin' | translation }}\n    <mat-raised-button\n      #tooltip=\"matTooltip\" (click)=\"tooltip.toggle()\"\n      matTooltip=\"{{ 'permission_admin_help' | translation }}\">\n      <ion-icon name=\"help-circle-outline\"></ion-icon>\n    </mat-raised-button>\n  </th>\n  <th class=\"col-2 text-center px-0 py-3\">\n    {{ 'permission_action' | translation }}\n  </th>\n</ng-template>\n\n<ng-template let-user=\"user\" #userActions>\n  <td class=\"text-center position-relative\">\n    <mat-radio-group\n      *ngIf=\"hasPermission(user, READ_PERMISSION) || sessionUserEmail !== user.email\">\n      <mat-radio-button [checked]=\"hasPermission(user, READ_PERMISSION)\"\n                        [value]=\"READ_PERMISSION\"\n                        (click)=\"changeUserPermission(user, READ_PERMISSION)\"\n                        value=\"4\">\n      </mat-radio-button>\n    </mat-radio-group>\n\n    <span class=\"radio-button-off\"\n          *ngIf=\"!hasPermission(user, READ_PERMISSION) && sessionUserEmail === user.email\">\n      -\n    </span>\n  </td>\n  <td class=\"text-center position-relative\">\n    <mat-radio-group\n      *ngIf=\"hasPermission(user, WRITE_PERMISSION) || sessionUserEmail !== user.email\">\n      <mat-radio-button [checked]=\"hasPermission(user, WRITE_PERMISSION)\"\n                        [value]=\"WRITE_PERMISSION\"\n                        (click)=\"changeUserPermission(user, WRITE_PERMISSION)\">\n      </mat-radio-button>\n    </mat-radio-group>\n\n    <span class=\"radio-button-off\"\n          *ngIf=\"!hasPermission(user, WRITE_PERMISSION) && sessionUserEmail === user.email\">-</span>\n  </td>\n  <td class=\"text-center position-relative\">\n    <mat-radio-group\n      *ngIf=\"hasPermission(user, ADMIN_PERMISSION) || sessionUserEmail !== user.email\">\n      <mat-radio-button [checked]=\"hasPermission(user, ADMIN_PERMISSION)\"\n                        [value]=\"ADMIN_PERMISSION\"\n                        (click)=\"changeUserPermission(user, ADMIN_PERMISSION)\">\n      </mat-radio-button>\n    </mat-radio-group>\n\n    <span class=\"radio-button-off\"\n          *ngIf=\"!hasPermission(user, ADMIN_PERMISSION) && sessionUserEmail === user.email\">-</span>\n  </td>\n  <td *ngIf=\"canAdmin===true\" class=\"p-0 text-center\">\n    <a class=\"btn btn-sm btn-danger lift\" (click)=\"detachUserFrom(user.email)\">\n      <ion-icon class=\"trash-icon\" [ios]=\"'trash-outline'\" [md]=\"'trash-outline'\"></ion-icon>\n    </a>\n  </td>\n</ng-template>\n", styles: [".radio-button-off{font-size:24px;color:#ddd;margin-right:8px}.trash-icon{position:relative;top:3px;font-size:18px}h1{color:#e96055;font-size:1.25rem;margin-top:0}.card{padding:12px;box-shadow:none}.card .card-table thead th{font-size:9.5px;word-break:break-all}.card .card-table td{font-size:15px;font-weight:500}@media (max-width: 991px){.card .card-table thead th:first-child,.card .card-table tbody td:first-child{padding-left:0!important}.card .card-table thead th:last-child,.card .card-table tbody td:last-child{padding-right:0!important}}ion-radio{--color-checked: #224261;--color: #66B8BE}ion-radio::part(container){border-color:#66b8be}ion-radio.radio-checked::part(container){border-color:#224261}input{background:#F2F5FC!important}@media (min-width: 1280px){button{line-height:1.5!important}}\n"] }]
        }], ctorParameters: function () { return [{ type: TranslationsLibService }, { type: PermissionsService }, { type: SessionLibService }, { type: i4$1.BreakpointObserver }, { type: i6.ToastController }]; }, propDecorators: { terminalVid: [{
                type: Input
            }], canAdmin: [{
                type: Input
            }], addUser: [{
                type: Input
            }], mode: [{
                type: Input
            }], regularUsers: [{
                type: Input
            }], contacts: [{
                type: Input
            }], platform: [{
                type: Input
            }], getPermissionsList: [{
                type: Output
            }] } });

class PermissionsTableComponent {
    constructor(permissionService, route, translationsLib) {
        this.permissionService = permissionService;
        this.route = route;
        this.translationsLib = translationsLib;
        this.vid = '';
        this.canAdmin = false;
        this.owner = null;
        this.installer = null;
        this.regularUsers = [];
        this.authedUserCanAdminInstaller = false;
        this.authedUserCanAdminOwner = false;
        this.contacts = [];
        this.addUser = false;
        this.mode = '';
        this.getPermissionsList = new EventEmitter();
    }
    ngOnInit() {
        if (this.vid === '') {
            this.vid = this.route.snapshot.paramMap.get('vid');
        }
        setTimeout(() => {
            //
        }, 100);
    }
    handlePermissionsReload() {
        this.getPermissionsList.emit();
    }
}
PermissionsTableComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: PermissionsTableComponent, deps: [{ token: PermissionsService }, { token: i1$1.ActivatedRoute }, { token: TranslationsLibService }], target: i0.ɵɵFactoryTarget.Component });
PermissionsTableComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: PermissionsTableComponent, selector: "lib-permissions-table", inputs: { vid: "vid", canAdmin: "canAdmin", owner: "owner", installer: "installer", regularUsers: "regularUsers", authedUserCanAdminInstaller: "authedUserCanAdminInstaller", authedUserCanAdminOwner: "authedUserCanAdminOwner", contacts: "contacts", addUser: "addUser", mode: "mode", platform: "platform" }, outputs: { getPermissionsList: "getPermissionsList" }, ngImport: i0, template: "<section>\n  <!-- OWNER & INSTALLER USERS TABLE -->\n  <lib-permission-table-main\n    [terminalVid]=\"vid\"\n    [owner]=\"owner\"\n    [installer]=\"installer\"\n    [mode]=\"mode\"\n    [authedUserCanAdminInstaller]=\"authedUserCanAdminInstaller\"\n    [authedUserCanAdminOwner]=\"authedUserCanAdminOwner\"\n  >\n  </lib-permission-table-main>\n\n  <!-- ADMINISTRATIVE MANAGEMENT -->\n  <lib-permissions-administrative-management *ngIf=\"mode === 'terminal'\"\n    [terminalVid]=\"vid\"\n    [ownerVid]=\"owner?.vid\"\n    [installerVid]=\"installer?.vid\"\n  >\n  </lib-permissions-administrative-management>\n\n  <!-- NON INJECTED REGULAR USERS TABLE -->\n  <lib-permissions-table-regular-users\n    [canAdmin]=\"canAdmin\"\n    [addUser]=\"addUser\"\n    [mode]=\"mode\"\n    [regularUsers]=\"regularUsers\"\n    [terminalVid]=\"vid\"\n    [contacts]=\"contacts\"\n    [platform]=\"platform\"\n    (getPermissionsList)=\"handlePermissionsReload()\"\n  >\n  </lib-permissions-table-regular-users>\n\n  <!-- INJECTED USERS TABLE -->\n  <lib-permissions-table-injected-users\n    [regularUsers]=\"regularUsers\"\n  >\n  </lib-permissions-table-injected-users>\n\n  <div class=\"card p-3 px-1 px-lg-4 shadow-none\">\n    <div class=\"row mt-lg-2 mt-4 mb-0\" >\n      <div class=\"col-12 text-center\">\n        <ion-icon id=\"permissions-support-icon\" name=\"help-circle-outline\"></ion-icon>\n        <span id=\"permissions-support-text\" [innerHTML]=\"'permission_support_help' | translation\"></span>\n      </div>\n    </div>\n  </div>\n</section>\n", styles: ["#permissions-support-icon{margin-right:5px}#permissions-support-text{position:relative;top:-3px;display:inline-block}#permissions-support-text p{margin:25px!important}\n"], dependencies: [{ kind: "directive", type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i6.IonIcon, selector: "ion-icon", inputs: ["color", "flipRtl", "icon", "ios", "lazy", "md", "mode", "name", "sanitize", "size", "src"] }, { kind: "component", type: PermissionTableMainComponent, selector: "lib-permission-table-main", inputs: ["terminalVid", "mode", "owner", "installer", "authedUserCanAdminOwner", "authedUserCanAdminInstaller"] }, { kind: "component", type: PermissionsTableInjectedUsersComponent, selector: "lib-permissions-table-injected-users", inputs: ["regularUsers"] }, { kind: "component", type: PermissionsAdministrativeManagementComponent, selector: "lib-permissions-administrative-management", inputs: ["terminalVid", "ownerVid", "installerVid"] }, { kind: "component", type: PermissionsTableRegularUsersComponent, selector: "lib-permissions-table-regular-users", inputs: ["terminalVid", "canAdmin", "addUser", "mode", "regularUsers", "contacts", "platform"], outputs: ["getPermissionsList"] }, { kind: "pipe", type: TranslationPipe, name: "translation" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: PermissionsTableComponent, decorators: [{
            type: Component,
            args: [{ selector: 'lib-permissions-table', template: "<section>\n  <!-- OWNER & INSTALLER USERS TABLE -->\n  <lib-permission-table-main\n    [terminalVid]=\"vid\"\n    [owner]=\"owner\"\n    [installer]=\"installer\"\n    [mode]=\"mode\"\n    [authedUserCanAdminInstaller]=\"authedUserCanAdminInstaller\"\n    [authedUserCanAdminOwner]=\"authedUserCanAdminOwner\"\n  >\n  </lib-permission-table-main>\n\n  <!-- ADMINISTRATIVE MANAGEMENT -->\n  <lib-permissions-administrative-management *ngIf=\"mode === 'terminal'\"\n    [terminalVid]=\"vid\"\n    [ownerVid]=\"owner?.vid\"\n    [installerVid]=\"installer?.vid\"\n  >\n  </lib-permissions-administrative-management>\n\n  <!-- NON INJECTED REGULAR USERS TABLE -->\n  <lib-permissions-table-regular-users\n    [canAdmin]=\"canAdmin\"\n    [addUser]=\"addUser\"\n    [mode]=\"mode\"\n    [regularUsers]=\"regularUsers\"\n    [terminalVid]=\"vid\"\n    [contacts]=\"contacts\"\n    [platform]=\"platform\"\n    (getPermissionsList)=\"handlePermissionsReload()\"\n  >\n  </lib-permissions-table-regular-users>\n\n  <!-- INJECTED USERS TABLE -->\n  <lib-permissions-table-injected-users\n    [regularUsers]=\"regularUsers\"\n  >\n  </lib-permissions-table-injected-users>\n\n  <div class=\"card p-3 px-1 px-lg-4 shadow-none\">\n    <div class=\"row mt-lg-2 mt-4 mb-0\" >\n      <div class=\"col-12 text-center\">\n        <ion-icon id=\"permissions-support-icon\" name=\"help-circle-outline\"></ion-icon>\n        <span id=\"permissions-support-text\" [innerHTML]=\"'permission_support_help' | translation\"></span>\n      </div>\n    </div>\n  </div>\n</section>\n", styles: ["#permissions-support-icon{margin-right:5px}#permissions-support-text{position:relative;top:-3px;display:inline-block}#permissions-support-text p{margin:25px!important}\n"] }]
        }], ctorParameters: function () { return [{ type: PermissionsService }, { type: i1$1.ActivatedRoute }, { type: TranslationsLibService }]; }, propDecorators: { vid: [{
                type: Input
            }], canAdmin: [{
                type: Input
            }], owner: [{
                type: Input
            }], installer: [{
                type: Input
            }], regularUsers: [{
                type: Input
            }], authedUserCanAdminInstaller: [{
                type: Input
            }], authedUserCanAdminOwner: [{
                type: Input
            }], contacts: [{
                type: Input
            }], addUser: [{
                type: Input
            }], mode: [{
                type: Input
            }], platform: [{
                type: Input
            }], getPermissionsList: [{
                type: Output
            }] } });

class FieldPermissionsComponent {
    constructor(permissionService, route, session, translationsLib) {
        this.permissionService = permissionService;
        this.route = route;
        this.session = session;
        this.translationsLib = translationsLib;
        this.platform = '';
        this.vid = '';
        this.permissions = undefined;
        this.canAdmin = false;
        this.installer = null;
        this.owner = null;
        this.regularUsers = [];
        this.ready = false;
        if (this.vid === '') {
            this.vid = this.route.snapshot.paramMap.get('vid');
        }
    }
    ngOnInit() {
        this.installer = this.installer || null;
        this.owner = this.owner || null;
        this.regularUsers = this.regularUsers || [];
        this.getPermissionsList();
    }
    getPermissionsList() {
        if (this.permissions === undefined) {
            this.permissionService.getPermissionsList().subscribe((res) => {
                res.fields.forEach((field) => {
                    if (field.vid === this.vid) {
                        this.permissions = field.permission_mapping_identity;
                        this.canAdmin = field.authed_user_can_admin;
                        this.deleteNulls();
                        this.getContacts();
                    }
                });
            });
        }
        else {
            // Backoffice admin user
            this.canAdmin = true;
            this.deleteNulls();
            this.getContacts();
        }
    }
    deleteNulls() {
        if (this.permissions.installer !== null) {
            this.installer = this.permissions.installer;
        }
        if (this.permissions.owner !== null) {
            this.owner = this.permissions.owner;
        }
        if (this.permissions.regular_users !== null) {
            if ('regular_users' in this.permissions) {
                this.regularUsers = this.permissions.regular_users;
            }
            this.regularUsers = Object.values(this.regularUsers);
        }
    }
    getContacts() {
        this.permissionService
            .getUserContacts(this.session.getSessionUserVid())
            .subscribe((res) => {
            this.contacts = res;
            this.ready = true;
        });
    }
}
FieldPermissionsComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: FieldPermissionsComponent, deps: [{ token: PermissionsService }, { token: i1$1.ActivatedRoute }, { token: SessionLibService }, { token: TranslationsLibService }], target: i0.ɵɵFactoryTarget.Component });
FieldPermissionsComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: FieldPermissionsComponent, selector: "lib-field-permissions", inputs: { platform: "platform", vid: "vid", permissions: "permissions" }, ngImport: i0, template: "<div class=\"my-4\">\r\n  <lib-loader *ngIf=\"ready === false\"></lib-loader>\r\n  <lib-permissions-table\r\n    *ngIf=\"ready === true\"\r\n    [vid]=\"vid\"\r\n    [canAdmin]=\"canAdmin\"\r\n    [owner]=\"owner\"\r\n    [regularUsers]=\"regularUsers\"\r\n    [contacts]=\"contacts\"\r\n    [mode]=\"'field'\"\r\n    [platform]=\"platform\"\r\n    (getPermissionsList)=\"getPermissionsList()\"\r\n  >\r\n  </lib-permissions-table>\r\n</div>\r\n", styles: ["#icono{display:grid;font-size:18px}.body{padding:1.5rem}.table thead th{font-size:9.5px}.table td{font-size:15px;font-weight:500}.card{padding:12px;box-shadow:none}.h3{color:#444;font-weight:700;font-size:13px}.h4{font-size:13px;color:#444}ion-radio{--color-checked: #224261;--color: #66b8be}\n"], dependencies: [{ kind: "directive", type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: LoaderComponent, selector: "lib-loader" }, { kind: "component", type: PermissionsTableComponent, selector: "lib-permissions-table", inputs: ["vid", "canAdmin", "owner", "installer", "regularUsers", "authedUserCanAdminInstaller", "authedUserCanAdminOwner", "contacts", "addUser", "mode", "platform"], outputs: ["getPermissionsList"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: FieldPermissionsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'lib-field-permissions', template: "<div class=\"my-4\">\r\n  <lib-loader *ngIf=\"ready === false\"></lib-loader>\r\n  <lib-permissions-table\r\n    *ngIf=\"ready === true\"\r\n    [vid]=\"vid\"\r\n    [canAdmin]=\"canAdmin\"\r\n    [owner]=\"owner\"\r\n    [regularUsers]=\"regularUsers\"\r\n    [contacts]=\"contacts\"\r\n    [mode]=\"'field'\"\r\n    [platform]=\"platform\"\r\n    (getPermissionsList)=\"getPermissionsList()\"\r\n  >\r\n  </lib-permissions-table>\r\n</div>\r\n", styles: ["#icono{display:grid;font-size:18px}.body{padding:1.5rem}.table thead th{font-size:9.5px}.table td{font-size:15px;font-weight:500}.card{padding:12px;box-shadow:none}.h3{color:#444;font-weight:700;font-size:13px}.h4{font-size:13px;color:#444}ion-radio{--color-checked: #224261;--color: #66b8be}\n"] }]
        }], ctorParameters: function () { return [{ type: PermissionsService }, { type: i1$1.ActivatedRoute }, { type: SessionLibService }, { type: TranslationsLibService }]; }, propDecorators: { platform: [{
                type: Input
            }], vid: [{
                type: Input
            }], permissions: [{
                type: Input
            }] } });

class PermissionsModule {
}
PermissionsModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: PermissionsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
PermissionsModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: PermissionsModule, declarations: [PermissionsTableComponent,
        PermissionTableMainComponent,
        PermissionsTableInjectedUsersComponent,
        PermissionsAdministrativeManagementComponent,
        PermissionsTableRegularUsersComponent,
        FieldPermissionsComponent], imports: [CommonModule,
        IonicModule,
        AppCommonsModule,
        App360SharedModule,
        MatExpansionModule,
        MatTabsModule,
        MatTreeModule,
        MatButtonModule,
        MatTooltipModule,
        MatAutocompleteModule,
        MatInputModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatRadioModule,
        MatIconModule,
        MatMenuModule], exports: [PermissionsTableComponent, FieldPermissionsComponent] });
PermissionsModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: PermissionsModule, imports: [CommonModule,
        IonicModule,
        AppCommonsModule,
        App360SharedModule,
        MatExpansionModule,
        MatTabsModule,
        MatTreeModule,
        MatButtonModule,
        MatTooltipModule,
        MatAutocompleteModule,
        MatInputModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatRadioModule,
        MatIconModule,
        MatMenuModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: PermissionsModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        PermissionsTableComponent,
                        PermissionTableMainComponent,
                        PermissionsTableInjectedUsersComponent,
                        PermissionsAdministrativeManagementComponent,
                        PermissionsTableRegularUsersComponent,
                        FieldPermissionsComponent
                    ],
                    exports: [PermissionsTableComponent, FieldPermissionsComponent],
                    imports: [
                        CommonModule,
                        IonicModule,
                        AppCommonsModule,
                        App360SharedModule,
                        MatExpansionModule,
                        MatTabsModule,
                        MatTreeModule,
                        MatButtonModule,
                        MatTooltipModule,
                        MatAutocompleteModule,
                        MatInputModule,
                        ReactiveFormsModule,
                        MatFormFieldModule,
                        MatRadioModule,
                        MatIconModule,
                        MatMenuModule
                    ]
                }]
        }] });

var CancelAlarmsType;
(function (CancelAlarmsType) {
    CancelAlarmsType["PROGRAM_START"] = "PROGRAM_START";
    CancelAlarmsType["PROGRAM_STOP"] = "PROGRAM_STOP";
    CancelAlarmsType["CANCEL_ALARMS"] = "CANCEL_ALARMS";
    CancelAlarmsType["FILTER_START"] = "FILTER_START";
    CancelAlarmsType["FILTER_STOP"] = "FILTER_STOP";
    CancelAlarmsType["BLOCK_WATER_SYSTEM"] = "BLOCK_WATER_SYSTEM";
})(CancelAlarmsType || (CancelAlarmsType = {}));
const GroupsOrder = [
    'common',
    'vent',
    'curtain',
    'heat',
    'haffan',
    'misting',
    'swithing',
    'CO2',
    'alarm' // alarmas
];

class FarmingRestApiService {
    constructor(httpRepositoryService) {
        this.httpRepositoryService = httpRepositoryService;
    }
    getDesktopClimateStates(terminalVid) {
        return this.httpRepositoryService.getRequest(`farming/${terminalVid}/climate/states`);
    }
    postClimateEquipment(terminalVid, info) {
        return this.httpRepositoryService.postRequest(`farming/${terminalVid}/nuve/equipment`, info);
    }
    postIrrigationEquipment(terminalVid, info) {
        return this.httpRepositoryService.postRequest(`farming/${terminalVid}/nuve/equipment`, info);
    }
    postConfigurableEquipment(terminalVid, info) {
        return this.httpRepositoryService.postRequest(`farming/${terminalVid}/nuve/equipment`, info);
    }
    getDesktopClimateStructureStates(terminalVid) {
        return this.httpRepositoryService.getRequest(`farming/${terminalVid}/nuve/climateStatesStructure`);
    }
    postDesktopClimateStructureStates(terminalVid, statesStructure) {
        return this.httpRepositoryService.postRequest(`farming/${terminalVid}/nuve/climateStatesStructure`, statesStructure);
    }
    getTerminal(vid) {
        return this.httpRepositoryService.getRequest('terminals/' + vid);
    }
    getClimateEquipment(terminalVid) {
        return this.httpRepositoryService.getRequest(`farming/${terminalVid}/nuve/equipment`);
    }
    getConfigurableEquipment(terminalVid) {
        return this.httpRepositoryService.getRequest(`farming/${terminalVid}/nuve/equipment`);
    }
    getIrrigationEquipment(terminalVid) {
        return this.httpRepositoryService.getRequest(`farming/${terminalVid}/nuve/equipment`);
    }
    getIrrigationEquipmentWithWaterSystems(terminalVid) {
        return this.httpRepositoryService.getRequest(`farming/${terminalVid}/nuve/equipment?q=watersystems-status`);
    }
    getTerminalLayoutConfiguration(vid) {
        return this.httpRepositoryService.getRequest('terminals/' + vid + '/configuration');
    }
    putTerminalLayoutConfiguration(vid, data) {
        return this.httpRepositoryService.putRequest('terminals/' + vid + '/configuration', data);
    }
    getClimateVentilations(terminalVid) {
        return this.httpRepositoryService.getRequest(`farming/${terminalVid}/climate/ventilation_temperature`);
    }
    postClimateVentilations(terminalVid, climateVentilations) {
        return this.httpRepositoryService.postRequest(`farming/${terminalVid}/climate/ventilation_temperature`, climateVentilations);
    }
    getVents(terminalVid) {
        return this.httpRepositoryService.getRequest(`farming/${terminalVid}/climate/vents`);
    }
    postVents(terminalVid, vents) {
        return this.httpRepositoryService.postRequest(`farming/${terminalVid}/climate/vents`, vents);
    }
    getFanSteps(terminalVid) {
        return this.httpRepositoryService.getRequest(`farming/${terminalVid}/climate/fan_steps`);
    }
    postFanSteps(terminalVid, fanSteps) {
        return this.httpRepositoryService.postRequest(`farming/${terminalVid}/climate/fan_steps`, fanSteps);
    }
    getThermalInversion(terminalVid) {
        return this.httpRepositoryService.getRequest(`farming/${terminalVid}/climate/thermal_inversion`);
    }
    postThermalInversion(terminalVid, thermalInversion) {
        return this.httpRepositoryService.postRequest(`farming/${terminalVid}/climate/thermal_inversion`, thermalInversion);
    }
    getHeatingTemperature(terminalVid) {
        return this.httpRepositoryService.getRequest(`farming/${terminalVid}/climate/heating_temperature`);
    }
    postHeatingTemperature(terminalVid, heatingTemperature) {
        return this.httpRepositoryService.postRequest(`farming/${terminalVid}/climate/heating_temperature`, heatingTemperature);
    }
    getHeaters(terminalVid) {
        return this.httpRepositoryService.getRequest(`farming/${terminalVid}/climate/heaters`);
    }
    postHeaters(terminalVid, heaters) {
        return this.httpRepositoryService.postRequest(`farming/${terminalVid}/climate/heaters`, heaters);
    }
    getPipes(terminalVid) {
        return this.httpRepositoryService.getRequest(`farming/${terminalVid}/climate/pipes`);
    }
    postPipes(terminalVid, pipes) {
        return this.httpRepositoryService.postRequest(`farming/${terminalVid}/climate/pipes`, pipes);
    }
    getTransportGroup(terminalVid) {
        return this.httpRepositoryService.getRequest(`farming/${terminalVid}/climate/transport_group`);
    }
    postTransportGroup(terminalVid, transportGroup) {
        return this.httpRepositoryService.postRequest(`farming/${terminalVid}/climate/transport_group`, transportGroup);
    }
    getCurtainEnergy(terminalVid) {
        return this.httpRepositoryService.getRequest(`farming/${terminalVid}/climate/mixed_curtains_energy`);
    }
    postCurtainEnergy(terminalVid, curtainEnergy) {
        return this.httpRepositoryService.postRequest(`farming/${terminalVid}/climate/mixed_curtains_energy`, curtainEnergy);
    }
    getCurtainShade(terminalVid) {
        return this.httpRepositoryService.getRequest(`farming/${terminalVid}/climate/mixed_curtains_shading`);
    }
    postCurtainShade(terminalVid, curtainShade) {
        return this.httpRepositoryService.postRequest(`farming/${terminalVid}/climate/mixed_curtains_shading`, curtainShade);
    }
    getCurtainRegulation(terminalVid) {
        return this.httpRepositoryService.getRequest(`farming/${terminalVid}/climate/mixed_curtains_regulation`);
    }
    postCurtainRegulation(terminalVid, curtainRegulation) {
        return this.httpRepositoryService.postRequest(`farming/${terminalVid}/climate/mixed_curtains_regulation`, curtainRegulation);
    }
    getCurtainGapping(terminalVid) {
        return this.httpRepositoryService.getRequest(`farming/${terminalVid}/climate/mixed_curtains_gapping`);
    }
    postCurtainGapping(terminalVid, curtainGapping) {
        return this.httpRepositoryService.postRequest(`farming/${terminalVid}/climate/mixed_curtains_gapping`, curtainGapping);
    }
    getDarkeningCurtain(terminalVid) {
        return this.httpRepositoryService.getRequest(`farming/${terminalVid}/climate/darkening_curtains`);
    }
    postDarkeningCurtain(terminalVid, curtainDarkening) {
        return this.httpRepositoryService.postRequest(`farming/${terminalVid}/climate/darkening_curtains`, curtainDarkening);
    }
    getShadingCurtain(terminalVid) {
        return this.httpRepositoryService.getRequest(`farming/${terminalVid}/climate/shading_curtains`);
    }
    postShadingCurtain(terminalVid, shadingCurtain) {
        return this.httpRepositoryService.postRequest(`farming/${terminalVid}/climate/shading_curtains`, shadingCurtain);
    }
    getSwitchingProgram(terminalVid) {
        return this.httpRepositoryService.getRequest(`farming/${terminalVid}/climate/switching_programs`);
    }
    postSwitchingProgram(terminalVid, switchingProgram) {
        return this.httpRepositoryService.postRequest(`farming/${terminalVid}/climate/switching_programs`, switchingProgram);
    }
    getMistingProgramming(terminalVid) {
        return this.httpRepositoryService.getRequest(`farming/${terminalVid}/climate/misting`);
    }
    postMistingProgramming(terminalVid, misting) {
        return this.httpRepositoryService.postRequest(`farming/${terminalVid}/climate/misting`, misting);
    }
    getMistingRegulation(terminalVid) {
        return this.httpRepositoryService.getRequest(`farming/${terminalVid}/climate/misting_regulation`);
    }
    postMistingRegulation(terminalVid, misting) {
        return this.httpRepositoryService.postRequest(`farming/${terminalVid}/climate/misting_regulation`, misting);
    }
    getHafFansProgramming(terminalVid) {
        return this.httpRepositoryService.getRequest(`farming/${terminalVid}/climate/haf_fans`);
    }
    postHafFansProgramming(terminalVid, hafFans) {
        return this.httpRepositoryService.postRequest(`farming/${terminalVid}/climate/haf_fans`, hafFans);
    }
    getHafFansAdjusting(terminalVid) {
        return this.httpRepositoryService.getRequest(`farming/${terminalVid}/climate/haf_fans_adjusting`);
    }
    postHafFansAdjusting(terminalVid, hafFans) {
        return this.httpRepositoryService.postRequest(`farming/${terminalVid}/climate/haf_fans_adjusting`, hafFans);
    }
    getAlarmsZone(terminalVid) {
        return this.httpRepositoryService.getRequest(`farming/${terminalVid}/climate/alarms_zone`);
    }
    postAlarmsZone(terminalVid, alarms) {
        return this.httpRepositoryService.postRequest(`farming/${terminalVid}/climate/alarms_zone`, alarms);
    }
    getAlarmsFrost(terminalVid) {
        return this.httpRepositoryService.getRequest(`farming/${terminalVid}/climate/alarms_frost`);
    }
    postAlarmsFrost(terminalVid, alarms) {
        return this.httpRepositoryService.postRequest(`farming/${terminalVid}/climate/alarms_frost`, alarms);
    }
    getAlarmsStorm(terminalVid) {
        return this.httpRepositoryService.getRequest(`farming/${terminalVid}/climate/alarms_storm`);
    }
    postAlarmsStorm(terminalVid, alarms) {
        return this.httpRepositoryService.postRequest(`farming/${terminalVid}/climate/alarms_storm`, alarms);
    }
    getAlarmsRain(terminalVid) {
        return this.httpRepositoryService.getRequest(`farming/${terminalVid}/climate/alarms_rain`);
    }
    postAlarmsRain(terminalVid, alarms) {
        return this.httpRepositoryService.postRequest(`farming/${terminalVid}/climate/alarms_rain`, alarms);
    }
    getCO2(terminalVid) {
        return this.httpRepositoryService.getRequest(`farming/${terminalVid}/climate/co2`);
    }
    postCO2(terminalVid, co2) {
        return this.httpRepositoryService.postRequest(`farming/${terminalVid}/climate/co2`, co2);
    }
    getInstallerPipes(terminalVid) {
        return this.httpRepositoryService.getRequest(`farming/${terminalVid}/climate_installer/pipes`);
    }
    postInstallerPipes(terminalVid, co2) {
        return this.httpRepositoryService.postRequest(`farming/${terminalVid}/climate_installer/pipes`, co2);
    }
    getInstallerMisting(terminalVid) {
        return this.httpRepositoryService.getRequest(`farming/${terminalVid}/climate_installer/misting`);
    }
    postInstallerMisting(terminalVid, misting) {
        return this.httpRepositoryService.postRequest(`farming/${terminalVid}/climate_installer/misting`, misting);
    }
    getInstallerMixedCurtains(terminalVid) {
        return this.httpRepositoryService.getRequest(`farming/${terminalVid}/climate_installer/mixed_curtains`);
    }
    postInstallerMixedCurtains(terminalVid, mixedCurtains) {
        return this.httpRepositoryService.postRequest(`farming/${terminalVid}/climate_installer/mixed_curtains`, mixedCurtains);
    }
    getInstallerDarkeningCurtains(terminalVid) {
        return this.httpRepositoryService.getRequest(`farming/${terminalVid}/climate_installer/darkening_curtains`);
    }
    postInstallerDarkeningCurtains(terminalVid, darkeningCurtains) {
        return this.httpRepositoryService.postRequest(`farming/${terminalVid}/climate_installer/darkening_curtains`, darkeningCurtains);
    }
    getInstallerShadingCurtains(terminalVid) {
        return this.httpRepositoryService.getRequest(`farming/${terminalVid}/climate_installer/shading_curtains`);
    }
    postInstallerShadingCurtains(terminalVid, shadingCurtains) {
        return this.httpRepositoryService.postRequest(`farming/${terminalVid}/climate_installer/shading_curtains`, shadingCurtains);
    }
    getInstallerZones(terminalVid) {
        return this.httpRepositoryService.getRequest(`farming/${terminalVid}/climate_installer/zones`);
    }
    postInstallerZones(terminalVid, zones) {
        return this.httpRepositoryService.postRequest(`farming/${terminalVid}/climate_installer/zones`, zones);
    }
    getInstallerVents(terminalVid) {
        return this.httpRepositoryService.getRequest(`farming/${terminalVid}/climate_installer/vents`);
    }
    postInstallerVents(terminalVid, vents) {
        return this.httpRepositoryService.postRequest(`farming/${terminalVid}/climate_installer/vents`, vents);
    }
    getInstallerCO2(terminalVid) {
        return this.httpRepositoryService.getRequest(`farming/${terminalVid}/climate_installer/co2`);
    }
    postInstallerCO2(terminalVid, co2) {
        return this.httpRepositoryService.postRequest(`farming/${terminalVid}/climate_installer/co2`, co2);
    }
    getConfigurablePrograms(terminalVid, programId = null, active = null) {
        let url = `farming/${terminalVid}/configurable/programs`;
        const params = [];
        if (programId !== null)
            params.push(`program=${programId.toString()}`);
        if (active !== null)
            params.push(`active=1`);
        if (params.length > 0)
            url += '?' + params.join('&');
        return this.httpRepositoryService.getRequest(url);
    }
    postConfigurablePrograms(terminalVid, programs) {
        return this.httpRepositoryService.postRequest(`farming/${terminalVid}/configurable/programs`, programs);
    }
    postManualActionsConfigurableProgram(terminalVid, payload) {
        return this.httpRepositoryService.postRequest(`farming/${terminalVid}/manual_actions/configurable`, payload);
    }
    getConnections(vid) {
        return this.httpRepositoryService.getRequest('farming/' + vid + '/connections');
    }
    postConnections(vid, data) {
        return this.httpRepositoryService.postRequest('farming/' + vid + '/connections', data);
    }
    putConnections(vid, data) {
        return this.httpRepositoryService.putRequest('farming/' + vid + '/connections', data);
    }
    putCalculations(vid, data) {
        return this.httpRepositoryService.putRequest('farming/' + vid + '/calculations', data);
    }
    postCalculations(vid, data) {
        return this.httpRepositoryService.postRequest('farming/' + vid + '/calculations', data);
    }
    postReprogram(vid, data) {
        return this.httpRepositoryService.postRequest('farming/' + vid + '/nuve/reprogram_sdi12', data);
    }
    getCalculationsdependencies(vid, data) {
        return this.httpRepositoryService.postRequest('farming/' + vid + '/calculations/dependencies', data);
    }
    getConnectionsdependencies(vid, data) {
        return this.httpRepositoryService.postRequest('farming/' + vid + '/connections/dependencies', data);
    }
    deleteCalculation(vid, data) {
        return this.httpRepositoryService.postRequest('farming/' + vid + '/remove_calculation', data);
    }
    deleteConnection(vid, data) {
        return this.httpRepositoryService.postRequest('farming/' + vid + '/disconnect', data);
    }
    getConnectionsAvailable(vid) {
        return this.httpRepositoryService.getRequest('farming/' + vid + '/connections/available');
    }
    getDataloggerData(vid) {
        return this.httpRepositoryService.getRequest('farming/' + vid + '/nuve/equipment');
    }
    getCalculations(vid) {
        return this.httpRepositoryService.getRequest('farming/' + vid + '/calculations');
    }
    getCalculationsAvailable(vid) {
        return this.httpRepositoryService.getRequest('farming/' + vid + '/calculations/available');
    }
    getChartsData(vid, data) {
        return this.httpRepositoryService.getRequest('farming/' +
            vid +
            '/charts/data?nexp=' +
            data.nexp +
            '&nent=' +
            data.nent +
            '&physicalType=' +
            data.physicalType +
            '&begin=' +
            data.begin +
            '&end=' +
            data.end +
            '&interval=' +
            data.interval);
    }
    postChartsData(vid, data) {
        return this.httpRepositoryService.postRequest('farming/' + vid + '/nuve/charts', data);
    }
    getET0Prediction(vid, data) {
        return this.httpRepositoryService.getRequest('farming/' +
            vid +
            '/nuve/et0_estimate?begin=' +
            data.begin +
            '&end=' +
            data.end);
    }
    getFAOValue(vid) {
        return this.httpRepositoryService.getRequest('farming/' + vid + '/nuve/fao_crops');
    }
    getFertilizerFormulas(terminalVid) {
        return this.httpRepositoryService.getRequest(`farming/${terminalVid}/irrigation/fertilizer_formulas`);
    }
    getFertilizerFormula(terminalVid, id) {
        return this.httpRepositoryService.getRequest(`farming/${terminalVid}/irrigation/fertilizer_formulas?formula=${id}`);
    }
    postFertilizerFormulas(terminalVid, fertilizerFormulas) {
        return this.httpRepositoryService.postRequest(`farming/${terminalVid}/irrigation/fertilizer_formulas`, fertilizerFormulas);
    }
    getIrrigationGroups(terminalVid) {
        return this.httpRepositoryService.getRequest(`farming/${terminalVid}/irrigation/groups`);
    }
    getIrrigationGroup(terminalVid, groupId) {
        return this.httpRepositoryService.getRequest(`farming/${terminalVid}/irrigation/groups?group=${groupId}`);
    }
    postIrrigationGroups(terminalVid, groups) {
        return this.httpRepositoryService.postRequest(`farming/${terminalVid}/irrigation/groups`, groups);
    }
    getIrrigationPrograms(terminalVid) {
        return this.httpRepositoryService.getRequest(`farming/${terminalVid}/irrigation/programs`);
    }
    getIrrigationProgram(terminalVid, programId) {
        return this.httpRepositoryService.getRequest(`farming/${terminalVid}/irrigation/programs?program=${programId}`);
    }
    postIrrigationPrograms(terminalVid, programs) {
        return this.httpRepositoryService.postRequest(`farming/${terminalVid}/irrigation/programs`, programs);
    }
    postManualActionsIrrigationProgram(terminalVid, payload) {
        return this.httpRepositoryService.postRequest(`farming/${terminalVid}/manual_actions/irrigation`, payload);
    }
    getValves(terminalVid) {
        return this.httpRepositoryService.getRequest(`farming/${terminalVid}/valves`);
    }
    getSensors(terminalVid) {
        return this.httpRepositoryService.getRequest(`farming/${terminalVid}/sensors`);
    }
    putSensor(terminalVid, sensor) {
        return this.httpRepositoryService.putRequest(`farming/${terminalVid}/sensors`, { sensor });
    }
    getSensorsSubtypes(terminalVid) {
        return this.httpRepositoryService.getRequest(`farming/${terminalVid}/nuve/magnitudes`);
    }
    getPumps(terminalVid) {
        return this.httpRepositoryService.getRequest(`farming/${terminalVid}/irrigation_installer/pumps`);
    }
    getDemands(terminalVid) {
        return this.httpRepositoryService.getRequest(`farming/${terminalVid}/irrigation_installer/demands`);
    }
    getPrograms(terminalVid) {
        return this.httpRepositoryService.getRequest(`farming/${terminalVid}/irrigation/programs`);
    }
    postPrograms(terminalVid, programs) {
        return this.httpRepositoryService.postRequest(`farming/${terminalVid}/irrigation/programs`, programs);
    }
    getDrainageTrays(terminalVid) {
        return this.httpRepositoryService.getRequest(`farming/${terminalVid}/irrigation_installer/drainage_trays`);
    }
    getDrainages(terminalVid) {
        return this.httpRepositoryService.getRequest(`farming/${terminalVid}/nuve/drainages`);
    }
    getDrainage(terminalVid, drainageId) {
        return this.httpRepositoryService.getRequest(`farming/${terminalVid}/nuve/drainages?drainage=${drainageId}`);
    }
    getDrainagesV4(terminalVid) {
        return this.httpRepositoryService.getRequest(`farming/${terminalVid}/irrigation/drainages_v4`);
    }
    postDrainagesV4(terminalVid, groups) {
        return this.httpRepositoryService.postRequest(`farming/${terminalVid}/irrigation/drainages_v4`, groups);
    }
    getDrainagesV3(terminalVid) {
        return this.httpRepositoryService.getRequest(`farming/${terminalVid}/irrigation/drainages_v3`);
    }
    postDrainagesV3(terminalVid, groups) {
        return this.httpRepositoryService.postRequest(`farming/${terminalVid}/irrigation/drainages_v3`, groups);
    }
    getMixtureFormulas(terminalVid) {
        return this.httpRepositoryService.getRequest(`farming/${terminalVid}/irrigation/mixture_formulas`);
    }
    getMixtureFormula(terminalVid, mixtureId) {
        return this.httpRepositoryService.getRequest(`farming/${terminalVid}/irrigation/mixture_formulas?formula=${mixtureId}`);
    }
    postMixtureFormulas(terminalVid, formulas) {
        return this.httpRepositoryService.postRequest(`farming/${terminalVid}/irrigation/mixture_formulas`, formulas);
    }
    getInputOutputs(terminalVid, mode, type) {
        return this.httpRepositoryService.getRequest(`farming/${terminalVid}/irrigation_installer/input_output?mode=${mode}&type=${type}`);
    }
    getMeteoAlarms(terminalVid) {
        return this.httpRepositoryService.getRequest(`farming/${terminalVid}/irrigation/meteo_alarms`);
    }
    postMeteoAlarms(terminalVid, meteoAlarms) {
        return this.httpRepositoryService.postRequest(`farming/${terminalVid}/irrigation/meteo_alarms`, meteoAlarms);
    }
    getIrrigationInstallerValves(terminalVid) {
        return this.httpRepositoryService.getRequest(`farming/${terminalVid}/irrigation_installer/valves`);
    }
    getIrrigationInstallerValve(terminalVid, valveId) {
        return this.httpRepositoryService.getRequest(`farming/${terminalVid}/irrigation_installer/valves?valve=${valveId}`);
    }
    postIrrigationInstallerValves(terminalVid, valves) {
        return this.httpRepositoryService.postRequest(`farming/${terminalVid}/irrigation_installer/valves`, valves);
    }
    getIrrigationInstallerDrainageTrays(terminalVid) {
        return this.httpRepositoryService.getRequest(`farming/${terminalVid}/irrigation_installer/drainage_trays`);
    }
    getIrrigationInstallerDrainageTray(terminalVid, trayId) {
        return this.httpRepositoryService.getRequest(`farming/${terminalVid}/irrigation_installer/drainage_trays?tray=${trayId}`);
    }
    postIrrigationInstallerDrainageTrays(terminalVid, drainage_trays) {
        return this.httpRepositoryService.postRequest(`farming/${terminalVid}/irrigation_installer/drainage_trays`, drainage_trays);
    }
    getIrrigationInstallerDemands(terminalVid) {
        return this.httpRepositoryService.getRequest(`farming/${terminalVid}/irrigation_installer/demands`);
    }
    getIrrigationInstallerDemand(terminalVid, demandId) {
        return this.httpRepositoryService.getRequest(`farming/${terminalVid}/irrigation_installer/demands?demand=${demandId}`);
    }
    postIrrigationInstallerDemands(terminalVid, demands) {
        return this.httpRepositoryService.postRequest(`farming/${terminalVid}/irrigation_installer/demands`, demands);
    }
    getIrrigationInstallerPHCERearmAlarms(terminalVid) {
        return this.httpRepositoryService.getRequest(`farming/${terminalVid}/irrigation_installer/ph_ce_rearm_alarm`);
    }
    postIrrigationInstallerPHCERearmAlarms(terminalVid, ph_ce_rearm_alarms) {
        return this.httpRepositoryService.postRequest(`farming/${terminalVid}/irrigation_installer/ph_ce_rearm_alarm`, ph_ce_rearm_alarms);
    }
    getIrrigationInstallerPump(terminalVid, pumpId) {
        return this.httpRepositoryService.getRequest(`farming/${terminalVid}/irrigation_installer/pumps?pump=${pumpId}`);
    }
    getIrrigationInstallerPumps(terminalVid) {
        return this.httpRepositoryService.getRequest(`farming/${terminalVid}/irrigation_installer/pumps`);
    }
    postIrrigationInstallerPumps(terminalVid, pumps) {
        return this.httpRepositoryService.postRequest(`farming/${terminalVid}/irrigation_installer/pumps`, pumps);
    }
    getIrrigationInstallerMixtureValves(terminalVid) {
        return this.httpRepositoryService.getRequest(`farming/${terminalVid}/irrigation_installer/mixture_valves`);
    }
    getIrrigationInstallerMixtureValve(terminalVid, mixtureValveId) {
        return this.httpRepositoryService.getRequest(`farming/${terminalVid}/irrigation_installer/mixture_valves?mixtureValve=${mixtureValveId}`);
    }
    postIrrigationInstallerMixtureValves(terminalVid, mixture_valves) {
        return this.httpRepositoryService.postRequest(`farming/${terminalVid}/irrigation_installer/mixture_valves`, mixture_valves);
    }
    getIrrigationInstallerWaterSystems(terminalVid) {
        return this.httpRepositoryService.getRequest(`farming/${terminalVid}/irrigation_installer/water_systems`);
    }
    postIrrigationInstallerWaterSystems(terminalVid, waterSystem) {
        return this.httpRepositoryService.postRequest(`farming/${terminalVid}/irrigation_installer/water_systems`, waterSystem);
    }
    getIrrigationInstallerFilters(terminalVid) {
        return this.httpRepositoryService.getRequest(`farming/${terminalVid}/irrigation_installer/filters`);
    }
    getIrrigationInstallerFilter(terminalVid, filterId) {
        return this.httpRepositoryService.getRequest(`farming/${terminalVid}/irrigation_installer/filters?filter=${filterId}`);
    }
    postIrrigationInstallerFilters(terminalVid, filters) {
        return this.httpRepositoryService.postRequest(`farming/${terminalVid}/irrigation_installer/filters`, filters);
    }
    getIrrigationInstallerMiscellaneous(terminalVid) {
        return this.httpRepositoryService.getRequest(`farming/${terminalVid}/irrigation_installer/miscellaneous`);
    }
    postIrrigationInstallerMiscellaneous(terminalVid, miscellaneous) {
        return this.httpRepositoryService.postRequest(`farming/${terminalVid}/irrigation_installer/miscellaneous`, miscellaneous);
    }
    getIrrigationInstallerFertilizers(terminalVid) {
        return this.httpRepositoryService.getRequest(`farming/${terminalVid}/irrigation_installer/fertilizers`);
    }
    postIrrigationInstallerFertilizers(terminalVid, fertilizers) {
        return this.httpRepositoryService.postRequest(`farming/${terminalVid}/irrigation_installer/fertilizers`, fertilizers);
    }
    getIrrigationInstallerAgitators(terminalVid) {
        return this.httpRepositoryService.getRequest(`farming/${terminalVid}/irrigation_installer/agitators`);
    }
    postIrrigationInstallerAgitators(terminalVid, agitators) {
        return this.httpRepositoryService.postRequest(`farming/${terminalVid}/irrigation_installer/agitators`, agitators);
    }
    getIrrigationInstallerFertilizersNuve(terminalVid) {
        return this.httpRepositoryService.getRequest(`farming/${terminalVid}/nuve/water_systems_fertilizers_agitators`);
    }
    postIrrigationInstallerFertilizersNuve(terminalVid, payload) {
        return this.httpRepositoryService.postRequest(`farming/${terminalVid}/nuve/water_systems_fertilizers_agitators`, payload);
    }
    getIrrigationInstallerIOReport(terminalVid) {
        return this.httpRepositoryService.getRequest(`farming/${terminalVid}/irrigation_installer/input_output`);
    }
    postCancelAlarmsIrrigation(terminalVid, data) {
        return this.httpRepositoryService.postRequest(`farming/${terminalVid}/manual_actions/irrigation`, data);
    }
    getManualActivationStatus(terminalVid) {
        return this.httpRepositoryService.getRequest(`farming/${terminalVid}/manual-activations/status`);
    }
    postStartFiltersCleaning(terminalVid, waterSystemId) {
        return this.httpRepositoryService.postRequest(`farming/${terminalVid}/manual-activations/${waterSystemId}/filters-cleaning/start`, []);
    }
    postStopFiltersCleaning(terminalVid, waterSystemId) {
        return this.httpRepositoryService.postRequest(`farming/${terminalVid}/manual-activations/${waterSystemId}/filters-cleaning/stop`, []);
    }
    postWaterSystemLock(terminalVid, waterSystemId) {
        return this.httpRepositoryService.postRequest(`farming/${terminalVid}/manual-activations/${waterSystemId}/lock`, []);
    }
}
FarmingRestApiService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: FarmingRestApiService, deps: [{ token: HttpRepositoryService }], target: i0.ɵɵFactoryTarget.Injectable });
FarmingRestApiService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: FarmingRestApiService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: FarmingRestApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: HttpRepositoryService }]; } });

class ClimateService {
    constructor(restApiService) {
        this.restApiService = restApiService;
    }
    /******** DESKTOP STATES *******/
    getDesktopClimateStates(terminalVid) {
        return this.restApiService.getDesktopClimateStates(terminalVid);
    }
    postClimateTerminal(terminalVid, info) {
        return this.restApiService.postClimateEquipment(terminalVid, info);
    }
    getDesktopClimateStructureStates(terminalVid) {
        return this.restApiService.getDesktopClimateStructureStates(terminalVid);
    }
    postDesktopClimateStructureStates(terminalVid, statesStructure) {
        return this.restApiService.postDesktopClimateStructureStates(terminalVid, statesStructure);
    }
    /******** TERMINAL *******/
    getTerminal(terminalVid) {
        return this.restApiService.getTerminal(terminalVid);
    }
    /******** EQUIPMENT *******/
    getClimateEquipment(terminalVid) {
        return this.restApiService.getClimateEquipment(terminalVid);
    }
    /******** TERMINAL LAYOUT *******/
    getTerminalLayoutConfiguration(terminalVid) {
        return this.restApiService.getTerminalLayoutConfiguration(terminalVid);
    }
    putTerminalLayoutConfiguration(terminalVid, config) {
        return this.restApiService.putTerminalLayoutConfiguration(terminalVid, config);
    }
    /******** VENTILATION TEMPERATURE *******/
    getClimateVentilations(terminalVid) {
        return this.restApiService.getClimateVentilations(terminalVid);
    }
    postClimateVentilations(terminalVid, climateVentilations) {
        return this.restApiService.postClimateVentilations(terminalVid, climateVentilations);
    }
    /******** VENTS *******/
    getVents(terminalVid) {
        return this.restApiService.getVents(terminalVid);
    }
    postVents(terminalVid, vents) {
        return this.restApiService.postVents(terminalVid, vents);
    }
    /******** FAN STEPS *******/
    getFanSteps(terminalVid) {
        return this.restApiService.getFanSteps(terminalVid);
    }
    postFanSteps(terminalVid, fanSteps) {
        return this.restApiService.postFanSteps(terminalVid, fanSteps);
    }
    /******** THERMAL INVERSION *******/
    getThermalInversion(terminalVid) {
        return this.restApiService.getThermalInversion(terminalVid);
    }
    postThermalInversion(terminalVid, thermalInversion) {
        return this.restApiService.postThermalInversion(terminalVid, thermalInversion);
    }
    /******** HEATING TEMPERATURE *******/
    getHeatingTemperature(terminalVid) {
        return this.restApiService.getHeatingTemperature(terminalVid);
    }
    postHeatingTemperature(terminalVid, heatingTemperature) {
        return this.restApiService.postHeatingTemperature(terminalVid, heatingTemperature);
    }
    /******** HEATERS *******/
    getHeaters(terminalVid) {
        return this.restApiService.getHeaters(terminalVid);
    }
    postHeaters(terminalVid, heaters) {
        return this.restApiService.postHeaters(terminalVid, heaters);
    }
    /******** PIPES *******/
    getPipes(terminalVid) {
        return this.restApiService.getPipes(terminalVid);
    }
    postPipes(terminalVid, pipes) {
        return this.restApiService.postPipes(terminalVid, pipes);
    }
    /******** TRANSPORT GROUP *******/
    getTransportGroup(terminalVid) {
        return this.restApiService.getTransportGroup(terminalVid);
    }
    postTransportGroup(terminalVid, transportGroup) {
        return this.restApiService.postTransportGroup(terminalVid, transportGroup);
    }
    /******** CURTAIN ENERGY *******/
    getCurtainEnergy(terminalVid) {
        return this.restApiService.getCurtainEnergy(terminalVid);
    }
    postCurtainEnergy(terminalVid, curtainEnergy) {
        return this.restApiService.postCurtainEnergy(terminalVid, curtainEnergy);
    }
    /******** CURTAIN SHADE *******/
    getCurtainShade(terminalVid) {
        return this.restApiService.getCurtainShade(terminalVid);
    }
    postCurtainShade(terminalVid, curtainShade) {
        return this.restApiService.postCurtainShade(terminalVid, curtainShade);
    }
    /******** CURTAIN REGULATION *******/
    getCurtainRegulation(terminalVid) {
        return this.restApiService.getCurtainRegulation(terminalVid);
    }
    postCurtainRegulation(terminalVid, curtainRegulation) {
        return this.restApiService.postCurtainRegulation(terminalVid, curtainRegulation);
    }
    /******** CURTAIN GAPPING *******/
    getCurtainGapping(terminalVid) {
        return this.restApiService.getCurtainGapping(terminalVid);
    }
    postCurtainGapping(terminalVid, curtainGapping) {
        return this.restApiService.postCurtainGapping(terminalVid, curtainGapping);
    }
    /******** DARKENING CURTAIN *******/
    getDarkeningCurtain(terminalVid) {
        return this.restApiService.getDarkeningCurtain(terminalVid);
    }
    postDarkeningCurtain(terminalVid, curtainDarkening) {
        return this.restApiService.postDarkeningCurtain(terminalVid, curtainDarkening);
    }
    /******** SHADING CURTAIN *******/
    getShadingCurtain(terminalVid) {
        return this.restApiService.getShadingCurtain(terminalVid);
    }
    postShadingCurtain(terminalVid, shadingCurtain) {
        return this.restApiService.postShadingCurtain(terminalVid, shadingCurtain);
    }
    /******** Switching Program *******/
    getSwitchingProgram(terminalVid) {
        return this.restApiService.getSwitchingProgram(terminalVid);
    }
    postSwitchingProgram(terminalVid, switchingProgram) {
        return this.restApiService.postSwitchingProgram(terminalVid, switchingProgram);
    }
    /******** MISTING *******/
    getMistingProgramming(terminalVid) {
        return this.restApiService.getMistingProgramming(terminalVid);
    }
    postMistingProgramming(terminalVid, misting) {
        return this.restApiService.postMistingProgramming(terminalVid, misting);
    }
    getMistingRegulation(terminalVid) {
        return this.restApiService.getMistingRegulation(terminalVid);
    }
    postMistingRegulation(terminalVid, misting) {
        return this.restApiService.postMistingRegulation(terminalVid, misting);
    }
    /******** HAF FANS *******/
    getHafFansProgramming(terminalVid) {
        return this.restApiService.getHafFansProgramming(terminalVid);
    }
    postHafFansProgramming(terminalVid, hafFans) {
        return this.restApiService.postHafFansProgramming(terminalVid, hafFans);
    }
    getHafFansAdjusting(terminalVid) {
        return this.restApiService.getHafFansAdjusting(terminalVid);
    }
    postHafFansAdjusting(terminalVid, hafFans) {
        return this.restApiService.postHafFansAdjusting(terminalVid, hafFans);
    }
    /******** ALARMS ZONE *******/
    getAlarmsZone(terminalVid) {
        return this.restApiService.getAlarmsZone(terminalVid);
    }
    postAlarmsZone(terminalVid, alarms) {
        return this.restApiService.postAlarmsZone(terminalVid, alarms);
    }
    /******** ALARMS FROST *******/
    getAlarmsFrost(terminalVid) {
        return this.restApiService.getAlarmsFrost(terminalVid);
    }
    postAlarmsFrost(terminalVid, alarms) {
        return this.restApiService.postAlarmsFrost(terminalVid, alarms);
    }
    /******** ALARMS STORM *******/
    getAlarmsStorm(terminalVid) {
        return this.restApiService.getAlarmsStorm(terminalVid);
    }
    postAlarmsStorm(terminalVid, alarms) {
        return this.restApiService.postAlarmsStorm(terminalVid, alarms);
    }
    /******** ALARMS RAIN *******/
    getAlarmsRain(terminalVid) {
        return this.restApiService.getAlarmsRain(terminalVid);
    }
    postAlarmsRain(terminalVid, alarms) {
        return this.restApiService.postAlarmsRain(terminalVid, alarms);
    }
    /******** CO2 *******/
    getCO2(terminalVid) {
        return this.restApiService.getCO2(terminalVid);
    }
    postCO2(terminalVid, co2) {
        return this.restApiService.postCO2(terminalVid, co2);
    }
    /******** INSTALLER PIPE *******/
    getInstallerPipes(terminalVid) {
        return this.restApiService.getInstallerPipes(terminalVid);
    }
    postInstallerPipes(terminalVid, pipes) {
        return this.restApiService.postInstallerPipes(terminalVid, pipes);
    }
    /******** INSTALLER MISTING *******/
    getInstallerMisting(terminalVid) {
        return this.restApiService.getInstallerMisting(terminalVid);
    }
    postInstallerMisting(terminalVid, misting) {
        return this.restApiService.postInstallerMisting(terminalVid, misting);
    }
    /******** INSTALLER MIXED CURTAINS *******/
    getInstallerMixedCurtains(terminalVid) {
        return this.restApiService.getInstallerMixedCurtains(terminalVid);
    }
    postInstallerMixedCurtains(terminalVid, mixedCurtains) {
        return this.restApiService.postInstallerMixedCurtains(terminalVid, mixedCurtains);
    }
    /******** INSTALLER DARKENING CURTAINS *******/
    getInstallerDarkeningCurtains(terminalVid) {
        return this.restApiService.getInstallerDarkeningCurtains(terminalVid);
    }
    postInstallerDarkeningCurtains(terminalVid, darkeningCurtains) {
        return this.restApiService.postInstallerDarkeningCurtains(terminalVid, darkeningCurtains);
    }
    /******** INSTALLER SHADING CURTAINS *******/
    getInstallerShadingCurtains(terminalVid) {
        return this.restApiService.getInstallerShadingCurtains(terminalVid);
    }
    postInstallerShadingCurtains(terminalVid, shadingCurtains) {
        return this.restApiService.postInstallerShadingCurtains(terminalVid, shadingCurtains);
    }
    /******** INSTALLER ZONES *******/
    getInstallerZones(terminalVid) {
        return this.restApiService.getInstallerZones(terminalVid);
    }
    postInstallerZones(terminalVid, vents) {
        return this.restApiService.postInstallerZones(terminalVid, vents);
    }
    /******** INSTALLER VENTS *******/
    getInstallerVents(terminalVid) {
        return this.restApiService.getInstallerVents(terminalVid);
    }
    postInstallerVens(terminalVid, vents) {
        return this.restApiService.postInstallerVents(terminalVid, vents);
    }
    /******** INSTALLER CO2 *******/
    getInstallerCO2(terminalVid) {
        return this.restApiService.getInstallerCO2(terminalVid);
    }
    postInstallerCO2(terminalVid, co2) {
        return this.restApiService.postInstallerCO2(terminalVid, co2);
    }
}
ClimateService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: ClimateService, deps: [{ token: FarmingRestApiService }], target: i0.ɵɵFactoryTarget.Injectable });
ClimateService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: ClimateService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: ClimateService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: FarmingRestApiService }]; } });

const MAX_VALVES = 32;
const MAX_PUMPS = 9;
const MAX_FERTILIZERS = 9;
const MAX_CONFIG_VALVES = 7;
const MAX_CONFIG_PUMPS = 3;
const MAX_CONFIG_FERTILIZERS = 4;
const FERTILIZER_TYPES = [
    { type: 'sequential', number: 1 },
    { type: 'proportional', number: 2 },
    { type: 'simultaneous', number: 3 }
];

class ConfigurableService {
    constructor(farmingRestApiService) {
        this.farmingRestApiService = farmingRestApiService;
    }
    getEquipment(terminalVid) {
        return this.farmingRestApiService.getConfigurableEquipment(terminalVid);
    }
    getTerminal(terminalVid) {
        return this.farmingRestApiService.getTerminal(terminalVid);
    }
    getPrograms(terminalVid, program, active) {
        return this.farmingRestApiService.getConfigurablePrograms(terminalVid, program, active);
    }
    postPrograms(terminalVid, programs) {
        return this.farmingRestApiService.postConfigurablePrograms(terminalVid, programs);
    }
    postManualActionsProgram(terminalVid, payload) {
        return this.farmingRestApiService.postManualActionsConfigurableProgram(terminalVid, payload);
    }
    postConfigurableTerminal(terminalVid, info) {
        return this.farmingRestApiService.postConfigurableEquipment(terminalVid, info);
    }
}
ConfigurableService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: ConfigurableService, deps: [{ token: FarmingRestApiService }], target: i0.ɵɵFactoryTarget.Injectable });
ConfigurableService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: ConfigurableService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: ConfigurableService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: FarmingRestApiService }]; } });

class DataloggerService {
    constructor(farmingRestApiService) {
        this.farmingRestApiService = farmingRestApiService;
    }
    getConnections(vid) {
        return this.farmingRestApiService.getConnections(vid);
    }
    postConnections(vid, data) {
        return this.farmingRestApiService.postConnections(vid, data);
    }
    putConnections(vid, data) {
        return this.farmingRestApiService.putConnections(vid, data);
    }
    putCalculations(vid, data) {
        return this.farmingRestApiService.putCalculations(vid, data);
    }
    postCalcs(vid, data) {
        return this.farmingRestApiService.postCalculations(vid, data);
    }
    postReprogram(vid, data) {
        return this.farmingRestApiService.postReprogram(vid, data);
    }
    getCalculationsDependencies(vid, data) {
        return this.farmingRestApiService.getCalculationsdependencies(vid, data);
    }
    getConnectionsDependencies(vid, data) {
        return this.farmingRestApiService.getConnectionsdependencies(vid, data);
    }
    deleteCalculation(vid, data) {
        return this.farmingRestApiService.deleteCalculation(vid, data);
    }
    deleteConnection(vid, data) {
        return this.farmingRestApiService.deleteConnection(vid, data);
    }
    getConnectionsAvailable(vid) {
        return this.farmingRestApiService.getConnectionsAvailable(vid);
    }
    getDataloggerData(vid) {
        return this.farmingRestApiService.getDataloggerData(vid);
    }
    getCalculations(vid) {
        return this.farmingRestApiService.getCalculations(vid);
    }
    getCalculationsAvailable(vid) {
        return this.farmingRestApiService.getCalculationsAvailable(vid);
    }
    getChartsData(vid, data) {
        return this.farmingRestApiService.getChartsData(vid, data);
    }
    postChartsData(vid, data) {
        return this.farmingRestApiService.postChartsData(vid, data);
    }
    getET0Prediction(vid, data) {
        return this.farmingRestApiService.getET0Prediction(vid, data);
    }
    getFAOValue(vid) {
        return this.farmingRestApiService.getFAOValue(vid);
    }
}
DataloggerService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: DataloggerService, deps: [{ token: FarmingRestApiService }], target: i0.ɵɵFactoryTarget.Injectable });
DataloggerService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: DataloggerService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: DataloggerService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: FarmingRestApiService }]; } });

/*************************
 ******* IRRIGATION ******
 ************************/
class IrrigationService {
    constructor(farmingRestApiService) {
        this.farmingRestApiService = farmingRestApiService;
    }
    /******** FERTILIZER FORMULAS *******/
    getFertilizerFormulas(terminalVid) {
        return this.farmingRestApiService.getFertilizerFormulas(terminalVid);
    }
    getFertilizerFormula(terminalVid, id) {
        return this.farmingRestApiService.getFertilizerFormula(terminalVid, id);
    }
    postFertilizerFormulas(terminalVid, fertilizerFormulas) {
        return this.farmingRestApiService.postFertilizerFormulas(terminalVid, fertilizerFormulas);
    }
    /******** GROUPS *******/
    getIrrigationGroups(terminalVid) {
        return this.farmingRestApiService.getIrrigationGroups(terminalVid);
    }
    getIrrigationGroup(terminalVid, groupId) {
        return this.farmingRestApiService.getIrrigationGroup(terminalVid, groupId);
    }
    postIrrigationGroups(terminalVid, groups) {
        return this.farmingRestApiService.postIrrigationGroups(terminalVid, groups);
    }
    /******** PROGRAMS *******/
    getIrrigationPrograms(terminalVid) {
        return this.farmingRestApiService.getIrrigationPrograms(terminalVid);
    }
    getIrrigationProgram(terminalVid, programId) {
        return this.farmingRestApiService.getIrrigationProgram(terminalVid, programId);
    }
    postIrrigationPrograms(terminalVid, programs) {
        return this.farmingRestApiService.postIrrigationPrograms(terminalVid, programs);
    }
    postManualActionsIrrigationProgram(terminalVid, payload) {
        return this.farmingRestApiService.postManualActionsIrrigationProgram(terminalVid, payload);
    }
    /******** VALVES *******/
    getValves(terminalVid) {
        return this.farmingRestApiService.getValves(terminalVid);
    }
    /******** SENSORS *******/
    getSensors(terminalVid) {
        return this.farmingRestApiService.getSensors(terminalVid);
    }
    putSensor(terminalVid, sensor) {
        return this.farmingRestApiService.putSensor(terminalVid, sensor);
    }
    getSensorsSubtypes(terminalVid) {
        return this.farmingRestApiService.getSensorsSubtypes(terminalVid);
    }
    /******** PUMPS *******/
    getPumps(terminalVid) {
        return this.farmingRestApiService.getPumps(terminalVid);
    }
    /******** DEMANDS *******/
    getDemands(terminalVid) {
        return this.farmingRestApiService.getDemands(terminalVid);
    }
    /******** PROGRAMS *******/
    getPrograms(terminalVid) {
        return this.farmingRestApiService.getPrograms(terminalVid);
    }
    postPrograms(terminalVid, programs) {
        return this.farmingRestApiService.postPrograms(terminalVid, programs);
    }
    /******** EQUIPMENT *******/
    getIrrigationTerminal(terminalVid) {
        return this.farmingRestApiService.getIrrigationEquipment(terminalVid);
    }
    getIrrigationEquipmentWithWaterSystems(terminalVid) {
        return this.farmingRestApiService.getIrrigationEquipmentWithWaterSystems(terminalVid);
    }
    postIrrigationTerminal(terminalVid, info) {
        return this.farmingRestApiService.postIrrigationEquipment(terminalVid, info);
    }
    /******** DRAINAGES *******/
    getDrainageTrays(terminalVid) {
        return this.farmingRestApiService.getDrainageTrays(terminalVid);
    }
    getDrainages(terminalVid) {
        return this.farmingRestApiService.getDrainages(terminalVid);
    }
    getDrainage(terminalVid, drainageId) {
        return this.farmingRestApiService.getDrainage(terminalVid, drainageId);
    }
    getDrainagesV4(terminalVid) {
        return this.farmingRestApiService.getDrainagesV4(terminalVid);
    }
    postDrainagesV4(terminalVid, drainages) {
        return this.farmingRestApiService.postDrainagesV4(terminalVid, drainages);
    }
    getDrainagesV3(terminalVid) {
        return this.farmingRestApiService.getDrainagesV3(terminalVid);
    }
    postDrainagesV3(terminalVid, drainages) {
        return this.farmingRestApiService.postDrainagesV3(terminalVid, drainages);
    }
    /******** MIXTURE FORMULAS *******/
    getMixtureFormulas(terminalVid) {
        return this.farmingRestApiService.getMixtureFormulas(terminalVid);
    }
    getMixtureFormula(terminalVid, mixtureId) {
        return this.farmingRestApiService.getMixtureFormula(terminalVid, mixtureId);
    }
    postMixtureFormulas(terminalVid, formulas) {
        return this.farmingRestApiService.postMixtureFormulas(terminalVid, formulas);
    }
    /******** INPUT OUTPUT *******/
    getInputOutputs(terminalVid, mode, type) {
        return this.farmingRestApiService.getInputOutputs(terminalVid, mode, type);
    }
    /******** METEO ALARMS *******/
    getMeteoAlarms(terminalVid) {
        return this.farmingRestApiService.getMeteoAlarms(terminalVid);
    }
    postMeteoAlarms(terminalVid, meteoAlarms) {
        return this.farmingRestApiService.postMeteoAlarms(terminalVid, meteoAlarms);
    }
    /******** TERMINAL LAYOUT *******/
    getTerminalLayoutConfiguration(terminalVid) {
        return this.farmingRestApiService.getTerminalLayoutConfiguration(terminalVid);
    }
    putTerminalLayoutConfiguration(terminalVid, config) {
        return this.farmingRestApiService
            .putTerminalLayoutConfiguration(terminalVid, config);
    }
    /******** TERMINAL *******/
    getTerminal(terminalVid) {
        return this.farmingRestApiService.getTerminal(terminalVid);
    }
    /***********************************
     ******* IRRIGATION INSTALLER ******
     **********************************/
    /******** VALVES *******/
    getIrrigationInstallerValves(terminalVid) {
        return this.farmingRestApiService.getIrrigationInstallerValves(terminalVid);
    }
    getIrrigationInstallerValve(terminalVid, valveId) {
        return this.farmingRestApiService.getIrrigationInstallerValve(terminalVid, valveId);
    }
    postIrrigationInstallerValves(terminalVid, valves) {
        return this.farmingRestApiService.postIrrigationInstallerValves(terminalVid, valves);
    }
    /******** DRAINAGE TRAYS *******/
    getIrrigationInstallerDrainageTrays(terminalVid) {
        return this.farmingRestApiService.getIrrigationInstallerDrainageTrays(terminalVid);
    }
    getIrrigationInstallerDrainageTray(terminalVid, trayId) {
        return this.farmingRestApiService.getIrrigationInstallerDrainageTray(terminalVid, trayId);
    }
    postIrrigationInstallerDrainageTrays(terminalVid, drainage_trays) {
        return this.farmingRestApiService.postIrrigationInstallerDrainageTrays(terminalVid, drainage_trays);
    }
    /******** DEMANDS *******/
    getIrrigationInstallerDemands(terminalVid) {
        return this.farmingRestApiService.getIrrigationInstallerDemands(terminalVid);
    }
    getIrrigationInstallerDemand(terminalVid, demandId) {
        return this.farmingRestApiService.getIrrigationInstallerDemand(terminalVid, demandId);
    }
    postIrrigationInstallerDemands(terminalVid, demands) {
        return this.farmingRestApiService.postIrrigationInstallerDemands(terminalVid, demands);
    }
    /******** PH CE REARM ALARMS *******/
    getIrrigationInstallerPHCERearmAlarms(terminalVid) {
        return this.farmingRestApiService.getIrrigationInstallerPHCERearmAlarms(terminalVid);
    }
    postIrrigationInstallerPHCERearmAlarms(terminalVid, ph_ce_rearm_alarms) {
        return this.farmingRestApiService.postIrrigationInstallerPHCERearmAlarms(terminalVid, ph_ce_rearm_alarms);
    }
    /******** PUMPS *******/
    getIrrigationInstallerPump(terminalVid, pumpId) {
        return this.farmingRestApiService.getIrrigationInstallerPump(terminalVid, pumpId);
    }
    getIrrigationInstallerPumps(terminalVid) {
        return this.farmingRestApiService.getIrrigationInstallerPumps(terminalVid);
    }
    postIrrigationInstallerPumps(terminalVid, pumps) {
        return this.farmingRestApiService.postIrrigationInstallerPumps(terminalVid, pumps);
    }
    /******** MIXTURE VALVES *******/
    getIrrigationInstallerMixtureValves(terminalVid) {
        return this.farmingRestApiService.getIrrigationInstallerMixtureValves(terminalVid);
    }
    getIrrigationInstallerMixtureValve(terminalVid, mixtureValveId) {
        return this.farmingRestApiService.getIrrigationInstallerMixtureValve(terminalVid, mixtureValveId);
    }
    postIrrigationInstallerMixtureValves(terminalVid, mixture_valves) {
        return this.farmingRestApiService.postIrrigationInstallerMixtureValves(terminalVid, mixture_valves);
    }
    /******** WATER SYSTEMS *******/
    getIrrigationInstallerWaterSystems(terminalVid) {
        return this.farmingRestApiService.getIrrigationInstallerWaterSystems(terminalVid);
    }
    postIrrigationInstallerWaterSystems(terminalVid, waterSystem) {
        return this.farmingRestApiService.postIrrigationInstallerWaterSystems(terminalVid, waterSystem);
    }
    /******** FILTERS *******/
    getIrrigationInstallerFilters(terminalVid) {
        return this.farmingRestApiService.getIrrigationInstallerFilters(terminalVid);
    }
    getIrrigationInstallerFilter(terminalVid, filterId) {
        return this.farmingRestApiService.getIrrigationInstallerFilter(terminalVid, filterId);
    }
    postIrrigationInstallerFilters(terminalVid, filters) {
        return this.farmingRestApiService.postIrrigationInstallerFilters(terminalVid, filters);
    }
    /******** MISCELLANEOUS *******/
    getIrrigationInstallerMiscellaneous(terminalVid) {
        return this.farmingRestApiService.getIrrigationInstallerMiscellaneous(terminalVid);
    }
    postIrrigationInstallerMiscellaneous(terminalVid, miscellaneous) {
        return this.farmingRestApiService.postIrrigationInstallerMiscellaneous(terminalVid, miscellaneous);
    }
    /******** FERTILIZERS *******/
    getIrrigationInstallerFertilizers(terminalVid) {
        return this.farmingRestApiService.getIrrigationInstallerFertilizers(terminalVid);
    }
    postIrrigationInstallerFertilizers(terminalVid, fertilizers) {
        return this.farmingRestApiService.postIrrigationInstallerFertilizers(terminalVid, fertilizers);
    }
    /******** AGITATORS *******/
    getIrrigationInstallerAgitators(terminalVid) {
        return this.farmingRestApiService.getIrrigationInstallerAgitators(terminalVid);
    }
    postIrrigationInstallerAgitators(terminalVid, agitators) {
        return this.farmingRestApiService.postIrrigationInstallerAgitators(terminalVid, agitators);
    }
    /******** FERTILIZERS UCROP *******/
    getIrrigationInstallerFertilizersNuve(terminalVid) {
        return this.farmingRestApiService.getIrrigationInstallerFertilizersNuve(terminalVid);
    }
    postIrrigationInstallerFertilizersNuve(terminalVid, payload) {
        return this.farmingRestApiService.postIrrigationInstallerFertilizersNuve(terminalVid, payload);
    }
    /******** IO REPORT *******/
    getIrrigationInstallerIOReport(terminalVid) {
        return this.farmingRestApiService.getIrrigationInstallerIOReport(terminalVid);
    }
    /******** CANCEL ALARMS *******/
    postCancelAlarmsIrrigation(terminalVid, data) {
        return this.farmingRestApiService.postCancelAlarmsIrrigation(terminalVid, data);
    }
    /******** MANUAL ACTIVATIONS *******/
    getManualActivationStatus(terminalVid) {
        return this.farmingRestApiService.getManualActivationStatus(terminalVid);
    }
    postStartFiltersCleaning(terminalVid, waterSystemId) {
        return this.farmingRestApiService.postStartFiltersCleaning(terminalVid, waterSystemId);
    }
    postStopFiltersCleaning(terminalVid, waterSystemId) {
        return this.farmingRestApiService.postStopFiltersCleaning(terminalVid, waterSystemId);
    }
    postWaterSystemLock(terminalVid, waterSystemId) {
        return this.farmingRestApiService.postWaterSystemLock(terminalVid, waterSystemId);
    }
}
IrrigationService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: IrrigationService, deps: [{ token: FarmingRestApiService }], target: i0.ɵɵFactoryTarget.Injectable });
IrrigationService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: IrrigationService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: IrrigationService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: FarmingRestApiService }]; } });

class WeatherRestApiService {
    constructor(httpRepositoryService) {
        this.httpRepositoryService = httpRepositoryService;
    }
    getWeatherCurrentWeatherByMultipleElements(data) {
        return this.httpRepositoryService.postRequest('analytics/meteo/current-weather-by-multiple-elements', data);
    }
    getWeatherCurrentByField(vid) {
        return this.httpRepositoryService.getRequest('analytics/meteo/current-weather-by-field/' + vid);
    }
    getCurrentWeatherByTerminal(vid) {
        return this.httpRepositoryService.getRequest('analytics/meteo/current-weather-by-terminal/' + vid);
    }
    getWeatherForecastByField(vid) {
        return this.httpRepositoryService.getRequest('analytics/meteo/forecast-weather-by-field/' + vid);
    }
    getWeatherHistoric(vid, startingDate, endingDate, noCache = false) {
        return this.httpRepositoryService.getRequest('analytics/meteo/historic-weather-by-field/' +
            vid +
            '?starting_date=' +
            startingDate +
            '&ending_date=' +
            endingDate +
            (noCache ? '&noCache=true' : ''));
    }
}
WeatherRestApiService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: WeatherRestApiService, deps: [{ token: HttpRepositoryService }], target: i0.ɵɵFactoryTarget.Injectable });
WeatherRestApiService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: WeatherRestApiService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: WeatherRestApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: HttpRepositoryService }]; } });

class WeatherService {
    constructor(weatherRestApiService) {
        this.weatherRestApiService = weatherRestApiService;
    }
    getWeatherCurrentByField(vid) {
        return this.weatherRestApiService.getWeatherCurrentByField(vid);
    }
    getWeatherCurrentWeatherByMultipleElements(data) {
        return this.weatherRestApiService.getWeatherCurrentWeatherByMultipleElements(data);
    }
    getCurrentWeatherByTerminal(vid) {
        return this.weatherRestApiService.getCurrentWeatherByTerminal(vid);
    }
    getForecast(vid) {
        return this.weatherRestApiService.getWeatherForecastByField(vid);
    }
    getHistoric(vid, startingDate, endingDate, noCache = false) {
        return this.weatherRestApiService.getWeatherHistoric(vid, startingDate, endingDate, noCache);
    }
}
WeatherService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: WeatherService, deps: [{ token: WeatherRestApiService }], target: i0.ɵɵFactoryTarget.Injectable });
WeatherService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: WeatherService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: WeatherService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: WeatherRestApiService }]; } });

const series = [];
let seriesCounter = 0;
let plotBandCounter = 0;
const DispersionChartModel = {
    chart: {
        type: 'scatter',
        zoomType: 'x',
        resetZoomButton: {
            position: {
                // align: 'right', // by default
                // verticalAlign: 'top', // by default
                x: -30,
                y: 0,
            },
        },
        events: {
            load() {
                const xAxis = this.xAxis;
                const that = this;
                document.addEventListener('keydown', (event) => {
                    // @ts-ignore
                    if (event.key === 'Backspace') {
                        const lastPlotLine = xAxis[0].plotLinesAndBands[xAxis[0].plotLinesAndBands.length - 1];
                        // Verificar si existe una plotline para eliminar
                        if (lastPlotLine) {
                            // Eliminar la última plotline
                            xAxis[0].removePlotLine(lastPlotLine.id);
                        }
                        else {
                            if (series.length > 0) {
                                series[series.length - 1].remove();
                                series.splice(series.length - 1, 1);
                            }
                        }
                    }
                    // @ts-ignore
                    if (event.key === 'Enter') {
                        that.series.forEach((serie) => {
                            serie.update({
                                enableMouseTracking: !serie.userOptions.enableMouseTracking,
                            });
                        });
                    }
                });
                const handleClick = (e) => {
                    // Verificar si ya existe una serie de 1 punto
                    const existingSeries = series.find((s) => s.data.length === 1 // Cambiado a 's' para evitar confusión
                    );
                    if (series.length < 2 || existingSeries) {
                        // Obtener las coordenadas del punto clicado
                        const x = e.xAxis[0].value;
                        const y = e.yAxis[0].value;
                        if (existingSeries) {
                            // Agregar el segundo punto a la serie existente
                            existingSeries.addPoint([x, y]);
                            // Opcionalmente, puedes hacer algo después de agregar el segundo punto, como actualizar el gráfico
                            this.redraw();
                        }
                        else {
                            // Crear una nueva serie con el primer punto
                            const newSeries = this.addSeries({
                                name: 'Nueva Serie',
                                data: [[x, y]],
                                type: 'line',
                                showInLegend: false,
                                enableMouseTracking: true,
                                dragDrop: {
                                    draggableY: true,
                                    draggableX: true,
                                }, // Permitir arrastrar los puntos verticalmente
                            });
                            // Almacenar la nueva serie en el arreglo de series
                            series.push(newSeries);
                            seriesCounter++;
                            // Opcionalmente, puedes hacer algo después de agregar la serie, como actualizar el gráfico
                            this.redraw();
                        }
                    }
                    else {
                        const plotBandId = `plotBand-${plotBandCounter++}`; // Generar un ID único
                        this.xAxis[0].addPlotLine({
                            id: plotBandId,
                            value: e.xAxis[0].value,
                            color: 'red',
                            width: 2,
                        });
                    }
                };
                // Vincular el evento de clic al gráfico
                this.container.addEventListener('click', handleClick);
                // Reestablecer el evento de clic en el redraw
                this.redraw = (function (originalRedraw) {
                    return function () {
                        originalRedraw.apply(this, arguments);
                        that.container.addEventListener('click', handleClick);
                    };
                })(this.redraw);
            },
        },
        panning: true,
        panKey: 'shift',
    },
    title: {
        align: 'left',
        text: null,
    },
    subtitle: {
        align: 'left',
        text: '',
    },
    accessibility: {
        announceNewData: {
            enabled: true,
        },
    },
    xAxis: {
        title: {
            text: null,
        },
    },
    yAxis: [
        {
            title: {
                text: 'VWC (%)',
            },
        },
    ],
    plotOptions: {},
    legend: {
        title: {
            text: null,
        },
    },
    credits: {
        enabled: false,
    },
    tooltip: {
        headerFormat: '<span style="font-size:11px">{point.x}</span><br>',
        shared: true,
        valueDecimals: 2,
    },
    dataLabels: {
        enabled: true,
        formatter() {
            return Highcharts.numberFormat(this.y, 2);
        },
    },
    series: [],
    exporting: {
        buttons: {
            contextButton: {
                menuItems: [
                    'printChart',
                    'separator',
                    'downloadPNG',
                    'downloadJPEG',
                    'downloadPDF',
                    'downloadSVG',
                    'separator',
                    'downloadCSV',
                    'downloadXLS',
                    //"viewData",
                    'openInCloud',
                ],
            },
        },
    },
};
const IrrigationConsultingChartModel = {
    chart: {
        type: 'arearange',
        zoomType: 'x',
        resetZoomButton: {
            position: {
                // align: 'right', // by default
                // verticalAlign: 'top', // by default
                x: -30,
                y: 0,
            },
        },
        /*events: {
          // Detecta cuando se cambia el rango del zoom
          selection: function (event) {
            if (event.xAxis) {
              let min = event.xAxis[0].min;
              let max = event.xAxis[0].max;
    
              // Actualiza la otra gráfica (dispersión) con los mismos límites de zoom
              const scatterChart = Highcharts.charts[1]; // La segunda gráfica está en 'container2'
              scatterChart.xAxis[0].setExtremes(min, max);
            }
            return true; // Permitir el zoom en la gráfica actual
          },
        },*/
        panning: true,
        panKey: 'shift',
    },
    title: {
        align: 'left',
        text: null,
    },
    subtitle: {
        align: 'left',
        text: '',
    },
    accessibility: {
        announceNewData: {
            enabled: true,
        },
    },
    xAxis: {
        type: 'datetime',
        labels: {
            formatter() {
                // @ts-ignore
                return Highcharts.dateFormat('%d/%m %H:%M', new Date(this.value));
            },
        },
    },
    yAxis: [
        {
            title: {
                text: null,
            },
        },
        {
            title: {
                text: null,
            },
            opposite: true,
        },
    ]
    /*plotBands: [
        {
          from: 20,
          to: 80,
          color: 'rgba(0,0,255,0.2)',
        },
        {
          from: 10,
          to: 20,
          color: 'rgba(0,255,0,0.2)',
        },
        {
          from: 0,
          to: 10,
          color: 'rgba(255,0,0,0.2)',
        },
      ],*/
    ,
    plotOptions: {},
    legend: {
        title: {
            text: null,
        },
    },
    credits: {
        enabled: false,
    },
    tooltip: {
        headerFormat: '<span style="font-size:11px">{point.x}</span><br>',
        /*pointFormat: '<b>{point.y:.2f}</b><br/>',*/
        shared: true,
        /* formatter() {
          return Highcharts.numberFormat(this.y, 2);
        },*/
        valueDecimals: 2,
    },
    dataLabels: {
        enabled: true,
    },
    series: [
        {
            name: '',
            unit: '',
            colorByPoint: false,
            data: [],
            id: '',
        },
    ],
    exporting: {
        buttons: {
            contextButton: {
                menuItems: [
                    'printChart',
                    'separator',
                    'downloadPNG',
                    'downloadJPEG',
                    'downloadPDF',
                    'downloadSVG',
                    'separator',
                    'downloadCSV',
                    'downloadXLS',
                    //"viewData",
                    'openInCloud',
                ],
            },
        },
    },
};

class GraphicsRestApiService {
    constructor(httpRepositoryService) {
        this.httpRepositoryService = httpRepositoryService;
    }
    postMultiGraph(data) {
        return this.httpRepositoryService.postRequest('farming/concurrent-terminal/nuve/charts', data);
    }
    postLineChart(data) {
        return this.httpRepositoryService.postRequest('analytics/charts/line-chart', data);
    }
    postSaveGraph(data) {
        return this.httpRepositoryService.postRequest('analytics/graphs/graph-bookmarks', data);
    }
    postSavedMetric(data) {
        return this.httpRepositoryService.postRequest('analytics/metrics/metric-bookmarks', data);
    }
    putSaveGraph(vid, data) {
        return this.httpRepositoryService.putRequest('analytics/graphs/graph-bookmarks/' + vid, data);
    }
    putSavedMetric(vid, data) {
        return this.httpRepositoryService.putRequest('analytics/metrics/metric-bookmarks/' + vid, data);
    }
    deleteSavedGraph(vid) {
        return this.httpRepositoryService.deleteRequest('analytics/graphs/graph-bookmarks/' + vid);
    }
    deleteSavedMetric(vid) {
        return this.httpRepositoryService.deleteRequest('analytics/metrics/metric-bookmarks/' + vid);
    }
    getSaveGraph() {
        return this.httpRepositoryService.getRequest('analytics/graphs/graph-bookmarks');
    }
    getSavedMetrics() {
        return this.httpRepositoryService.getRequest('analytics/metrics/metric-bookmarks');
    }
    getIntervalLimits() {
        return this.httpRepositoryService.getRequest('analytics/charts/interval-limits');
    }
    postLineChartDataTable(data) {
        return this.httpRepositoryService.postRequest('analytics/charts/line-chart/data-table', data);
    }
}
GraphicsRestApiService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: GraphicsRestApiService, deps: [{ token: HttpRepositoryService }], target: i0.ɵɵFactoryTarget.Injectable });
GraphicsRestApiService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: GraphicsRestApiService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: GraphicsRestApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: HttpRepositoryService }]; } });

class GraphicsService {
    constructor(graphicsRestApiService) {
        this.graphicsRestApiService = graphicsRestApiService;
    }
    postMultiGraph(data) {
        return this.graphicsRestApiService.postMultiGraph(data);
    }
    postLineChart(data) {
        return this.graphicsRestApiService.postLineChart(data);
    }
    postSaveGraph(data) {
        return this.graphicsRestApiService.postSaveGraph(data);
    }
    postSavedMetric(data) {
        return this.graphicsRestApiService.postSavedMetric(data);
    }
    putSaveGraph(vid, data) {
        return this.graphicsRestApiService.putSaveGraph(vid, data);
    }
    putSavedMetric(vid, data) {
        return this.graphicsRestApiService.putSavedMetric(vid, data);
    }
    deleteSavedGraph(vid) {
        return this.graphicsRestApiService.deleteSavedGraph(vid);
    }
    deleteSavedMetric(vid) {
        return this.graphicsRestApiService.deleteSavedMetric(vid);
    }
    getSaveGraph() {
        return this.graphicsRestApiService.getSaveGraph();
    }
    getSavedMetrics() {
        return this.graphicsRestApiService.getSavedMetrics();
    }
    getIntervalLimits() {
        return this.graphicsRestApiService.getIntervalLimits();
    }
    postLineChartDataTable(data) {
        return this.graphicsRestApiService.postLineChartDataTable(data);
    }
}
GraphicsService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: GraphicsService, deps: [{ token: GraphicsRestApiService }], target: i0.ɵɵFactoryTarget.Injectable });
GraphicsService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: GraphicsService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: GraphicsService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: GraphicsRestApiService }]; } });

theme(Highcharts);
Exporting(Highcharts);
ExportData(Highcharts);
HC_accessibility(Highcharts);
highchartsMore(Highcharts);
class IrrigationConsultingMainChartComponent {
    constructor(translationsLib, modulesService, graphicsService, irrigationService) {
        this.translationsLib = translationsLib;
        this.modulesService = modulesService;
        this.graphicsService = graphicsService;
        this.irrigationService = irrigationService;
        this.viewMode = 1;
        this.updateFlag = false;
        this.chartConstructor = 'chart';
        this.Highcharts = Highcharts;
        this.irrigationChart = IrrigationConsultingChartModel;
        this.loadedGraph = false;
        this.maxValue = 0;
        this.selectedTabIndex = 0;
        this.hideChart = true;
        this.range = new FormGroup({
            start: new FormControl(null),
            end: new FormControl(null),
        });
        this.noPrediction = false;
    }
    ngOnInit() {
        this.maxDate = new Date();
        if (this.viewMode === 3 && this.dates) {
            const inicio = new Date(this.dates.start);
            const fin = new Date(this.dates.end);
            inicio.setDate(inicio.getDate() - 2);
            fin.setDate(fin.getDate() + 2);
            this.range.patchValue({
                start: inicio,
                end: fin,
            });
        }
        else {
            const inicio = new Date();
            const fin = new Date();
            inicio.setDate(fin.getDate() - 2);
            this.range.patchValue({
                start: inicio,
                end: fin,
            });
        }
        this.irrigationChart.series = [];
        this.getPredictionData();
    }
    getPredictionData() {
        this.modulesService.getIRISPrediction(this.vid).subscribe((res) => {
            this.predictionData = res;
            if (this.predictionData['message']) {
                this.noPrediction = true;
            }
            this.createGraph();
        });
    }
    onTabChange(event) {
        this.selectedTabIndex = event.index;
        this.loadedGraph = false;
        const inicio = new Date();
        const fin = new Date();
        if (event.index === 0) {
            inicio.setDate(fin.getDate() - 1);
        }
        if (event.index === 1) {
            inicio.setDate(fin.getDate() - 2);
        }
        if (event.index === 2) {
            inicio.setDate(fin.getDate() - 7);
        }
        if (event.index === 3) {
            inicio.setDate(fin.getDate() - 30);
        }
        this.range.patchValue({
            start: inicio,
            end: fin,
        });
        if (event.index === 4) {
            this.loadedGraph = true;
            this.range.patchValue({ start: null, end: null });
        }
        this.createGraph();
    }
    createPersonalizedGraph() {
        this.loadedGraph = false;
        this.createGraph();
        this.hideChart = false;
    }
    createGraph() {
        this.irrigationChart.series = [];
        const data = {
            start: moment(this.range.value.start).format('YY-MM-DD HH:mm:ss'),
            end: moment(this.range.value.end).format('YY-MM-DD HH:mm:ss'),
        };
        const tensiometer = [];
        if (this.viewMode !== 3) {
            /* LO DEJO POR SI VUELVEN A PEDIR QUITAR EL SENSOR DE HUMEDAD
            if (
              this.module.irrigation_consulting_configuration.sensor1.physicalType ===
              0
            ) {
              tensiometer.push(
                this.module.irrigation_consulting_configuration.sensor1
              );
            } else {
              tensiometer.push(
                this.module.irrigation_consulting_configuration.sensor2
              );
            }*/
            tensiometer.push(this.module.irrigation_consulting_configuration.sensor1);
            tensiometer.push(this.module.irrigation_consulting_configuration.sensor2);
            if (this.module.irrigation_consulting_configuration.sensor3) {
                tensiometer.push(this.module.irrigation_consulting_configuration.sensor3);
            }
        }
        else {
            tensiometer.push(this.module.irrigation_consulting_configuration.sensor1);
            tensiometer.push(this.module.irrigation_consulting_configuration.sensor2);
            if (this.module.irrigation_consulting_configuration.sensor3) {
                tensiometer.push(this.module.irrigation_consulting_configuration.sensor3);
            }
        }
        const sensorsData = {
            begin: moment(this.range.value.start).format('YY-MM-DD HH:mm:ss'),
            end: moment(this.range.value.end).format('YY-MM-DD HH:mm:ss'),
            sensors: tensiometer,
            interval: 1500,
            terminal_vid: this.module.terminal_vid,
        };
        this.modulesService
            .getModuleDataByVid(this.vid, data)
            .subscribe((moduleData) => {
            this.graphicsService
                .postMultiGraph({
                method: 'post',
                terminals: [sensorsData],
            })
                .subscribe(async (tension) => {
                const xAxis = [];
                const tensionSeries = [];
                const banda1 = [];
                const banda2 = [];
                const banda3 = [];
                const banda4 = [];
                let tensionCounter = 0;
                for (const sensor of tension.terminals[0].sensors) {
                    this.unit = sensor.unit;
                    const seriesFixed = [];
                    for (const val of sensor.data) {
                        if (this.maxValue === 0 || this.maxValue < val.value) {
                            this.maxValue = val.value;
                        }
                        seriesFixed.push([val.timestamp, val.value]);
                        xAxis.push(val.timestamp);
                    }
                    // Valores por defecto
                    let color = '#000000';
                    let yAxis = 0;
                    const tensionTypes = [0, 15];
                    const vwcTypes = [12, 16];
                    if (tensionTypes.includes(sensor.physicalType)) {
                        color = tensionCounter === 0 ? '#af1f00' : '#800080';
                        yAxis = 0;
                        tensionCounter++;
                    }
                    else if (vwcTypes.includes(sensor.physicalType)) {
                        color = '#000baf';
                        yAxis = 1;
                    }
                    // Si hay predicción para el sensor, añadirla
                    if (this.predictionData['sensors']) {
                        const matchingPrediction = this.predictionData['sensors'].find((sensorPred) => sensor.physicalType === sensorPred.physical_type &&
                            sensor.nent === sensorPred.nent &&
                            sensor.nexp === sensorPred.nexp);
                        if (matchingPrediction) {
                            seriesFixed.push(matchingPrediction['predictions'][0]);
                        }
                    }
                    // Crear siempre la serie, tenga predicción o no
                    const serie = {
                        name: sensor.name,
                        type: 'line',
                        data: seriesFixed,
                        yAxis,
                        color,
                    };
                    tensionSeries.push(serie);
                }
                moduleData.bands.forEach((band, index) => {
                    if (index === 0 && tensionSeries[0] && tensionSeries[0].data.length > 0) {
                        band[0] = tensionSeries[0].data[0][0];
                    }
                    else {
                        band[0] = band[0] * 1000;
                    }
                });
                if (moduleData.bands.length > 0 && this.predictionData['sensors']) {
                    moduleData.bands[moduleData.bands.length - 1][0] =
                        this.predictionData['sensors'][0]['predictions'][this.predictionData['sensors'][0]['predictions'].length - 1][0];
                }
                const datosRiego = moduleData.bands;
                if (this.viewMode === 3) {
                    moduleData.backgrounds_by_tension.forEach((tension) => {
                        tension[0] = tension[0] * 1000;
                        let time = tension[0];
                        if (banda1.length === 0 && tensionSeries[0] && tensionSeries[0].data.length > 0) {
                            time = tensionSeries[0].data[0][0]; //primer valor de las series
                        }
                        //Los datos vienen desordenados el 3 es inicio cc el 1 es inicio de recarga y el 2 es fin de recarga
                        banda1.push([time, 0, tension[3]]);
                        banda2.push([time, tension[3], tension[1]]);
                        banda3.push([time, tension[1], tension[2]]);
                        if (this.maxValue !== 0) {
                            banda4.push([time, tension[2], this.maxValue]);
                        }
                        else {
                            if (this.unit === 'mb') {
                                this.maxValue = 10000;
                            }
                            else {
                                this.maxValue = 100;
                            }
                            banda4.push([time, tension[2], this.maxValue]);
                        }
                    });
                }
                setTimeout(() => {
                    let predictedData = [];
                    if (this.predictionData['sensors']) {
                        const sensors = this.predictionData['sensors'];
                        const typeLabels = {
                            VWC: 'VWC',
                            SOIL_TENSION: 'Tension',
                        };
                        let tensionCount = 0;
                        const getColor = (type) => {
                            if (type === 'VWC')
                                return '#000baf';
                            if (type === 'SOIL_TENSION') {
                                return tensionCount++ === 0 ? '#af1f00' : '#800080'; // rojo, luego morado
                            }
                            return '#000000'; // fallback
                        };
                        const getYAxis = (type) => (type === 'VWC' ? 1 : 0);
                        const getName = (type) => this.translationsLib.get(`Predicción ${typeLabels[type] ?? type}`);
                        predictedData = sensors.slice(0, 3).map((sensor) => {
                            if (!sensor)
                                return null;
                            return {
                                color: getColor(sensor.type),
                                name: getName(sensor.type),
                                marker: { enabled: false },
                                fillOpacity: 0.3,
                                data: sensor.predictions,
                                yAxis: getYAxis(sensor.type),
                                type: 'line',
                                dashStyle: 'Dot',
                            };
                        }).filter(Boolean);
                    }
                    this.loadedGraph = true;
                    this.irrigationChart.xAxis.categories = xAxis;
                    this.irrigationChart.plotOptions = {
                        scatter: {
                            dataLabels: {
                                color: 'black',
                                verticalAlign: 'bottom',
                                y: +10,
                                align: 'left',
                                inside: true,
                                enabled: true,
                            },
                            enableMouseTracking: false,
                            marker: {
                                enabled: false,
                            },
                        },
                    };
                    let series;
                    if (this.viewMode === 3) {
                        series = [
                            {
                                name: this.translationsLib.get('asesor_saturation'),
                                marker: { enabled: false },
                                enableMouseTracking: false,
                                color: 'rgba(0,0,255,0.25)',
                                data: banda1,
                                yAxis: 0,
                            },
                            {
                                color: 'rgba(0,255,0,0.25)',
                                name: this.translationsLib.get('asesor_cc'),
                                marker: { enabled: false },
                                enableMouseTracking: false,
                                data: banda2,
                                yAxis: 0,
                            },
                            {
                                name: this.translationsLib.get('asesor_recharge_zone'),
                                marker: { enabled: false },
                                enableMouseTracking: false,
                                color: 'rgba(255,211,0,0.4)',
                                data: banda3,
                                yAxis: 0,
                            },
                            {
                                name: this.translationsLib.get('asesor_PMP'),
                                marker: { enabled: false },
                                enableMouseTracking: false,
                                color: 'rgba(255,0,0,0.25)',
                                data: banda4,
                                yAxis: 0,
                            },
                            /*{
                              showInLegend: false,
                              dataLabels: {
                                format: 'Punto de marchitaciÃ³n',
                                zIndex: 2,
                                color: 'rgb(255,0,0)',
                                style: {
                                  textOutline: 'none',
                                },
                              },
                              type: 'scatter',
                              data: [Date.UTC(2021, 0, 1), (banda1[0][1] + banda1[0][2]) / 2],
                            },
                            {
                              showInLegend: false,
                              dataLabels: {
                                format: 'Mucha agua',
                                align: 'left',
                                zIndex: 2,
                                color: 'rgb(0,150,255)',
                                style: {
                                  textOutline: 'none',
                                },
                              },
                              type: 'scatter',
                              data: [Date.UTC(2021, 0, 1), (banda4[0][1] + banda4[0][2]) / 2],
                            },
                            {
                              showInLegend: false,
                              dataLabels: {
                                format: 'AbsorciÃ³n ideal',
                                align: 'left',
                                zIndex: 2,
                                color: 'rgb(50,200,100)',
                                style: {
                                  textOutline: 'none',
                                },
                              },
                              type: 'scatter',
                              data: [Date.UTC(2021, 0, 1), (banda3[0][1] + banda3[0][2]) / 2],
                            },*/
                            {
                                color: '#006cfd',
                                name: this.translationsLib.get('asesor_irrigation_bands'),
                                marker: { enabled: false },
                                fillOpacity: 0.3,
                                data: datosRiego,
                                yAxis: 0,
                            },
                            ...tensionSeries,
                        ];
                    }
                    else {
                        series = [
                            {
                                color: '#006cfd',
                                name: this.translationsLib.get('asesor_irrigation_bands'),
                                marker: { enabled: false },
                                fillOpacity: 0.3,
                                data: datosRiego,
                                yAxis: 0,
                            },
                            ...predictedData,
                            ...tensionSeries,
                        ];
                    }
                    const that = this;
                    this.irrigationChart.tooltip.formatter = function () {
                        let tooltip = '<b>' +
                            Highcharts.dateFormat('%d/%m/%y %H:%M', Number(new Date(this.x))) +
                            '</b><br/>';
                        // Recorrer cada punto de datos en el tooltip
                        this.points.forEach((point) => {
                            const seriesType = point.series.options.type;
                            if (seriesType !== 'line') {
                                tooltip +=
                                    '<span style="color:' +
                                        point.color +
                                        '">\u25CF</span> ' +
                                        point.series.name +
                                        ': ' +
                                        point.point.low +
                                        ' - ' +
                                        point.point.high +
                                        ' ' +
                                        that.unit +
                                        '<br/>';
                            }
                            else {
                                tooltip +=
                                    '<span style="color:' +
                                        point.color +
                                        '">\u25CF</span> ' +
                                        point.series.name +
                                        ': ' +
                                        point.y +
                                        ' ' +
                                        that.unit +
                                        '<br/>';
                            }
                        });
                        return tooltip;
                    };
                    this.irrigationChart.xAxis.tickInterval = 6 * 3600 * 1000;
                    this.irrigationChart.yAxis[0].title.text =
                        this.translationsLib.get('asesor_tension');
                    this.irrigationChart.yAxis[1].title.text =
                        this.translationsLib.get('HR');
                    this.irrigationChart.series = series;
                    this.updateFlag = true;
                    if (this.maxValue !== 0) {
                        this.irrigationChart.yAxis.max = this.maxValue;
                    }
                    else {
                        if (this.unit === 'mb') {
                            this.maxValue = 10000;
                        }
                        else {
                            this.maxValue = 100;
                        }
                        this.irrigationChart.yAxis.max = this.maxValue;
                    }
                }, 2000);
            });
        });
    }
}
IrrigationConsultingMainChartComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: IrrigationConsultingMainChartComponent, deps: [{ token: TranslationsLibService }, { token: ModulesService }, { token: GraphicsService }, { token: IrrigationService }], target: i0.ɵɵFactoryTarget.Component });
IrrigationConsultingMainChartComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: IrrigationConsultingMainChartComponent, selector: "lib-irrigation-consulting-main-chart", inputs: { module: "module", vid: "vid", viewMode: "viewMode", dates: "dates" }, providers: [
        { provide: MAT_DATE_LOCALE, useValue: 'es-ES' },
        {
            provide: DateAdapter,
            useClass: MomentDateAdapter,
            deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
        },
        { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
    ], ngImport: i0, template: "<h5 class=\"alert alert-info mx-4\" *ngIf=\"this.noPrediction === true\">{{ predictionData.message | translation }}</h5>\n<div class=\"card mx-2 my-4\" *ngIf=\"viewMode ===1\">\n  <!--<div class=\"row mx-2\">\n    <div class=\"col-9\">\n      <mat-form-field  appearance=\"fill\" style=\"border:0px; padding: 0px;\">\n        <mat-date-range-input [formGroup]=\"range\" [rangePicker]=\"picker\">\n          <input matStartDate formControlName=\"start\" placeholder=\"{{ 'graphics_init_date' | translation }}\">\n          <input matEndDate formControlName=\"end\" placeholder=\"{{ 'graphics_end_date' | translation }}\">\n        </mat-date-range-input>\n        <mat-datepicker-toggle matIconSuffix [for]=\"picker\" ></mat-datepicker-toggle>\n        <mat-date-range-picker #picker></mat-date-range-picker>\n        <mat-error *ngIf=\"range.controls.start.hasError('matStartDateInvalid')\">{{ 'graphics_invalid_start_date' | translation }}</mat-error>\n        <mat-error *ngIf=\"range.controls.end.hasError('matEndDateInvalid')\">{{ 'graphics_invalid_end_date' | translation }}</mat-error>\n      </mat-form-field>\n    </div>\n    <div class=\"col-3 text-end\">\n      <div class=\"btn btn-primary\" (click)=\"createGraph()\">\n        {{ 'graphics_create_graph' | translation }}\n      </div>\n    </div>\n  </div>-->\n  <h4 class=\"mx-4 text-uppercase\" style=\"color: #ee7869\">{{ 'modules_irrigation_advisor' | translation }}</h4>\n  <lib-loader *ngIf=\"loadedGraph!== true\"></lib-loader>\n  <highcharts-chart [Highcharts]=\"Highcharts\"\n                    [constructorType]=\"chartConstructor\"\n                    [options]=\"irrigationChart\"\n                    [(update)]=\"updateFlag\"\n                    [callbackFunction]=\"chartCallback\"\n                    [oneToOne]=\"true\"\n                    style=\"height: 450px; display: block;\"\n                    class=\"mb-2\"\n  >\n  </highcharts-chart>\n</div>\n<div  *ngIf=\"viewMode !== 1\">\n  <mat-tab-group mat-align-tabs=\"start\" (selectedTabChange)=\"onTabChange($event)\">\n    <mat-tab [label]=\"'DL_24_hours' | translation\">\n      <ng-container *ngIf=\"selectedTabIndex === 0\">\n        <lib-loader *ngIf=\"loadedGraph !== true\"></lib-loader>\n        <h4 class=\"text-muted fw-normal fst-italic text-end mb-1 mx-1\">{{ 'graphics_interval_advice' | translation }} 5 {{ 'graphics_minutes' | translation }}</h4>\n        <highcharts-chart [Highcharts]=\"Highcharts\"\n                          [constructorType]=\"chartConstructor\"\n                          [options]=\"irrigationChart\"\n                          [(update)]=\"updateFlag\"\n                          [callbackFunction]=\"chartCallback\"\n                          [oneToOne]=\"true\"\n                          style=\"height: 450px; display: block;\"\n                          class=\"mb-2 mt-4\"\n        >\n        </highcharts-chart>\n      </ng-container>\n    </mat-tab>\n    <mat-tab [label]=\"'DL_2_days' | translation\">\n      <ng-container *ngIf=\"selectedTabIndex === 1\">\n        <lib-loader *ngIf=\"loadedGraph !== true\"></lib-loader>\n        <h4 class=\"text-muted fw-normal fst-italic text-end mb-1 mx-1\">{{ 'graphics_interval_advice' | translation }} 5 {{ 'graphics_minutes' | translation }}</h4>\n        <highcharts-chart [Highcharts]=\"Highcharts\"\n                          [constructorType]=\"chartConstructor\"\n                          [options]=\"irrigationChart\"\n                          [(update)]=\"updateFlag\"\n                          [callbackFunction]=\"chartCallback\"\n                          [oneToOne]=\"true\"\n                          style=\"height: 450px; display: block;\"\n                          class=\"mb-2 mt-4\"\n        >\n        </highcharts-chart>\n      </ng-container>\n    </mat-tab>\n    <mat-tab [label]=\"'DL_7_days' | translation\">\n      <ng-container *ngIf=\"selectedTabIndex === 2\">\n        <lib-loader *ngIf=\"loadedGraph !== true\"></lib-loader>\n        <h4 class=\"text-muted fw-normal fst-italic text-end mb-1 mx-1\">{{ 'graphics_interval_advice' | translation }} 15 {{ 'graphics_minutes' | translation }}</h4>\n        <highcharts-chart [Highcharts]=\"Highcharts\"\n                          [constructorType]=\"chartConstructor\"\n                          [options]=\"irrigationChart\"\n                          [(update)]=\"updateFlag\"\n                          [callbackFunction]=\"chartCallback\"\n                          [oneToOne]=\"true\"\n                          style=\"height: 450px; display: block;\"\n                          class=\"mb-2 mt-4\"\n        >\n        </highcharts-chart>\n      </ng-container>\n    </mat-tab>\n    <mat-tab [label]=\"'DL_last_month' | translation\">\n      <ng-container *ngIf=\"selectedTabIndex === 3\">\n        <lib-loader *ngIf=\"loadedGraph !== true\"></lib-loader>\n        <h4 class=\"text-muted fw-normal fst-italic text-end mb-1 mx-1\">{{ 'graphics_interval_advice' | translation }} 30 {{ 'graphics_minutes' | translation }}</h4>\n        <highcharts-chart [Highcharts]=\"Highcharts\"\n                          [constructorType]=\"chartConstructor\"\n                          [options]=\"irrigationChart\"\n                          [(update)]=\"updateFlag\"\n                          [callbackFunction]=\"chartCallback\"\n                          [oneToOne]=\"true\"\n                          style=\"height: 450px; display: block;\"\n                          class=\"mb-2 mt-4\"\n        >\n        </highcharts-chart>\n      </ng-container>\n    </mat-tab>\n    <mat-tab [label]=\"'irrigation_consulting_personalized_dates' | translation\">\n      <ng-container *ngIf=\"selectedTabIndex === 4\">\n        <div class=\"row\">\n          <div class=\"col-12 text-end\">\n            <mat-form-field class=\"selector\" appearance=\"fill\">\n              <mat-date-range-input [formGroup]=\"range\" [rangePicker]=\"picker\" [max]=\"maxDate\">\n                <input matStartDate formControlName=\"start\"\n                       placeholder=\"{{ translationsLib.get('start_date') }}\">\n                <input matEndDate formControlName=\"end\"\n                       placeholder=\"{{ translationsLib.get('end_date') }}\">\n              </mat-date-range-input>\n              <mat-datepicker-toggle matSuffix [for]=\"picker\"></mat-datepicker-toggle>\n              <mat-date-range-picker #picker></mat-date-range-picker>\n            </mat-form-field>\n            <button class=\"btn btn-primary mx-2\" (click)=\"createPersonalizedGraph()\">{{ 'graphics_create_graph' | translation }}</button>\n          </div>\n        </div>\n        <div class=\"row\" >\n          <lib-loader style=\"min-height: 100px\" *ngIf=\"loadedGraph !== true\"></lib-loader>\n          <highcharts-chart [hidden]=\"hideChart === true\"\n                            [Highcharts]=\"Highcharts\"\n                            [constructorType]=\"chartConstructor\"\n                            [options]=\"irrigationChart\"\n                            [(update)]=\"updateFlag\"\n                            [callbackFunction]=\"chartCallback\"\n                            [oneToOne]=\"true\"\n                            style=\"height: 450px; display: block;\"\n                            class=\"mb-2 mt-4\"\n          >\n          </highcharts-chart>\n        </div>\n      </ng-container>\n    </mat-tab>\n  </mat-tab-group>\n</div>\n", styles: [".card{padding:12px;border:2px solid #ee7869}mat-date-range-input{width:80%;height:50%;display:inline-block}::ng-deep .mat-form-field-appearance-fill .mat-form-field-flex{padding:0!important}.range-container{position:relative;height:60px}.selector{min-width:230px}::ng-deep .mat-date-range-input-container{min-width:200px}\n"], dependencies: [{ kind: "directive", type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i6$1.HighchartsChartComponent, selector: "highcharts-chart", inputs: ["Highcharts", "constructorType", "callbackFunction", "oneToOne", "runOutsideAngular", "options", "update"], outputs: ["updateChange", "chartInstance"] }, { kind: "component", type: LoaderComponent, selector: "lib-loader" }, { kind: "component", type: i8$1.MatFormField, selector: "mat-form-field", inputs: ["color", "appearance", "hideRequiredMarker", "hintLabel", "floatLabel"], exportAs: ["matFormField"] }, { kind: "directive", type: i8$1.MatSuffix, selector: "[matSuffix]" }, { kind: "component", type: i9$1.MatDatepickerToggle, selector: "mat-datepicker-toggle", inputs: ["for", "tabIndex", "aria-label", "disabled", "disableRipple"], exportAs: ["matDatepickerToggle"] }, { kind: "component", type: i9$1.MatDateRangeInput, selector: "mat-date-range-input", inputs: ["rangePicker", "required", "dateFilter", "min", "max", "disabled", "separator", "comparisonStart", "comparisonEnd"], exportAs: ["matDateRangeInput"] }, { kind: "directive", type: i9$1.MatStartDate, selector: "input[matStartDate]", inputs: ["errorStateMatcher"], outputs: ["dateChange", "dateInput"] }, { kind: "directive", type: i9$1.MatEndDate, selector: "input[matEndDate]", inputs: ["errorStateMatcher"], outputs: ["dateChange", "dateInput"] }, { kind: "component", type: i9$1.MatDateRangePicker, selector: "mat-date-range-picker", exportAs: ["matDateRangePicker"] }, { kind: "directive", type: i16.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i16.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i16.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i16.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i16.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "component", type: i11.MatTabGroup, selector: "mat-tab-group", inputs: ["color", "disableRipple"], exportAs: ["matTabGroup"] }, { kind: "component", type: i11.MatTab, selector: "mat-tab", inputs: ["disabled", "label", "aria-label", "aria-labelledby", "labelClass", "bodyClass"], exportAs: ["matTab"] }, { kind: "pipe", type: TranslationPipe, name: "translation" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: IrrigationConsultingMainChartComponent, decorators: [{
            type: Component,
            args: [{ selector: 'lib-irrigation-consulting-main-chart', providers: [
                        { provide: MAT_DATE_LOCALE, useValue: 'es-ES' },
                        {
                            provide: DateAdapter,
                            useClass: MomentDateAdapter,
                            deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
                        },
                        { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
                    ], template: "<h5 class=\"alert alert-info mx-4\" *ngIf=\"this.noPrediction === true\">{{ predictionData.message | translation }}</h5>\n<div class=\"card mx-2 my-4\" *ngIf=\"viewMode ===1\">\n  <!--<div class=\"row mx-2\">\n    <div class=\"col-9\">\n      <mat-form-field  appearance=\"fill\" style=\"border:0px; padding: 0px;\">\n        <mat-date-range-input [formGroup]=\"range\" [rangePicker]=\"picker\">\n          <input matStartDate formControlName=\"start\" placeholder=\"{{ 'graphics_init_date' | translation }}\">\n          <input matEndDate formControlName=\"end\" placeholder=\"{{ 'graphics_end_date' | translation }}\">\n        </mat-date-range-input>\n        <mat-datepicker-toggle matIconSuffix [for]=\"picker\" ></mat-datepicker-toggle>\n        <mat-date-range-picker #picker></mat-date-range-picker>\n        <mat-error *ngIf=\"range.controls.start.hasError('matStartDateInvalid')\">{{ 'graphics_invalid_start_date' | translation }}</mat-error>\n        <mat-error *ngIf=\"range.controls.end.hasError('matEndDateInvalid')\">{{ 'graphics_invalid_end_date' | translation }}</mat-error>\n      </mat-form-field>\n    </div>\n    <div class=\"col-3 text-end\">\n      <div class=\"btn btn-primary\" (click)=\"createGraph()\">\n        {{ 'graphics_create_graph' | translation }}\n      </div>\n    </div>\n  </div>-->\n  <h4 class=\"mx-4 text-uppercase\" style=\"color: #ee7869\">{{ 'modules_irrigation_advisor' | translation }}</h4>\n  <lib-loader *ngIf=\"loadedGraph!== true\"></lib-loader>\n  <highcharts-chart [Highcharts]=\"Highcharts\"\n                    [constructorType]=\"chartConstructor\"\n                    [options]=\"irrigationChart\"\n                    [(update)]=\"updateFlag\"\n                    [callbackFunction]=\"chartCallback\"\n                    [oneToOne]=\"true\"\n                    style=\"height: 450px; display: block;\"\n                    class=\"mb-2\"\n  >\n  </highcharts-chart>\n</div>\n<div  *ngIf=\"viewMode !== 1\">\n  <mat-tab-group mat-align-tabs=\"start\" (selectedTabChange)=\"onTabChange($event)\">\n    <mat-tab [label]=\"'DL_24_hours' | translation\">\n      <ng-container *ngIf=\"selectedTabIndex === 0\">\n        <lib-loader *ngIf=\"loadedGraph !== true\"></lib-loader>\n        <h4 class=\"text-muted fw-normal fst-italic text-end mb-1 mx-1\">{{ 'graphics_interval_advice' | translation }} 5 {{ 'graphics_minutes' | translation }}</h4>\n        <highcharts-chart [Highcharts]=\"Highcharts\"\n                          [constructorType]=\"chartConstructor\"\n                          [options]=\"irrigationChart\"\n                          [(update)]=\"updateFlag\"\n                          [callbackFunction]=\"chartCallback\"\n                          [oneToOne]=\"true\"\n                          style=\"height: 450px; display: block;\"\n                          class=\"mb-2 mt-4\"\n        >\n        </highcharts-chart>\n      </ng-container>\n    </mat-tab>\n    <mat-tab [label]=\"'DL_2_days' | translation\">\n      <ng-container *ngIf=\"selectedTabIndex === 1\">\n        <lib-loader *ngIf=\"loadedGraph !== true\"></lib-loader>\n        <h4 class=\"text-muted fw-normal fst-italic text-end mb-1 mx-1\">{{ 'graphics_interval_advice' | translation }} 5 {{ 'graphics_minutes' | translation }}</h4>\n        <highcharts-chart [Highcharts]=\"Highcharts\"\n                          [constructorType]=\"chartConstructor\"\n                          [options]=\"irrigationChart\"\n                          [(update)]=\"updateFlag\"\n                          [callbackFunction]=\"chartCallback\"\n                          [oneToOne]=\"true\"\n                          style=\"height: 450px; display: block;\"\n                          class=\"mb-2 mt-4\"\n        >\n        </highcharts-chart>\n      </ng-container>\n    </mat-tab>\n    <mat-tab [label]=\"'DL_7_days' | translation\">\n      <ng-container *ngIf=\"selectedTabIndex === 2\">\n        <lib-loader *ngIf=\"loadedGraph !== true\"></lib-loader>\n        <h4 class=\"text-muted fw-normal fst-italic text-end mb-1 mx-1\">{{ 'graphics_interval_advice' | translation }} 15 {{ 'graphics_minutes' | translation }}</h4>\n        <highcharts-chart [Highcharts]=\"Highcharts\"\n                          [constructorType]=\"chartConstructor\"\n                          [options]=\"irrigationChart\"\n                          [(update)]=\"updateFlag\"\n                          [callbackFunction]=\"chartCallback\"\n                          [oneToOne]=\"true\"\n                          style=\"height: 450px; display: block;\"\n                          class=\"mb-2 mt-4\"\n        >\n        </highcharts-chart>\n      </ng-container>\n    </mat-tab>\n    <mat-tab [label]=\"'DL_last_month' | translation\">\n      <ng-container *ngIf=\"selectedTabIndex === 3\">\n        <lib-loader *ngIf=\"loadedGraph !== true\"></lib-loader>\n        <h4 class=\"text-muted fw-normal fst-italic text-end mb-1 mx-1\">{{ 'graphics_interval_advice' | translation }} 30 {{ 'graphics_minutes' | translation }}</h4>\n        <highcharts-chart [Highcharts]=\"Highcharts\"\n                          [constructorType]=\"chartConstructor\"\n                          [options]=\"irrigationChart\"\n                          [(update)]=\"updateFlag\"\n                          [callbackFunction]=\"chartCallback\"\n                          [oneToOne]=\"true\"\n                          style=\"height: 450px; display: block;\"\n                          class=\"mb-2 mt-4\"\n        >\n        </highcharts-chart>\n      </ng-container>\n    </mat-tab>\n    <mat-tab [label]=\"'irrigation_consulting_personalized_dates' | translation\">\n      <ng-container *ngIf=\"selectedTabIndex === 4\">\n        <div class=\"row\">\n          <div class=\"col-12 text-end\">\n            <mat-form-field class=\"selector\" appearance=\"fill\">\n              <mat-date-range-input [formGroup]=\"range\" [rangePicker]=\"picker\" [max]=\"maxDate\">\n                <input matStartDate formControlName=\"start\"\n                       placeholder=\"{{ translationsLib.get('start_date') }}\">\n                <input matEndDate formControlName=\"end\"\n                       placeholder=\"{{ translationsLib.get('end_date') }}\">\n              </mat-date-range-input>\n              <mat-datepicker-toggle matSuffix [for]=\"picker\"></mat-datepicker-toggle>\n              <mat-date-range-picker #picker></mat-date-range-picker>\n            </mat-form-field>\n            <button class=\"btn btn-primary mx-2\" (click)=\"createPersonalizedGraph()\">{{ 'graphics_create_graph' | translation }}</button>\n          </div>\n        </div>\n        <div class=\"row\" >\n          <lib-loader style=\"min-height: 100px\" *ngIf=\"loadedGraph !== true\"></lib-loader>\n          <highcharts-chart [hidden]=\"hideChart === true\"\n                            [Highcharts]=\"Highcharts\"\n                            [constructorType]=\"chartConstructor\"\n                            [options]=\"irrigationChart\"\n                            [(update)]=\"updateFlag\"\n                            [callbackFunction]=\"chartCallback\"\n                            [oneToOne]=\"true\"\n                            style=\"height: 450px; display: block;\"\n                            class=\"mb-2 mt-4\"\n          >\n          </highcharts-chart>\n        </div>\n      </ng-container>\n    </mat-tab>\n  </mat-tab-group>\n</div>\n", styles: [".card{padding:12px;border:2px solid #ee7869}mat-date-range-input{width:80%;height:50%;display:inline-block}::ng-deep .mat-form-field-appearance-fill .mat-form-field-flex{padding:0!important}.range-container{position:relative;height:60px}.selector{min-width:230px}::ng-deep .mat-date-range-input-container{min-width:200px}\n"] }]
        }], ctorParameters: function () { return [{ type: TranslationsLibService }, { type: ModulesService }, { type: GraphicsService }, { type: IrrigationService }]; }, propDecorators: { module: [{
                type: Input
            }], vid: [{
                type: Input
            }], viewMode: [{
                type: Input
            }], dates: [{
                type: Input
            }] } });

class IrrigationConsultingModule {
}
IrrigationConsultingModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: IrrigationConsultingModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
IrrigationConsultingModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: IrrigationConsultingModule, declarations: [IrrigationConsultingMainChartComponent], imports: [CommonModule,
        HighchartsChartModule,
        CommonModule,
        AppCommonsModule,
        IonicModule,
        MatFormFieldModule,
        MatDatepickerModule,
        ReactiveFormsModule,
        FormsModule,
        TimepickerModule,
        MatInputModule,
        MatButtonModule,
        App360SharedModule,
        MatTabsModule], exports: [IrrigationConsultingMainChartComponent] });
IrrigationConsultingModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: IrrigationConsultingModule, imports: [CommonModule,
        HighchartsChartModule,
        CommonModule,
        AppCommonsModule,
        IonicModule,
        MatFormFieldModule,
        MatDatepickerModule,
        ReactiveFormsModule,
        FormsModule,
        TimepickerModule,
        MatInputModule,
        MatButtonModule,
        App360SharedModule,
        MatTabsModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: IrrigationConsultingModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [IrrigationConsultingMainChartComponent],
                    imports: [
                        CommonModule,
                        HighchartsChartModule,
                        CommonModule,
                        AppCommonsModule,
                        IonicModule,
                        MatFormFieldModule,
                        MatDatepickerModule,
                        ReactiveFormsModule,
                        FormsModule,
                        TimepickerModule,
                        MatInputModule,
                        MatButtonModule,
                        App360SharedModule,
                        MatTabsModule,
                    ],
                    schemas: [CUSTOM_ELEMENTS_SCHEMA],
                    exports: [IrrigationConsultingMainChartComponent],
                    providers: [],
                }]
        }] });

const LineChartsModel = {
    chart: {
        marginTop: 50,
        type: 'line',
        zoomType: 'x',
        zooming: {
            mouseWheel: {
                enabled: false,
            },
        },
        panning: true,
        panKey: 'shift',
        events: {
            selection: function (event) {
                var chart = this;
                if (event.xAxis) {
                    // Se ha realizado un zoom en el eje X
                    if (!chart.resetZoomButton) {
                        // @ts-ignore perdón si no no va :(
                        const translationsLib = new TranslationsLibService();
                        chart.resetZoomButton = chart.renderer
                            .button(translationsLib.get('reset_zoom'), null, null, 
                        // eslint-disable-next-line prefer-arrow/prefer-arrow-functions
                        function () {
                            chart.update({
                                marginTop: 50,
                            });
                            chart.xAxis[0].setExtremes(null, null);
                            chart.resetZoomButton.destroy();
                            chart.resetZoomButton = null;
                        })
                            .attr({
                            align: 'left',
                            x: 70,
                            y: 7,
                            zIndex: 7,
                            verticalAlign: 'top',
                            floating: true,
                        })
                            .add();
                    }
                }
                else {
                    // No se ha realizado un zoom en el eje X
                    if (chart.resetZoomButton) {
                        chart.resetZoomButton.destroy();
                        chart.resetZoomButton = null;
                    }
                }
            },
        },
    },
    /*rangeSelector: {
      enabled: true,
      selected: 1,
      inputEnabled: false,
      buttonTheme: {
        width: 125,
        height: 30,
        style: {
          fontSize: '14px',
        },
      },
      buttonPosition: {
        align: 'right',
        x: 0,
        y: 0,
      },
      buttons: [
        {
          type: 'all',
          text: 'Reset Zoom',
          theme: {
            fill: 'white',
            'stroke-width': 1,
            stroke: 'silver',
            r: 0,
          },
        },
      ],
      labelStyle: {
        display: 'none', // Ocultar el texto "Zoom"
      },
    },*/
    navigator: {
        enabled: true,
        xAxis: {
            type: 'category',
            tickPositioner: function () {
                var positions = [], tick = 0, increment = 100; // Adjust the increment as needed
                for (tick; tick <= this.categories.length; tick += increment) {
                    positions.push(tick);
                }
                return positions;
            }
            /*type: 'datetime',
            labels: {
              enabled: false
            }*/
        },
    },
    title: {
        align: 'left',
        text: null,
    },
    subtitle: {
        align: 'left',
        text: '',
    },
    accessibility: {
        announceNewData: {
            enabled: true,
        },
    },
    xAxis: {
        categories: [],
    },
    yAxis: [
        {
            title: {
                text: null,
            },
        },
    ],
    plotOptions: {},
    legend: {
        title: {
            text: null,
        },
        /*layout: 'vertical',
        align: 'right',
        verticalAlign: 'top',
        x: -40,
        y: 0,
        floating: true,
        borderWidth: 1,
        backgroundColor:
          Highcharts.defaultOptions.legend.backgroundColor || '#FFFFFF',
        shadow: true,*/
    },
    credits: {
        enabled: false,
    },
    tooltip: {
        headerFormat: '<span style="font-size:11px">{point.x}</span><br>',
        /*pointFormat: '<b>{point.y:.2f}</b><br/>',*/
        shared: true,
        /* formatter() {
          return Highcharts.numberFormat(this.y, 2);
        },*/
        valueDecimals: 2,
    },
    dataLabels: {
        enabled: true,
        formatter() {
            return Highcharts.numberFormat(this.y, 2);
        },
    },
    series: [
        {
            name: '',
            unit: '',
            colorByPoint: false,
            data: [],
            id: '',
        },
    ],
    exporting: {
        filename: 'ucrop chart',
        buttons: {
            contextButton: {
                menuItems: [
                    'printChart',
                    'separator',
                    'downloadPNG',
                    'downloadJPEG',
                    'downloadPDF',
                    'separator',
                    'downloadCSV',
                    'downloadXLS',
                    //"viewData",
                    'openInCloud',
                ],
            },
        },
        exportData: {
            formatter: function () {
                const series = this.series;
                return series[0].data.map((point, i) => {
                    const timestampUTC = point.x;
                    const utcDate = new Date(timestampUTC);
                    const formattedUTC = utcDate.toISOString().replace('T', ' ').substring(0, 16);
                    const row = {
                        'Hora (UTC)': formattedUTC,
                    };
                    series.forEach(s => {
                        row[s.name] = s.data[i] ? s.data[i].y : null;
                    });
                    return row;
                });
            },
        },
        csv: {
            columnHeaderFormatter: function (item, key) {
                if (key === 'x')
                    return 'Hora (UTC)';
                return item.name;
            },
        },
    },
};

class FieldsRestApiService {
    constructor(httpRepositoryService) {
        this.httpRepositoryService = httpRepositoryService;
    }
    getField(data) {
        return this.httpRepositoryService.getRequest('fields/' + data);
    }
    getFields() {
        return this.httpRepositoryService.getRequest('fields');
    }
    postField(data) {
        return this.httpRepositoryService.postRequest('fields', data);
    }
    putFields(data, vid) {
        return this.httpRepositoryService.putRequest('fields/' + vid, data);
    }
    deleteField(vid) {
        return this.httpRepositoryService.deleteRequest('fields/' + vid);
    }
    backofficeGetField(vid) {
        return this.httpRepositoryService.getRequest('backoffice-users/fields/' + vid);
    }
    backofficePutField(vid, data) {
        return this.httpRepositoryService.putRequest('backoffice-users/fields/' + vid, data);
    }
    backofficeDeleteField(vid) {
        return this.httpRepositoryService.deleteRequest('backoffice-users/fields/' + vid);
    }
}
FieldsRestApiService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: FieldsRestApiService, deps: [{ token: HttpRepositoryService }], target: i0.ɵɵFactoryTarget.Injectable });
FieldsRestApiService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: FieldsRestApiService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: FieldsRestApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: HttpRepositoryService }]; } });

class FieldsService {
    constructor(restApiService) {
        this.restApiService = restApiService;
    }
    getField(data) {
        return this.restApiService.getField(data);
    }
    getFields() {
        return this.restApiService.getFields();
    }
    postField(data) {
        return this.restApiService.postField(data);
    }
    putFields(data, vid) {
        return this.restApiService.putFields(data, vid);
    }
    deleteField(vid) {
        return this.restApiService.deleteField(vid);
    }
    backofficeGetField(vid) {
        return this.restApiService.backofficeGetField(vid);
    }
    backofficePutField(vid, data) {
        return this.restApiService.backofficePutField(vid, data);
    }
    backofficeDeleteField(vid) {
        return this.restApiService.backofficeDeleteField(vid);
    }
}
FieldsService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: FieldsService, deps: [{ token: FieldsRestApiService }], target: i0.ɵɵFactoryTarget.Injectable });
FieldsService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: FieldsService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: FieldsService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: FieldsRestApiService }]; } });

class MulticropChildrenComponent {
    constructor(translationsLib) {
        this.translationsLib = translationsLib;
        this.cropTypologies = ['integrated', 'ecological', 'traditional'];
        this.farmTypes = [
            'open_field',
            'open_field_trellis',
            'greenhouse_venlo',
            'greenhouse_tunnel',
            'greenhouse_chapel',
            'greenhouse_multichapel_multitunnel',
            'greenhouse_asymmetric',
            'greenhouse_gothic',
            'greenhouse_parral_flat',
            'greenhouse_parral_scratches_fakes',
        ];
        this.irrigationMethods = ['drip', 'underground_drip', 'aspersion', 'microspray'];
        this.irrigationSources = [
            'water_well',
            'surface_water',
            'irrigation_consortium_community',
        ];
        this.save = new EventEmitter();
        this.fb = new FormBuilder();
        this.fieldForm = this.fb.group({
            crop_id: [
                0,
                [Validators.required, Validators.pattern('^[0-9]*$'), Validators.min(1)],
            ],
            crop_typology: [null, []],
            farm_type: [null, []],
            irrigation_method: [null, []],
            irrigation_source: [null, []],
            distance_between_rows: [null, [Validators.pattern('^[0-9]*$')]],
            distance_between_plants_in_row: [
                null,
                [Validators.pattern('^[0-9]*$')],
            ],
            drippers_per_plant: [null, [Validators.pattern('^[0-9]*$')]],
            emitter_type: [
                null,
                [Validators.pattern(/^\d+([.,]\d+)?$/)],
            ],
        });
    }
    ngOnInit() {
        if (this.edit) {
            const { crop_id, crop_typology, farm_type, irrigation_method, irrigation_source, distance_between_rows, distance_between_plants_in_row, drippers_per_plant, emitter_type, } = this.edit;
            this.fieldForm.setValue({
                crop_id,
                crop_typology,
                farm_type,
                irrigation_method,
                irrigation_source,
                distance_between_rows,
                distance_between_plants_in_row,
                drippers_per_plant,
                emitter_type: emitter_type?.toString().replace('.', ','),
            });
        }
    }
    onSubmit() {
        event.preventDefault();
        if (this.fieldForm.valid) {
            const rawValue = this.fieldForm.value;
            // Normaliza el valor del campo emitter_type
            const emitterTypeRaw = rawValue.emitter_type;
            const emitterType = typeof emitterTypeRaw === 'string'
                ? parseFloat(emitterTypeRaw.replace(',', '.'))
                : emitterTypeRaw;
            const multicropToEmit = {
                ...rawValue,
                emitter_type: emitterType,
                vid: this.edit?.vid || null,
            };
            this.save.emit(multicropToEmit);
        }
    }
}
MulticropChildrenComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: MulticropChildrenComponent, deps: [{ token: TranslationsLibService }], target: i0.ɵɵFactoryTarget.Component });
MulticropChildrenComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: MulticropChildrenComponent, selector: "lib-multicrop-children", inputs: { edit: "edit", crops: "crops" }, outputs: { save: "save" }, ngImport: i0, template: "<form [formGroup]=\"fieldForm\" (submit)=\"onSubmit()\">\n  <div class=\"row\">\n    <mat-form-field id=\"cropSelected\" class=\"col-12\" appearance=\"outline\">\n      <mat-label>{{ \"field_crop\" | translation }}</mat-label>\n      <mat-select formControlName=\"crop_id\">\n        <mat-option *ngFor=\"let crop of crops\" [value]=\"crop.id\">\n          {{ crop.name }}\n        </mat-option>\n      </mat-select>\n    </mat-form-field>\n  </div>\n\n  <div class=\"row\">\n    <mat-form-field class=\"col-12\" appearance=\"outline\">\n      <mat-label>{{ \"field_crop_typologies\" | translation }}</mat-label>\n      <mat-select formControlName=\"crop_typology\">\n        <mat-option *ngFor=\"let typology of cropTypologies\" [value]=\"typology\">\n          {{ \"field_\" + typology | translation }}\n        </mat-option>\n      </mat-select>\n    </mat-form-field>\n  </div>\n\n  <div class=\"row\">\n    <mat-form-field class=\"col-12\" appearance=\"outline\">\n      <mat-label>{{ \"field_farm\" | translation }}</mat-label>\n      <mat-select formControlName=\"farm_type\">\n        <mat-option *ngFor=\"let farm of farmTypes\" [value]=\"farm\">\n          {{ \"field_\" + farm | translation }}\n        </mat-option>\n      </mat-select>\n    </mat-form-field>\n  </div>\n\n  <div class=\"row\">\n    <mat-form-field class=\"col-12\" appearance=\"outline\">\n      <mat-label>{{ \"field_irrigation_method\" | translation }}</mat-label>\n      <mat-select formControlName=\"irrigation_method\">\n        <mat-option *ngFor=\"let method of irrigationMethods\" [value]=\"method\">\n          {{ \"field_\" + method | translation }}\n        </mat-option>\n      </mat-select>\n    </mat-form-field>\n  </div>\n\n  <div class=\"row\">\n    <mat-form-field class=\"col-12\" appearance=\"outline\">\n      <mat-label>{{ \"field_irrigation_source\" | translation }}</mat-label>\n      <mat-select formControlName=\"irrigation_source\">\n        <mat-option *ngFor=\"let source of irrigationSources\" [value]=\"source\">\n          {{ \"field_\" + source | translation }}\n        </mat-option>\n      </mat-select>\n    </mat-form-field>\n  </div>\n\n  <div class=\"row\">\n    <mat-form-field class=\"col-6\" appearance=\"outline\">\n      <mat-label>{{ \"field_distance_between_rows\" | translation }}</mat-label>\n      <input\n        matInput\n        type=\"number\"\n        formControlName=\"distance_between_rows\"\n        placeholder=\"0\"\n      />\n    </mat-form-field>\n    <mat-form-field class=\"col-6\" appearance=\"outline\">\n      <mat-label>{{\n        \"field_distance_between_plants_in_row\" | translation\n      }}</mat-label>\n      <input\n        matInput\n        type=\"number\"\n        formControlName=\"distance_between_plants_in_row\"\n        placeholder=\"0\"\n      />\n    </mat-form-field>\n  </div>\n\n  <div class=\"row\">\n    <mat-form-field class=\"col-6\" appearance=\"outline\">\n      <mat-label>{{ \"field_drippers_per_plant\" | translation }}</mat-label>\n      <input\n        matInput\n        type=\"number\"\n        formControlName=\"drippers_per_plant\"\n        placeholder=\"0\"\n      />\n    </mat-form-field>\n    <mat-form-field class=\"col-6\" appearance=\"outline\">\n      <mat-label>{{ \"field_emitter_type\" | translation }}</mat-label>\n      <input\n        matInput\n        type=\"text\"\n        formControlName=\"emitter_type\"\n        placeholder=\"0\"\n      />\n    </mat-form-field>\n  </div>\n\n  <div class=\"row\">\n    <div class=\"col-12 text-end\">\n      <button type=\"submit\" class=\"btn btn-primary\" id=\"saveCrop\">\n        {{ \"save\" | translation }}\n      </button>\n    </div>\n  </div>\n</form>\n", styles: ["::ng-deep .mat-tab-group.mat-primary .mat-ink-bar,.mat-tab-nav-bar.mat-primary .mat-ink-bar{background-color:#224261}.select{cursor:pointer;appearance:auto}::ng-deep .mat-form-field-appearance-outline .mat-form-field-outline{background-color:var(--input-color)}\n"], dependencies: [{ kind: "directive", type: i5.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i16.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i16.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i16.NumberValueAccessor, selector: "input[type=number][formControlName],input[type=number][formControl],input[type=number][ngModel]" }, { kind: "directive", type: i16.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i16.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i16.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i16.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "component", type: i8$1.MatFormField, selector: "mat-form-field", inputs: ["color", "appearance", "hideRequiredMarker", "hintLabel", "floatLabel"], exportAs: ["matFormField"] }, { kind: "directive", type: i8$1.MatLabel, selector: "mat-label" }, { kind: "component", type: i10.MatOption, selector: "mat-option", exportAs: ["matOption"] }, { kind: "directive", type: i7$1.MatInput, selector: "input[matInput], textarea[matInput], select[matNativeControl],      input[matNativeControl], textarea[matNativeControl]", inputs: ["disabled", "id", "placeholder", "name", "required", "type", "errorStateMatcher", "aria-describedby", "value", "readonly"], exportAs: ["matInput"] }, { kind: "component", type: i7$2.MatSelect, selector: "mat-select", inputs: ["disabled", "disableRipple", "tabIndex"], exportAs: ["matSelect"] }, { kind: "pipe", type: TranslationPipe, name: "translation" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: MulticropChildrenComponent, decorators: [{
            type: Component,
            args: [{ selector: 'lib-multicrop-children', template: "<form [formGroup]=\"fieldForm\" (submit)=\"onSubmit()\">\n  <div class=\"row\">\n    <mat-form-field id=\"cropSelected\" class=\"col-12\" appearance=\"outline\">\n      <mat-label>{{ \"field_crop\" | translation }}</mat-label>\n      <mat-select formControlName=\"crop_id\">\n        <mat-option *ngFor=\"let crop of crops\" [value]=\"crop.id\">\n          {{ crop.name }}\n        </mat-option>\n      </mat-select>\n    </mat-form-field>\n  </div>\n\n  <div class=\"row\">\n    <mat-form-field class=\"col-12\" appearance=\"outline\">\n      <mat-label>{{ \"field_crop_typologies\" | translation }}</mat-label>\n      <mat-select formControlName=\"crop_typology\">\n        <mat-option *ngFor=\"let typology of cropTypologies\" [value]=\"typology\">\n          {{ \"field_\" + typology | translation }}\n        </mat-option>\n      </mat-select>\n    </mat-form-field>\n  </div>\n\n  <div class=\"row\">\n    <mat-form-field class=\"col-12\" appearance=\"outline\">\n      <mat-label>{{ \"field_farm\" | translation }}</mat-label>\n      <mat-select formControlName=\"farm_type\">\n        <mat-option *ngFor=\"let farm of farmTypes\" [value]=\"farm\">\n          {{ \"field_\" + farm | translation }}\n        </mat-option>\n      </mat-select>\n    </mat-form-field>\n  </div>\n\n  <div class=\"row\">\n    <mat-form-field class=\"col-12\" appearance=\"outline\">\n      <mat-label>{{ \"field_irrigation_method\" | translation }}</mat-label>\n      <mat-select formControlName=\"irrigation_method\">\n        <mat-option *ngFor=\"let method of irrigationMethods\" [value]=\"method\">\n          {{ \"field_\" + method | translation }}\n        </mat-option>\n      </mat-select>\n    </mat-form-field>\n  </div>\n\n  <div class=\"row\">\n    <mat-form-field class=\"col-12\" appearance=\"outline\">\n      <mat-label>{{ \"field_irrigation_source\" | translation }}</mat-label>\n      <mat-select formControlName=\"irrigation_source\">\n        <mat-option *ngFor=\"let source of irrigationSources\" [value]=\"source\">\n          {{ \"field_\" + source | translation }}\n        </mat-option>\n      </mat-select>\n    </mat-form-field>\n  </div>\n\n  <div class=\"row\">\n    <mat-form-field class=\"col-6\" appearance=\"outline\">\n      <mat-label>{{ \"field_distance_between_rows\" | translation }}</mat-label>\n      <input\n        matInput\n        type=\"number\"\n        formControlName=\"distance_between_rows\"\n        placeholder=\"0\"\n      />\n    </mat-form-field>\n    <mat-form-field class=\"col-6\" appearance=\"outline\">\n      <mat-label>{{\n        \"field_distance_between_plants_in_row\" | translation\n      }}</mat-label>\n      <input\n        matInput\n        type=\"number\"\n        formControlName=\"distance_between_plants_in_row\"\n        placeholder=\"0\"\n      />\n    </mat-form-field>\n  </div>\n\n  <div class=\"row\">\n    <mat-form-field class=\"col-6\" appearance=\"outline\">\n      <mat-label>{{ \"field_drippers_per_plant\" | translation }}</mat-label>\n      <input\n        matInput\n        type=\"number\"\n        formControlName=\"drippers_per_plant\"\n        placeholder=\"0\"\n      />\n    </mat-form-field>\n    <mat-form-field class=\"col-6\" appearance=\"outline\">\n      <mat-label>{{ \"field_emitter_type\" | translation }}</mat-label>\n      <input\n        matInput\n        type=\"text\"\n        formControlName=\"emitter_type\"\n        placeholder=\"0\"\n      />\n    </mat-form-field>\n  </div>\n\n  <div class=\"row\">\n    <div class=\"col-12 text-end\">\n      <button type=\"submit\" class=\"btn btn-primary\" id=\"saveCrop\">\n        {{ \"save\" | translation }}\n      </button>\n    </div>\n  </div>\n</form>\n", styles: ["::ng-deep .mat-tab-group.mat-primary .mat-ink-bar,.mat-tab-nav-bar.mat-primary .mat-ink-bar{background-color:#224261}.select{cursor:pointer;appearance:auto}::ng-deep .mat-form-field-appearance-outline .mat-form-field-outline{background-color:var(--input-color)}\n"] }]
        }], ctorParameters: function () { return [{ type: TranslationsLibService }]; }, propDecorators: { edit: [{
                type: Input
            }], crops: [{
                type: Input
            }], save: [{
                type: Output
            }] } });

class MulticropComponent {
    constructor(translationsLib, commonService) {
        this.translationsLib = translationsLib;
        this.commonService = commonService;
        this.multicrops = [];
        this.updateMulticrops = new EventEmitter();
    }
    ngOnInit() {
        this.getCropsList();
    }
    getCropsList() {
        this.commonService.getCrops().subscribe((response) => {
            this.crops = response;
        });
    }
    getCropNameById(id) {
        if (this.crops) {
            return this.crops.find((crop) => crop.id === id)?.name;
        }
    }
    newMulticrop() {
        this.selectedMulticropIndex = null;
        this.selectedMulticrop = null;
        this.modal.present();
    }
    editMulticrop(multicrop) {
        this.selectedMulticropIndex = multicrop;
        this.selectedMulticrop = this.multicrops[multicrop];
        this.modal.present();
    }
    removeMulticrop(multicrop) {
        this.multicrops.splice(multicrop, 1);
        this.updateMulticrops.emit(this.multicrops);
    }
    multicropEvent(multicrop) {
        if (this.selectedMulticrop === null)
            this.multicrops.push(multicrop);
        else
            this.multicrops[this.selectedMulticropIndex] = multicrop;
        this.selectedMulticropIndex = null;
        this.selectedMulticrop = null;
        this.modal.dismiss();
        this.updateMulticrops.emit(this.multicrops);
    }
}
MulticropComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: MulticropComponent, deps: [{ token: TranslationsLibService }, { token: AppCommonsService }], target: i0.ɵɵFactoryTarget.Component });
MulticropComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: MulticropComponent, selector: "lib-multicrop", inputs: { multicrops: "multicrops" }, outputs: { updateMulticrops: "updateMulticrops" }, viewQueries: [{ propertyName: "modal", first: true, predicate: IonModal, descendants: true }], ngImport: i0, template: "<div class=\"form-group\">\n  <label class=\"form-label\">{{ \"field_crops\" | translation }}</label>\n  <ul class=\"list-group\">\n    <li\n      *ngIf=\"multicrops.length === 0\"\n      class=\"list-group-item py-2 text-center\"\n    >\n      {{ \"field_add_at_least_one_crop\" | translation }}\n    </li>\n    <li\n      *ngFor=\"let multicrop of multicrops; index as m\"\n      class=\"list-group-item py-2\"\n    >\n      {{ crops && getCropNameById(multicrop.crop_id) }}\n      <span class=\"float-end\">\n        <button class=\"mx-2 text-primary bg-white\" (click)=\"editMulticrop(m)\">\n          <ion-icon name=\"create-outline\"></ion-icon>\n        </button>\n        <button class=\"mx-2 text-danger bg-white\" (click)=\"removeMulticrop(m)\">\n          <ion-icon name=\"trash-outline\"></ion-icon>\n        </button>\n      </span>\n    </li>\n  </ul>\n</div>\n\n<div class=\"form-group text-end\">\n  <button class=\"btn btn-sm btn-terciary\" id=\"crop\" (click)=\"newMulticrop()\">\n    {{ \"field_new_crop\" | translation }}\n  </button>\n</div>\n\n<ion-modal [breakpoints]=\"[1]\" #modal id=\"modal\" class=\"auto-height\">\n  <ng-template>\n    <div class=\"inner-content pb-0\">\n      <ion-toolbar>\n        <ion-title *ngIf=\"selectedMulticrop\">{{\n          \"field_edit_crop\" | translation\n        }}</ion-title>\n        <ion-title *ngIf=\"!selectedMulticrop\">{{\n          \"field_new_crop\" | translation\n        }}</ion-title>\n        <ion-buttons slot=\"end\">\n          <ion-button color=\"light\" (click)=\"modal.dismiss()\">\n            <ion-icon name=\"close-outline\"></ion-icon>\n          </ion-button>\n        </ion-buttons>\n      </ion-toolbar>\n      <div class=\"container p-4\">\n        <lib-multicrop-children\n          [crops]=\"crops\"\n          [edit]=\"selectedMulticrop\"\n          (save)=\"multicropEvent($event)\"\n        ></lib-multicrop-children>\n      </div>\n    </div>\n  </ng-template>\n</ion-modal>\n", styles: ["ion-modal{--border-radius: 16px;--box-shadow: 0 10px 15px -3px rgb(0 0 0 / .1), 0 4px 6px -4px rgb(0 0 0 / .1)}ion-modal ion-toolbar{--background: var(--primary-color);--color: white}ion-modal .container{background:white}.btn-terciary{background-color:#66b8be;color:#fff}.btn-terciary:hover{background-color:#2f676b;color:#fff}\n"], dependencies: [{ kind: "directive", type: i5.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i6.IonButton, selector: "ion-button", inputs: ["buttonType", "color", "disabled", "download", "expand", "fill", "form", "href", "mode", "rel", "routerAnimation", "routerDirection", "shape", "size", "strong", "target", "type"] }, { kind: "component", type: i6.IonButtons, selector: "ion-buttons", inputs: ["collapse"] }, { kind: "component", type: i6.IonIcon, selector: "ion-icon", inputs: ["color", "flipRtl", "icon", "ios", "lazy", "md", "mode", "name", "sanitize", "size", "src"] }, { kind: "component", type: i6.IonTitle, selector: "ion-title", inputs: ["color", "size"] }, { kind: "component", type: i6.IonToolbar, selector: "ion-toolbar", inputs: ["color", "mode"] }, { kind: "component", type: i6.IonModal, selector: "ion-modal", inputs: ["animated", "keepContentsMounted", "backdropBreakpoint", "backdropDismiss", "breakpoints", "canDismiss", "cssClass", "enterAnimation", "event", "handle", "handleBehavior", "initialBreakpoint", "isOpen", "keyboardClose", "leaveAnimation", "mode", "presentingElement", "showBackdrop", "swipeToClose", "translucent", "trigger"] }, { kind: "component", type: MulticropChildrenComponent, selector: "lib-multicrop-children", inputs: ["edit", "crops"], outputs: ["save"] }, { kind: "pipe", type: TranslationPipe, name: "translation" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: MulticropComponent, decorators: [{
            type: Component,
            args: [{ selector: 'lib-multicrop', template: "<div class=\"form-group\">\n  <label class=\"form-label\">{{ \"field_crops\" | translation }}</label>\n  <ul class=\"list-group\">\n    <li\n      *ngIf=\"multicrops.length === 0\"\n      class=\"list-group-item py-2 text-center\"\n    >\n      {{ \"field_add_at_least_one_crop\" | translation }}\n    </li>\n    <li\n      *ngFor=\"let multicrop of multicrops; index as m\"\n      class=\"list-group-item py-2\"\n    >\n      {{ crops && getCropNameById(multicrop.crop_id) }}\n      <span class=\"float-end\">\n        <button class=\"mx-2 text-primary bg-white\" (click)=\"editMulticrop(m)\">\n          <ion-icon name=\"create-outline\"></ion-icon>\n        </button>\n        <button class=\"mx-2 text-danger bg-white\" (click)=\"removeMulticrop(m)\">\n          <ion-icon name=\"trash-outline\"></ion-icon>\n        </button>\n      </span>\n    </li>\n  </ul>\n</div>\n\n<div class=\"form-group text-end\">\n  <button class=\"btn btn-sm btn-terciary\" id=\"crop\" (click)=\"newMulticrop()\">\n    {{ \"field_new_crop\" | translation }}\n  </button>\n</div>\n\n<ion-modal [breakpoints]=\"[1]\" #modal id=\"modal\" class=\"auto-height\">\n  <ng-template>\n    <div class=\"inner-content pb-0\">\n      <ion-toolbar>\n        <ion-title *ngIf=\"selectedMulticrop\">{{\n          \"field_edit_crop\" | translation\n        }}</ion-title>\n        <ion-title *ngIf=\"!selectedMulticrop\">{{\n          \"field_new_crop\" | translation\n        }}</ion-title>\n        <ion-buttons slot=\"end\">\n          <ion-button color=\"light\" (click)=\"modal.dismiss()\">\n            <ion-icon name=\"close-outline\"></ion-icon>\n          </ion-button>\n        </ion-buttons>\n      </ion-toolbar>\n      <div class=\"container p-4\">\n        <lib-multicrop-children\n          [crops]=\"crops\"\n          [edit]=\"selectedMulticrop\"\n          (save)=\"multicropEvent($event)\"\n        ></lib-multicrop-children>\n      </div>\n    </div>\n  </ng-template>\n</ion-modal>\n", styles: ["ion-modal{--border-radius: 16px;--box-shadow: 0 10px 15px -3px rgb(0 0 0 / .1), 0 4px 6px -4px rgb(0 0 0 / .1)}ion-modal ion-toolbar{--background: var(--primary-color);--color: white}ion-modal .container{background:white}.btn-terciary{background-color:#66b8be;color:#fff}.btn-terciary:hover{background-color:#2f676b;color:#fff}\n"] }]
        }], ctorParameters: function () { return [{ type: TranslationsLibService }, { type: AppCommonsService }]; }, propDecorators: { modal: [{
                type: ViewChild,
                args: [IonModal]
            }], multicrops: [{
                type: Input
            }], updateMulticrops: [{
                type: Output
            }] } });

class FieldsEditComponent {
    constructor(route, fieldsService, router, commonsService, terminalService, helpersLib, translationsLib, terminalsLib, mapsLib, analyiticsLib, environmentService) {
        this.route = route;
        this.fieldsService = fieldsService;
        this.router = router;
        this.commonsService = commonsService;
        this.terminalService = terminalService;
        this.helpersLib = helpersLib;
        this.translationsLib = translationsLib;
        this.terminalsLib = terminalsLib;
        this.mapsLib = mapsLib;
        this.analyiticsLib = analyiticsLib;
        this.environmentService = environmentService;
        this.platform = '';
        this.field = null;
        this.terminals = null;
        this.breadcrumbsChange = new EventEmitter();
        this.fieldLoaded = new EventEmitter();
        this.vid = '';
        this.addDevice = false;
        this.terminalFound = false;
        this.loading = true;
        this.multicrops = [];
        this.fb = new FormBuilder();
        this.breadcrumbs = [];
        this.editField = this.fb.group({
            name: ['', Validators.required],
            multicrops: [],
            color: [''],
            coordinates: []
        });
        this.results = this.fb.group({
            nombre_equipo: [''],
            terminal: ['']
        });
        this.chargeMap = false;
        route.params.subscribe((val) => {
            const divMap = document.getElementById('map');
            if (divMap !== null) {
                location.reload();
            }
        });
    }
    ngOnInit() {
        this.vid = this.route.snapshot.paramMap.get('vid');
        this.getField();
        if (this.platform !== 'backoffice') {
            this.getTerminals();
        }
        setTimeout(() => {
            this.analyiticsLib.sendEventFieldEdit(this.fieldName, this.vid);
        }, 200);
    }
    getField() {
        const fieldRequest$ = this.platform === 'backoffice'
            ? this.fieldsService.backofficeGetField(this.vid)
            : this.fieldsService.getField(this.vid);
        const fallbackRoute = this.platform === 'backoffice' ? '/bo-fields' : '/home/dashboard';
        fieldRequest$.subscribe({
            next: (field) => {
                this.getFieldData(field);
                this.fieldLoaded.emit(this.field);
            },
            error: () => {
                this.router.navigate([fallbackRoute]);
            }
        });
    }
    getTerminals() {
        if (this.platform === 'backoffice') {
            return;
        }
        this.terminalService.getTerminals().subscribe((response) => {
            this.terminals = [];
            let fields = [];
            fields = response;
            fields.forEach((terminal) => {
                if (terminal.field_vid === this.vid) {
                    this.terminals.push(terminal);
                }
            });
        });
    }
    getCenterCoords() {
        let lat = 0;
        let lng = 0;
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for (let i = 0; i < this.coords.length; ++i) {
            lat += this.coords[i].latitude;
            lng += this.coords[i].longitude;
        }
        lat /= this.coords.length;
        lng /= this.coords.length;
        this.center = { lat, lng };
    }
    staticMapString(coordenadasString, centro, size) {
        let color = this.editField.value.color;
        color = color.slice(1);
        this.staticMap = this.mapsLib.staticPolygonMapString(coordenadasString, centro, color, size, this.zoom);
    }
    saveData() {
        if (this.editField.value.name === '') {
            Swal.fire({
                text: this.translationsLib.get('field_error_creating_new_field1'),
                icon: 'error',
                confirmButtonColor: '#224261'
            });
        }
        else if (this.coords === undefined) {
            Swal.fire({
                text: this.translationsLib.get('field_error_creating_new_field_need_polygon_points'),
                icon: 'error',
                confirmButtonColor: '#224261'
            });
        }
        else if (this.multicrops === undefined || this.multicrops.length === 0) {
            Swal.fire({
                text: this.translationsLib.get('field_error_creating_new_field_field3'),
                icon: 'error',
                confirmButtonColor: '#224261'
            });
        }
        else {
            const data = {
                name: this.editField.value.name,
                color: this.editField.value.color,
                multicrops: this.multicrops,
                coordinates: this.editField.value.coordinates,
                config: { map_zoom: this.zoom }
            };
            const putFieldRequest$ = this.platform === 'backoffice'
                ? this.fieldsService.backofficePutField(this.vid, data)
                : this.fieldsService.putFields(data, this.vid);
            putFieldRequest$.subscribe((response) => {
                this.commonsService.getMenu().subscribe(async (res) => {
                    // await this.router.navigate(['./field', { vid: this.vid }]);
                    location.reload();
                });
            }, (error) => {
                Swal.fire({
                    icon: 'error',
                    title: this.translationsLib.get('error'),
                    text: this.translationsLib.get('error_updating_data'),
                    confirmButtonColor: '#2c7be5'
                });
            });
        }
    }
    deleteField() {
        Swal.fire({
            text: this.translationsLib.get('field_delete_field_text'),
            showCancelButton: true,
            confirmButtonText: this.translationsLib.get('delete'),
            cancelButtonText: this.translationsLib.get('cancel'),
            confirmButtonColor: '#e63757',
            cancelButtonColor: '#224261'
        }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
                const deleteFieldRequest$ = this.platform === 'backoffice'
                    ? this.fieldsService.backofficeDeleteField(this.vid)
                    : this.fieldsService.deleteField(this.vid);
                deleteFieldRequest$.subscribe((response) => {
                    Swal.fire({
                        text: this.translationsLib.get('field_delete_field_success'),
                        icon: 'success'
                    }).then((res) => {
                        window.location.href = '/';
                    });
                });
            }
        });
    }
    editTerminal(vid, type) {
        this.router.navigate([this.terminalsLib.generateRoute(vid, type)]);
    }
    detachTerminal(tVid) {
        Swal.fire({
            text: this.translationsLib.get('field_detach_terminal_from_field'),
            confirmButtonText: this.translationsLib.get('accept'),
            cancelButtonText: this.translationsLib.get('cancel'),
            confirmButtonColor: '#224261',
            showCancelButton: true
        }).then((res) => {
            if (res.isConfirmed) {
                const deleteFieldRequest$ = this.platform === 'backoffice'
                    ? this.terminalService.backofficeDetachTerminalfromField(tVid, this.vid)
                    : this.terminalService.detachTerminalfromField(tVid, this.vid);
                deleteFieldRequest$.subscribe((response) => {
                    this.terminals = [];
                    if (this.platform === 'backoffice') {
                        this.getField();
                    }
                    else {
                        this.getTerminals();
                    }
                }, (error) => {
                    Swal.fire({
                        text: this.translationsLib.get('field_detach_terminal_from_field_error'),
                        confirmButtonText: this.translationsLib.get('accept'),
                        showConfirmButton: true
                    });
                });
            }
        });
    }
    getNonAttachedList() {
        const nonAttachedListRequest$ = this.platform === 'backoffice'
            ? this.terminalService.getNonAttachedOfFieldOwner(this.vid)
            : this.terminalService.getNonAttached();
        nonAttachedListRequest$.subscribe((response) => {
            this.nonAttached = response;
            if (this.nonAttached.length === 0) {
                this.nonAttached = null;
            }
        });
    }
    searchPrePairingNonAttached(vid) {
        this.serialNumberRes = vid;
        const response = this.nonAttached.filter((term) => term.vid === this.serialNumberRes);
        this.terminalFound = true;
        this.image_path =
            this.environmentService.getBackend() + '/' + response[0].image_path;
        this.results.setValue({
            nombre_equipo: response[0].name,
            terminal: response[0].metadata.terminal
        });
    }
    attach() {
        const postAttachingRequest$ = this.platform === 'backoffice'
            ? this.terminalService.backofficePostAttaching(this.serialNumberRes, this.vid)
            : this.terminalService.postAttaching(this.serialNumberRes, this.vid);
        postAttachingRequest$.subscribe((attach) => {
            this.addDevice = false;
            this.terminals = [];
            if (this.platform === 'backoffice') {
                this.getField();
            }
            else {
                this.getTerminals();
            }
        });
    }
    forceReload() {
        location.reload();
    }
    multicropsEvent(multicrops) {
        this.multicrops = multicrops;
    }
    patchCoordinates(event) {
        this.editField.patchValue({ coordinates: event });
    }
    canAdminField() {
        return this.field.authed_user_can_admin;
    }
    getFieldData(field) {
        this.field = field;
        this.fieldSize = (field.coordinates_area / 10000).toFixed(2);
        this.fieldName = field.name;
        this.breadcrumbs = [
            {
                text: this.fieldName,
                disabled: false,
                to: ['/field', { vid: this.vid }],
                active: false
            },
            {
                text: this.translationsLib.get('edit'),
                disabled: false,
                to: ' ',
                active: true
            }
        ];
        this.breadcrumbsChange.emit(this.breadcrumbs);
        this.helpersLib.setTitle(this.translationsLib.get('field_field'), this.fieldName, this.translationsLib.get('edit'));
        this.coords = field.coordinates;
        this.getCenterCoords();
        if (this.platform === 'backoffice') {
            this.terminals = field.terminals_info;
        }
        this.zoom = field.config?.map_zoom;
        if (field.multicrops === undefined ||
            (field.multicrops.length === 0 &&
                field.crop_id !== undefined &&
                field.crop_id !== null)) {
            this.multicrops = [
                {
                    vid: null,
                    crop_id: field.crop_id,
                    crop_typology: '',
                    farm_type: '',
                    irrigation_method: '',
                    irrigation_source: '',
                    distance_between_rows: 0,
                    distance_between_plants_in_row: 0,
                    drippers_per_plant: 0,
                    emitter_type: 0
                }
            ];
        }
        else {
            this.multicrops = field.multicrops;
        }
        this.editField.setValue({
            name: field.name,
            multicrops: this.multicrops,
            color: field.color,
            coordinates: field.coordinates
        });
        let coordenadasString = '';
        this.coords.forEach((coord) => {
            coordenadasString += coord.latitude + ',' + coord.longitude + '%7C';
        });
        coordenadasString = coordenadasString.slice(0, coordenadasString.length - 3); //quito la última coma
        this.staticMapString(coordenadasString, this.center, this.field.coordinates_area / 10000);
        this.loading = false;
    }
}
FieldsEditComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: FieldsEditComponent, deps: [{ token: i1$1.ActivatedRoute }, { token: FieldsService }, { token: i1$1.Router }, { token: AppCommonsService }, { token: TerminalsService }, { token: HelpersLibService }, { token: TranslationsLibService }, { token: TerminalsLibService }, { token: MapsLibService }, { token: AnalyticsLibService }, { token: EnvironmentService }], target: i0.ɵɵFactoryTarget.Component });
FieldsEditComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: FieldsEditComponent, selector: "lib-fields-edit", inputs: { platform: "platform", field: "field", terminals: "terminals" }, outputs: { breadcrumbsChange: "breadcrumbsChange", fieldLoaded: "fieldLoaded" }, ngImport: i0, template: "<div class=\"container-fluid p-1 p-lg-2 lib-fields-edit-component\">\n  <div class=\"mx-lg-4\">\n    <div class=\"col-12\" *ngIf=\"loading\">\n      <lib-loader></lib-loader>\n    </div>\n    <div class=\"col-12\" *ngIf=\"!loading\">\n      <mat-tab-group mat-align-tabs=\"start\" [selectedIndex]=\"0\">\n        <mat-tab label=\"{{ 'field_field' | translation }}\">\n          <div class=\"my-4\">\n            <div class=\"card p-2 p-lg-4\">\n              <div class=\"card-body p-2 p-lg-0\">\n                <form [formGroup]=\"editField\">\n                  <div class=\"row justify-content-between\">\n                    <div class=\"col-12 col-md-6\">\n                      <div class=\"form-group row\">\n                        <div class=\"col-12 col-md-6 col-xxl-8\">\n                          <label class=\"form-label\">\n                            {{ \"field_name\" | translation }}\n                          </label>\n                          <input\n                            id=\"fieldName\"\n                            type=\"text\"\n                            class=\"form-control\"\n                            formControlName=\"name\"\n                            [value]=\"editField.value.name\"\n                          />\n                        </div>\n                        <div\n                          class=\"col-12 col-md-6 col-xxl-4 mt-4 mt-md-0 d-flex align-items-center justify-content-between d-md-block text-end\"\n                        >\n                          <label class=\"form-label\">\n                            {{ \"field_color\" | translation }}\n                          </label>\n                          <div>\n                            <input\n                              type=\"color\"\n                              class=\"form-control d-inline-block bg-light\"\n                              formControlName=\"color\"\n                              [value]=\"editField.value.color\"\n                            />\n                          </div>\n                        </div>\n                      </div>\n\n                      <lib-multicrop\n                        [multicrops]=\"multicrops\"\n                        (updateMulticrops)=\"multicropsEvent($event)\"\n                      ></lib-multicrop>\n                    </div>\n                    <div class=\"col-12 col-md-6\">\n                      <div class=\"form-group\" id=\"mapa\">\n                        <img\n                          id=\"static\"\n                          src=\"{{ staticMap }}\"\n                          *ngIf=\"chargeMap === false\"\n                          class=\"rounded w-100\"\n                        />\n                        <button\n                          class=\"btn btn-primary mb-3\"\n                          id=\"editMap\"\n                          (click)=\"chargeMap = true\"\n                          *ngIf=\"chargeMap === false\"\n                        >\n                          {{ \"field_edit_map\" | translation }}\n                        </button>\n                        <button\n                          readonly\n                          class=\"btn\"\n                          id=\"fieldSize\"\n                          *ngIf=\"chargeMap === true\"\n                        >\n                          {{ \"field_size\" | translation }}: {{ fieldSize }} ha\n                        </button>\n                        <!--<div id=\"map\" *ngIf=\"chargeMap===true\" class=\"rounded\"></div>-->\n                        <lib-leaflet-maps\n                          *ngIf=\"chargeMap === true\"\n                          [coming]=\"'fields-edit'\"\n                          (editedFieldCoordinates)=\"patchCoordinates($event)\"\n                          (fieldSize)=\"fieldSize = $event\"\n                          [field]=\"{\n                            color: editField.value.color,\n                            coordinates: coords,\n                            allValves: null,\n                            terminals: null,\n                            field: null,\n                            type: null,\n                            longitude: null,\n                            latitude: null,\n                            irrgationStatus: null\n                          }\"\n                        ></lib-leaflet-maps>\n                        <!--<button class=\"btn\" id=\"deletePolygon\" *ngIf=\"chargeMap===true\">\n                            <ion-icon name=\"trash-outline\"></ion-icon>\n                          </button>-->\n                      </div>\n                    </div>\n                  </div>\n                  <div class=\"row\" id=\"buttonAlign\">\n                    <div class=\"col-12\">\n                      <button\n                        class=\"btn btn-lg btn-primary\"\n                        id=\"saveField\"\n                        (click)=\"saveData()\"\n                      >\n                        {{ \"save\" | translation }}\n                      </button>\n                    </div>\n                  </div>\n                </form>\n              </div>\n            </div>\n            <hr class=\"my-4\" />\n            <div class=\"card p-2 p-lg-4\">\n              <div class=\"card-body p-2 p-lg-0\">\n                <div class=\"row\">\n                  <div class=\"col-12 col-md-9\">\n                    <!-- Heading -->\n                    <h4 class=\"title\">\n                      {{ \"field_delete_field\" | translation }}\n                    </h4>\n                    <!-- Text -->\n                    <div\n                      class=\"small text-muted\"\n                      [innerHTML]=\"'field_delete_field_help' | translation\"\n                    ></div>\n                  </div>\n                  <div class=\"col-12 col-md-3 text-end\">\n                    <button\n                      class=\"btn btn-lg btn-danger\"\n                      id=\"deleteField\"\n                      (click)=\"deleteField()\"\n                      [disabled]=\"terminals && terminals.length > 0\"\n                    >\n                      {{ \"delete\" | translation }}\n                    </button>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n        </mat-tab>\n        <mat-tab label=\"{{ 'terminal_terminals' | translation }}\">\n          <div class=\"my-4 overflow-hidden\">\n            <div class=\"card p-3\">\n              <table class=\"table table-responsive-sm card-table\">\n                <thead>\n                  <tr>\n                    <th>\n                      <a class=\"text-muted list-sort\">\n                        {{ \"terminal_name\" | translation }}\n                      </a>\n                    </th>\n                    <th class=\"d-none d-md-table-cell\">\n                      <a class=\"text-muted list-sort\">\n                        {{ \"terminal_serial_number\" | translation }}\n                      </a>\n                    </th>\n                    <th class=\"d-none d-md-table-cell\">\n                      <a class=\"text-muted list-sort\">\n                        {{ \"terminal_model\" | translation }}\n                      </a>\n                    </th>\n                    <th class=\"text-end\">\n                      {{ \"terminal_actions\" | translation }}\n                    </th>\n                  </tr>\n                </thead>\n                <tbody class=\"list\" *ngIf=\"terminals !== null\">\n                  <tr *ngFor=\"let term of terminals\" style=\"cursor: pointer\">\n                    <td (click)=\"editTerminal(term.vid, term.type)\">\n                      {{ term.name }}\n                    </td>\n                    <td\n                      (click)=\"editTerminal(term.vid, term.type)\"\n                      class=\"d-none d-md-table-cell\"\n                    >\n                      {{ term.vid }}\n                    </td>\n                    <td\n                      (click)=\"editTerminal(term.vid, term.type)\"\n                      class=\"d-none d-md-table-cell\"\n                    >\n                      {{ term.pretty_type_name }}\n                    </td>\n                    <td>\n                      <button\n                        id=\"{{ term.name }}\"\n                        *ngIf=\"canAdminField()\"\n                        class=\"btn btn-danger\"\n                        (click)=\"detachTerminal(term.vid)\"\n                      >\n                        <ion-icon name=\"trash-outline\"></ion-icon>\n                      </button>\n                    </td>\n                  </tr>\n                </tbody>\n              </table>\n              <p\n                class=\"text pt-3 mt-4 text-center\"\n                *ngIf=\"terminals && terminals.length === 0\"\n              >\n                <i\n                  [innerHTML]=\"\n                    'terminal_field_with_no_terminals_text' | translation\n                  \"\n                ></i>\n              </p>\n              <div\n                class=\"row mt-4\"\n                *ngIf=\"nonAttached !== null && addDevice === false\"\n              >\n                <div class=\"col-12 text-end\">\n                  <button\n                    class=\"btn btn-primary\"\n                    (click)=\"addDevice = true; getNonAttachedList()\"\n                  >\n                    {{ \"field_add_terminal\" | translation }}\n                  </button>\n                </div>\n              </div>\n              <div class=\"row mt-4\" *ngIf=\"addDevice === false\">\n                <div\n                  class=\"col-12 col-lg-10 text-start text-lg-end align-self-center\"\n                >\n                  <span class=\"text-muted\">\n                    {{\n                      \"field_force_reload_after_adding_new_terminal\"\n                        | translation\n                    }}\n                  </span>\n                </div>\n                <div class=\"col-12 col-lg-2 text-end\">\n                  <button\n                    class=\"btn btn-warning text-black\"\n                    (click)=\"forceReload()\"\n                  >\n                    {{ \"force_reload\" | translation }}\n                  </button>\n                </div>\n              </div>\n            </div>\n            <div class=\"card\" *ngIf=\"addDevice === true\">\n              <mat-tab-group mat-align-tabs=\"start\" [selectedIndex]=\"0\">\n                <mat-tab\n                  label=\"{{ 'terminal_non_attached_terminals' | translation }}\"\n                  *ngIf=\"nonAttached !== null\"\n                >\n                  <br />\n                  <div class=\"col-12 col-lg-6\">\n                    <form>\n                      <div class=\"form-group\">\n                        <!-- Label -->\n                        <label class=\"form-label\">\n                          {{ \"terminal_choose_terminal\" | translation }}\n                        </label>\n                        <!-- Input -->\n                        <select class=\"form-control select\" #vidSelected>\n                          <option [value]=\"\"></option>\n                          <option\n                            id=\"vidNonAttached\"\n                            *ngFor=\"let term of nonAttached\"\n                            [value]=\"term.vid\"\n                          >\n                            {{ term.name }}\n                          </option>\n                        </select>\n                      </div>\n                      <button\n                        type=\"button\"\n                        class=\"btn btn-lg btn-primary mb-3 botondcha\"\n                        (click)=\"searchPrePairingNonAttached(vidSelected.value)\"\n                      >\n                        {{ \"search\" | translation }}\n                      </button>\n                    </form>\n                  </div>\n                </mat-tab>\n              </mat-tab-group>\n              <mat-tab-group\n                mat-align-tabs=\"start\"\n                *ngIf=\"terminalFound\"\n                style=\"overflow-x: hidden\"\n              >\n                <mat-tab\n                  label=\"{{ 'field_attach_terminal_results' | translation }}\"\n                >\n                  <br />\n                  <div class=\"card\" id=\"deviceInfo\" *ngIf=\"terminalFound\">\n                    <div class=\"row\">\n                      <div class=\"d-none d-md-block col-12 col-md-2\">\n                        <img src=\"{{ image_path }}\" style=\"max-height: 150px\" />\n                      </div>\n                      <div class=\"col-12 col-md-10\">\n                        <div class=\"row\">\n                          <label class=\"form-label-title text-uppercase\">\n                            {{ \"terminal_model\" | translation }}\n                          </label>\n                          <h2>{{ results.value.nombre_equipo }}</h2>\n                        </div>\n                        <div class=\"row\">\n                          <label class=\"form-label-title text-uppercase\">\n                            {{ \"terminal_serial_number\" | translation }}\n                          </label>\n                          <h5>{{ serialNumberRes }}</h5>\n                        </div>\n                        <div class=\"row\">\n                          <label class=\"form-label-title text-uppercase\">\n                            {{ \"terminal_number\" | translation }}\n                          </label>\n                          <h5>{{ results.value.terminal }}</h5>\n                        </div>\n                      </div>\n                    </div>\n                    <div class=\"row\">\n                      <div class=\"col-12 col-md-6 help-text\">\n                        <p\n                          [innerHTML]=\"\n                            'field_attach_terminal_results_text' | translation\n                          \"\n                        ></p>\n                      </div>\n                      <div class=\"col-12 col-md-6 text-end\">\n                        <button\n                          type=\"button\"\n                          class=\"btn btn-lg btn-primary mb-3 botondcha\"\n                          (click)=\"attach()\"\n                          *ngIf=\"terminalFound\"\n                        >\n                          {{ \"save\" | translation }}\n                        </button>\n                      </div>\n                    </div>\n                  </div>\n                </mat-tab>\n              </mat-tab-group>\n            </div>\n          </div>\n        </mat-tab>\n        <mat-tab label=\"{{ 'permission_permissions' | translation }}\">\n          <div class=\"my-4 overflow-hidden\">\n            <div class=\"card p-3\">\n              <lib-field-permissions\n                [vid]=\"vid\"\n                [platform]=\"platform\"\n                [permissions]=\"\n                  platform === 'backoffice'\n                    ? field.permission_mapping_identity\n                    : undefined\n                \"\n              ></lib-field-permissions>\n            </div>\n          </div>\n        </mat-tab>\n      </mat-tab-group>\n    </div>\n  </div>\n</div>\n", styles: ["@media (max-width: 991px){.lib-fields-edit-component #map{position:relative;height:213px}.lib-fields-edit-component .row{overflow-x:hidden}.lib-fields-edit-component .col-5,.lib-fields-edit-component .col-7{width:100%}.lib-fields-edit-component .card{padding:12px!important}.lib-fields-edit-component .card-body{padding:0!important}.lib-fields-edit-component #deletePolygon{background-color:#fff;color:#000;position:absolute;right:10px;top:28%;max-width:40px;max-height:40px}.lib-fields-edit-component #fieldSize{position:absolute;z-index:100000;top:250px;left:30px;right:30px;margin:auto;background-color:#fff;color:#5a6470;font-size:13px;font-weight:600;pointer-events:none;min-width:80%}.lib-fields-edit-component #editMap{position:absolute;z-index:100000;right:5%;top:5%;font-size:13px;font-weight:600}}@media (min-width: 991px){.lib-fields-edit-component .col-7{text-align:right;padding:0}.lib-fields-edit-component #map{position:relative;height:352px}.lib-fields-edit-component #deletePolygon{background-color:#fff;color:#000;position:absolute;right:10px;top:40%;max-width:40px;max-height:40px}.lib-fields-edit-component #fieldSize{position:absolute;z-index:100000;left:3%;top:90%;background-color:#fff;color:#5a6470;font-size:13px;font-weight:600;pointer-events:none}.lib-fields-edit-component #editMap{position:absolute;z-index:100000;right:20px;top:5%;font-size:13px;font-weight:600}}.lib-fields-edit-component ::ng-deep .mat-tab-group.mat-primary .mat-ink-bar,.lib-fields-edit-component .mat-tab-nav-bar.mat-primary .mat-ink-bar{background-color:#2f4f99;font-family:Cerebri Sans,sans-serif!important}.lib-fields-edit-component #buttonAlign{margin-top:2em;justify-content:end}.lib-fields-edit-component #mapa{margin-bottom:0;text-align:right;position:relative}.lib-fields-edit-component .card{padding:2em}.lib-fields-edit-component .mat-tab .mat-tab-body{margin-top:2em!important}.lib-fields-edit-component .mx-4{margin-top:2em}.lib-fields-edit-component .form-control,.lib-fields-edit-component .form-select{background-color:#f0f4ff;font-size:13px;font-family:Cerebri Sans}.lib-fields-edit-component .col-form-label{font-weight:500;font-size:15px;color:#444}.lib-fields-edit-component .table tr{cursor:pointer}.lib-fields-edit-component .table tr:hover{background-color:#f0f0f0}.lib-fields-edit-component .table thead th{font-size:9.5px}.lib-fields-edit-component .table td{font-size:15px;font-weight:500}.lib-fields-edit-component .btn{float:right}.lib-fields-edit-component .input-group-text{color:#000;background-color:#f0f4ff}.lib-fields-edit-component .select{cursor:pointer;appearance:auto}.lib-fields-edit-component .card-header-title{color:#e96055;font-size:15px;margin-top:0;font-weight:700}.lib-fields-edit-component .help-text{margin-top:12px}.lib-fields-edit-component .botondcha{float:right;max-height:41px;border-radius:9px;max-width:115.5px;line-height:10px;margin-bottom:0!important;margin-top:6px}.lib-fields-edit-component #deviceInfo{background-color:#66b8be14}.lib-fields-edit-component .form-label-title{font-size:9.5px;line-height:11px;letter-spacing:1.3px;color:#e96055;font-weight:700}.lib-fields-edit-component #fake-card{border:1px solid #e7e7e7!important;border-radius:16px!important}.lib-fields-edit-component input.ng-invalid{outline:1px solid red}.lib-fields-edit-component ::ng-deep .plt-android body #main-content ion-content{--background: var(--content-background-color)}.lib-fields-edit-component ::ng-deep .plt-android body{background:var(--content-background-color)}\n"], dependencies: [{ kind: "directive", type: i5.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i6.IonIcon, selector: "ion-icon", inputs: ["color", "flipRtl", "icon", "ios", "lazy", "md", "mode", "name", "sanitize", "size", "src"] }, { kind: "component", type: LoaderComponent, selector: "lib-loader" }, { kind: "component", type: LeafletMapsComponent, selector: "lib-leaflet-maps", inputs: ["fields", "field", "coming", "markerCoordinates", "terminalData", "backofficeTerminal", "allValves", "valve", "selectedValve", "colorField", "selectedValveToEdit"], outputs: ["fieldSize", "terminalsEdit", "terminalsActivation", "config360", "editedFieldCoordinates", "fieldsNew", "changeValve", "changeAllValves", "backofficeEvent"] }, { kind: "component", type: i11.MatTabGroup, selector: "mat-tab-group", inputs: ["color", "disableRipple"], exportAs: ["matTabGroup"] }, { kind: "component", type: i11.MatTab, selector: "mat-tab", inputs: ["disabled", "label", "aria-label", "aria-labelledby", "labelClass", "bodyClass"], exportAs: ["matTab"] }, { kind: "directive", type: i16.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i16.NgSelectOption, selector: "option", inputs: ["ngValue", "value"] }, { kind: "directive", type: i16.ɵNgSelectMultipleOption, selector: "option", inputs: ["ngValue", "value"] }, { kind: "directive", type: i16.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i16.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i16.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i16.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i16.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "component", type: FieldPermissionsComponent, selector: "lib-field-permissions", inputs: ["platform", "vid", "permissions"] }, { kind: "component", type: MulticropComponent, selector: "lib-multicrop", inputs: ["multicrops"], outputs: ["updateMulticrops"] }, { kind: "pipe", type: TranslationPipe, name: "translation" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: FieldsEditComponent, decorators: [{
            type: Component,
            args: [{ selector: 'lib-fields-edit', template: "<div class=\"container-fluid p-1 p-lg-2 lib-fields-edit-component\">\n  <div class=\"mx-lg-4\">\n    <div class=\"col-12\" *ngIf=\"loading\">\n      <lib-loader></lib-loader>\n    </div>\n    <div class=\"col-12\" *ngIf=\"!loading\">\n      <mat-tab-group mat-align-tabs=\"start\" [selectedIndex]=\"0\">\n        <mat-tab label=\"{{ 'field_field' | translation }}\">\n          <div class=\"my-4\">\n            <div class=\"card p-2 p-lg-4\">\n              <div class=\"card-body p-2 p-lg-0\">\n                <form [formGroup]=\"editField\">\n                  <div class=\"row justify-content-between\">\n                    <div class=\"col-12 col-md-6\">\n                      <div class=\"form-group row\">\n                        <div class=\"col-12 col-md-6 col-xxl-8\">\n                          <label class=\"form-label\">\n                            {{ \"field_name\" | translation }}\n                          </label>\n                          <input\n                            id=\"fieldName\"\n                            type=\"text\"\n                            class=\"form-control\"\n                            formControlName=\"name\"\n                            [value]=\"editField.value.name\"\n                          />\n                        </div>\n                        <div\n                          class=\"col-12 col-md-6 col-xxl-4 mt-4 mt-md-0 d-flex align-items-center justify-content-between d-md-block text-end\"\n                        >\n                          <label class=\"form-label\">\n                            {{ \"field_color\" | translation }}\n                          </label>\n                          <div>\n                            <input\n                              type=\"color\"\n                              class=\"form-control d-inline-block bg-light\"\n                              formControlName=\"color\"\n                              [value]=\"editField.value.color\"\n                            />\n                          </div>\n                        </div>\n                      </div>\n\n                      <lib-multicrop\n                        [multicrops]=\"multicrops\"\n                        (updateMulticrops)=\"multicropsEvent($event)\"\n                      ></lib-multicrop>\n                    </div>\n                    <div class=\"col-12 col-md-6\">\n                      <div class=\"form-group\" id=\"mapa\">\n                        <img\n                          id=\"static\"\n                          src=\"{{ staticMap }}\"\n                          *ngIf=\"chargeMap === false\"\n                          class=\"rounded w-100\"\n                        />\n                        <button\n                          class=\"btn btn-primary mb-3\"\n                          id=\"editMap\"\n                          (click)=\"chargeMap = true\"\n                          *ngIf=\"chargeMap === false\"\n                        >\n                          {{ \"field_edit_map\" | translation }}\n                        </button>\n                        <button\n                          readonly\n                          class=\"btn\"\n                          id=\"fieldSize\"\n                          *ngIf=\"chargeMap === true\"\n                        >\n                          {{ \"field_size\" | translation }}: {{ fieldSize }} ha\n                        </button>\n                        <!--<div id=\"map\" *ngIf=\"chargeMap===true\" class=\"rounded\"></div>-->\n                        <lib-leaflet-maps\n                          *ngIf=\"chargeMap === true\"\n                          [coming]=\"'fields-edit'\"\n                          (editedFieldCoordinates)=\"patchCoordinates($event)\"\n                          (fieldSize)=\"fieldSize = $event\"\n                          [field]=\"{\n                            color: editField.value.color,\n                            coordinates: coords,\n                            allValves: null,\n                            terminals: null,\n                            field: null,\n                            type: null,\n                            longitude: null,\n                            latitude: null,\n                            irrgationStatus: null\n                          }\"\n                        ></lib-leaflet-maps>\n                        <!--<button class=\"btn\" id=\"deletePolygon\" *ngIf=\"chargeMap===true\">\n                            <ion-icon name=\"trash-outline\"></ion-icon>\n                          </button>-->\n                      </div>\n                    </div>\n                  </div>\n                  <div class=\"row\" id=\"buttonAlign\">\n                    <div class=\"col-12\">\n                      <button\n                        class=\"btn btn-lg btn-primary\"\n                        id=\"saveField\"\n                        (click)=\"saveData()\"\n                      >\n                        {{ \"save\" | translation }}\n                      </button>\n                    </div>\n                  </div>\n                </form>\n              </div>\n            </div>\n            <hr class=\"my-4\" />\n            <div class=\"card p-2 p-lg-4\">\n              <div class=\"card-body p-2 p-lg-0\">\n                <div class=\"row\">\n                  <div class=\"col-12 col-md-9\">\n                    <!-- Heading -->\n                    <h4 class=\"title\">\n                      {{ \"field_delete_field\" | translation }}\n                    </h4>\n                    <!-- Text -->\n                    <div\n                      class=\"small text-muted\"\n                      [innerHTML]=\"'field_delete_field_help' | translation\"\n                    ></div>\n                  </div>\n                  <div class=\"col-12 col-md-3 text-end\">\n                    <button\n                      class=\"btn btn-lg btn-danger\"\n                      id=\"deleteField\"\n                      (click)=\"deleteField()\"\n                      [disabled]=\"terminals && terminals.length > 0\"\n                    >\n                      {{ \"delete\" | translation }}\n                    </button>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n        </mat-tab>\n        <mat-tab label=\"{{ 'terminal_terminals' | translation }}\">\n          <div class=\"my-4 overflow-hidden\">\n            <div class=\"card p-3\">\n              <table class=\"table table-responsive-sm card-table\">\n                <thead>\n                  <tr>\n                    <th>\n                      <a class=\"text-muted list-sort\">\n                        {{ \"terminal_name\" | translation }}\n                      </a>\n                    </th>\n                    <th class=\"d-none d-md-table-cell\">\n                      <a class=\"text-muted list-sort\">\n                        {{ \"terminal_serial_number\" | translation }}\n                      </a>\n                    </th>\n                    <th class=\"d-none d-md-table-cell\">\n                      <a class=\"text-muted list-sort\">\n                        {{ \"terminal_model\" | translation }}\n                      </a>\n                    </th>\n                    <th class=\"text-end\">\n                      {{ \"terminal_actions\" | translation }}\n                    </th>\n                  </tr>\n                </thead>\n                <tbody class=\"list\" *ngIf=\"terminals !== null\">\n                  <tr *ngFor=\"let term of terminals\" style=\"cursor: pointer\">\n                    <td (click)=\"editTerminal(term.vid, term.type)\">\n                      {{ term.name }}\n                    </td>\n                    <td\n                      (click)=\"editTerminal(term.vid, term.type)\"\n                      class=\"d-none d-md-table-cell\"\n                    >\n                      {{ term.vid }}\n                    </td>\n                    <td\n                      (click)=\"editTerminal(term.vid, term.type)\"\n                      class=\"d-none d-md-table-cell\"\n                    >\n                      {{ term.pretty_type_name }}\n                    </td>\n                    <td>\n                      <button\n                        id=\"{{ term.name }}\"\n                        *ngIf=\"canAdminField()\"\n                        class=\"btn btn-danger\"\n                        (click)=\"detachTerminal(term.vid)\"\n                      >\n                        <ion-icon name=\"trash-outline\"></ion-icon>\n                      </button>\n                    </td>\n                  </tr>\n                </tbody>\n              </table>\n              <p\n                class=\"text pt-3 mt-4 text-center\"\n                *ngIf=\"terminals && terminals.length === 0\"\n              >\n                <i\n                  [innerHTML]=\"\n                    'terminal_field_with_no_terminals_text' | translation\n                  \"\n                ></i>\n              </p>\n              <div\n                class=\"row mt-4\"\n                *ngIf=\"nonAttached !== null && addDevice === false\"\n              >\n                <div class=\"col-12 text-end\">\n                  <button\n                    class=\"btn btn-primary\"\n                    (click)=\"addDevice = true; getNonAttachedList()\"\n                  >\n                    {{ \"field_add_terminal\" | translation }}\n                  </button>\n                </div>\n              </div>\n              <div class=\"row mt-4\" *ngIf=\"addDevice === false\">\n                <div\n                  class=\"col-12 col-lg-10 text-start text-lg-end align-self-center\"\n                >\n                  <span class=\"text-muted\">\n                    {{\n                      \"field_force_reload_after_adding_new_terminal\"\n                        | translation\n                    }}\n                  </span>\n                </div>\n                <div class=\"col-12 col-lg-2 text-end\">\n                  <button\n                    class=\"btn btn-warning text-black\"\n                    (click)=\"forceReload()\"\n                  >\n                    {{ \"force_reload\" | translation }}\n                  </button>\n                </div>\n              </div>\n            </div>\n            <div class=\"card\" *ngIf=\"addDevice === true\">\n              <mat-tab-group mat-align-tabs=\"start\" [selectedIndex]=\"0\">\n                <mat-tab\n                  label=\"{{ 'terminal_non_attached_terminals' | translation }}\"\n                  *ngIf=\"nonAttached !== null\"\n                >\n                  <br />\n                  <div class=\"col-12 col-lg-6\">\n                    <form>\n                      <div class=\"form-group\">\n                        <!-- Label -->\n                        <label class=\"form-label\">\n                          {{ \"terminal_choose_terminal\" | translation }}\n                        </label>\n                        <!-- Input -->\n                        <select class=\"form-control select\" #vidSelected>\n                          <option [value]=\"\"></option>\n                          <option\n                            id=\"vidNonAttached\"\n                            *ngFor=\"let term of nonAttached\"\n                            [value]=\"term.vid\"\n                          >\n                            {{ term.name }}\n                          </option>\n                        </select>\n                      </div>\n                      <button\n                        type=\"button\"\n                        class=\"btn btn-lg btn-primary mb-3 botondcha\"\n                        (click)=\"searchPrePairingNonAttached(vidSelected.value)\"\n                      >\n                        {{ \"search\" | translation }}\n                      </button>\n                    </form>\n                  </div>\n                </mat-tab>\n              </mat-tab-group>\n              <mat-tab-group\n                mat-align-tabs=\"start\"\n                *ngIf=\"terminalFound\"\n                style=\"overflow-x: hidden\"\n              >\n                <mat-tab\n                  label=\"{{ 'field_attach_terminal_results' | translation }}\"\n                >\n                  <br />\n                  <div class=\"card\" id=\"deviceInfo\" *ngIf=\"terminalFound\">\n                    <div class=\"row\">\n                      <div class=\"d-none d-md-block col-12 col-md-2\">\n                        <img src=\"{{ image_path }}\" style=\"max-height: 150px\" />\n                      </div>\n                      <div class=\"col-12 col-md-10\">\n                        <div class=\"row\">\n                          <label class=\"form-label-title text-uppercase\">\n                            {{ \"terminal_model\" | translation }}\n                          </label>\n                          <h2>{{ results.value.nombre_equipo }}</h2>\n                        </div>\n                        <div class=\"row\">\n                          <label class=\"form-label-title text-uppercase\">\n                            {{ \"terminal_serial_number\" | translation }}\n                          </label>\n                          <h5>{{ serialNumberRes }}</h5>\n                        </div>\n                        <div class=\"row\">\n                          <label class=\"form-label-title text-uppercase\">\n                            {{ \"terminal_number\" | translation }}\n                          </label>\n                          <h5>{{ results.value.terminal }}</h5>\n                        </div>\n                      </div>\n                    </div>\n                    <div class=\"row\">\n                      <div class=\"col-12 col-md-6 help-text\">\n                        <p\n                          [innerHTML]=\"\n                            'field_attach_terminal_results_text' | translation\n                          \"\n                        ></p>\n                      </div>\n                      <div class=\"col-12 col-md-6 text-end\">\n                        <button\n                          type=\"button\"\n                          class=\"btn btn-lg btn-primary mb-3 botondcha\"\n                          (click)=\"attach()\"\n                          *ngIf=\"terminalFound\"\n                        >\n                          {{ \"save\" | translation }}\n                        </button>\n                      </div>\n                    </div>\n                  </div>\n                </mat-tab>\n              </mat-tab-group>\n            </div>\n          </div>\n        </mat-tab>\n        <mat-tab label=\"{{ 'permission_permissions' | translation }}\">\n          <div class=\"my-4 overflow-hidden\">\n            <div class=\"card p-3\">\n              <lib-field-permissions\n                [vid]=\"vid\"\n                [platform]=\"platform\"\n                [permissions]=\"\n                  platform === 'backoffice'\n                    ? field.permission_mapping_identity\n                    : undefined\n                \"\n              ></lib-field-permissions>\n            </div>\n          </div>\n        </mat-tab>\n      </mat-tab-group>\n    </div>\n  </div>\n</div>\n", styles: ["@media (max-width: 991px){.lib-fields-edit-component #map{position:relative;height:213px}.lib-fields-edit-component .row{overflow-x:hidden}.lib-fields-edit-component .col-5,.lib-fields-edit-component .col-7{width:100%}.lib-fields-edit-component .card{padding:12px!important}.lib-fields-edit-component .card-body{padding:0!important}.lib-fields-edit-component #deletePolygon{background-color:#fff;color:#000;position:absolute;right:10px;top:28%;max-width:40px;max-height:40px}.lib-fields-edit-component #fieldSize{position:absolute;z-index:100000;top:250px;left:30px;right:30px;margin:auto;background-color:#fff;color:#5a6470;font-size:13px;font-weight:600;pointer-events:none;min-width:80%}.lib-fields-edit-component #editMap{position:absolute;z-index:100000;right:5%;top:5%;font-size:13px;font-weight:600}}@media (min-width: 991px){.lib-fields-edit-component .col-7{text-align:right;padding:0}.lib-fields-edit-component #map{position:relative;height:352px}.lib-fields-edit-component #deletePolygon{background-color:#fff;color:#000;position:absolute;right:10px;top:40%;max-width:40px;max-height:40px}.lib-fields-edit-component #fieldSize{position:absolute;z-index:100000;left:3%;top:90%;background-color:#fff;color:#5a6470;font-size:13px;font-weight:600;pointer-events:none}.lib-fields-edit-component #editMap{position:absolute;z-index:100000;right:20px;top:5%;font-size:13px;font-weight:600}}.lib-fields-edit-component ::ng-deep .mat-tab-group.mat-primary .mat-ink-bar,.lib-fields-edit-component .mat-tab-nav-bar.mat-primary .mat-ink-bar{background-color:#2f4f99;font-family:Cerebri Sans,sans-serif!important}.lib-fields-edit-component #buttonAlign{margin-top:2em;justify-content:end}.lib-fields-edit-component #mapa{margin-bottom:0;text-align:right;position:relative}.lib-fields-edit-component .card{padding:2em}.lib-fields-edit-component .mat-tab .mat-tab-body{margin-top:2em!important}.lib-fields-edit-component .mx-4{margin-top:2em}.lib-fields-edit-component .form-control,.lib-fields-edit-component .form-select{background-color:#f0f4ff;font-size:13px;font-family:Cerebri Sans}.lib-fields-edit-component .col-form-label{font-weight:500;font-size:15px;color:#444}.lib-fields-edit-component .table tr{cursor:pointer}.lib-fields-edit-component .table tr:hover{background-color:#f0f0f0}.lib-fields-edit-component .table thead th{font-size:9.5px}.lib-fields-edit-component .table td{font-size:15px;font-weight:500}.lib-fields-edit-component .btn{float:right}.lib-fields-edit-component .input-group-text{color:#000;background-color:#f0f4ff}.lib-fields-edit-component .select{cursor:pointer;appearance:auto}.lib-fields-edit-component .card-header-title{color:#e96055;font-size:15px;margin-top:0;font-weight:700}.lib-fields-edit-component .help-text{margin-top:12px}.lib-fields-edit-component .botondcha{float:right;max-height:41px;border-radius:9px;max-width:115.5px;line-height:10px;margin-bottom:0!important;margin-top:6px}.lib-fields-edit-component #deviceInfo{background-color:#66b8be14}.lib-fields-edit-component .form-label-title{font-size:9.5px;line-height:11px;letter-spacing:1.3px;color:#e96055;font-weight:700}.lib-fields-edit-component #fake-card{border:1px solid #e7e7e7!important;border-radius:16px!important}.lib-fields-edit-component input.ng-invalid{outline:1px solid red}.lib-fields-edit-component ::ng-deep .plt-android body #main-content ion-content{--background: var(--content-background-color)}.lib-fields-edit-component ::ng-deep .plt-android body{background:var(--content-background-color)}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$1.ActivatedRoute }, { type: FieldsService }, { type: i1$1.Router }, { type: AppCommonsService }, { type: TerminalsService }, { type: HelpersLibService }, { type: TranslationsLibService }, { type: TerminalsLibService }, { type: MapsLibService }, { type: AnalyticsLibService }, { type: EnvironmentService }]; }, propDecorators: { platform: [{
                type: Input
            }], field: [{
                type: Input
            }], terminals: [{
                type: Input
            }], breadcrumbsChange: [{
                type: Output
            }], fieldLoaded: [{
                type: Output
            }] } });

class FieldsModule {
}
FieldsModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: FieldsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
FieldsModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: FieldsModule, declarations: [FieldsEditComponent,
        MulticropComponent,
        MulticropChildrenComponent], imports: [CommonModule,
        IonicModule,
        AppCommonsModule,
        MatTabsModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatAutocompleteModule,
        PermissionsModule,
        MatInputModule,
        MatTooltipModule,
        MatFormFieldModule,
        MatSelectModule,
        MatInputModule], exports: [FieldsEditComponent, MulticropComponent] });
FieldsModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: FieldsModule, imports: [CommonModule,
        IonicModule,
        AppCommonsModule,
        MatTabsModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatAutocompleteModule,
        PermissionsModule,
        MatInputModule,
        MatTooltipModule,
        MatFormFieldModule,
        MatSelectModule,
        MatInputModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: FieldsModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        FieldsEditComponent,
                        MulticropComponent,
                        MulticropChildrenComponent
                    ],
                    exports: [FieldsEditComponent, MulticropComponent],
                    imports: [
                        CommonModule,
                        IonicModule,
                        AppCommonsModule,
                        MatTabsModule,
                        ReactiveFormsModule,
                        MatFormFieldModule,
                        MatAutocompleteModule,
                        PermissionsModule,
                        MatInputModule,
                        MatTooltipModule,
                        MatFormFieldModule,
                        MatSelectModule,
                        MatInputModule,
                    ]
                }]
        }] });

/*
 * Public API Surface of app360-shared
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AnalyticsLibService, App360SharedModule, AppCommonsModule, AppCommonsService, BottomTabsComponent, CancelAlarmsType, ClimateService, ConfigurableService, DataloggerService, DispersionChartModel, EnvironmentService, EquipmentGeneralTypes, FERTILIZER_TYPES, FieldCropsNamesPipe, FieldPermissionsComponent, FieldsEditComponent, FieldsModule, FieldsService, GraphicsService, GroupsOrder, HelpersLibService, HighchartsLibService, HttpRepositoryService, INVITATIONS_TYPES, InvitationsComponent, IrrigationConsultingChartModel, IrrigationConsultingMainChartComponent, IrrigationConsultingModule, IrrigationService, LeafletMapsComponent, LineChartsModel, LoaderComponent, MAX_CONFIG_FERTILIZERS, MAX_CONFIG_PUMPS, MAX_CONFIG_VALVES, MAX_FERTILIZERS, MAX_PUMPS, MAX_VALVES, MapsLibService, MapsModule, ModulesService, MulticropComponent, NotificationsModule, NotificationsService, OrganizationsItemProfileComponent, OrganizationsModule, OrganizationsService, PermissionsLibService, PermissionsModule, PermissionsService, PermissionsTableComponent, PlatformLibService, ProgressBarComponent, SanitizeLibService, SensorIconPipe, SessionLibService, SidebarComponent, SidebarLibService, TERMINAL_ENABLED_ENABLED, TERMINAL_ENABLED_FULLY_DISABLED, TERMINAL_ENABLED_TEMPORARY_DISABLED, TERMINAL_TYPES_CARTS, TERMINAL_TYPES_CLIMATE, TERMINAL_TYPES_CONFIGURABLE, TERMINAL_TYPES_DATALOGGER, TERMINAL_TYPES_IRRIGATION, TerminalHeaderComponent, TerminalsLibService, TerminalsService, TextAvatarComponent, TransformDatePipe, TransformDateTimePipe, TranslationPipe, TranslationsLibService, UserSummaryPipe, UserType, UsersLibService, WeatherService };
